import { GandalfConstant, GandalfConstantList } from 'gandalf';

/** see com.rev360.model.connect.constant.a2pbrandstatus.A2pBrandStatus */
/* istanbul ignore next */
export class A2pBrandStatus extends GandalfConstant<string> {
	static readonly PENDING = new A2pBrandStatus('PENDING', "Pending");
	static readonly APPROVED = new A2pBrandStatus('APPROVED', "Approved");
	static readonly FAILED = new A2pBrandStatus('FAILED', "Failed");
	static readonly IN_REVIEW = new A2pBrandStatus('IN_REVIEW', "In Review");
	static readonly DELETED = new A2pBrandStatus('DELETED', "Deleted");
	static readonly SUSPENDED = new A2pBrandStatus('SUSPENDED', "Suspended");
	
	static readonly VALUES: GandalfConstantList<A2pBrandStatus> = {
		label: 'A2p Brand Status',
		values: [A2pBrandStatus.PENDING, A2pBrandStatus.APPROVED, A2pBrandStatus.FAILED, A2pBrandStatus.IN_REVIEW, A2pBrandStatus.DELETED, A2pBrandStatus.SUSPENDED, ]
	};
}

/** see com.rev360.model.connect.constant.a2pbrandtype.A2pBrandType */
/* istanbul ignore next */
export class A2pBrandType extends GandalfConstant<number> {
	static readonly STARTER = new A2pBrandType(1, "Starter");
	static readonly LOW_VOLUME_STANDARD = new A2pBrandType(2, "Low Volume Standard");
	static readonly STANDARD = new A2pBrandType(3, "Standard");
	
	static readonly VALUES: GandalfConstantList<A2pBrandType> = {
		label: 'A2P Brand Type',
		values: [A2pBrandType.STARTER, A2pBrandType.LOW_VOLUME_STANDARD, A2pBrandType.STANDARD, ]
	};
}

/** see com.rev360.model.connect.constant.a2pcampaignstatus.A2pCampaignStatus */
/* istanbul ignore next */
export class A2pCampaignStatus extends GandalfConstant<string> {
	static readonly PENDING = new A2pCampaignStatus('PENDING', "Pending");
	static readonly IN_PROGRESS = new A2pCampaignStatus('IN_PROGRESS', "In Progress");
	static readonly FAILED = new A2pCampaignStatus('FAILED', "Failed");
	static readonly VERIFIED = new A2pCampaignStatus('VERIFIED', "Verified");
	
	static readonly VALUES: GandalfConstantList<A2pCampaignStatus> = {
		label: 'A2p Campaign Status',
		values: [A2pCampaignStatus.PENDING, A2pCampaignStatus.IN_PROGRESS, A2pCampaignStatus.FAILED, A2pCampaignStatus.VERIFIED, ]
	};
}

/** see com.rev360.model.connect.constant.a2pRegistrationStatus.A2pRegistrationStatus */
/* istanbul ignore next */
export class A2pRegistrationStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new A2pRegistrationStatus(1, "Active");
	static readonly INACTIVE = new A2pRegistrationStatus(2, "Inactive");
	static readonly IN_PROGRESS = new A2pRegistrationStatus(3, "In Progress");
	
	static readonly VALUES: GandalfConstantList<A2pRegistrationStatus> = {
		label: 'A2p Registration Status',
		values: [A2pRegistrationStatus.ACTIVE, A2pRegistrationStatus.INACTIVE, A2pRegistrationStatus.IN_PROGRESS, ]
	};
}

/** see com.rev360.model.common.constant.accesscodestatus.AccessCodeStatus */
/* istanbul ignore next */
export class AccessCodeStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new AccessCodeStatus(0, "Inactive");
	static readonly ACTIVE = new AccessCodeStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<AccessCodeStatus> = {
		label: 'Access Code Status',
		values: [AccessCodeStatus.INACTIVE, AccessCodeStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.note.constant.accessmode.AccessMode */
/* istanbul ignore next */
export class AccessMode extends GandalfConstant<number> {
	static readonly PUBLIC = new AccessMode(0, "Public");
	static readonly PRIVATE = new AccessMode(1, "Private");
	static readonly RESTRICTED = new AccessMode(2, "Restricted");
	
	static readonly VALUES: GandalfConstantList<AccessMode> = {
		label: 'Access Mode',
		values: [AccessMode.PUBLIC, AccessMode.PRIVATE, AccessMode.RESTRICTED, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.AccountingPaymentByItemPreferenceValues */
/* istanbul ignore next */
export class AccountingPaymentByItemPreferenceValues extends GandalfConstant<string> {
	static readonly NONE = new AccountingPaymentByItemPreferenceValues('none', "None");
	static readonly OPTIONAL = new AccountingPaymentByItemPreferenceValues('optional', "Optional");
	static readonly REQUIRED = new AccountingPaymentByItemPreferenceValues('required', "Required");
	
	static readonly VALUES: GandalfConstantList<AccountingPaymentByItemPreferenceValues> = {
		label: 'Accounting Payment by Item Preference Values',
		values: [AccountingPaymentByItemPreferenceValues.NONE, AccountingPaymentByItemPreferenceValues.OPTIONAL, AccountingPaymentByItemPreferenceValues.REQUIRED, ]
	};
}

/** see com.rev360.pms.service.reporting.accounting.constants.accountingreportoutputtype.AccountingReportOutputType */
/* istanbul ignore next */
export class AccountingReportOutputType extends GandalfConstant<number> {
	static readonly DETAILED = new AccountingReportOutputType(0, "Detailed");
	static readonly SUMMARY = new AccountingReportOutputType(1, "Summary");
	
	static readonly VALUES: GandalfConstantList<AccountingReportOutputType> = {
		label: 'Accounting Report Output Type',
		values: [AccountingReportOutputType.DETAILED, AccountingReportOutputType.SUMMARY, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.AccountingStatementFormatPreferenceValues */
/* istanbul ignore next */
export class AccountingStatementFormatPreferenceValues extends GandalfConstant<string> {
	static readonly PDF = new AccountingStatementFormatPreferenceValues('1', "PDF");
	static readonly XML = new AccountingStatementFormatPreferenceValues('2', "XML");
	
	static readonly VALUES: GandalfConstantList<AccountingStatementFormatPreferenceValues> = {
		label: 'Accounting Statement Format Preference Values',
		values: [AccountingStatementFormatPreferenceValues.PDF, AccountingStatementFormatPreferenceValues.XML, ]
	};
}

/** see com.rev360.pms.service.reporting.constant.ActiveStatusSearch */
/* istanbul ignore next */
export class ActiveStatusSearch extends GandalfConstant<number> {
	static readonly ALL = new ActiveStatusSearch(0, "All");
	static readonly ACTIVE = new ActiveStatusSearch(1, "Active");
	static readonly INACTIVE = new ActiveStatusSearch(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<ActiveStatusSearch> = {
		label: 'Gender Search',
		values: [ActiveStatusSearch.ALL, ActiveStatusSearch.ACTIVE, ActiveStatusSearch.INACTIVE, ]
	};
}

/** see com.rev360.model.bridge.constant.activitytemplateabbreviation.ActivityTemplateAbbreviation */
/* istanbul ignore next */
export class ActivityTemplateAbbreviation extends GandalfConstant<string> {
	static readonly ZEISS_EXPORT = new ActivityTemplateAbbreviation('ZFPD', "Zeiss Export");
	static readonly ZEISS_LAUNCH = new ActivityTemplateAbbreviation('ZFLE', "Zeiss Launch");
	static readonly OPTOVUE_REVUE_EXPORT = new ActivityTemplateAbbreviation('ORPD', "Optovue Revue Export");
	static readonly OPTOMAP_EXPORT = new ActivityTemplateAbbreviation('OPPD', "Optomap Export");
	static readonly OPTOMAP_REVIEW = new ActivityTemplateAbbreviation('OPRW', "Optomap Review");
	static readonly NOW_2020_EXPORT = new ActivityTemplateAbbreviation('NWPD', "20/20 Now Export");
	static readonly REV_INTEGRATOR_EXPORT = new ActivityTemplateAbbreviation('RINT', "RevIntegrator Export");
	static readonly PATIENT_COMMUNICATIONS_EMAIL_OPT_OUT_LANDING_PAGE = new ActivityTemplateAbbreviation('EOPT', "Email Opt-out");
	static readonly PATIENT_COMMUNICATIONS_TEXT_OPT_OUT_LANDING_PAGE = new ActivityTemplateAbbreviation('TOPT', "Text Message Opt-out");
	static readonly PATIENT_COMMUNICATIONS_APPOINTMENT_LANDING_PAGE = new ActivityTemplateAbbreviation('PAPT', "Appointment");
	static readonly PATIENT_PORTAL_PASSWORD_RESET = new ActivityTemplateAbbreviation('PPWR', "PHR Password Reset");
	
	static readonly VALUES: GandalfConstantList<ActivityTemplateAbbreviation> = {
		label: 'ActivityTemplateAbbreviationLabel',
		values: [ActivityTemplateAbbreviation.ZEISS_EXPORT, ActivityTemplateAbbreviation.ZEISS_LAUNCH, ActivityTemplateAbbreviation.OPTOVUE_REVUE_EXPORT, ActivityTemplateAbbreviation.OPTOMAP_EXPORT, ActivityTemplateAbbreviation.OPTOMAP_REVIEW, ActivityTemplateAbbreviation.NOW_2020_EXPORT, ActivityTemplateAbbreviation.REV_INTEGRATOR_EXPORT, ActivityTemplateAbbreviation.PATIENT_COMMUNICATIONS_EMAIL_OPT_OUT_LANDING_PAGE, ActivityTemplateAbbreviation.PATIENT_COMMUNICATIONS_TEXT_OPT_OUT_LANDING_PAGE, ActivityTemplateAbbreviation.PATIENT_COMMUNICATIONS_APPOINTMENT_LANDING_PAGE, ActivityTemplateAbbreviation.PATIENT_PORTAL_PASSWORD_RESET, ]
	};
}

/** see com.rev360.model.data.constant.affiliation.Affiliation */
/* istanbul ignore next */
export class Affiliation extends GandalfConstant<number> {
	static readonly AFFILIATE_VISION_SOURCE = new Affiliation(1, "VisionSource");
	static readonly AFFILIATE_LUXOTTICA = new Affiliation(2, "Luxottica");
	static readonly AFFILIATE_LUX_ST = new Affiliation(3, "Lux - S/T");
	static readonly AFFILIATE_IDOC = new Affiliation(4, "IDOC");
	static readonly AFFILIATE_PEN = new Affiliation(5, "PEN");
	static readonly AFFILIATE_PECAA = new Affiliation(6, "PECAA");
	static readonly AFFILIATE_PRIMA = new Affiliation(7, "Prima");
	static readonly AFFILIATE_WALMART_SAMS = new Affiliation(8, "Walmart / Sams");
	static readonly AFFILIATE_ALL_DOCS = new Affiliation(9, "All Docs");
	static readonly AFFILIATE_VISION_WEST = new Affiliation(10, "Vision West");
	static readonly AFFILIATE_WVA = new Affiliation(11, "WVA");
	static readonly AFFILIATE_OOGP = new Affiliation(12, "OOGP");
	static readonly AFFILIATE_OBC = new Affiliation(13, "OBC");
	static readonly AFFILIATE_VISION_TRENDS = new Affiliation(14, "Vision Trends");
	static readonly AFFILIATE_COVD = new Affiliation(15, "COVD");
	static readonly AFFILIATE_CLEINMAN = new Affiliation(16, "Cleinman");
	static readonly AFFILIATE_SHOPKO = new Affiliation(17, "Shopko");
	static readonly AFFILIATE_OPT_COM = new Affiliation(18, "Opt.com");
	static readonly AFFILIATE_OD_WIRE = new Affiliation(19, "ODwire");
	static readonly AFFILIATE_EYE_RECOMMEND = new Affiliation(20, "EyeRecommend");
	static readonly AFFILIATE_2020_EXPRESS = new Affiliation(21, "20/20 Express");
	static readonly AFFILIATE_EYEMART_EXPRESS = new Affiliation(22, "Eyemart Express");
	static readonly AFFILIATE_TARGET_CORPORATE = new Affiliation(23, "Target Corporate");
	static readonly AFFILIATE_FIRSTSIGHT = new Affiliation(24, "FirstSight");
	static readonly AFFILIATE_LUXOTTICA_EMPLOYED = new Affiliation(25, "Luxottica Employed");
	static readonly AFFILIATE_WALMART_EMPLOYED = new Affiliation(26, "Walmart Employed");
	static readonly AFFILIATE_ENTERPRISE = new Affiliation(27, "Enterprise");
	
	static readonly VALUES: GandalfConstantList<Affiliation> = {
		label: 'Affiliation',
		values: [Affiliation.AFFILIATE_VISION_SOURCE, Affiliation.AFFILIATE_LUXOTTICA, Affiliation.AFFILIATE_LUX_ST, Affiliation.AFFILIATE_IDOC, Affiliation.AFFILIATE_PEN, Affiliation.AFFILIATE_PECAA, Affiliation.AFFILIATE_PRIMA, Affiliation.AFFILIATE_WALMART_SAMS, Affiliation.AFFILIATE_ALL_DOCS, Affiliation.AFFILIATE_VISION_WEST, Affiliation.AFFILIATE_WVA, Affiliation.AFFILIATE_OOGP, Affiliation.AFFILIATE_OBC, Affiliation.AFFILIATE_VISION_TRENDS, Affiliation.AFFILIATE_COVD, Affiliation.AFFILIATE_CLEINMAN, Affiliation.AFFILIATE_SHOPKO, Affiliation.AFFILIATE_OPT_COM, Affiliation.AFFILIATE_OD_WIRE, Affiliation.AFFILIATE_EYE_RECOMMEND, Affiliation.AFFILIATE_2020_EXPRESS, Affiliation.AFFILIATE_EYEMART_EXPRESS, Affiliation.AFFILIATE_TARGET_CORPORATE, Affiliation.AFFILIATE_FIRSTSIGHT, Affiliation.AFFILIATE_LUXOTTICA_EMPLOYED, Affiliation.AFFILIATE_WALMART_EMPLOYED, Affiliation.AFFILIATE_ENTERPRISE, ]
	};
}

/** see com.rev360.model.aiprompt.constant.AiPromptPackageType */
/* istanbul ignore next */
export class AiPromptPackageType extends GandalfConstant<number> {
	static readonly ENCOUNTER_SCRIBE = new AiPromptPackageType(1, "Encounter Scribe");
	
	static readonly VALUES: GandalfConstantList<AiPromptPackageType> = {
		label: 'AI Prompt Package Type',
		values: [AiPromptPackageType.ENCOUNTER_SCRIBE, ]
	};
}

/** see com.rev360.model.common.constant.alertcategory.AlertCategory */
/* istanbul ignore next */
export class AlertCategory extends GandalfConstant<number> {
	static readonly GENERAL = new AlertCategory(0, "General");
	static readonly ACCOUNTING = new AlertCategory(1, "Accounting");
	static readonly SCHEDULING = new AlertCategory(2, "Scheduling");
	static readonly ALLERGIES = new AlertCategory(3, "Allergies");
	static readonly INSURANCE = new AlertCategory(4, "Insurance");
	static readonly DOCUMENTS = new AlertCategory(5, "Documents");
	static readonly MEDICAL = new AlertCategory(6, "Medical");
	
	static readonly VALUES: GandalfConstantList<AlertCategory> = {
		label: 'Alert Category',
		values: [AlertCategory.GENERAL, AlertCategory.ACCOUNTING, AlertCategory.SCHEDULING, AlertCategory.ALLERGIES, AlertCategory.INSURANCE, AlertCategory.DOCUMENTS, AlertCategory.MEDICAL, ]
	};
}

/** see com.rev360.model.common.constant.alertdisplaytype.AlertDisplayType */
/* istanbul ignore next */
export class AlertDisplayType extends GandalfConstant<number> {
	static readonly NONE = new AlertDisplayType(0, "None");
	static readonly MODAL = new AlertDisplayType(1, "Modal");
	static readonly BANNER = new AlertDisplayType(2, "Banner");
	
	static readonly VALUES: GandalfConstantList<AlertDisplayType> = {
		label: 'Alert Display Type',
		values: [AlertDisplayType.NONE, AlertDisplayType.MODAL, AlertDisplayType.BANNER, ]
	};
}

/** see com.rev360.model.common.constant.alertseverity.AlertSeverity */
/* istanbul ignore next */
export class AlertSeverity extends GandalfConstant<number> {
	static readonly LOW = new AlertSeverity(1, "Low");
	static readonly MEDIUM = new AlertSeverity(2, "Medium");
	static readonly HIGH = new AlertSeverity(3, "High");
	
	static readonly VALUES: GandalfConstantList<AlertSeverity> = {
		label: 'Alert Severity',
		values: [AlertSeverity.LOW, AlertSeverity.MEDIUM, AlertSeverity.HIGH, ]
	};
}

/** see com.rev360.model.common.constant.alertstatus.AlertStatus */
/* istanbul ignore next */
export class AlertStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new AlertStatus(0, "Inactive");
	static readonly ACTIVE = new AlertStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<AlertStatus> = {
		label: 'Alert Status',
		values: [AlertStatus.INACTIVE, AlertStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.person.constant.allergy.AllergySeverity */
/* istanbul ignore next */
export class AllergySeverity extends GandalfConstant<number> {
	static readonly NONE = new AllergySeverity(0, "None");
	static readonly MILD = new AllergySeverity(1, "Mild");
	static readonly MODERATE = new AllergySeverity(2, "Moderate");
	static readonly SEVERE = new AllergySeverity(3, "Severe");
	
	static readonly VALUES: GandalfConstantList<AllergySeverity> = {
		label: 'Severity',
		values: [AllergySeverity.NONE, AllergySeverity.MILD, AllergySeverity.MODERATE, AllergySeverity.SEVERE, ]
	};
}

/** see com.rev360.model.person.constant.allergy.AllergyStatus */
/* istanbul ignore next */
export class AllergyStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new AllergyStatus(0, "Inactive");
	static readonly ACTIVE = new AllergyStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<AllergyStatus> = {
		label: 'Status',
		values: [AllergyStatus.INACTIVE, AllergyStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.amendment.constant.amendmentsource.AmendmentSource */
/* istanbul ignore next */
export class AmendmentSource extends GandalfConstant<number> {
	static readonly SOURCE_PATIENT = new AmendmentSource(0, "Patient");
	static readonly SOURCE_OTHER = new AmendmentSource(1, "Other");
	
	static readonly VALUES: GandalfConstantList<AmendmentSource> = {
		label: 'Amendment Source',
		values: [AmendmentSource.SOURCE_PATIENT, AmendmentSource.SOURCE_OTHER, ]
	};
}

/** see com.rev360.model.amendment.constant.amendmentstatus.AmendmentStatus */
/* istanbul ignore next */
export class AmendmentStatus extends GandalfConstant<number> {
	static readonly STATUS_SUBMITTED = new AmendmentStatus(0, "Submitted");
	static readonly STATUS_ACCEPTED = new AmendmentStatus(1, "Accepted");
	static readonly STATUS_DENIED = new AmendmentStatus(2, "Denied");
	
	static readonly VALUES: GandalfConstantList<AmendmentStatus> = {
		label: 'Amendment Status',
		values: [AmendmentStatus.STATUS_SUBMITTED, AmendmentStatus.STATUS_ACCEPTED, AmendmentStatus.STATUS_DENIED, ]
	};
}

/** see com.rev360.model.file.constant.ApplicationFileEntity */
/* istanbul ignore next */
export class ApplicationFileEntity extends GandalfConstant<string> {
	static readonly FEATURE_FLAG = new ApplicationFileEntity('FeatureFlag', "Feature Flag");
	
	static readonly VALUES: GandalfConstantList<ApplicationFileEntity> = {
		label: 'Application File Entity',
		values: [ApplicationFileEntity.FEATURE_FLAG, ]
	};
}

/** see com.rev360.model.file.constant.ApplicationFileFolder */
/* istanbul ignore next */
export class ApplicationFileFolder extends GandalfConstant<string> {
	static readonly DELETED_FILES = new ApplicationFileFolder('14', "Deleted Files");
	static readonly FEATURE_FLAG = new ApplicationFileFolder('FeatureFlag', "Feature Flag");
	
	static readonly VALUES: GandalfConstantList<ApplicationFileFolder> = {
		label: 'Application File Folder',
		values: [ApplicationFileFolder.DELETED_FILES, ApplicationFileFolder.FEATURE_FLAG, ]
	};
}

/** see com.rev360.pms.service.reporting.constant.AppointmentConfirmationStatusSearch */
/* istanbul ignore next */
export class AppointmentConfirmationStatusSearch extends GandalfConstant<number> {
	static readonly CONFIRMED = new AppointmentConfirmationStatusSearch(0, "Confirmed");
	static readonly NOT_CONFIRMED = new AppointmentConfirmationStatusSearch(1, "Not Confirmed");
	
	static readonly VALUES: GandalfConstantList<AppointmentConfirmationStatusSearch> = {
		label: 'Schedule Appointment Confirmation Status Search',
		values: [AppointmentConfirmationStatusSearch.CONFIRMED, AppointmentConfirmationStatusSearch.NOT_CONFIRMED, ]
	};
}

/** see com.rev360.pms.service.order.ArrellioProcessorAttribute */
/* istanbul ignore next */
export class ArrellioProcessorAttribute extends GandalfConstant<string> {
	static readonly IS_LOCATION_DEFAULT = new ArrellioProcessorAttribute('Is Location Default', "Is Location Default");
	
	static readonly VALUES: GandalfConstantList<ArrellioProcessorAttribute> = {
		label: 'Arrellio',
		values: [ArrellioProcessorAttribute.IS_LOCATION_DEFAULT, ]
	};
}

/** see com.rev360.web.api.enums.AuthorizationMode */
/* istanbul ignore next */
export class AuthorizationMode extends GandalfConstant<string> {
	static readonly KINDE = new AuthorizationMode('KINDE', "Kinde");
	static readonly FORM = new AuthorizationMode('FORM', "Form");
	
	static readonly VALUES: GandalfConstantList<AuthorizationMode> = {
		label: 'Authorization Mode',
		values: [AuthorizationMode.KINDE, AuthorizationMode.FORM, ]
	};
}

/** see com.rev360.model.insurance.authorization.constant.authorizationstatus.AuthorizationStatus */
/* istanbul ignore next */
export class AuthorizationStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new AuthorizationStatus(1, "Active");
	static readonly EXPIRED = new AuthorizationStatus(2, "Expired");
	static readonly DELETED = new AuthorizationStatus(3, "Deleted");
	
	static readonly VALUES: GandalfConstantList<AuthorizationStatus> = {
		label: 'Authorization Status',
		values: [AuthorizationStatus.ACTIVE, AuthorizationStatus.EXPIRED, AuthorizationStatus.DELETED, ]
	};
}

/** see com.rev360.model.diagnosis.constant.autodiagnosisdestination.AutoDiagnosisDestination */
/* istanbul ignore next */
export class AutoDiagnosisDestination extends GandalfConstant<number> {
	static readonly FINDING = new AutoDiagnosisDestination(1, "Finding");
	static readonly DIAGNOSIS = new AutoDiagnosisDestination(2, "Diagnosis");
	
	static readonly VALUES: GandalfConstantList<AutoDiagnosisDestination> = {
		label: 'Auto Diagnosis Destination',
		values: [AutoDiagnosisDestination.FINDING, AutoDiagnosisDestination.DIAGNOSIS, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.AutoDxDefaultTabPreferenceValues */
/* istanbul ignore next */
export class AutoDxDefaultTabPreferenceValues extends GandalfConstant<string> {
	static readonly FINDINGS = new AutoDxDefaultTabPreferenceValues('findings', "Today's Findings");
	static readonly MASTER = new AutoDxDefaultTabPreferenceValues('master', "Master Dx");
	
	static readonly VALUES: GandalfConstantList<AutoDxDefaultTabPreferenceValues> = {
		label: 'Auto Dx Default Tab Preference Values',
		values: [AutoDxDefaultTabPreferenceValues.FINDINGS, AutoDxDefaultTabPreferenceValues.MASTER, ]
	};
}

/** see com.rev360.pms.service.accounting.constant.BarcodeSearchType */
/* istanbul ignore next */
export class BarcodeSearchType extends GandalfConstant<number> {
	static readonly GENERIC = new BarcodeSearchType(0, "Search Generic");
	static readonly ITEMS = new BarcodeSearchType(1, "Search Items");
	static readonly PRODUCTS = new BarcodeSearchType(2, "Search Products");
	static readonly PRODUCTS_AND_ITEMS = new BarcodeSearchType(3, "Search Products and Items");
	
	static readonly VALUES: GandalfConstantList<BarcodeSearchType> = {
		label: 'Barcode Search Type',
		values: [BarcodeSearchType.GENERIC, BarcodeSearchType.ITEMS, BarcodeSearchType.PRODUCTS, BarcodeSearchType.PRODUCTS_AND_ITEMS, ]
	};
}

/** see com.rev360.model.prescription.constant.basecurveunit.BaseCurveUnit */
/* istanbul ignore next */
export class BaseCurveUnit extends GandalfConstant<string> {
	static readonly MILLIMETER = new BaseCurveUnit('mm', "mm");
	static readonly DIOPTER = new BaseCurveUnit('D', "D");
	
	static readonly VALUES: GandalfConstantList<BaseCurveUnit> = {
		label: 'Base Curve Unit',
		values: [BaseCurveUnit.MILLIMETER, BaseCurveUnit.DIOPTER, ]
	};
}

/** see com.rev360.model.utilities.constant.batchjobprocessorinfostatus.BatchJobProcessorInfoStatus */
/* istanbul ignore next */
export class BatchJobProcessorInfoStatus extends GandalfConstant<number> {
	static readonly ERROR = new BatchJobProcessorInfoStatus(0, "Error");
	static readonly PENDING = new BatchJobProcessorInfoStatus(1, "Pending");
	static readonly IN_PROCESS = new BatchJobProcessorInfoStatus(2, "In Process");
	static readonly COMPLETE = new BatchJobProcessorInfoStatus(3, "Complete");
	
	static readonly VALUES: GandalfConstantList<BatchJobProcessorInfoStatus> = {
		label: 'Batch Job Processor Info Status',
		values: [BatchJobProcessorInfoStatus.ERROR, BatchJobProcessorInfoStatus.PENDING, BatchJobProcessorInfoStatus.IN_PROCESS, BatchJobProcessorInfoStatus.COMPLETE, ]
	};
}

/** see com.rev360.model.utilities.constant.batchjobrecurrencestatus.BatchJobRecurrenceStatus */
/* istanbul ignore next */
export class BatchJobRecurrenceStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new BatchJobRecurrenceStatus(1, "Active");
	static readonly PROCESSING = new BatchJobRecurrenceStatus(2, "Processing");
	static readonly ERROR = new BatchJobRecurrenceStatus(4, "Error");
	static readonly CANCELED = new BatchJobRecurrenceStatus(5, "Canceled");
	
	static readonly VALUES: GandalfConstantList<BatchJobRecurrenceStatus> = {
		label: 'Batch Job Recurrence Status',
		values: [BatchJobRecurrenceStatus.ACTIVE, BatchJobRecurrenceStatus.PROCESSING, BatchJobRecurrenceStatus.ERROR, BatchJobRecurrenceStatus.CANCELED, ]
	};
}

/** see com.rev360.model.utilities.constant.batchjobstatus.BatchJobStatus */
/* istanbul ignore next */
export class BatchJobStatus extends GandalfConstant<number> {
	static readonly ERROR = new BatchJobStatus(0, "Error");
	static readonly PENDING = new BatchJobStatus(1, "Pending");
	static readonly IN_PROCESS = new BatchJobStatus(2, "In Process");
	static readonly COMPLETE = new BatchJobStatus(3, "Complete");
	
	static readonly VALUES: GandalfConstantList<BatchJobStatus> = {
		label: 'Batch Job Status',
		values: [BatchJobStatus.ERROR, BatchJobStatus.PENDING, BatchJobStatus.IN_PROCESS, BatchJobStatus.COMPLETE, ]
	};
}

/** see com.rev360.model.data.BetaSystemCode */
/* istanbul ignore next */
export class BetaSystemCode extends GandalfConstant<string> {
	static readonly VISION_WEB = new BetaSystemCode('visionweb', "VisionWeb");
	static readonly PATIENT_STATEMENTS = new BetaSystemCode('patientStatements', "Patient Statements");
	static readonly PATIENT_PORTAL_LOGIN = new BetaSystemCode('patientPortalLogin', "Patient Portal Login");
	static readonly RXNT = new BetaSystemCode('rxnt', "RXNT");
	static readonly TEST_EDITOR = new BetaSystemCode('testEditor', "Test Editor");
	static readonly COMMAND_LOGS = new BetaSystemCode('commandLogs', "Command Logs");
	static readonly ACCOUNTING_CATEGORIES = new BetaSystemCode('accountingCategories', "Accounting Categories");
	static readonly EYEFINITY = new BetaSystemCode('eyefinity', "Eyefinity");
	static readonly MESSAGING = new BetaSystemCode('messaging', "Messaging");
	static readonly ITEM_EXTERNAL_PROVIDER = new BetaSystemCode('itemExternalProvider', "Item External Provider");
	static readonly SERVICE_CATEGORIES = new BetaSystemCode('serviceCategories', "Service Categories");
	static readonly TEST_FILES = new BetaSystemCode('testFiles', "Test Files");
	static readonly ZEISS_FORUM_INTEGRATION = new BetaSystemCode('zeissForumIntegration', "Zeiss Forum Integration");
	static readonly CLINIC_AID_CLAIMS_PROCESSOR = new BetaSystemCode('clinicAidClaimsProcessor', "Use ClinicAid claims processor");
	static readonly BCBS_EDI_PROCESSOR = new BetaSystemCode('bcbsEDIProcessor', "BCBS EDI Processor");
	static readonly BETA_SERVER = new BetaSystemCode('betaServer', "Beta Server");
	static readonly INVENTORY_RECONCILIATION = new BetaSystemCode('inventoryReconciliation', "Inventory Reconciliation");
	static readonly SCANNER_INTEGRATION = new BetaSystemCode('scannerIntegration', "Scanner Integration");
	static readonly ALLOW_INVOICE_APPOINTMENT = new BetaSystemCode('allowInvoiceAppointment', "Allow Invoice Appointment");
	static readonly OPTOVUE_REVUE_INTEGRATION = new BetaSystemCode('optovueRevueIntegration', "Optovue Revue Integration");
	static readonly AUTOMATOR_VSP_ELIGIBILITY = new BetaSystemCode('automatorVspEligibility', "Automator Vsp Eligibility");
	static readonly ACCOUNT_MANUAL_INVOICES = new BetaSystemCode('accountingManualInvoices', "Accounting Manual Invoices");
	static readonly INVOICE_FREEZE_DATE = new BetaSystemCode('invoiceFreezeDate', "Invoice Freeze Date");
	static readonly INVENTORY_MANAGEMENT = new BetaSystemCode('inventoryManagement', "Inventory Management");
	static readonly IP_ADDRESS_RULES = new BetaSystemCode('ipAddressRules', "IP Address Rules");
	static readonly LOCAL_SENDER_837_PROCESSOR = new BetaSystemCode('localSender837Processor', "Local Sender 837 Processor");
	static readonly VISI_OFFICE_INTEGRATION = new BetaSystemCode('visiOfficeIntegration', "VisiOffice Integration");
	static readonly OPTOMAP_INTEGRATION = new BetaSystemCode('optomapIntegration', "Optomap Integration");
	static readonly REV_INTEGRATOR_EXPORT = new BetaSystemCode('revIntegratorExport', "RevIntegrator Export");
	static readonly DEMOGRAPHICS_PREFERENCE_FIELDS = new BetaSystemCode('demographicsPreferenceFields', "Demographics Preference Fields");
	static readonly ALLOW_2015_IN_OLD_MEANINGFUL_USE_REPORTS = new BetaSystemCode('allow2015InOldMeaningfulUseReports', "Allow 2015 in Reports");
	static readonly STATEMENTS_FILE_FORMAT = new BetaSystemCode('statementsFileFormat', "Statements File Format");
	static readonly PATIENT_COMMUNICATION_PARTNER_WEAVE = new BetaSystemCode('patientCommunication.partner.weave', "Patient Communications Partner Weave");
	static readonly AUTOMATOR_VSP_ORDERS = new BetaSystemCode('automatorVspOrders', "Automator Vsp Orders");
	static readonly ALLOW_ERA_POSTING = new BetaSystemCode('allowERAPosting', "Allow ERA Posting");
	static readonly NON_STANDARD_ZIP_CODES = new BetaSystemCode('NonStandardZipCodes', "Non Standard Zip Codes");
	static readonly AUTOMATOR_REV_COVERAGE_AND_ALLOWANCE = new BetaSystemCode('automatorRevCoverageAndAllowance', "Automator RevCoverage and Allowance");
	static readonly OOGP_SMARTFLOW_ORDERING = new BetaSystemCode('OOGP.smartflow.ordering', "OOGP SmartFlow Ordering");
	static readonly BARCODE_PRINTING = new BetaSystemCode('barcodePrinting', "Barcode Printing");
	static readonly RECALL_LOCATION_MAPPING = new BetaSystemCode('recallLocationMapping', "Recall Location Mapping");
	static readonly ALLOW_AOA_CQM_REPORT = new BetaSystemCode('allowAoaCqmReport', "Allow AOA CQM Report");
	static readonly PATIENT_ADDRESS_NOT_REQUIRED = new BetaSystemCode('patientAddressNotRequired', "Patient Address Not Required");
	static readonly REV_CONNECT = new BetaSystemCode('revConnect', "RevConnect");
	static readonly ABB_SMARTFLOW_ORDERING = new BetaSystemCode('ABB.smartflow.ordering', "ABB SmartFlow Ordering");
	static readonly OPTIKAM_PAD_INTEGRATION = new BetaSystemCode('optikamPadIntegration', "Optikam Pad Integration");
	static readonly PATIENT_COMMUNICATION_PARTNER_EPPOINTMENTS = new BetaSystemCode('patientCommunication.partner.eppointments', "Patient Communication Partner Eppointments");
	static readonly WVA_SMARTFLOW_ORDERING = new BetaSystemCode('WVA.smartflow.ordering', "WVA SmartFlow Ordering");
	static readonly TWELVE_84 = new BetaSystemCode('Twelve84', "twelve84");
	static readonly NEWERA_SMARTFLOW_RDERING = new BetaSystemCode('NEWERA.smartflow.ordering', "NewERA SmartFlow Ordering");
	static readonly ENABLE_SHA256 = new BetaSystemCode('enableSHA256', "Enable SHA-256");
	static readonly CAN_LIVE_CHAT = new BetaSystemCode('canLiveChat', "Can Live Chat");
	static readonly BLUEFIN_SREDKEY = new BetaSystemCode('bluefinSredkey', "Bluefin SREDKEY");
	static readonly ALLOW_TAX_GROUPS = new BetaSystemCode('allowTaxGroups', "Allow Tax Groups");
	static readonly MIPS_QUALITY_REPORT_SERIAL = new BetaSystemCode('mipsQualitySerialMeasureGen', "MIPS Quality Report Serial");
	static readonly PATIENT_COMMUNICATION_PARTNER_AFFINITY = new BetaSystemCode('patientCommunication.partner.affinity', "Patient Communication Partner Affinity");
	static readonly REV_IMAGING = new BetaSystemCode('revImaging', "RevImaging");
	static readonly HOYA_SMARTFLOW_ORDERING = new BetaSystemCode('HOYA.smartflow.ordering', "HOYA SmartFlow Ordering");
	static readonly COOPER_SMARTFLOW_ORDERING = new BetaSystemCode('COOPER.smartflow.ordering', "Cooper SmartFlow Ordering");
	static readonly PATIENT_DATA_INTEGRATION_TEST_DATA = new BetaSystemCode('patientDataIntegration.testdata', "Patient Data Integration Test Data");
	static readonly REVCONNECT_TWILIO = new BetaSystemCode('CSPAM.revconnect.twilio', "RevConnect: Twilio unique practice phone numbers");
	static readonly TRIZETTO_SFTP_PASSWORD = new BetaSystemCode('APIE.triZetto.sftp.password.update', "TriZetto SFTP Password Update");
	static readonly ENTERPRISE_ADMIN = new BetaSystemCode('QOL.admin.employee.limitedView', "Enterprise Admin");
	static readonly ENABLE_PARTNER_TAB_CALLBACKS = new BetaSystemCode('enablePartnerToTabCallbacks', "Enable Partner to TAB callbacks");
	static readonly TWILIO_IS_HIGH_VOLUME = new BetaSystemCode('CSPAM.twilio.highVolume', "Twilio: Practice is High Volume");
	static readonly MIPS_QUALITY_REPORTING = new BetaSystemCode('MIPS.reports.qualityReporting', "MIPS Quality Reporting");
	static readonly ALLOW_MULTIPLE_REMOTE_ADDRESSES = new BetaSystemCode('allowMultipleRemoteAddresses', "Allow multiple remote IP addresses during authentication");
	static readonly RUN_QRDA3_WITHOUT_UI_REPORT = new BetaSystemCode('REV.run.qrda3.without.ui.report', "Run QDRA3 without UI report");
	
	static readonly VALUES: GandalfConstantList<BetaSystemCode> = {
		label: 'Beta System Code',
		values: [BetaSystemCode.VISION_WEB, BetaSystemCode.PATIENT_STATEMENTS, BetaSystemCode.PATIENT_PORTAL_LOGIN, BetaSystemCode.RXNT, BetaSystemCode.TEST_EDITOR, BetaSystemCode.COMMAND_LOGS, BetaSystemCode.ACCOUNTING_CATEGORIES, BetaSystemCode.EYEFINITY, BetaSystemCode.MESSAGING, BetaSystemCode.ITEM_EXTERNAL_PROVIDER, BetaSystemCode.SERVICE_CATEGORIES, BetaSystemCode.TEST_FILES, BetaSystemCode.ZEISS_FORUM_INTEGRATION, BetaSystemCode.CLINIC_AID_CLAIMS_PROCESSOR, BetaSystemCode.BCBS_EDI_PROCESSOR, BetaSystemCode.BETA_SERVER, BetaSystemCode.INVENTORY_RECONCILIATION, BetaSystemCode.SCANNER_INTEGRATION, BetaSystemCode.ALLOW_INVOICE_APPOINTMENT, BetaSystemCode.OPTOVUE_REVUE_INTEGRATION, BetaSystemCode.AUTOMATOR_VSP_ELIGIBILITY, BetaSystemCode.ACCOUNT_MANUAL_INVOICES, BetaSystemCode.INVOICE_FREEZE_DATE, BetaSystemCode.INVENTORY_MANAGEMENT, BetaSystemCode.IP_ADDRESS_RULES, BetaSystemCode.LOCAL_SENDER_837_PROCESSOR, BetaSystemCode.VISI_OFFICE_INTEGRATION, BetaSystemCode.OPTOMAP_INTEGRATION, BetaSystemCode.REV_INTEGRATOR_EXPORT, BetaSystemCode.DEMOGRAPHICS_PREFERENCE_FIELDS, BetaSystemCode.ALLOW_2015_IN_OLD_MEANINGFUL_USE_REPORTS, BetaSystemCode.STATEMENTS_FILE_FORMAT, BetaSystemCode.PATIENT_COMMUNICATION_PARTNER_WEAVE, BetaSystemCode.AUTOMATOR_VSP_ORDERS, BetaSystemCode.ALLOW_ERA_POSTING, BetaSystemCode.NON_STANDARD_ZIP_CODES, BetaSystemCode.AUTOMATOR_REV_COVERAGE_AND_ALLOWANCE, BetaSystemCode.OOGP_SMARTFLOW_ORDERING, BetaSystemCode.BARCODE_PRINTING, BetaSystemCode.RECALL_LOCATION_MAPPING, BetaSystemCode.ALLOW_AOA_CQM_REPORT, BetaSystemCode.PATIENT_ADDRESS_NOT_REQUIRED, BetaSystemCode.REV_CONNECT, BetaSystemCode.ABB_SMARTFLOW_ORDERING, BetaSystemCode.OPTIKAM_PAD_INTEGRATION, BetaSystemCode.PATIENT_COMMUNICATION_PARTNER_EPPOINTMENTS, BetaSystemCode.WVA_SMARTFLOW_ORDERING, BetaSystemCode.TWELVE_84, BetaSystemCode.NEWERA_SMARTFLOW_RDERING, BetaSystemCode.ENABLE_SHA256, BetaSystemCode.CAN_LIVE_CHAT, BetaSystemCode.BLUEFIN_SREDKEY, BetaSystemCode.ALLOW_TAX_GROUPS, BetaSystemCode.MIPS_QUALITY_REPORT_SERIAL, BetaSystemCode.PATIENT_COMMUNICATION_PARTNER_AFFINITY, BetaSystemCode.REV_IMAGING, BetaSystemCode.HOYA_SMARTFLOW_ORDERING, BetaSystemCode.COOPER_SMARTFLOW_ORDERING, BetaSystemCode.PATIENT_DATA_INTEGRATION_TEST_DATA, BetaSystemCode.REVCONNECT_TWILIO, BetaSystemCode.TRIZETTO_SFTP_PASSWORD, BetaSystemCode.ENTERPRISE_ADMIN, BetaSystemCode.ENABLE_PARTNER_TAB_CALLBACKS, BetaSystemCode.TWILIO_IS_HIGH_VOLUME, BetaSystemCode.MIPS_QUALITY_REPORTING, BetaSystemCode.ALLOW_MULTIPLE_REMOTE_ADDRESSES, BetaSystemCode.RUN_QRDA3_WITHOUT_UI_REPORT, ]
	};
}

/** see com.rev360.model.encounter.constant.billableitemstatus.BillableItemStatus */
/* istanbul ignore next */
export class BillableItemStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new BillableItemStatus(0, "Inactive");
	static readonly ACTIVE = new BillableItemStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<BillableItemStatus> = {
		label: 'BillableItem Status',
		values: [BillableItemStatus.INACTIVE, BillableItemStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.practice.constant.billingid.BillingId */
/* istanbul ignore next */
export class BillingId extends GandalfConstant<number> {
	static readonly NONE = new BillingId(0, "NONE");
	static readonly EIN = new BillingId(1, "EIN");
	static readonly SSN = new BillingId(2, "SSN");
	
	static readonly VALUES: GandalfConstantList<BillingId> = {
		label: 'Billing Id',
		values: [BillingId.NONE, BillingId.EIN, BillingId.SSN, ]
	};
}

/** see com.rev360.pms.service.accounting.constant.BillingInvoiceStatus */
/* istanbul ignore next */
export class BillingInvoiceStatus extends GandalfConstant<string> {
	static readonly AUTHORIZED = new BillingInvoiceStatus('Authorized', "Authorized");
	static readonly PENDING = new BillingInvoiceStatus('Pending', "Pending");
	
	static readonly VALUES: GandalfConstantList<BillingInvoiceStatus> = {
		label: 'BillingInvoiceStatus',
		values: [BillingInvoiceStatus.AUTHORIZED, BillingInvoiceStatus.PENDING, ]
	};
}

/** see com.rev360.model.person.constant.bloodtype.BloodType */
/* istanbul ignore next */
export class BloodType extends GandalfConstant<string> {
	static readonly UNKNOWN = new BloodType('', "");
	static readonly NOT_APPLICABLE = new BloodType('N/A', "N/A");
	static readonly A = new BloodType('A', "A");
	static readonly A_POSITIVE = new BloodType('A+', "A+");
	static readonly A_NEGATIVE = new BloodType('A-', "A-");
	static readonly B = new BloodType('B', "B");
	static readonly B_POSITIVE = new BloodType('B+', "B+");
	static readonly B_NEGATIVE = new BloodType('B-', "B-");
	static readonly AB = new BloodType('AB', "AB");
	static readonly AB_POSITIVE = new BloodType('AB+', "AB+");
	static readonly AB_NEGATIVE = new BloodType('AB-', "AB-");
	static readonly O = new BloodType('O', "O");
	static readonly O_POSITIVE = new BloodType('O+', "O+");
	static readonly O_NEGATIVE = new BloodType('O-', "O-");
	
	static readonly VALUES: GandalfConstantList<BloodType> = {
		label: 'Blood Type',
		values: [BloodType.UNKNOWN, BloodType.NOT_APPLICABLE, BloodType.A, BloodType.A_POSITIVE, BloodType.A_NEGATIVE, BloodType.B, BloodType.B_POSITIVE, BloodType.B_NEGATIVE, BloodType.AB, BloodType.AB_POSITIVE, BloodType.AB_NEGATIVE, BloodType.O, BloodType.O_POSITIVE, BloodType.O_NEGATIVE, ]
	};
}

/** see com.rev360.model.bridge.constant.bridgetasktype.BridgeTaskType */
/* istanbul ignore next */
export class BridgeTaskType extends GandalfConstant<number> {
	static readonly WRITE_FILE = new BridgeTaskType(9, "Write File");
	static readonly READ_FILE = new BridgeTaskType(10, "Read File");
	static readonly RUN_EXECUTABLE = new BridgeTaskType(11, "Run Executable");
	static readonly LAUNCH_EXTENSION = new BridgeTaskType(12, "Launch Extension");
	static readonly REV_AUTOMATOR = new BridgeTaskType(13, "Rev Automator");
	
	static readonly VALUES: GandalfConstantList<BridgeTaskType> = {
		label: 'Bridge Task Type',
		values: [BridgeTaskType.WRITE_FILE, BridgeTaskType.READ_FILE, BridgeTaskType.RUN_EXECUTABLE, BridgeTaskType.LAUNCH_EXTENSION, BridgeTaskType.REV_AUTOMATOR, ]
	};
}

/** see com.rev360.model.vendor.constant.businessstatus.BusinessStatus */
/* istanbul ignore next */
export class BusinessStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new BusinessStatus(0, "Inactive");
	static readonly ACTIVE = new BusinessStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<BusinessStatus> = {
		label: 'Business Status',
		values: [BusinessStatus.INACTIVE, BusinessStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.diagnosis.constant.careplanitemcategory.CarePlanItemCategory */
/* istanbul ignore next */
export class CarePlanItemCategory extends GandalfConstant<number> {
	static readonly GENERAL = new CarePlanItemCategory(1, "General");
	static readonly RECALL = new CarePlanItemCategory(2, "Recall");
	static readonly EDUCATION = new CarePlanItemCategory(3, "Education");
	static readonly CQM = new CarePlanItemCategory(6, "CQM");
	static readonly MEDICATION = new CarePlanItemCategory(20, "Med Rx");
	static readonly LAB_ORDER = new CarePlanItemCategory(25, "Order - Medical");
	static readonly GOAL = new CarePlanItemCategory(26, "Goal");
	
	static readonly VALUES: GandalfConstantList<CarePlanItemCategory> = {
		label: 'Care Plan Item Category',
		values: [CarePlanItemCategory.GENERAL, CarePlanItemCategory.RECALL, CarePlanItemCategory.EDUCATION, CarePlanItemCategory.CQM, CarePlanItemCategory.MEDICATION, CarePlanItemCategory.LAB_ORDER, CarePlanItemCategory.GOAL, ]
	};
}

/** see com.rev360.model.diagnosis.constant.careplanitemeducationsource.CarePlanItemEducationSource */
/* istanbul ignore next */
export class CarePlanItemEducationSource extends GandalfConstant<number> {
	static readonly GENERAL_INFORMATION = new CarePlanItemEducationSource(1, "General Information");
	static readonly WEBSITE = new CarePlanItemEducationSource(2, "Website");
	static readonly FILE = new CarePlanItemEducationSource(3, "File");
	static readonly VIDEO = new CarePlanItemEducationSource(4, "Video");
	
	static readonly VALUES: GandalfConstantList<CarePlanItemEducationSource> = {
		label: 'Care Plan Item Education Source',
		values: [CarePlanItemEducationSource.GENERAL_INFORMATION, CarePlanItemEducationSource.WEBSITE, CarePlanItemEducationSource.FILE, CarePlanItemEducationSource.VIDEO, ]
	};
}

/** see com.rev360.model.diagnosis.constant.careplanitemlaborderduration.CarePlanItemLabOrderDuration */
/* istanbul ignore next */
export class CarePlanItemLabOrderDuration extends GandalfConstant<number> {
	static readonly HOUR = new CarePlanItemLabOrderDuration(4, "Hour(s)");
	static readonly DAY = new CarePlanItemLabOrderDuration(5, "Day(s)");
	static readonly WEEK = new CarePlanItemLabOrderDuration(6, "Week(s)");
	static readonly MONTH = new CarePlanItemLabOrderDuration(7, "Month(s)");
	static readonly YEAR = new CarePlanItemLabOrderDuration(8, "Year(s)");
	
	static readonly VALUES: GandalfConstantList<CarePlanItemLabOrderDuration> = {
		label: 'Care Plan Item Lab Order Duration',
		values: [CarePlanItemLabOrderDuration.HOUR, CarePlanItemLabOrderDuration.DAY, CarePlanItemLabOrderDuration.WEEK, CarePlanItemLabOrderDuration.MONTH, CarePlanItemLabOrderDuration.YEAR, ]
	};
}

/** see com.rev360.model.diagnosis.constant.careplanitemrecallduration.CarePlanItemRecallDuration */
/* istanbul ignore next */
export class CarePlanItemRecallDuration extends GandalfConstant<number> {
	static readonly HOUR = new CarePlanItemRecallDuration(4, "Hour(s)");
	static readonly DAY = new CarePlanItemRecallDuration(5, "Day(s)");
	static readonly WEEK = new CarePlanItemRecallDuration(6, "Week(s)");
	static readonly MONTH = new CarePlanItemRecallDuration(7, "Month(s)");
	static readonly YEAR = new CarePlanItemRecallDuration(8, "Year(s)");
	
	static readonly VALUES: GandalfConstantList<CarePlanItemRecallDuration> = {
		label: 'Care Plan Item Recall Duration',
		values: [CarePlanItemRecallDuration.HOUR, CarePlanItemRecallDuration.DAY, CarePlanItemRecallDuration.WEEK, CarePlanItemRecallDuration.MONTH, CarePlanItemRecallDuration.YEAR, ]
	};
}

/** see com.rev360.core.service.diagnosis.constant.CarePlanItemTemplateMasterId */
/* istanbul ignore next */
export class CarePlanItemTemplateMasterId extends GandalfConstant<number> {
	static readonly CPIT_CQM_POAG_CUP_DISC_RATIO = new CarePlanItemTemplateMasterId(2, "POAG Cup/Disc Ratio");
	static readonly CPIT_CQM_CURRENT_MED_REVIEW = new CarePlanItemTemplateMasterId(3, "Current Med Review");
	static readonly CPIT_CQM_DIAB_RET_MACULAR_EDEMA = new CarePlanItemTemplateMasterId(4, "Diabetic Retinopathy Macular Edema");
	static readonly CPIT_CQM_DIAB_RET_SEVERITY = new CarePlanItemTemplateMasterId(5, "Diabetic Retinopathy Severity");
	static readonly CPIT_CQM_DIAB_RET_COMM_MACULAR_EDEMA = new CarePlanItemTemplateMasterId(6, "Diabetic Retinopathy Comm Macular Edema");
	static readonly CPIT_CQM_DIAB_RET_COMM_SEVERITY = new CarePlanItemTemplateMasterId(7, "Diabetic Comm Retinopathy Severity");
	static readonly CPIT_CQM_POAG_STRUCTURAL_ABNORMALITIES = new CarePlanItemTemplateMasterId(8, "POAG Structural Abnormalities");
	
	static readonly VALUES: GandalfConstantList<CarePlanItemTemplateMasterId> = {
		label: 'CarePlanItemTemplateMasterId',
		values: [CarePlanItemTemplateMasterId.CPIT_CQM_POAG_CUP_DISC_RATIO, CarePlanItemTemplateMasterId.CPIT_CQM_CURRENT_MED_REVIEW, CarePlanItemTemplateMasterId.CPIT_CQM_DIAB_RET_MACULAR_EDEMA, CarePlanItemTemplateMasterId.CPIT_CQM_DIAB_RET_SEVERITY, CarePlanItemTemplateMasterId.CPIT_CQM_DIAB_RET_COMM_MACULAR_EDEMA, CarePlanItemTemplateMasterId.CPIT_CQM_DIAB_RET_COMM_SEVERITY, CarePlanItemTemplateMasterId.CPIT_CQM_POAG_STRUCTURAL_ABNORMALITIES, ]
	};
}

/** see com.rev360.model.category.constant.categoryentitytype.CategoryEntityType */
/* istanbul ignore next */
export class CategoryEntityType extends GandalfConstant<string> {
	static readonly CAMPAIGN = new CategoryEntityType('Campaign', "Campaign");
	static readonly CUSTOMER = new CategoryEntityType('Customer', "Customer");
	static readonly EMPLOYEE = new CategoryEntityType('Employee', "Employee");
	static readonly PATIENT = new CategoryEntityType('Patient', "Patient");
	static readonly PRACTICE = new CategoryEntityType('Practice', "Practice");
	static readonly PROVIDER = new CategoryEntityType('Provider', "Provider");
	static readonly SCHEDULE_ITEM = new CategoryEntityType('ScheduleItem', "ScheduleItem");
	static readonly TASK = new CategoryEntityType('Task', "Task");
	static readonly ALLERGY = new CategoryEntityType('Allergy', "Allergy");
	static readonly PHARMACY = new CategoryEntityType('Pharmacy', "Pharmacy");
	static readonly DIAGNOSIS = new CategoryEntityType('Diagnosis', "Diagnosis");
	static readonly TASK_ITEM = new CategoryEntityType('TaskItem', "TaskItem");
	static readonly ENCOUNTER = new CategoryEntityType('Encounter', "Encounter");
	static readonly ENCOUNTER_TEST_NOTE = new CategoryEntityType('EncounterTest', "EncounterTest");
	static readonly ENCOUNTER_TEST = new CategoryEntityType('TestCategory', "TestCategory");
	static readonly ENCOUNTER_FIELD = new CategoryEntityType('FieldCategory', "FieldCategory");
	static readonly ENCOUNTER_SCREEN = new CategoryEntityType('ScreenCategory', "ScreenCategory");
	static readonly PRESCRIPTION = new CategoryEntityType('Prescription', "Prescription");
	static readonly INVOICE = new CategoryEntityType('Invoice', "Invoice");
	static readonly PATIENT_ACCOUNT = new CategoryEntityType('PatientAccount', "PatientAccount");
	static readonly INSURANCE_ACCOUNT = new CategoryEntityType('InsuranceAccount', "InsuranceAccount");
	static readonly INSURANCE_CARRIER = new CategoryEntityType('InsuranceCarrier', "InsuranceCarrier");
	static readonly ORDER = new CategoryEntityType('Order', "Order");
	static readonly PATIENT_QUERY = new CategoryEntityType('PatientQueryCategory', "PatientQueryCategory");
	static readonly TRIGGER_QUERY = new CategoryEntityType('TriggerQueryCategory', "TriggerQueryCategory");
	static readonly EDUCATION_QUERY = new CategoryEntityType('EducationQueryCategory', "EducationQueryCategory");
	static readonly PAYMENT = new CategoryEntityType('Payment', "Payment");
	static readonly MASTER_REPORTS_QUERY = new CategoryEntityType('MasterReportsQueryCategory', "MasterReportsQueryCategory");
	static readonly SERVICES_CATEGORY = new CategoryEntityType('ServicesCategory', "ServicesCategory");
	static readonly REPORTS_CATEGORY = new CategoryEntityType('ReportsCategory', "ReportsCategory");
	
	static readonly VALUES: GandalfConstantList<CategoryEntityType> = {
		label: 'Category Entity Type',
		values: [CategoryEntityType.CAMPAIGN, CategoryEntityType.CUSTOMER, CategoryEntityType.EMPLOYEE, CategoryEntityType.PATIENT, CategoryEntityType.PRACTICE, CategoryEntityType.PROVIDER, CategoryEntityType.SCHEDULE_ITEM, CategoryEntityType.TASK, CategoryEntityType.ALLERGY, CategoryEntityType.PHARMACY, CategoryEntityType.DIAGNOSIS, CategoryEntityType.TASK_ITEM, CategoryEntityType.ENCOUNTER, CategoryEntityType.ENCOUNTER_TEST_NOTE, CategoryEntityType.ENCOUNTER_TEST, CategoryEntityType.ENCOUNTER_FIELD, CategoryEntityType.ENCOUNTER_SCREEN, CategoryEntityType.PRESCRIPTION, CategoryEntityType.INVOICE, CategoryEntityType.PATIENT_ACCOUNT, CategoryEntityType.INSURANCE_ACCOUNT, CategoryEntityType.INSURANCE_CARRIER, CategoryEntityType.ORDER, CategoryEntityType.PATIENT_QUERY, CategoryEntityType.TRIGGER_QUERY, CategoryEntityType.EDUCATION_QUERY, CategoryEntityType.PAYMENT, CategoryEntityType.MASTER_REPORTS_QUERY, CategoryEntityType.SERVICES_CATEGORY, CategoryEntityType.REPORTS_CATEGORY, ]
	};
}

/** see com.rev360.model.patient.ccda.constant.ccdaexportdaterangetype.CcdaExportDateRangeType */
/* istanbul ignore next */
export class CcdaExportDateRangeType extends GandalfConstant<number> {
	static readonly LAST_30_DAYS = new CcdaExportDateRangeType(1, "Last 30 days");
	static readonly LAST_90_DAYS = new CcdaExportDateRangeType(2, "Last 90 days");
	static readonly LAST_SIX_MONTHS = new CcdaExportDateRangeType(3, "Last 6 months");
	static readonly LAST_12_MONTHS = new CcdaExportDateRangeType(4, "Last 12 months");
	static readonly CUSTOM = new CcdaExportDateRangeType(5, "Custom");
	
	static readonly VALUES: GandalfConstantList<CcdaExportDateRangeType> = {
		label: 'CCDA Export Date Range Type',
		values: [CcdaExportDateRangeType.LAST_30_DAYS, CcdaExportDateRangeType.LAST_90_DAYS, CcdaExportDateRangeType.LAST_SIX_MONTHS, CcdaExportDateRangeType.LAST_12_MONTHS, CcdaExportDateRangeType.CUSTOM, ]
	};
}

/** see com.rev360.model.patient.ccda.constant.ccdaexportfrequency.CcdaExportFrequency */
/* istanbul ignore next */
export class CcdaExportFrequency extends GandalfConstant<number> {
	static readonly ONE_TIME = new CcdaExportFrequency(1, "One time");
	static readonly DAY_INTERVAL = new CcdaExportFrequency(2, "Day interval");
	static readonly MONTHLY = new CcdaExportFrequency(3, "Monthly");
	
	static readonly VALUES: GandalfConstantList<CcdaExportFrequency> = {
		label: 'CCDA Export Frequency',
		values: [CcdaExportFrequency.ONE_TIME, CcdaExportFrequency.DAY_INTERVAL, CcdaExportFrequency.MONTHLY, ]
	};
}

/** see com.rev360.model.patient.ccda.constant.ccdaexportstatus.CcdaExportStatus */
/* istanbul ignore next */
export class CcdaExportStatus extends GandalfConstant<number> {
	static readonly CANCELED = new CcdaExportStatus(0, "Canceled");
	static readonly ACTIVE = new CcdaExportStatus(1, "Active");
	static readonly ERROR = new CcdaExportStatus(2, "Error");
	static readonly COMPLETED = new CcdaExportStatus(3, "Completed");
	
	static readonly VALUES: GandalfConstantList<CcdaExportStatus> = {
		label: 'CCDA Export Status',
		values: [CcdaExportStatus.CANCELED, CcdaExportStatus.ACTIVE, CcdaExportStatus.ERROR, CcdaExportStatus.COMPLETED, ]
	};
}

/** see com.rev360.model.interoperability.constant.cdasection.CdaSections */
/* istanbul ignore next */
export class CdaSections extends GandalfConstant<number> {
	static readonly ADDENDUM = new CdaSections(1, "Addendum");
	static readonly ADVANCE_DIRECTIVES = new CdaSections(2, "Advance Directives");
	static readonly ALLERGIES = new CdaSections(3, "Allergies");
	static readonly ASSESSMENT = new CdaSections(4, "Assessment");
	static readonly CHIEF_COMPLAINT = new CdaSections(5, "Chief Complaint");
	static readonly CLINICAL_PRESENTATION = new CdaSections(6, "Clinical Presentation");
	static readonly COMPLICATIONS = new CdaSections(7, "Complications");
	static readonly CONCLUSIONS = new CdaSections(8, "Conclusions");
	static readonly CURRENT_IMAGING_PROCEDURE_DESCRIPTIONS = new CdaSections(9, "Current Imaging Procedure Descriptions");
	static readonly DICOM_OBJECT_CATALOG = new CdaSections(10, "Dicom Object Catalog");
	static readonly DOCUMENT_SUMMARY = new CdaSections(11, "Document Summary");
	static readonly ENCOUNTERS = new CdaSections(12, "Encounters");
	static readonly FAMILY_HISTORY = new CdaSections(13, "Family History");
	static readonly FINDINGS = new CdaSections(14, "Findings");
	static readonly FUNCTIONAL_STATUS = new CdaSections(15, "Functional Status");
	static readonly GENERAL_STATUS = new CdaSections(16, "General Status");
	static readonly HISTORY_OF_PAST_ILLNESS = new CdaSections(17, "History of Past Illness");
	static readonly HISTORY_OF_PRESENT_ILLNESS = new CdaSections(18, "History of Present Illness");
	static readonly IMMUNIZATIONS = new CdaSections(19, "Immunizations");
	static readonly KEY_IMAGES = new CdaSections(20, "Key Images");
	static readonly MEDICAL_EQUIPMENT = new CdaSections(21, "Medical Equipment");
	static readonly MEDICAL_HISTORY = new CdaSections(22, "Medical History");
	static readonly MEDICATIONS = new CdaSections(23, "Medications");
	static readonly PAYORS = new CdaSections(24, "Payers");
	static readonly PHYSICAL_EXAM = new CdaSections(25, "Physical Exam");
	static readonly PLAN_OF_CARE = new CdaSections(26, "Plan of Care");
	static readonly PRIOR_IMAGING_PROCEDURE_DESCRIPTIONS = new CdaSections(27, "Prior Imaging Procedure Descriptions");
	static readonly PROBLEM_LIST = new CdaSections(28, "Problem List");
	static readonly PROCEDURES = new CdaSections(29, "Procedures");
	static readonly RADIOLOGY_COMPARISON_STUDY_OBSERVATION = new CdaSections(30, "Radiology Comparison Study Observation");
	static readonly RADIOLOGY_IMPRESSIONS = new CdaSections(31, "Radiology Impressions");
	static readonly RADIOLOGY_STUDY_RECOMMENDATION = new CdaSections(32, "Radiology Study Recommendation");
	static readonly REASON_FOR_REFERRAL = new CdaSections(33, "Reason For Referral");
	static readonly REASON_FOR_VISIT = new CdaSections(34, "Reason For Visit");
	static readonly REQUESTED_IMAGING_STUDIES_INFORMATION = new CdaSections(35, "Requested Imaging Studies Information");
	static readonly RESULTS = new CdaSections(36, "Results");
	static readonly REVIEW_OF_SYSTEMS = new CdaSections(37, "Review of Systems");
	static readonly SOCIAL_HISTORY = new CdaSections(38, "Social History");
	static readonly VITAL_SIGNS = new CdaSections(39, "Vital Signs");
	static readonly INSTRUCTIONS = new CdaSections(40, "Instructions");
	static readonly MEDICATIONS_ADMINISTERED = new CdaSections(41, "Medications Administered");
	static readonly GOALS = new CdaSections(42, "Goals");
	static readonly HEALTH_CONCERNS = new CdaSections(43, "Health Concerns");
	static readonly MENTAL_STATUS = new CdaSections(44, "Mental Status");
	static readonly NUTRITION_STATUS = new CdaSections(45, "Nutrition Status");
	static readonly ASSESSMENT_AND_PLAN = new CdaSections(46, "Assessment and Plan");
	static readonly CONSULTATION_NOTES = new CdaSections(47, "Consultation Notes");
	static readonly HISTORY_AND_PHYSICAL_NOTES = new CdaSections(48, "History and Physical Notes");
	static readonly IMAGING_NARRATIVE_NOTES = new CdaSections(49, "Imaging Narrative Notes");
	static readonly PROCEDURE_NOTES = new CdaSections(50, "Procedure Notes");
	static readonly PROGRESS_NOTES = new CdaSections(51, "Progress Notes");
	static readonly LABORATORY_NARRATIVE_NOTES = new CdaSections(52, "Laboratory Narrative Notes");
	static readonly PATHOLOGY_NARRATIVE_NOTES = new CdaSections(53, "Pathology Narrative Notes");
	
	static readonly VALUES: GandalfConstantList<CdaSections> = {
		label: 'Cda Sections',
		values: [CdaSections.ADDENDUM, CdaSections.ADVANCE_DIRECTIVES, CdaSections.ALLERGIES, CdaSections.ASSESSMENT, CdaSections.CHIEF_COMPLAINT, CdaSections.CLINICAL_PRESENTATION, CdaSections.COMPLICATIONS, CdaSections.CONCLUSIONS, CdaSections.CURRENT_IMAGING_PROCEDURE_DESCRIPTIONS, CdaSections.DICOM_OBJECT_CATALOG, CdaSections.DOCUMENT_SUMMARY, CdaSections.ENCOUNTERS, CdaSections.FAMILY_HISTORY, CdaSections.FINDINGS, CdaSections.FUNCTIONAL_STATUS, CdaSections.GENERAL_STATUS, CdaSections.HISTORY_OF_PAST_ILLNESS, CdaSections.HISTORY_OF_PRESENT_ILLNESS, CdaSections.IMMUNIZATIONS, CdaSections.KEY_IMAGES, CdaSections.MEDICAL_EQUIPMENT, CdaSections.MEDICAL_HISTORY, CdaSections.MEDICATIONS, CdaSections.PAYORS, CdaSections.PHYSICAL_EXAM, CdaSections.PLAN_OF_CARE, CdaSections.PRIOR_IMAGING_PROCEDURE_DESCRIPTIONS, CdaSections.PROBLEM_LIST, CdaSections.PROCEDURES, CdaSections.RADIOLOGY_COMPARISON_STUDY_OBSERVATION, CdaSections.RADIOLOGY_IMPRESSIONS, CdaSections.RADIOLOGY_STUDY_RECOMMENDATION, CdaSections.REASON_FOR_REFERRAL, CdaSections.REASON_FOR_VISIT, CdaSections.REQUESTED_IMAGING_STUDIES_INFORMATION, CdaSections.RESULTS, CdaSections.REVIEW_OF_SYSTEMS, CdaSections.SOCIAL_HISTORY, CdaSections.VITAL_SIGNS, CdaSections.INSTRUCTIONS, CdaSections.MEDICATIONS_ADMINISTERED, CdaSections.GOALS, CdaSections.HEALTH_CONCERNS, CdaSections.MENTAL_STATUS, CdaSections.NUTRITION_STATUS, CdaSections.ASSESSMENT_AND_PLAN, CdaSections.CONSULTATION_NOTES, CdaSections.HISTORY_AND_PHYSICAL_NOTES, CdaSections.IMAGING_NARRATIVE_NOTES, CdaSections.PROCEDURE_NOTES, CdaSections.PROGRESS_NOTES, CdaSections.LABORATORY_NARRATIVE_NOTES, CdaSections.PATHOLOGY_NARRATIVE_NOTES, ]
	};
}

/** see com.rev360.model.inventory.product.constant.changerequestpricingmodifier.ChangeRequestPricingModifier */
/* istanbul ignore next */
export class ChangeRequestPricingModifier extends GandalfConstant<number> {
	static readonly PERCENT_STATIC = new ChangeRequestPricingModifier(0, "Static Percent");
	static readonly PERCENT_RELATIVE = new ChangeRequestPricingModifier(1, "Relative Percent");
	static readonly RELATIVE_AMOUNT = new ChangeRequestPricingModifier(2, "Relative Amount");
	static readonly STATIC = new ChangeRequestPricingModifier(3, "Static Amount");
	
	static readonly VALUES: GandalfConstantList<ChangeRequestPricingModifier> = {
		label: 'Change Request Pricing Modifier',
		values: [ChangeRequestPricingModifier.PERCENT_STATIC, ChangeRequestPricingModifier.PERCENT_RELATIVE, ChangeRequestPricingModifier.RELATIVE_AMOUNT, ChangeRequestPricingModifier.STATIC, ]
	};
}

/** see com.rev360.model.inventory.product.constant.changerequeststatus.ChangeRequestStatus */
/* istanbul ignore next */
export class ChangeRequestStatus extends GandalfConstant<number> {
	static readonly PENDING = new ChangeRequestStatus(0, "Pending");
	static readonly APPLIED = new ChangeRequestStatus(1, "Applied");
	
	static readonly VALUES: GandalfConstantList<ChangeRequestStatus> = {
		label: 'Change Request Status',
		values: [ChangeRequestStatus.PENDING, ChangeRequestStatus.APPLIED, ]
	};
}

/** see com.rev360.model.inventory.product.constant.changerequesttype.ChangeRequestType */
/* istanbul ignore next */
export class ChangeRequestType extends GandalfConstant<number> {
	static readonly PRICING = new ChangeRequestType(0, "Pricing");
	static readonly ATTRIBUTE = new ChangeRequestType(1, "Attribute");
	
	static readonly VALUES: GandalfConstantList<ChangeRequestType> = {
		label: 'Change Request Type',
		values: [ChangeRequestType.PRICING, ChangeRequestType.ATTRIBUTE, ]
	};
}

/** see com.rev360.model.encounter.constant.checkouttaskstatus.CheckoutTaskStatus */
/* istanbul ignore next */
export class CheckoutTaskStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new CheckoutTaskStatus(1, "Active");
	static readonly COMPLETE = new CheckoutTaskStatus(2, "Complete");
	
	static readonly VALUES: GandalfConstantList<CheckoutTaskStatus> = {
		label: 'Checkout Task Status',
		values: [CheckoutTaskStatus.ACTIVE, CheckoutTaskStatus.COMPLETE, ]
	};
}

/** see com.rev360.model.data.constant.citytype.CityType */
/* istanbul ignore next */
export class CityType extends GandalfConstant<string> {
	static readonly DEFAULT = new CityType('D', "Default");
	static readonly APPROVED = new CityType('A', "Approved");
	static readonly NOT_APPROVED = new CityType('N', "Not approved");
	
	static readonly VALUES: GandalfConstantList<CityType> = {
		label: 'City Type',
		values: [CityType.DEFAULT, CityType.APPROVED, CityType.NOT_APPROVED, ]
	};
}

/** see com.rev360.model.insurance.constant.claimattachmenttransmission.ClaimAttachmentTransmission */
/* istanbul ignore next */
export class ClaimAttachmentTransmission extends GandalfConstant<string> {
	static readonly AVAILABLE_ON_REQUEST = new ClaimAttachmentTransmission('AA', "AA (Available on Request at Provider Site)");
	static readonly MAIL = new ClaimAttachmentTransmission('BM', "BM (By Mail)");
	static readonly ELECTRONICALLY = new ClaimAttachmentTransmission('EL', "EL (Electronically Only)");
	static readonly EMAIL = new ClaimAttachmentTransmission('EM', "EM (E-Mail)");
	static readonly FILE_TRANSFER = new ClaimAttachmentTransmission('FT', "FT (File Transfer)");
	static readonly FAX = new ClaimAttachmentTransmission('FX', "FX (By Fax)");
	
	static readonly VALUES: GandalfConstantList<ClaimAttachmentTransmission> = {
		label: 'Claim Attachment Transmission',
		values: [ClaimAttachmentTransmission.AVAILABLE_ON_REQUEST, ClaimAttachmentTransmission.MAIL, ClaimAttachmentTransmission.ELECTRONICALLY, ClaimAttachmentTransmission.EMAIL, ClaimAttachmentTransmission.FILE_TRANSFER, ClaimAttachmentTransmission.FAX, ]
	};
}

/** see com.rev360.model.insurance.constant.claimattachmenttype.ClaimAttachmentType */
/* istanbul ignore next */
export class ClaimAttachmentType extends GandalfConstant<string> {
	static readonly REPORT_JUSTIFYING_TREATMENT = new ClaimAttachmentType('03', "03 (Report Justifying Treatment Beyond Utilization Guidelines)");
	static readonly DRUGS_ADMINISTERED = new ClaimAttachmentType('04', "04 (Drugs Administered)");
	static readonly TREATMENT_DIAGNOSIS = new ClaimAttachmentType('05', "05 (Treatment Diagnosis)");
	static readonly INITIAL_ASSESSMENT = new ClaimAttachmentType('06', "06 (Initial Assessment)");
	static readonly FUNCTIONAL_GOALS = new ClaimAttachmentType('07', "07 (Functional Goals)");
	static readonly PLAN_OF_TREATMENT = new ClaimAttachmentType('08', "08 (Plan of Treatment)");
	static readonly PROGRESS_REPORT = new ClaimAttachmentType('09', "09 (Progress Report)");
	static readonly CONTINUED_TREATMENT = new ClaimAttachmentType('10', "10 (Continued Treatment)");
	static readonly CHEMICAL_ANALYSIS = new ClaimAttachmentType('11', "11 (Chemical Analysis)");
	static readonly CERTIFIED_TEST_REPORT = new ClaimAttachmentType('13', "13 (Certified Test Report)");
	static readonly JUSTIFICATION_FOR_ADMISSION = new ClaimAttachmentType('15', "15 (Justification for Admission)");
	static readonly RECOVERY_PLAN = new ClaimAttachmentType('21', "21 (Recovery Plan)");
	static readonly ALLERGIES_DOCUMENT = new ClaimAttachmentType('A3', "A3 (Allergies/Sensitivities Document)");
	static readonly AUTOPSY_REPORT = new ClaimAttachmentType('A4', "A4 (Autopsy Report)");
	static readonly AMBULANCE_CERTIFICATION = new ClaimAttachmentType('AM', "AM (Ambulance Certification)");
	static readonly ADMISSION_SUMMARY = new ClaimAttachmentType('AS', "AS (Admission Summary)");
	static readonly PRESCRITPION = new ClaimAttachmentType('B2', "B2 (Prescription)");
	static readonly PHYSICIAN_ORDER = new ClaimAttachmentType('B3', "B3 (Physician Order)");
	static readonly REFERRAL_FORM = new ClaimAttachmentType('B4', "B4 (Referral Form)");
	static readonly BENCHMARK_TESTING_RESULTS = new ClaimAttachmentType('BR', "BR (Benchmark Testing Results)");
	static readonly BASELINE = new ClaimAttachmentType('BS', "BS (Baseline)");
	static readonly BLANKET_TEST_RESULTS = new ClaimAttachmentType('BT', "BT (Blanket Test Results)");
	static readonly CHIROPRACTIC_JUSTIFICATION = new ClaimAttachmentType('CB', "CB (Chiropractic Justification)");
	static readonly CONSENT_FORM = new ClaimAttachmentType('CK', "CK (Consent Form(s))");
	static readonly CERTIFICATION = new ClaimAttachmentType('CT', "CT (Certification)");
	static readonly DRUG_PROFILE_DOCUMENT = new ClaimAttachmentType('D2', "D2 (Drug Profile Document)");
	static readonly DENTAL_MODELS = new ClaimAttachmentType('DA', "DA (Dental Models)");
	static readonly DURABLE_MEDICAL_EQUIPMENT_PRESCRIPTION = new ClaimAttachmentType('DB', "DB (Durable Medical Equipment Prescription)");
	static readonly DIAGNOSTIC_REPORT = new ClaimAttachmentType('DG', "DG (Diagnostic Report)");
	static readonly DISCHARGE_MONITORING_REPORT = new ClaimAttachmentType('DJ', "DJ (Discharge Monitoring Report)");
	static readonly DISCHARGE_SUMMARY = new ClaimAttachmentType('DS', "DS (Discharge Summary)");
	static readonly EXPLANATION_OF_BENEFITS = new ClaimAttachmentType('EB', "EB (Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payor))");
	static readonly HEALTH_CERTIFICATE = new ClaimAttachmentType('HC', "HC (Health Certificate)");
	static readonly HEALTH_CLINIC_REPORT = new ClaimAttachmentType('HR', "HR (Health Clinic Records)");
	static readonly IMMUNIZATION_RECORD = new ClaimAttachmentType('I5', "I5 (Immunization Record)");
	static readonly STATE_SCHOOL_IMMUNIZATION_RECORDS = new ClaimAttachmentType('IR', "IR (State School Immunization Records)");
	static readonly LABORATORY_RESULTS = new ClaimAttachmentType('LA', "LA (Laboratory Results)");
	static readonly MEDICAL_RECORD = new ClaimAttachmentType('M1', "M1 (Medical Record Attachment)");
	static readonly MODELS = new ClaimAttachmentType('MT', "MT (Models)");
	static readonly NURSING_NOTES = new ClaimAttachmentType('NN', "NN (Nursing Notes)");
	static readonly OPERATIVE_NOTE = new ClaimAttachmentType('OB', "OB (Operative Note)");
	static readonly OXYGEN_CONTENT = new ClaimAttachmentType('OC', "OC (Oxygen Content Averaging Report)");
	static readonly ORDERS_AND_TREATMENTS = new ClaimAttachmentType('OD', "OD (Orders and Treatments Document)");
	static readonly OBJECTIVE_PHYSICAL_EXAMINATION = new ClaimAttachmentType('OE', "OE (Objective Physical Examination (including vital signs) Document)");
	static readonly OXYGEN_THERAPY = new ClaimAttachmentType('OX', "OX (Oxygen Therapy Certification)");
	static readonly SUPPORT_DATA = new ClaimAttachmentType('OZ', "OZ (Support Data for Claim)");
	static readonly PATHOLOGY_REPORT = new ClaimAttachmentType('P4', "P4 (Pathology Report)");
	static readonly PATIENT_MEDICAL_HISTORY = new ClaimAttachmentType('P5', "P5 (Patient Medical History Document)");
	static readonly PARENTAL_OR_ENTERAL = new ClaimAttachmentType('PE', "PE (Parenteral or Enteral Certification)");
	static readonly PHYSICAL_THERAPY_NOTES = new ClaimAttachmentType('PN', "PN (Physical Therapy Notes)");
	static readonly PROSTHETICS_OR_ORTHOTIC = new ClaimAttachmentType('PO', "PO (Prosthetics or Orthotic Certification)");
	static readonly PARAMEDICAL_RESULTS = new ClaimAttachmentType('PQ', "PQ (Paramedical Results)");
	static readonly PHYSICIANS_REPORT = new ClaimAttachmentType('PY', "PY (Physician's Report)");
	static readonly PHYSICAL_THERAPY_CERTIFICATION = new ClaimAttachmentType('PZ', "PZ (Physical Therapy Certification)");
	static readonly RADIOLOGY_FILMS = new ClaimAttachmentType('RB', "RB (Radiology Films)");
	static readonly RADIOLOGY_REPORTS = new ClaimAttachmentType('RR', "RR (Radiology Reports)");
	static readonly REPORT_OF_TESTS_AND_ANALYSIS_REPORT = new ClaimAttachmentType('RT', "RT (Report of Tests and Analysis Report)");
	static readonly RENEWABLE_OXYGEN_CONTENT = new ClaimAttachmentType('RX', "RX (Renewable Oxygen Content Averaging Report)");
	static readonly SYMPTOMS_DOCUMENT = new ClaimAttachmentType('SG', "SG (Symptoms Document)");
	static readonly DEATH_NOTIFICATION = new ClaimAttachmentType('V5', "V5 (Death Notification)");
	static readonly PHOTOGRAPHS = new ClaimAttachmentType('XP', "XP (Photographs)");
	
	static readonly VALUES: GandalfConstantList<ClaimAttachmentType> = {
		label: 'Claim Attachment Type',
		values: [ClaimAttachmentType.REPORT_JUSTIFYING_TREATMENT, ClaimAttachmentType.DRUGS_ADMINISTERED, ClaimAttachmentType.TREATMENT_DIAGNOSIS, ClaimAttachmentType.INITIAL_ASSESSMENT, ClaimAttachmentType.FUNCTIONAL_GOALS, ClaimAttachmentType.PLAN_OF_TREATMENT, ClaimAttachmentType.PROGRESS_REPORT, ClaimAttachmentType.CONTINUED_TREATMENT, ClaimAttachmentType.CHEMICAL_ANALYSIS, ClaimAttachmentType.CERTIFIED_TEST_REPORT, ClaimAttachmentType.JUSTIFICATION_FOR_ADMISSION, ClaimAttachmentType.RECOVERY_PLAN, ClaimAttachmentType.ALLERGIES_DOCUMENT, ClaimAttachmentType.AUTOPSY_REPORT, ClaimAttachmentType.AMBULANCE_CERTIFICATION, ClaimAttachmentType.ADMISSION_SUMMARY, ClaimAttachmentType.PRESCRITPION, ClaimAttachmentType.PHYSICIAN_ORDER, ClaimAttachmentType.REFERRAL_FORM, ClaimAttachmentType.BENCHMARK_TESTING_RESULTS, ClaimAttachmentType.BASELINE, ClaimAttachmentType.BLANKET_TEST_RESULTS, ClaimAttachmentType.CHIROPRACTIC_JUSTIFICATION, ClaimAttachmentType.CONSENT_FORM, ClaimAttachmentType.CERTIFICATION, ClaimAttachmentType.DRUG_PROFILE_DOCUMENT, ClaimAttachmentType.DENTAL_MODELS, ClaimAttachmentType.DURABLE_MEDICAL_EQUIPMENT_PRESCRIPTION, ClaimAttachmentType.DIAGNOSTIC_REPORT, ClaimAttachmentType.DISCHARGE_MONITORING_REPORT, ClaimAttachmentType.DISCHARGE_SUMMARY, ClaimAttachmentType.EXPLANATION_OF_BENEFITS, ClaimAttachmentType.HEALTH_CERTIFICATE, ClaimAttachmentType.HEALTH_CLINIC_REPORT, ClaimAttachmentType.IMMUNIZATION_RECORD, ClaimAttachmentType.STATE_SCHOOL_IMMUNIZATION_RECORDS, ClaimAttachmentType.LABORATORY_RESULTS, ClaimAttachmentType.MEDICAL_RECORD, ClaimAttachmentType.MODELS, ClaimAttachmentType.NURSING_NOTES, ClaimAttachmentType.OPERATIVE_NOTE, ClaimAttachmentType.OXYGEN_CONTENT, ClaimAttachmentType.ORDERS_AND_TREATMENTS, ClaimAttachmentType.OBJECTIVE_PHYSICAL_EXAMINATION, ClaimAttachmentType.OXYGEN_THERAPY, ClaimAttachmentType.SUPPORT_DATA, ClaimAttachmentType.PATHOLOGY_REPORT, ClaimAttachmentType.PATIENT_MEDICAL_HISTORY, ClaimAttachmentType.PARENTAL_OR_ENTERAL, ClaimAttachmentType.PHYSICAL_THERAPY_NOTES, ClaimAttachmentType.PROSTHETICS_OR_ORTHOTIC, ClaimAttachmentType.PARAMEDICAL_RESULTS, ClaimAttachmentType.PHYSICIANS_REPORT, ClaimAttachmentType.PHYSICAL_THERAPY_CERTIFICATION, ClaimAttachmentType.RADIOLOGY_FILMS, ClaimAttachmentType.RADIOLOGY_REPORTS, ClaimAttachmentType.REPORT_OF_TESTS_AND_ANALYSIS_REPORT, ClaimAttachmentType.RENEWABLE_OXYGEN_CONTENT, ClaimAttachmentType.SYMPTOMS_DOCUMENT, ClaimAttachmentType.DEATH_NOTIFICATION, ClaimAttachmentType.PHOTOGRAPHS, ]
	};
}

/** see com.rev360.model.insurance.constant.claimcurrentillnessdatequalifier.ClaimCurrentIllnessDateQualifier */
/* istanbul ignore next */
export class ClaimCurrentIllnessDateQualifier extends GandalfConstant<string> {
	static readonly ONSET = new ClaimCurrentIllnessDateQualifier('431', "431-Onset of Current Symptoms or Illness");
	static readonly MENSTRUAL = new ClaimCurrentIllnessDateQualifier('484', "484-Last Menstrual Period");
	
	static readonly VALUES: GandalfConstantList<ClaimCurrentIllnessDateQualifier> = {
		label: 'Claim Current Illness Date Qualifier',
		values: [ClaimCurrentIllnessDateQualifier.ONSET, ClaimCurrentIllnessDateQualifier.MENSTRUAL, ]
	};
}

/** see com.rev360.model.insurance.constant.claimepsdtapply.ClaimEpsdtApply */
/* istanbul ignore next */
export class ClaimEpsdtApply extends GandalfConstant<number> {
	static readonly YES = new ClaimEpsdtApply(1, "Yes");
	static readonly NO = new ClaimEpsdtApply(2, "No");
	
	static readonly VALUES: GandalfConstantList<ClaimEpsdtApply> = {
		label: 'ClaimEpsdtApply',
		values: [ClaimEpsdtApply.YES, ClaimEpsdtApply.NO, ]
	};
}

/** see com.rev360.model.accounting.constant.claimepsdtcode.ClaimEpsdtCode */
/* istanbul ignore next */
export class ClaimEpsdtCode extends GandalfConstant<string> {
	static readonly AV = new ClaimEpsdtCode('AV', "AV (Available - Not Used)");
	static readonly NU = new ClaimEpsdtCode('NU', "NU (Not Used)");
	static readonly S2 = new ClaimEpsdtCode('S2', "S2 (Under Treatment)");
	static readonly ST = new ClaimEpsdtCode('ST', "ST (New Services Requested)");
	
	static readonly VALUES: GandalfConstantList<ClaimEpsdtCode> = {
		label: 'Claim Epsdt Codes',
		values: [ClaimEpsdtCode.AV, ClaimEpsdtCode.NU, ClaimEpsdtCode.S2, ClaimEpsdtCode.ST, ]
	};
}

/** see com.rev360.model.insurance.constant.claimfilingcode.ClaimFilingCode */
/* istanbul ignore next */
export class ClaimFilingCode extends GandalfConstant<string> {
	static readonly NONE = new ClaimFilingCode('', "");
	static readonly OTHER_NON_FEDERAL = new ClaimFilingCode('11', "11-Other Non-Federal Programs");
	static readonly PREFERRED_PROVIDER_ORGANIZATION = new ClaimFilingCode('12', "12-Preferred Provider Organization (PPO)");
	static readonly POINT_OF_SERVICE = new ClaimFilingCode('13', "13-Point of Service (POS)");
	static readonly EXCLUSIVE_PROVIDER_ORGANIZATION = new ClaimFilingCode('14', "14-Exclusive Provider Organization (EPO)");
	static readonly INDEMNITY = new ClaimFilingCode('15', "15-Indemnity Insurance");
	static readonly HEALTH_MAINTENANCE_ORGANIZATION_MEDICARE_RISK = new ClaimFilingCode('16', "16-Health Maintenance Organization (HMO) Medicare Risk");
	static readonly AUTOMOBILE_MEDICAL = new ClaimFilingCode('AM', "AM-Automobile Medical");
	static readonly BLUE_CROSS_BLUE_SHIELD = new ClaimFilingCode('BL', "BL-Blue Cross/Blue Shield");
	static readonly CHAMPUS = new ClaimFilingCode('CH', "CH-Champus");
	static readonly COMMERCIAL = new ClaimFilingCode('CI', "CI-Commercial");
	static readonly DISABILITY = new ClaimFilingCode('DS', "DS-Disability");
	static readonly FEDERAL_EMPLOYEES_PROGRAM = new ClaimFilingCode('FI', "FI-Federal Employees Program FEP");
	static readonly HEALTH_MAINTENANCE_ORGANIZATION = new ClaimFilingCode('HM', "HM-Health Maintenance Organization");
	static readonly LIABILITY_MEDICAL = new ClaimFilingCode('LM', "LM-Liability Medical");
	static readonly MEDICARE_PART_B = new ClaimFilingCode('MB', "MB-Medicare Part B");
	static readonly MEDICAID = new ClaimFilingCode('MC', "MC-Medicaid");
	static readonly OTHER_FEDERAL = new ClaimFilingCode('OF', "OF-Other Federal Program");
	static readonly TITLE_V = new ClaimFilingCode('TV', "TV-Title V");
	static readonly VETERAN_ADMINISTRATION = new ClaimFilingCode('VA', "VA-Veteran Administration Plan");
	static readonly WORKERS_COMPENSATION = new ClaimFilingCode('WC', "WC-Workers Compensation Health Claim");
	static readonly MUTUALLY_DEFINED_UNKNOWN = new ClaimFilingCode('ZZ', "ZZ-Mutually Defined Unknown");
	
	static readonly VALUES: GandalfConstantList<ClaimFilingCode> = {
		label: 'Claim Filing Code',
		values: [ClaimFilingCode.NONE, ClaimFilingCode.OTHER_NON_FEDERAL, ClaimFilingCode.PREFERRED_PROVIDER_ORGANIZATION, ClaimFilingCode.POINT_OF_SERVICE, ClaimFilingCode.EXCLUSIVE_PROVIDER_ORGANIZATION, ClaimFilingCode.INDEMNITY, ClaimFilingCode.HEALTH_MAINTENANCE_ORGANIZATION_MEDICARE_RISK, ClaimFilingCode.AUTOMOBILE_MEDICAL, ClaimFilingCode.BLUE_CROSS_BLUE_SHIELD, ClaimFilingCode.CHAMPUS, ClaimFilingCode.COMMERCIAL, ClaimFilingCode.DISABILITY, ClaimFilingCode.FEDERAL_EMPLOYEES_PROGRAM, ClaimFilingCode.HEALTH_MAINTENANCE_ORGANIZATION, ClaimFilingCode.LIABILITY_MEDICAL, ClaimFilingCode.MEDICARE_PART_B, ClaimFilingCode.MEDICAID, ClaimFilingCode.OTHER_FEDERAL, ClaimFilingCode.TITLE_V, ClaimFilingCode.VETERAN_ADMINISTRATION, ClaimFilingCode.WORKERS_COMPENSATION, ClaimFilingCode.MUTUALLY_DEFINED_UNKNOWN, ]
	};
}

/** see com.rev360.model.insurance.constant.claimformat.ClaimFormat */
/* istanbul ignore next */
export class ClaimFormat extends GandalfConstant<number> {
	static readonly UNKNOWN = new ClaimFormat(0, "Unknown");
	static readonly HCFA1500_PRINT_IMAGE = new ClaimFormat(1, "HCFA1500 Print Image");
	static readonly VSP = new ClaimFormat(100, "VSP");
	static readonly ANSI_837 = new ClaimFormat(837, "ANSI 837");
	static readonly ANSI_277 = new ClaimFormat(277, "ANSI 277");
	static readonly ANSI_997 = new ClaimFormat(997, "ANSI 997");
	static readonly OHIP = new ClaimFormat(200, "OHIP");
	static readonly ANSI_270 = new ClaimFormat(270, "ANSI 270");
	static readonly ANSI_271 = new ClaimFormat(271, "ANSI 271");
	static readonly CLINICAID = new ClaimFormat(1000, "Clinicaid");
	
	static readonly VALUES: GandalfConstantList<ClaimFormat> = {
		label: 'Claim Format',
		values: [ClaimFormat.UNKNOWN, ClaimFormat.HCFA1500_PRINT_IMAGE, ClaimFormat.VSP, ClaimFormat.ANSI_837, ClaimFormat.ANSI_277, ClaimFormat.ANSI_997, ClaimFormat.OHIP, ClaimFormat.ANSI_270, ClaimFormat.ANSI_271, ClaimFormat.CLINICAID, ]
	};
}

/** see com.rev360.model.insurance.constant.claimfrequencycode.ClaimFrequencyCode */
/* istanbul ignore next */
export class ClaimFrequencyCode extends GandalfConstant<string> {
	static readonly ORIGINAL = new ClaimFrequencyCode('1', "1-ORIGINAL (Admit thru Discharge Claim)");
	static readonly CORRECTED = new ClaimFrequencyCode('6', "6-CORRECTED (Adjustment of Prior Claim)");
	static readonly REPLACEMENT = new ClaimFrequencyCode('7', "7-REPLACEMENT (Replacement of Prior Claim)");
	static readonly VOID = new ClaimFrequencyCode('8', "8-VOID (Void/Cancel of Prior Claim)");
	
	static readonly VALUES: GandalfConstantList<ClaimFrequencyCode> = {
		label: 'Claim Frequency Code',
		values: [ClaimFrequencyCode.ORIGINAL, ClaimFrequencyCode.CORRECTED, ClaimFrequencyCode.REPLACEMENT, ClaimFrequencyCode.VOID, ]
	};
}

/** see com.rev360.model.accounting.constant.claimnotecode.ClaimNoteCode */
/* istanbul ignore next */
export class ClaimNoteCode extends GandalfConstant<string> {
	static readonly NONE = new ClaimNoteCode('', "");
	static readonly ADD = new ClaimNoteCode('ADD', "Additional Information");
	static readonly DCP = new ClaimNoteCode('DCP', "Goals, Rehabilitation Potential, or Discharge Plans");
	static readonly PMT = new ClaimNoteCode('PMT', "Payment");
	static readonly TPO = new ClaimNoteCode('TPO', "Third Party Organization Notes");
	static readonly NOC = new ClaimNoteCode('NOC', "Procedure Description");
	
	static readonly VALUES: GandalfConstantList<ClaimNoteCode> = {
		label: 'Claim Note Codes',
		values: [ClaimNoteCode.NONE, ClaimNoteCode.ADD, ClaimNoteCode.DCP, ClaimNoteCode.PMT, ClaimNoteCode.TPO, ClaimNoteCode.NOC, ]
	};
}

/** see com.rev360.model.practice.constant.claimnpientity.ClaimNpiEntity */
/* istanbul ignore next */
export class ClaimNpiEntity extends GandalfConstant<number> {
	static readonly NONE = new ClaimNpiEntity(0, "None");
	static readonly INDIVIDUAL = new ClaimNpiEntity(1, "Individual");
	static readonly ORGANIZATION = new ClaimNpiEntity(2, "Organization");
	
	static readonly VALUES: GandalfConstantList<ClaimNpiEntity> = {
		label: 'Claim Npi Entity',
		values: [ClaimNpiEntity.NONE, ClaimNpiEntity.INDIVIDUAL, ClaimNpiEntity.ORGANIZATION, ]
	};
}

/** see com.rev360.model.insurance.constant.claimprocessingstatus.ClaimProcessingStatus */
/* istanbul ignore next */
export class ClaimProcessingStatus extends GandalfConstant<number> {
	static readonly NONE = new ClaimProcessingStatus(1, "");
	static readonly TRANSMIT_READY = new ClaimProcessingStatus(2, "Ready to submit");
	static readonly TRANSMIT_COMPLETE = new ClaimProcessingStatus(3, "Submitted");
	static readonly TRANSMIT_RETRY = new ClaimProcessingStatus(4, "Retry");
	static readonly TRANSMIT_ERROR = new ClaimProcessingStatus(5, "Error");
	static readonly TRANSMIT_CANCEL = new ClaimProcessingStatus(6, "Canceled");
	static readonly TRANSMIT_MARKED = new ClaimProcessingStatus(7, "Mark as submitted");
	
	static readonly VALUES: GandalfConstantList<ClaimProcessingStatus> = {
		label: 'Claim Processing Status',
		values: [ClaimProcessingStatus.NONE, ClaimProcessingStatus.TRANSMIT_READY, ClaimProcessingStatus.TRANSMIT_COMPLETE, ClaimProcessingStatus.TRANSMIT_RETRY, ClaimProcessingStatus.TRANSMIT_ERROR, ClaimProcessingStatus.TRANSMIT_CANCEL, ClaimProcessingStatus.TRANSMIT_MARKED, ]
	};
}

/** see com.rev360.model.insurance.constant.claimprovider.ClaimProviderId */
/* istanbul ignore next */
export class ClaimProviderId extends GandalfConstant<number> {
	static readonly NONE = new ClaimProviderId(0, "None");
	static readonly EIN = new ClaimProviderId(1, "EIN");
	static readonly SSN = new ClaimProviderId(2, "SSN");
	static readonly INSURANCE_ID = new ClaimProviderId(3, "Insurance Id");
	
	static readonly VALUES: GandalfConstantList<ClaimProviderId> = {
		label: 'Claim Provider Id',
		values: [ClaimProviderId.NONE, ClaimProviderId.EIN, ClaimProviderId.SSN, ClaimProviderId.INSURANCE_ID, ]
	};
}

/** see com.rev360.model.insurance.constant.claimsimilarillnessdatequalifier.ClaimSimilarIllnessDateQualifier */
/* istanbul ignore next */
export class ClaimSimilarIllnessDateQualifier extends GandalfConstant<string> {
	static readonly INITIAL_TREATMENT = new ClaimSimilarIllnessDateQualifier('454', "454-Initial Treatment");
	static readonly LATEST_VISIT = new ClaimSimilarIllnessDateQualifier('304', "304-Latest Visit or Consultation");
	static readonly ACUTE_MANIFESTATION = new ClaimSimilarIllnessDateQualifier('453', "453-Acute Manifestation of a Chronic Condition");
	static readonly ACCIDENT = new ClaimSimilarIllnessDateQualifier('439', "439-Accident");
	static readonly LAST_XRAY = new ClaimSimilarIllnessDateQualifier('455', "455-Last X-ray");
	static readonly PRESCRIPTION = new ClaimSimilarIllnessDateQualifier('471', "471-Prescription");
	static readonly REPORT_START = new ClaimSimilarIllnessDateQualifier('090', "090-Report Start");
	static readonly REPORT_END = new ClaimSimilarIllnessDateQualifier('091', "091-Report End");
	static readonly FIRST_VISIT = new ClaimSimilarIllnessDateQualifier('444', "444-First Visit or Consultation");
	
	static readonly VALUES: GandalfConstantList<ClaimSimilarIllnessDateQualifier> = {
		label: 'Claim Similar Illness Date Qualifier',
		values: [ClaimSimilarIllnessDateQualifier.INITIAL_TREATMENT, ClaimSimilarIllnessDateQualifier.LATEST_VISIT, ClaimSimilarIllnessDateQualifier.ACUTE_MANIFESTATION, ClaimSimilarIllnessDateQualifier.ACCIDENT, ClaimSimilarIllnessDateQualifier.LAST_XRAY, ClaimSimilarIllnessDateQualifier.PRESCRIPTION, ClaimSimilarIllnessDateQualifier.REPORT_START, ClaimSimilarIllnessDateQualifier.REPORT_END, ClaimSimilarIllnessDateQualifier.FIRST_VISIT, ]
	};
}

/** see com.rev360.model.insurance.claimstatus.constant.claimstatusfilestatus.ClaimStatusFileStatus */
/* istanbul ignore next */
export class ClaimStatusFileStatus extends GandalfConstant<number> {
	static readonly OK = new ClaimStatusFileStatus(0, "Ok");
	static readonly UNKNOWN = new ClaimStatusFileStatus(1, "Unknown");
	static readonly ERROR = new ClaimStatusFileStatus(2, "Error");
	
	static readonly VALUES: GandalfConstantList<ClaimStatusFileStatus> = {
		label: 'Claim Status File Status',
		values: [ClaimStatusFileStatus.OK, ClaimStatusFileStatus.UNKNOWN, ClaimStatusFileStatus.ERROR, ]
	};
}

/** see com.rev360.model.insurance.claimstatus.constant.claimstatusfiletype.ClaimStatusFileType */
/* istanbul ignore next */
export class ClaimStatusFileType extends GandalfConstant<string> {
	static readonly X12 = new ClaimStatusFileType('X12', "X12");
	
	static readonly VALUES: GandalfConstantList<ClaimStatusFileType> = {
		label: 'Claim Status File Type',
		values: [ClaimStatusFileType.X12, ]
	};
}

/** see com.rev360.model.insurance.claimstatus.constant.claimstatusfiletypeidentifier.ClaimStatusFileTypeIdentifier */
/* istanbul ignore next */
export class ClaimStatusFileTypeIdentifier extends GandalfConstant<string> {
	static readonly X12_277 = new ClaimStatusFileTypeIdentifier('277', "277");
	
	static readonly VALUES: GandalfConstantList<ClaimStatusFileTypeIdentifier> = {
		label: 'Claim Status File Type Identifier',
		values: [ClaimStatusFileTypeIdentifier.X12_277, ]
	};
}

/** see com.rev360.model.insurance.claimstatus.constant.claimstatusprocessingrunstatus.ClaimStatusProcessingRunStatus */
/* istanbul ignore next */
export class ClaimStatusProcessingRunStatus extends GandalfConstant<number> {
	static readonly SUCCESS = new ClaimStatusProcessingRunStatus(0, "Success");
	static readonly ERROR = new ClaimStatusProcessingRunStatus(1, "Error");
	
	static readonly VALUES: GandalfConstantList<ClaimStatusProcessingRunStatus> = {
		label: 'ClaimStatusProcessingRunStatus',
		values: [ClaimStatusProcessingRunStatus.SUCCESS, ClaimStatusProcessingRunStatus.ERROR, ]
	};
}

/** see com.rev360.model.insurance.claimstatus.constant.claimstatusstatus.ClaimStatusStatus */
/* istanbul ignore next */
export class ClaimStatusStatus extends GandalfConstant<number> {
	static readonly UNKNOWN = new ClaimStatusStatus(0, "Unknown");
	static readonly ACCEPTED = new ClaimStatusStatus(1, "Accepted");
	static readonly REJECTED = new ClaimStatusStatus(2, "Rejected");
	
	static readonly VALUES: GandalfConstantList<ClaimStatusStatus> = {
		label: 'Claim Status Status',
		values: [ClaimStatusStatus.UNKNOWN, ClaimStatusStatus.ACCEPTED, ClaimStatusStatus.REJECTED, ]
	};
}

/** see com.rev360.model.insurance.constant.claimsubmitmech.ClaimSubmitMechanism */
/* istanbul ignore next */
export class ClaimSubmitMechanism extends GandalfConstant<number> {
	static readonly NONE = new ClaimSubmitMechanism(0, "None");
	static readonly NONELECTRONIC = new ClaimSubmitMechanism(100, "Non-Electronic");
	static readonly ELECTRONIC = new ClaimSubmitMechanism(1, "Electronic");
	static readonly FAX = new ClaimSubmitMechanism(2, "Fax");
	static readonly MAIL = new ClaimSubmitMechanism(3, "Mail");
	static readonly PRINT = new ClaimSubmitMechanism(4, "Print");
	
	static readonly VALUES: GandalfConstantList<ClaimSubmitMechanism> = {
		label: 'Claim Submit Mechanism',
		values: [ClaimSubmitMechanism.NONE, ClaimSubmitMechanism.NONELECTRONIC, ClaimSubmitMechanism.ELECTRONIC, ClaimSubmitMechanism.FAX, ClaimSubmitMechanism.MAIL, ClaimSubmitMechanism.PRINT, ]
	};
}

/** see com.rev360.model.insurance.constant.claimvisionconditionapply.ClaimVisionConditionApply */
/* istanbul ignore next */
export class ClaimVisionConditionApply extends GandalfConstant<number> {
	static readonly YES = new ClaimVisionConditionApply(1, "Yes");
	static readonly NO = new ClaimVisionConditionApply(2, "No");
	
	static readonly VALUES: GandalfConstantList<ClaimVisionConditionApply> = {
		label: 'Claim Vision Condition Apply',
		values: [ClaimVisionConditionApply.YES, ClaimVisionConditionApply.NO, ]
	};
}

/** see com.rev360.model.accounting.constant.copaytype.CoPayType */
/* istanbul ignore next */
export class CoPayType extends GandalfConstant<number> {
	static readonly UNKNOWN = new CoPayType(0, "Patient co-pay");
	static readonly SERVICE = new CoPayType(1, "Patient general co-pay");
	static readonly MATERIAL = new CoPayType(2, "Patient material co-pay");
	static readonly MEDICAL_EXAM = new CoPayType(3, "Patient medical exam co-pay");
	static readonly ROUTINE_EXAM = new CoPayType(4, "Patient routine exam co-pay");
	static readonly CL_FITTING = new CoPayType(5, "Patient CL fitting co-pay");
	
	static readonly VALUES: GandalfConstantList<CoPayType> = {
		label: 'Co Pay Types',
		values: [CoPayType.UNKNOWN, CoPayType.SERVICE, CoPayType.MATERIAL, CoPayType.MEDICAL_EXAM, CoPayType.ROUTINE_EXAM, CoPayType.CL_FITTING, ]
	};
}

/** see com.rev360.model.data.constant.codeset.CodeSet */
/* istanbul ignore next */
export class CodeSet extends GandalfConstant<number> {
	static readonly ICD9 = new CodeSet(1, "ICD-9");
	static readonly ICD10 = new CodeSet(2, "ICD-10");
	static readonly SNOMED = new CodeSet(3, "SNOMED");
	static readonly CPT = new CodeSet(4, "CPT");
	static readonly LOINC = new CodeSet(5, "LOINC");
	static readonly RXNORM = new CodeSet(6, "RxNorm");
	static readonly FDA = new CodeSet(7, "FDA");
	
	static readonly VALUES: GandalfConstantList<CodeSet> = {
		label: 'Code Set',
		values: [CodeSet.ICD9, CodeSet.ICD10, CodeSet.SNOMED, CodeSet.CPT, CodeSet.LOINC, CodeSet.RXNORM, CodeSet.FDA, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultchiefcomplaintlevel.CodingResultChiefComplaintLevel */
/* istanbul ignore next */
export class CodingResultChiefComplaintLevel extends GandalfConstant<number> {
	static readonly NOT_PRESENT = new CodingResultChiefComplaintLevel(0, "Not Present");
	static readonly PRESENT = new CodingResultChiefComplaintLevel(1, "Present");
	
	static readonly VALUES: GandalfConstantList<CodingResultChiefComplaintLevel> = {
		label: 'Coding Result Chief Complaint Level',
		values: [CodingResultChiefComplaintLevel.NOT_PRESENT, CodingResultChiefComplaintLevel.PRESENT, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultexamlevel.CodingResultExamLevel */
/* istanbul ignore next */
export class CodingResultExamLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultExamLevel(0, "None");
	static readonly PROBLEM_FOCUSED = new CodingResultExamLevel(1, "Problem Focused");
	static readonly EXPANDED_PROBLEM_FOCUSED = new CodingResultExamLevel(2, "Expanded Problem Focused");
	static readonly DETAILED = new CodingResultExamLevel(3, "Detailed");
	static readonly COMPREHENSIVE = new CodingResultExamLevel(4, "Comprehensive");
	
	static readonly VALUES: GandalfConstantList<CodingResultExamLevel> = {
		label: 'Coding Result Exam Level',
		values: [CodingResultExamLevel.NONE, CodingResultExamLevel.PROBLEM_FOCUSED, CodingResultExamLevel.EXPANDED_PROBLEM_FOCUSED, CodingResultExamLevel.DETAILED, CodingResultExamLevel.COMPREHENSIVE, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultfinallevel.CodingResultFinalLevel */
/* istanbul ignore next */
export class CodingResultFinalLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultFinalLevel(0, "None");
	static readonly LEVEL_1 = new CodingResultFinalLevel(1, "Level 1");
	static readonly LEVEL_2 = new CodingResultFinalLevel(2, "Level 2");
	static readonly LEVEL_3 = new CodingResultFinalLevel(3, "Level 3");
	static readonly LEVEL_4 = new CodingResultFinalLevel(4, "Level 4");
	static readonly LEVEL_5 = new CodingResultFinalLevel(5, "Level 5");
	
	static readonly VALUES: GandalfConstantList<CodingResultFinalLevel> = {
		label: 'Coding Result Final Level',
		values: [CodingResultFinalLevel.NONE, CodingResultFinalLevel.LEVEL_1, CodingResultFinalLevel.LEVEL_2, CodingResultFinalLevel.LEVEL_3, CodingResultFinalLevel.LEVEL_4, CodingResultFinalLevel.LEVEL_5, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresulthistorylevel.CodingResultHistoryLevel */
/* istanbul ignore next */
export class CodingResultHistoryLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultHistoryLevel(0, "None");
	static readonly PROBLEM_FOCUSED = new CodingResultHistoryLevel(1, "Problem Focused");
	static readonly EXPANDED_PROBLEM_FOCUSED = new CodingResultHistoryLevel(2, "Expanded Problem Focused");
	static readonly DETAILED = new CodingResultHistoryLevel(3, "Detailed");
	static readonly COMPREHENSIVE = new CodingResultHistoryLevel(4, "Comprehensive");
	
	static readonly VALUES: GandalfConstantList<CodingResultHistoryLevel> = {
		label: 'Coding Result History Level',
		values: [CodingResultHistoryLevel.NONE, CodingResultHistoryLevel.PROBLEM_FOCUSED, CodingResultHistoryLevel.EXPANDED_PROBLEM_FOCUSED, CodingResultHistoryLevel.DETAILED, CodingResultHistoryLevel.COMPREHENSIVE, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresulthpilevel.CodingResultHpiLevel */
/* istanbul ignore next */
export class CodingResultHpiLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultHpiLevel(0, "None");
	static readonly BRIEF = new CodingResultHpiLevel(1, "Brief");
	static readonly EXTENDED = new CodingResultHpiLevel(2, "Extended");
	
	static readonly VALUES: GandalfConstantList<CodingResultHpiLevel> = {
		label: 'Coding Result HPI Level',
		values: [CodingResultHpiLevel.NONE, CodingResultHpiLevel.BRIEF, CodingResultHpiLevel.EXTENDED, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultmdmcomplexitylevel.CodingResultMdmComplexityLevel */
/* istanbul ignore next */
export class CodingResultMdmComplexityLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultMdmComplexityLevel(0, "None");
	static readonly MINIMAL = new CodingResultMdmComplexityLevel(1, "Minimal");
	static readonly LIMITED = new CodingResultMdmComplexityLevel(2, "Limited");
	static readonly MODERATE = new CodingResultMdmComplexityLevel(3, "Moderate");
	static readonly EXTENSIVE = new CodingResultMdmComplexityLevel(4, "Extensive");
	
	static readonly VALUES: GandalfConstantList<CodingResultMdmComplexityLevel> = {
		label: 'Coding Result MDM Complexity Level',
		values: [CodingResultMdmComplexityLevel.NONE, CodingResultMdmComplexityLevel.MINIMAL, CodingResultMdmComplexityLevel.LIMITED, CodingResultMdmComplexityLevel.MODERATE, CodingResultMdmComplexityLevel.EXTENSIVE, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultmdmdiagnosislevel.CodingResultMdmDiagnosisLevel */
/* istanbul ignore next */
export class CodingResultMdmDiagnosisLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultMdmDiagnosisLevel(0, "None");
	static readonly MINIMAL = new CodingResultMdmDiagnosisLevel(1, "Minimal");
	static readonly LOW = new CodingResultMdmDiagnosisLevel(2, "Low");
	static readonly MODERATE = new CodingResultMdmDiagnosisLevel(3, "Moderate");
	static readonly HIGH = new CodingResultMdmDiagnosisLevel(4, "High");
	
	static readonly VALUES: GandalfConstantList<CodingResultMdmDiagnosisLevel> = {
		label: 'Coding Result MDM Diagnosis Level',
		values: [CodingResultMdmDiagnosisLevel.NONE, CodingResultMdmDiagnosisLevel.MINIMAL, CodingResultMdmDiagnosisLevel.LOW, CodingResultMdmDiagnosisLevel.MODERATE, CodingResultMdmDiagnosisLevel.HIGH, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultmdmlevel.CodingResultMdmLevel */
/* istanbul ignore next */
export class CodingResultMdmLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultMdmLevel(0, "None");
	static readonly STRAIGHT_FORWARD = new CodingResultMdmLevel(1, "Straight Forward");
	static readonly LOW_COMPLEXITY = new CodingResultMdmLevel(2, "Low Complexity");
	static readonly MODERATE_COMPLEXITY = new CodingResultMdmLevel(3, "Moderate Complexity");
	static readonly HIGH_COMPLEXITY = new CodingResultMdmLevel(4, "High Complexity");
	
	static readonly VALUES: GandalfConstantList<CodingResultMdmLevel> = {
		label: 'Coding Result MDM Level',
		values: [CodingResultMdmLevel.NONE, CodingResultMdmLevel.STRAIGHT_FORWARD, CodingResultMdmLevel.LOW_COMPLEXITY, CodingResultMdmLevel.MODERATE_COMPLEXITY, CodingResultMdmLevel.HIGH_COMPLEXITY, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultmdmrisklevel.CodingResultMdmRiskLevel */
/* istanbul ignore next */
export class CodingResultMdmRiskLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultMdmRiskLevel(0, "None");
	static readonly LOW = new CodingResultMdmRiskLevel(1, "Low");
	static readonly MINIMAL = new CodingResultMdmRiskLevel(2, "Minimal");
	static readonly MODERATE = new CodingResultMdmRiskLevel(3, "Moderate");
	static readonly HIGH = new CodingResultMdmRiskLevel(4, "High");
	
	static readonly VALUES: GandalfConstantList<CodingResultMdmRiskLevel> = {
		label: 'Coding Result MDM Risk Level',
		values: [CodingResultMdmRiskLevel.NONE, CodingResultMdmRiskLevel.LOW, CodingResultMdmRiskLevel.MINIMAL, CodingResultMdmRiskLevel.MODERATE, CodingResultMdmRiskLevel.HIGH, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultpfshlevel.CodingResultPfshLevel */
/* istanbul ignore next */
export class CodingResultPfshLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultPfshLevel(0, "None");
	static readonly PERTINENT = new CodingResultPfshLevel(1, "Pertinent");
	static readonly COMPLETE = new CodingResultPfshLevel(2, "Complete");
	
	static readonly VALUES: GandalfConstantList<CodingResultPfshLevel> = {
		label: 'Coding Result PFSH Level',
		values: [CodingResultPfshLevel.NONE, CodingResultPfshLevel.PERTINENT, CodingResultPfshLevel.COMPLETE, ]
	};
}

/** see com.rev360.model.encounter.constant.codingresultroslevel.CodingResultRosLevel */
/* istanbul ignore next */
export class CodingResultRosLevel extends GandalfConstant<number> {
	static readonly NONE = new CodingResultRosLevel(0, "None");
	static readonly PERTINENT = new CodingResultRosLevel(1, "Pertinent");
	static readonly EXTENDED = new CodingResultRosLevel(2, "Extended");
	static readonly COMPLETE = new CodingResultRosLevel(3, "Complete");
	
	static readonly VALUES: GandalfConstantList<CodingResultRosLevel> = {
		label: 'Coding Result ROS Level',
		values: [CodingResultRosLevel.NONE, CodingResultRosLevel.PERTINENT, CodingResultRosLevel.EXTENDED, CodingResultRosLevel.COMPLETE, ]
	};
}

/** see com.rev360.model.common.constant.communicationmechanismtype.CommunicationMechanismType */
/* istanbul ignore next */
export class CommunicationMechanismType extends GandalfConstant<number> {
	static readonly PHONE = new CommunicationMechanismType(1, "Phone");
	static readonly EMAIL = new CommunicationMechanismType(2, "Email");
	static readonly FAX = new CommunicationMechanismType(3, "Fax");
	static readonly TEXT = new CommunicationMechanismType(4, "Text");
	static readonly INSTANT_MESSAGING = new CommunicationMechanismType(5, "Instant Messaging");
	static readonly IN_PERSON = new CommunicationMechanismType(6, "In Person");
	static readonly MAIL = new CommunicationMechanismType(7, "Mail");
	
	static readonly VALUES: GandalfConstantList<CommunicationMechanismType> = {
		label: 'Communication Mechanism Type',
		values: [CommunicationMechanismType.PHONE, CommunicationMechanismType.EMAIL, CommunicationMechanismType.FAX, CommunicationMechanismType.TEXT, CommunicationMechanismType.INSTANT_MESSAGING, CommunicationMechanismType.IN_PERSON, CommunicationMechanismType.MAIL, ]
	};
}

/** see com.rev360.connect.service.patient.CommunicationMethod */
/* istanbul ignore next */
export class CommunicationMethod extends GandalfConstant<number> {
	static readonly EMAIL = new CommunicationMethod(1, "Email Messages");
	static readonly TEXT = new CommunicationMethod(2, "Text Messages");
	static readonly HOME_PHONE = new CommunicationMethod(3, "Home Phone Calls");
	static readonly WORK_PHONE = new CommunicationMethod(4, "Work Phone Calls");
	static readonly CELL_PHONE = new CommunicationMethod(5, "Cell Phone Calls");
	static readonly MAIL = new CommunicationMethod(6, "Mail");
	
	static readonly VALUES: GandalfConstantList<CommunicationMethod> = {
		label: 'Communication Method',
		values: [CommunicationMethod.EMAIL, CommunicationMethod.TEXT, CommunicationMethod.HOME_PHONE, CommunicationMethod.WORK_PHONE, CommunicationMethod.CELL_PHONE, CommunicationMethod.MAIL, ]
	};
}

/** see com.rev360.model.patient.constant.communicationpreferencesdonotcall.CommunicationPreferencesDoNotCall */
/* istanbul ignore next */
export class CommunicationPreferencesDoNotCall extends GandalfConstant<number> {
	static readonly UNKNOWN = new CommunicationPreferencesDoNotCall(0, "Unknown");
	static readonly YES = new CommunicationPreferencesDoNotCall(1, "Yes");
	static readonly NO = new CommunicationPreferencesDoNotCall(2, "No");
	
	static readonly VALUES: GandalfConstantList<CommunicationPreferencesDoNotCall> = {
		label: 'Communication Preferences Do-Not-Call',
		values: [CommunicationPreferencesDoNotCall.UNKNOWN, CommunicationPreferencesDoNotCall.YES, CommunicationPreferencesDoNotCall.NO, ]
	};
}

/** see com.rev360.model.practice.constant.connectbusinesstype.ConnectBusinessType */
/* istanbul ignore next */
export class ConnectBusinessType extends GandalfConstant<number> {
	static readonly SOLE_PROPRIETORSHIP = new ConnectBusinessType(1, "Sole Proprietorship");
	static readonly PARTNERSHIP = new ConnectBusinessType(2, "Partnership");
	static readonly LIMITED_LIABILITY_CORPORATION = new ConnectBusinessType(3, "Limited Liability Corporation");
	static readonly CO_OPERATIVE = new ConnectBusinessType(4, "Co-operative");
	static readonly NON_PROFIT_CORPORATION = new ConnectBusinessType(5, "Non-profit Corporation");
	static readonly CORPORATION = new ConnectBusinessType(6, "Corporation");
	
	static readonly VALUES: GandalfConstantList<ConnectBusinessType> = {
		label: 'Connect Business Type',
		values: [ConnectBusinessType.SOLE_PROPRIETORSHIP, ConnectBusinessType.PARTNERSHIP, ConnectBusinessType.LIMITED_LIABILITY_CORPORATION, ConnectBusinessType.CO_OPERATIVE, ConnectBusinessType.NON_PROFIT_CORPORATION, ConnectBusinessType.CORPORATION, ]
	};
}

/** see com.rev360.model.connect.campaign.constant.connectcampaignmessagestatus.ConnectCampaignMessageStatus */
/* istanbul ignore next */
export class ConnectCampaignMessageStatus extends GandalfConstant<number> {
	static readonly SCHEDULED = new ConnectCampaignMessageStatus(1, "Scheduled");
	static readonly QUEUED = new ConnectCampaignMessageStatus(2, "Queued");
	static readonly PROCESSING = new ConnectCampaignMessageStatus(3, "Processing");
	static readonly ERROR = new ConnectCampaignMessageStatus(4, "Error");
	static readonly SENT = new ConnectCampaignMessageStatus(5, "Sent");
	static readonly OPENED = new ConnectCampaignMessageStatus(6, "Opened");
	static readonly UNDELIVERABLE = new ConnectCampaignMessageStatus(7, "Undeliverable");
	static readonly OPTED_OUT = new ConnectCampaignMessageStatus(8, "Opted-Out");
	static readonly NOT_ELIGIBLE = new ConnectCampaignMessageStatus(9, "Not Eligible");
	static readonly DELIVERED = new ConnectCampaignMessageStatus(10, "Delivered");
	
	static readonly VALUES: GandalfConstantList<ConnectCampaignMessageStatus> = {
		label: 'Connect Campaign Message Status',
		values: [ConnectCampaignMessageStatus.SCHEDULED, ConnectCampaignMessageStatus.QUEUED, ConnectCampaignMessageStatus.PROCESSING, ConnectCampaignMessageStatus.ERROR, ConnectCampaignMessageStatus.SENT, ConnectCampaignMessageStatus.OPENED, ConnectCampaignMessageStatus.UNDELIVERABLE, ConnectCampaignMessageStatus.OPTED_OUT, ConnectCampaignMessageStatus.NOT_ELIGIBLE, ConnectCampaignMessageStatus.DELIVERED, ]
	};
}

/** see com.rev360.model.connect.campaign.constant.connectcampaignstatus.ConnectCampaignStatus */
/* istanbul ignore next */
export class ConnectCampaignStatus extends GandalfConstant<number> {
	static readonly DRAFT = new ConnectCampaignStatus(0, "Draft");
	static readonly SCHEDULED = new ConnectCampaignStatus(1, "Scheduled");
	static readonly IN_PROGRESS = new ConnectCampaignStatus(2, "In Process");
	static readonly SENT = new ConnectCampaignStatus(3, "Sent");
	static readonly ERROR = new ConnectCampaignStatus(4, "Error");
	static readonly DELETED = new ConnectCampaignStatus(5, "Deleted");
	
	static readonly VALUES: GandalfConstantList<ConnectCampaignStatus> = {
		label: 'Connect Campaign Status',
		values: [ConnectCampaignStatus.DRAFT, ConnectCampaignStatus.SCHEDULED, ConnectCampaignStatus.IN_PROGRESS, ConnectCampaignStatus.SENT, ConnectCampaignStatus.ERROR, ConnectCampaignStatus.DELETED, ]
	};
}

/** see com.rev360.connect.service.connect.campaign.ConnectCampaignTemplateToken */
/* istanbul ignore next */
export class ConnectCampaignTemplateToken extends GandalfConstant<string> {
	static readonly PRACTICE_NAME = new ConnectCampaignTemplateToken('{{practice.name}}', "Practice Name");
	static readonly PRACTICE_WEBSITE = new ConnectCampaignTemplateToken('{{practice.website}}', "Practice Website");
	static readonly PATIENT_FIRST_NAME = new ConnectCampaignTemplateToken('{{patient.firstName}}', "Patient First Name");
	static readonly PATIENT_LAST_NAME = new ConnectCampaignTemplateToken('{{patient.lastName}}', "Patient Last Name");
	static readonly PATIENT_PROVIDER_FIRST_NAME = new ConnectCampaignTemplateToken('{{patient.provider.firstName}}', "Patient Provider First Name");
	static readonly PATIENT_PROVIDER_LAST_NAME = new ConnectCampaignTemplateToken('{{patient.provider.lastName}}', "Patient Provider Last Name");
	static readonly PATIENT_PROVIDER_CREDENTIALS = new ConnectCampaignTemplateToken('{{patient.provider.credentials}}', "Patient Provider Credentials");
	static readonly PHR_LINK = new ConnectCampaignTemplateToken('{{phr.link}}', "PHR Link");
	static readonly LOCATION_NAME = new ConnectCampaignTemplateToken('{{location.name}}', "Location Name");
	static readonly LOCATION_ADDRESS_1 = new ConnectCampaignTemplateToken('{{location.address1}}', "Location Address 1");
	static readonly LOCATION_ADDRESS_2 = new ConnectCampaignTemplateToken('{{location.address2}}', "Location Address 2");
	static readonly LOCATION_CITY = new ConnectCampaignTemplateToken('{{location.city}}', "Location City");
	static readonly LOCATION_STATE = new ConnectCampaignTemplateToken('{{location.state}}', "Location State");
	static readonly LOCATION_POSTAL_CODE = new ConnectCampaignTemplateToken('{{location.postalCode}}', "Location Postal Code");
	static readonly LOCATION_PHONE = new ConnectCampaignTemplateToken('{{location.phone}}', "Location Phone");
	static readonly LOCATION_OFFICE_HOURS = new ConnectCampaignTemplateToken('{{location.officeHours}}', "Location Office Hours");
	static readonly LOCATION_LOGO = new ConnectCampaignTemplateToken('{{location.logo}}', "Location Logo");
	static readonly LOCATION_WEBSITE = new ConnectCampaignTemplateToken('{{location.website}}', "Location Website");
	
	static readonly VALUES: GandalfConstantList<ConnectCampaignTemplateToken> = {
		label: 'Connect Template Token',
		values: [ConnectCampaignTemplateToken.PRACTICE_NAME, ConnectCampaignTemplateToken.PRACTICE_WEBSITE, ConnectCampaignTemplateToken.PATIENT_FIRST_NAME, ConnectCampaignTemplateToken.PATIENT_LAST_NAME, ConnectCampaignTemplateToken.PATIENT_PROVIDER_FIRST_NAME, ConnectCampaignTemplateToken.PATIENT_PROVIDER_LAST_NAME, ConnectCampaignTemplateToken.PATIENT_PROVIDER_CREDENTIALS, ConnectCampaignTemplateToken.PHR_LINK, ConnectCampaignTemplateToken.LOCATION_NAME, ConnectCampaignTemplateToken.LOCATION_ADDRESS_1, ConnectCampaignTemplateToken.LOCATION_ADDRESS_2, ConnectCampaignTemplateToken.LOCATION_CITY, ConnectCampaignTemplateToken.LOCATION_STATE, ConnectCampaignTemplateToken.LOCATION_POSTAL_CODE, ConnectCampaignTemplateToken.LOCATION_PHONE, ConnectCampaignTemplateToken.LOCATION_OFFICE_HOURS, ConnectCampaignTemplateToken.LOCATION_LOGO, ConnectCampaignTemplateToken.LOCATION_WEBSITE, ]
	};
}

/** see com.rev360.model.practice.constant.connectcompanytype.ConnectCompanyType */
/* istanbul ignore next */
export class ConnectCompanyType extends GandalfConstant<number> {
	static readonly PRIVATE = new ConnectCompanyType(1, "Private");
	static readonly PUBLIC = new ConnectCompanyType(2, "Public");
	static readonly NON_PROFIT = new ConnectCompanyType(3, "Non-profit");
	static readonly GOVERNMENT = new ConnectCompanyType(4, "Government");
	
	static readonly VALUES: GandalfConstantList<ConnectCompanyType> = {
		label: 'Connect Company Type',
		values: [ConnectCompanyType.PRIVATE, ConnectCompanyType.PUBLIC, ConnectCompanyType.NON_PROFIT, ConnectCompanyType.GOVERNMENT, ]
	};
}

/** see com.rev360.model.connect.conversation.constant.connectconversationclassification.ConnectConversationClassification */
/* istanbul ignore next */
export class ConnectConversationClassification extends GandalfConstant<number> {
	static readonly ACTIVE = new ConnectConversationClassification(1, "Active");
	static readonly SPAM = new ConnectConversationClassification(2, "Spam");
	static readonly ARCHIVED = new ConnectConversationClassification(3, "Archived");
	
	static readonly VALUES: GandalfConstantList<ConnectConversationClassification> = {
		label: 'Connect Conversation Classification',
		values: [ConnectConversationClassification.ACTIVE, ConnectConversationClassification.SPAM, ConnectConversationClassification.ARCHIVED, ]
	};
}

/** see com.rev360.model.connect.conversation.constant.connectconversationmessageprocessorstatus.ConnectConversationMessageProcessorStatus */
/* istanbul ignore next */
export class ConnectConversationMessageProcessorStatus extends GandalfConstant<number> {
	static readonly PENDING = new ConnectConversationMessageProcessorStatus(1, "Pending");
	static readonly QUEUED = new ConnectConversationMessageProcessorStatus(2, "Queued");
	static readonly PROCESSING = new ConnectConversationMessageProcessorStatus(3, "Processing");
	static readonly COMPLETE = new ConnectConversationMessageProcessorStatus(4, "Complete");
	static readonly FAILURE = new ConnectConversationMessageProcessorStatus(5, "Failure");
	
	static readonly VALUES: GandalfConstantList<ConnectConversationMessageProcessorStatus> = {
		label: 'Connect Conversation Message Processor Status',
		values: [ConnectConversationMessageProcessorStatus.PENDING, ConnectConversationMessageProcessorStatus.QUEUED, ConnectConversationMessageProcessorStatus.PROCESSING, ConnectConversationMessageProcessorStatus.COMPLETE, ConnectConversationMessageProcessorStatus.FAILURE, ]
	};
}

/** see com.rev360.model.connect.conversation.constant.connectconversationmessagestatus.ConnectConversationMessageStatus */
/* istanbul ignore next */
export class ConnectConversationMessageStatus extends GandalfConstant<number> {
	static readonly SENT = new ConnectConversationMessageStatus(1, "Sent");
	static readonly FAILED = new ConnectConversationMessageStatus(2, "Failed");
	static readonly RECEIVED = new ConnectConversationMessageStatus(3, "Received");
	
	static readonly VALUES: GandalfConstantList<ConnectConversationMessageStatus> = {
		label: 'Connect Conversation Message Status',
		values: [ConnectConversationMessageStatus.SENT, ConnectConversationMessageStatus.FAILED, ConnectConversationMessageStatus.RECEIVED, ]
	};
}

/** see com.rev360.model.connect.conversation.constant.connectconversationreadstatus.ConnectConversationReadStatus */
/* istanbul ignore next */
export class ConnectConversationReadStatus extends GandalfConstant<number> {
	static readonly READ = new ConnectConversationReadStatus(1, "Read");
	static readonly UNREAD = new ConnectConversationReadStatus(2, "Unread");
	
	static readonly VALUES: GandalfConstantList<ConnectConversationReadStatus> = {
		label: 'Connect Conversation Read Status',
		values: [ConnectConversationReadStatus.READ, ConnectConversationReadStatus.UNREAD, ]
	};
}

/** see com.rev360.model.connect.conversation.constant.connectconversationresolutionstatus.ConnectConversationResolutionStatus */
/* istanbul ignore next */
export class ConnectConversationResolutionStatus extends GandalfConstant<number> {
	static readonly RESOLVED = new ConnectConversationResolutionStatus(1, "Resolved");
	static readonly UNRESOLVED = new ConnectConversationResolutionStatus(2, "Unresolved");
	
	static readonly VALUES: GandalfConstantList<ConnectConversationResolutionStatus> = {
		label: 'Connect Conversation Resolution Status',
		values: [ConnectConversationResolutionStatus.RESOLVED, ConnectConversationResolutionStatus.UNRESOLVED, ]
	};
}

/** see com.rev360.model.connect.conversation.constant.connectconversationsendertype.ConnectConversationSenderType */
/* istanbul ignore next */
export class ConnectConversationSenderType extends GandalfConstant<number> {
	static readonly PATIENT = new ConnectConversationSenderType(1, "Patient");
	static readonly EMPLOYEE = new ConnectConversationSenderType(2, "Employee");
	static readonly SYSTEM = new ConnectConversationSenderType(3, "System");
	
	static readonly VALUES: GandalfConstantList<ConnectConversationSenderType> = {
		label: 'Connect Conversation Sender Type',
		values: [ConnectConversationSenderType.PATIENT, ConnectConversationSenderType.EMPLOYEE, ConnectConversationSenderType.SYSTEM, ]
	};
}

/** see com.rev360.model.connect.constant.connectintervalitemtype.ConnectIntervalItemType */
/* istanbul ignore next */
export class ConnectIntervalItemType extends GandalfConstant<number> {
	static readonly MINUTES = new ConnectIntervalItemType(1, "Minutes");
	static readonly HOURS = new ConnectIntervalItemType(2, "Hours");
	static readonly DAYS = new ConnectIntervalItemType(3, "Days");
	static readonly WEEKS = new ConnectIntervalItemType(4, "Weeks");
	
	static readonly VALUES: GandalfConstantList<ConnectIntervalItemType> = {
		label: 'Connect Interval Item Type',
		values: [ConnectIntervalItemType.MINUTES, ConnectIntervalItemType.HOURS, ConnectIntervalItemType.DAYS, ConnectIntervalItemType.WEEKS, ]
	};
}

/** see com.rev360.model.connect.constant.connectmessagecategory.ConnectMessageCategory */
/* istanbul ignore next */
export class ConnectMessageCategory extends GandalfConstant<number> {
	static readonly APPOINTMENT = new ConnectMessageCategory(1, "Appointment");
	static readonly RECALL = new ConnectMessageCategory(2, "Recall");
	static readonly RECARE = new ConnectMessageCategory(3, "Recare");
	static readonly ORDER = new ConnectMessageCategory(4, "Order");
	static readonly BIRTHDAY = new ConnectMessageCategory(5, "Birthday");
	static readonly WAITLIST = new ConnectMessageCategory(6, "Waitlist");
	
	static readonly VALUES: GandalfConstantList<ConnectMessageCategory> = {
		label: 'Connect Message Category',
		values: [ConnectMessageCategory.APPOINTMENT, ConnectMessageCategory.RECALL, ConnectMessageCategory.RECARE, ConnectMessageCategory.ORDER, ConnectMessageCategory.BIRTHDAY, ConnectMessageCategory.WAITLIST, ]
	};
}

/** see com.rev360.model.connect.constant.connectmessagemethod.ConnectMessageMethod */
/* istanbul ignore next */
export class ConnectMessageMethod extends GandalfConstant<number> {
	static readonly EMAIL = new ConnectMessageMethod(1, "Email");
	static readonly SMS = new ConnectMessageMethod(2, "Text");
	
	static readonly VALUES: GandalfConstantList<ConnectMessageMethod> = {
		label: 'Method',
		values: [ConnectMessageMethod.EMAIL, ConnectMessageMethod.SMS, ]
	};
}

/** see com.rev360.model.connect.constant.connectmessagequeuestatus.ConnectMessageQueueStatus */
/* istanbul ignore next */
export class ConnectMessageQueueStatus extends GandalfConstant<number> {
	static readonly PENDING = new ConnectMessageQueueStatus(1, "Pending");
	static readonly SENDING = new ConnectMessageQueueStatus(2, "Sending");
	static readonly SENT = new ConnectMessageQueueStatus(3, "Sent");
	static readonly ERROR = new ConnectMessageQueueStatus(4, "Error");
	
	static readonly VALUES: GandalfConstantList<ConnectMessageQueueStatus> = {
		label: 'Queue Status',
		values: [ConnectMessageQueueStatus.PENDING, ConnectMessageQueueStatus.SENDING, ConnectMessageQueueStatus.SENT, ConnectMessageQueueStatus.ERROR, ]
	};
}

/** see com.rev360.model.connect.constant.connectmessagesource.ConnectMessageSource */
/* istanbul ignore next */
export class ConnectMessageSource extends GandalfConstant<number> {
	static readonly MANUAL = new ConnectMessageSource(1, "Manual");
	static readonly AUTOMATIC = new ConnectMessageSource(2, "Automatic");
	
	static readonly VALUES: GandalfConstantList<ConnectMessageSource> = {
		label: 'Source',
		values: [ConnectMessageSource.MANUAL, ConnectMessageSource.AUTOMATIC, ]
	};
}

/** see com.rev360.model.connect.constant.connectmessagestatus.ConnectMessageStatus */
/* istanbul ignore next */
export class ConnectMessageStatus extends GandalfConstant<number> {
	static readonly PENDING = new ConnectMessageStatus(1, "Pending");
	static readonly SENT = new ConnectMessageStatus(2, "Sent");
	static readonly OPENED = new ConnectMessageStatus(3, "Opened");
	static readonly UNDELIVERABLE = new ConnectMessageStatus(4, "Undeliverable");
	static readonly OPTED_OUT = new ConnectMessageStatus(5, "Opted-Out");
	
	static readonly VALUES: GandalfConstantList<ConnectMessageStatus> = {
		label: 'Status',
		values: [ConnectMessageStatus.PENDING, ConnectMessageStatus.SENT, ConnectMessageStatus.OPENED, ConnectMessageStatus.UNDELIVERABLE, ConnectMessageStatus.OPTED_OUT, ]
	};
}

/** see com.rev360.model.connect.constant.connectmessageundesirablestatus.ConnectMessageUndesirableStatus */
/* istanbul ignore next */
export class ConnectMessageUndesirableStatus extends GandalfConstant<number> {
	static readonly UNDESIRABLE = new ConnectMessageUndesirableStatus(0, "Undesirable");
	static readonly DESIRABLE = new ConnectMessageUndesirableStatus(1, "Desirable");
	
	static readonly VALUES: GandalfConstantList<ConnectMessageUndesirableStatus> = {
		label: 'Undesirable Status',
		values: [ConnectMessageUndesirableStatus.UNDESIRABLE, ConnectMessageUndesirableStatus.DESIRABLE, ]
	};
}

/** see com.rev360.model.connect.constant.connectsettingsrecareperiod.ConnectSettingsRecarePeriod */
/* istanbul ignore next */
export class ConnectSettingsRecarePeriod extends GandalfConstant<number> {
	static readonly RECARE_6_MONTHS = new ConnectSettingsRecarePeriod(1, "6 months");
	static readonly RECARE_12_MONTHS = new ConnectSettingsRecarePeriod(2, "12 months");
	static readonly RECARE_18_MONTHS = new ConnectSettingsRecarePeriod(3, "18 months");
	static readonly RECARE_24_MONTHS = new ConnectSettingsRecarePeriod(4, "24 months");
	static readonly RECARE_36_MONTHS = new ConnectSettingsRecarePeriod(5, "36 months");
	
	static readonly VALUES: GandalfConstantList<ConnectSettingsRecarePeriod> = {
		label: 'Connect Settings Recare Period',
		values: [ConnectSettingsRecarePeriod.RECARE_6_MONTHS, ConnectSettingsRecarePeriod.RECARE_12_MONTHS, ConnectSettingsRecarePeriod.RECARE_18_MONTHS, ConnectSettingsRecarePeriod.RECARE_24_MONTHS, ConnectSettingsRecarePeriod.RECARE_36_MONTHS, ]
	};
}

/** see com.rev360.model.connect.constant.connecttemplatecategory.ConnectTemplateCategory */
/* istanbul ignore next */
export class ConnectTemplateCategory extends GandalfConstant<number> {
	static readonly APPOINTMENT = new ConnectTemplateCategory(1, "Appointment");
	static readonly RECALL = new ConnectTemplateCategory(2, "Recall");
	static readonly RECARE = new ConnectTemplateCategory(3, "Recare");
	static readonly ORDER = new ConnectTemplateCategory(4, "Order");
	static readonly BIRTHDAY = new ConnectTemplateCategory(5, "Birthday");
	static readonly WAITLIST = new ConnectTemplateCategory(6, "Waitlist");
	static readonly CONFIRMED_APPOINTMENT = new ConnectTemplateCategory(8, "Confirmed Appointment");
	
	static readonly VALUES: GandalfConstantList<ConnectTemplateCategory> = {
		label: 'Connect Template Category',
		values: [ConnectTemplateCategory.APPOINTMENT, ConnectTemplateCategory.RECALL, ConnectTemplateCategory.RECARE, ConnectTemplateCategory.ORDER, ConnectTemplateCategory.BIRTHDAY, ConnectTemplateCategory.WAITLIST, ConnectTemplateCategory.CONFIRMED_APPOINTMENT, ]
	};
}

/** see com.rev360.model.history.constant.contactlenshistorypackaging.ContactLensHistoryPackaging */
/* istanbul ignore next */
export class ContactLensHistoryPackaging extends GandalfConstant<number> {
	static readonly UNKNOWN = new ContactLensHistoryPackaging(0, "Unknown");
	static readonly LENS = new ContactLensHistoryPackaging(1, "Lens");
	static readonly BOX = new ContactLensHistoryPackaging(2, "Box");
	
	static readonly VALUES: GandalfConstantList<ContactLensHistoryPackaging> = {
		label: 'Contact Lens History Packaging',
		values: [ContactLensHistoryPackaging.UNKNOWN, ContactLensHistoryPackaging.LENS, ContactLensHistoryPackaging.BOX, ]
	};
}

/** see com.rev360.model.history.constant.contactlenshistorytype.ContactLensHistoryType */
/* istanbul ignore next */
export class ContactLensHistoryType extends GandalfConstant<number> {
	static readonly UNKNOWN = new ContactLensHistoryType(0, "Unknown");
	static readonly SOFT = new ContactLensHistoryType(1, "Soft");
	static readonly RGP = new ContactLensHistoryType(2, "RGP");
	static readonly HYBRID = new ContactLensHistoryType(3, "Hybrid");
	
	static readonly VALUES: GandalfConstantList<ContactLensHistoryType> = {
		label: 'Contact Lens History Type',
		values: [ContactLensHistoryType.UNKNOWN, ContactLensHistoryType.SOFT, ContactLensHistoryType.RGP, ContactLensHistoryType.HYBRID, ]
	};
}

/** see com.rev360.model.prescription.constant.contactlensmodality.ContactLensModality */
/* istanbul ignore next */
export class ContactLensModality extends GandalfConstant<number> {
	static readonly UNKNOWN = new ContactLensModality(0, "Unknown");
	static readonly CONTINUOUS_WEAR = new ContactLensModality(1, "Continuous Wear");
	static readonly DAILY_WEAR = new ContactLensModality(2, "Daily Wear");
	
	static readonly VALUES: GandalfConstantList<ContactLensModality> = {
		label: 'Contact Lens Modality',
		values: [ContactLensModality.UNKNOWN, ContactLensModality.CONTINUOUS_WEAR, ContactLensModality.DAILY_WEAR, ]
	};
}

/** see com.rev360.model.inventory.contactlenses.constant.contactlenspackagetype.ContactLensPackageType */
/* istanbul ignore next */
export class ContactLensPackageType extends GandalfConstant<number> {
	static readonly BLISTER = new ContactLensPackageType(1, "Blister");
	static readonly VIAL = new ContactLensPackageType(2, "Vial");
	static readonly BOX = new ContactLensPackageType(3, "Box");
	
	static readonly VALUES: GandalfConstantList<ContactLensPackageType> = {
		label: 'Contact Lens Package Type',
		values: [ContactLensPackageType.BLISTER, ContactLensPackageType.VIAL, ContactLensPackageType.BOX, ]
	};
}

/** see com.rev360.model.prescription.constant.contactlensprescriptiontype.ContactLensPrescriptionType */
/* istanbul ignore next */
export class ContactLensPrescriptionType extends GandalfConstant<number> {
	static readonly SOFT = new ContactLensPrescriptionType(1, "Soft");
	static readonly RGP = new ContactLensPrescriptionType(2, "RGP");
	static readonly HYBRID = new ContactLensPrescriptionType(3, "Hybrid");
	
	static readonly VALUES: GandalfConstantList<ContactLensPrescriptionType> = {
		label: 'Contact Lens Prescription Type',
		values: [ContactLensPrescriptionType.SOFT, ContactLensPrescriptionType.RGP, ContactLensPrescriptionType.HYBRID, ]
	};
}

/** see com.rev360.model.inventory.contactlenses.constant.contactlenstype.ContactLensType */
/* istanbul ignore next */
export class ContactLensType extends GandalfConstant<number> {
	static readonly UNKNOWN = new ContactLensType(0, "Unknown");
	static readonly SOFT = new ContactLensType(1, "Soft");
	static readonly RGP = new ContactLensType(2, "RGP");
	static readonly SYNERGEYES = new ContactLensType(3, "Hybrid");
	static readonly SOFTPERM = new ContactLensType(4, "Soft permeable");
	
	static readonly VALUES: GandalfConstantList<ContactLensType> = {
		label: 'Contact Lens Type',
		values: [ContactLensType.UNKNOWN, ContactLensType.SOFT, ContactLensType.RGP, ContactLensType.SYNERGEYES, ContactLensType.SOFTPERM, ]
	};
}

/** see com.rev360.pms.service.reporting.administration.constants.CqmSearchTypes */
/* istanbul ignore next */
export class CqmSearchTypes extends GandalfConstant<number> {
	static readonly PQRI = new CqmSearchTypes(0, "PQRI");
	static readonly CQM_PRIMARY = new CqmSearchTypes(1, "eCQM Primary");
	static readonly CQM_EXTENDED = new CqmSearchTypes(2, "eCQM Extended");
	static readonly CQM_AOA = new CqmSearchTypes(3, "AOA eCQM");
	static readonly MIPS_CQM_PRIMARY = new CqmSearchTypes(4, "Mips CQM Primary");
	static readonly IMPORT_CQM = new CqmSearchTypes(5, "Import CQM");
	
	static readonly VALUES: GandalfConstantList<CqmSearchTypes> = {
		label: 'Cqm Search Types',
		values: [CqmSearchTypes.PQRI, CqmSearchTypes.CQM_PRIMARY, CqmSearchTypes.CQM_EXTENDED, CqmSearchTypes.CQM_AOA, CqmSearchTypes.MIPS_CQM_PRIMARY, CqmSearchTypes.IMPORT_CQM, ]
	};
}

/** see com.rev360.model.practice.constant.creditcardtypes.CreditCardType */
/* istanbul ignore next */
export class CreditCardType extends GandalfConstant<number> {
	static readonly VISA = new CreditCardType(1, "Visa");
	static readonly MASTERCARD = new CreditCardType(2, "Mastercard");
	static readonly AMEX = new CreditCardType(3, "Amex");
	static readonly DISCOVER = new CreditCardType(4, "Discover");
	static readonly DINERS = new CreditCardType(5, "Diners");
	static readonly JCB = new CreditCardType(6, "JCB");
	static readonly EN_ROUTE = new CreditCardType(7, "EnRoute");
	static readonly DEBIT = new CreditCardType(8, "Debit");
	static readonly MILITARY = new CreditCardType(10, "Military Star");
	static readonly OTHER = new CreditCardType(9, "Other");
	
	static readonly VALUES: GandalfConstantList<CreditCardType> = {
		label: 'Credit Card Type',
		values: [CreditCardType.VISA, CreditCardType.MASTERCARD, CreditCardType.AMEX, CreditCardType.DISCOVER, CreditCardType.DINERS, CreditCardType.JCB, CreditCardType.EN_ROUTE, CreditCardType.DEBIT, CreditCardType.MILITARY, CreditCardType.OTHER, ]
	};
}

/** see com.rev360.model.accounting.constant.creditstatus.CreditStatus */
/* istanbul ignore next */
export class CreditStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new CreditStatus(1, "Applied");
	static readonly VOID = new CreditStatus(2, "Void");
	
	static readonly VALUES: GandalfConstantList<CreditStatus> = {
		label: 'Credit Status',
		values: [CreditStatus.ACTIVE, CreditStatus.VOID, ]
	};
}

/** see com.rev360.model.accounting.constant.credittype.CreditType */
/* istanbul ignore next */
export class CreditType extends GandalfConstant<number> {
	static readonly PATIENT = new CreditType(1, "Patient");
	static readonly INSURANCE = new CreditType(2, "Insurance");
	static readonly ANONYMOUS = new CreditType(3, "Anonymous");
	
	static readonly VALUES: GandalfConstantList<CreditType> = {
		label: 'Credit Type',
		values: [CreditType.PATIENT, CreditType.INSURANCE, CreditType.ANONYMOUS, ]
	};
}

/** see com.rev360.pms.service.document.CustomExamTemplateField */
/* istanbul ignore next */
export class CustomExamTemplateField extends GandalfConstant<string> {
	static readonly OD_RX = new CustomExamTemplateField('OD Rx', "OD Rx");
	static readonly OS_RX = new CustomExamTemplateField('OS Rx', "OS Rx");
	static readonly NOTE = new CustomExamTemplateField('Test Note', "Test Note");
	
	static readonly VALUES: GandalfConstantList<CustomExamTemplateField> = {
		label: 'Custom Exam Template Field',
		values: [CustomExamTemplateField.OD_RX, CustomExamTemplateField.OS_RX, CustomExamTemplateField.NOTE, ]
	};
}

/** see com.rev360.core.service.query.CustomReportsMasterCategory */
/* istanbul ignore next */
export class CustomReportsMasterCategory extends GandalfConstant<number> {
	static readonly PATIENTS = new CustomReportsMasterCategory(2600, "Patients");
	static readonly SCHEDULE = new CustomReportsMasterCategory(2601, "Schedule");
	static readonly ACCOUNTING = new CustomReportsMasterCategory(2602, "Accounting");
	static readonly ORDERS = new CustomReportsMasterCategory(2603, "Orders");
	static readonly TASKS = new CustomReportsMasterCategory(2604, "Tasks");
	static readonly INVENTORY = new CustomReportsMasterCategory(2605, "Inventory");
	
	static readonly VALUES: GandalfConstantList<CustomReportsMasterCategory> = {
		label: 'Custom Reports Master Category',
		values: [CustomReportsMasterCategory.PATIENTS, CustomReportsMasterCategory.SCHEDULE, CustomReportsMasterCategory.ACCOUNTING, CustomReportsMasterCategory.ORDERS, CustomReportsMasterCategory.TASKS, CustomReportsMasterCategory.INVENTORY, ]
	};
}

/** see com.rev360.model.customer.constant.customerstatus.CustomerStatus */
/* istanbul ignore next */
export class CustomerStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new CustomerStatus(0, "Inactive");
	static readonly ACTIVE = new CustomerStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<CustomerStatus> = {
		label: 'Customer Status',
		values: [CustomerStatus.INACTIVE, CustomerStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.immunization.constant.cvxdetailstatus.CvxDetailStatus */
/* istanbul ignore next */
export class CvxDetailStatus extends GandalfConstant<string> {
	static readonly ACTIVE = new CvxDetailStatus('Active', "Active");
	static readonly INACTIVE = new CvxDetailStatus('Inactive', "Inactive");
	static readonly NON_US = new CvxDetailStatus('Non-US', "Non-US");
	static readonly NEVER_ACTIVE = new CvxDetailStatus('Never Active', "Never Active");
	
	static readonly VALUES: GandalfConstantList<CvxDetailStatus> = {
		label: 'Cvx Detail Status',
		values: [CvxDetailStatus.ACTIVE, CvxDetailStatus.INACTIVE, CvxDetailStatus.NON_US, CvxDetailStatus.NEVER_ACTIVE, ]
	};
}

/** see com.rev360.model.schedule.constant.dailypatterntype.DailyPatternType */
/* istanbul ignore next */
export class DailyPatternType extends GandalfConstant<number> {
	static readonly EVERY_X_DAYS = new DailyPatternType(1, "Every X Days");
	static readonly EVERY_WEEKDAY = new DailyPatternType(2, "Every Weekday");
	
	static readonly VALUES: GandalfConstantList<DailyPatternType> = {
		label: 'Daily Pattern Type',
		values: [DailyPatternType.EVERY_X_DAYS, DailyPatternType.EVERY_WEEKDAY, ]
	};
}

/** see com.rev360.model.data.constant.datalogaction.DataLogAction */
/* istanbul ignore next */
export class DataLogAction extends GandalfConstant<string> {
	static readonly UPDATE = new DataLogAction('U', "Update");
	static readonly INSERT = new DataLogAction('I', "Create");
	static readonly DELETE = new DataLogAction('D', "Delete");
	static readonly QUERY = new DataLogAction('Q', "Query");
	
	static readonly VALUES: GandalfConstantList<DataLogAction> = {
		label: 'Data Log Action',
		values: [DataLogAction.UPDATE, DataLogAction.INSERT, DataLogAction.DELETE, DataLogAction.QUERY, ]
	};
}

/** see com.rev360.model.data.constant.datalogsource.DataLogSource */
/* istanbul ignore next */
export class DataLogSource extends GandalfConstant<number> {
	static readonly PMS = new DataLogSource(1, "PMS");
	static readonly PHR = new DataLogSource(2, "PHR");
	static readonly CUSTOMER_CARE = new DataLogSource(3, "Customer Care");
	static readonly MYREV = new DataLogSource(4, "MyRev");
	static readonly API = new DataLogSource(5, "API");
	
	static readonly VALUES: GandalfConstantList<DataLogSource> = {
		label: 'Data Log Source',
		values: [DataLogSource.PMS, DataLogSource.PHR, DataLogSource.CUSTOMER_CARE, DataLogSource.MYREV, DataLogSource.API, ]
	};
}

/** see com.rev360.model.common.constant.daterange.DateRangeType */
/* istanbul ignore next */
export class DateRangeType extends GandalfConstant<number> {
	static readonly ANY = new DateRangeType(0, "Any");
	static readonly TODAY = new DateRangeType(1, "Today");
	static readonly YESTERDAY = new DateRangeType(30, "Yesterday");
	static readonly WEEK_TO_DATE = new DateRangeType(2, "Week-to-date");
	static readonly MONTH_TO_DATE = new DateRangeType(3, "Month-to-date");
	static readonly QUARTER_TO_DATE = new DateRangeType(4, "Quarter-to-date");
	static readonly YEAR_TO_DATE = new DateRangeType(5, "Year-to-date");
	static readonly LAST_WEEK = new DateRangeType(10, "Last week");
	static readonly LAST_MONTH = new DateRangeType(11, "Last month");
	static readonly LAST_QUARTER = new DateRangeType(12, "Last quarter");
	static readonly LAST_YEAR = new DateRangeType(13, "Last year");
	static readonly CUSTOM = new DateRangeType(20, "Custom");
	
	static readonly VALUES: GandalfConstantList<DateRangeType> = {
		label: 'Date Range Type',
		values: [DateRangeType.ANY, DateRangeType.TODAY, DateRangeType.YESTERDAY, DateRangeType.WEEK_TO_DATE, DateRangeType.MONTH_TO_DATE, DateRangeType.QUARTER_TO_DATE, DateRangeType.YEAR_TO_DATE, DateRangeType.LAST_WEEK, DateRangeType.LAST_MONTH, DateRangeType.LAST_QUARTER, DateRangeType.LAST_YEAR, DateRangeType.CUSTOM, ]
	};
}

/** see com.rev360.model.schedule.constant.dayselect.DaySelect */
/* istanbul ignore next */
export class DaySelect extends GandalfConstant<number> {
	static readonly DAY = new DaySelect(-3, "day");
	static readonly WEEK_DAY = new DaySelect(-2, "weekday");
	static readonly WEEKEND_DAY = new DaySelect(-1, "weekend day");
	static readonly SUNDAY = new DaySelect(1, "Sunday");
	static readonly MONDAY = new DaySelect(2, "Monday");
	static readonly TUESDAY = new DaySelect(3, "Tuesday");
	static readonly WEDNESDAY = new DaySelect(4, "Wednesday");
	static readonly THURSDAY = new DaySelect(5, "Thursday");
	static readonly FRIDAY = new DaySelect(6, "Friday");
	static readonly SATURDAY = new DaySelect(7, "Saturday");
	
	static readonly VALUES: GandalfConstantList<DaySelect> = {
		label: 'Day',
		values: [DaySelect.DAY, DaySelect.WEEK_DAY, DaySelect.WEEKEND_DAY, DaySelect.SUNDAY, DaySelect.MONDAY, DaySelect.TUESDAY, DaySelect.WEDNESDAY, DaySelect.THURSDAY, DaySelect.FRIDAY, DaySelect.SATURDAY, ]
	};
}

/** see com.rev360.pms.service.reporting.accounting.constants.depositsreporttype.DepositsReportType */
/* istanbul ignore next */
export class DepositsReportType extends GandalfConstant<string> {
	static readonly DEPOSITS_BY_PAYER = new DepositsReportType('depositsByPayor', "Deposits by Payer");
	static readonly DEPOSITS_BY_METHOD = new DepositsReportType('depositsByMethod', "Deposits by Method");
	static readonly DEPOSITS_BY_METHOD_CARD_TYPE = new DepositsReportType('depositsByMethodCardType', "Deposits by Method and Card Type");
	static readonly DEPOSITS_BY_METHOD_DETAILED = new DepositsReportType('depositsByMethodDetailed', "Deposits by Method with Details");
	static readonly DEPOSITS_BY_PROVIDER = new DepositsReportType('depositsByProvider', "Deposits by Provider");
	
	static readonly VALUES: GandalfConstantList<DepositsReportType> = {
		label: 'Deposits report type',
		values: [DepositsReportType.DEPOSITS_BY_PAYER, DepositsReportType.DEPOSITS_BY_METHOD, DepositsReportType.DEPOSITS_BY_METHOD_CARD_TYPE, DepositsReportType.DEPOSITS_BY_METHOD_DETAILED, DepositsReportType.DEPOSITS_BY_PROVIDER, ]
	};
}

/** see com.rev360.model.device.constant.devicemeasurementstatus.DeviceMeasurementStatus */
/* istanbul ignore next */
export class DeviceMeasurementStatus extends GandalfConstant<number> {
	static readonly UNASSIGNED = new DeviceMeasurementStatus(0, "Unassigned");
	static readonly PATIENT_ASSIGNED = new DeviceMeasurementStatus(1, "Patient Assigned");
	static readonly ORDER_ASSIGNED = new DeviceMeasurementStatus(2, "Order  Assigned");
	static readonly IGNORE = new DeviceMeasurementStatus(3, "Ignore");
	
	static readonly VALUES: GandalfConstantList<DeviceMeasurementStatus> = {
		label: 'DeviceMeasurementStatus',
		values: [DeviceMeasurementStatus.UNASSIGNED, DeviceMeasurementStatus.PATIENT_ASSIGNED, DeviceMeasurementStatus.ORDER_ASSIGNED, DeviceMeasurementStatus.IGNORE, ]
	};
}

/** see com.rev360.model.device.constant.devicemeasurementtemplatemasteridentifier.DeviceMeasurementTemplateMasterIdentifier */
/* istanbul ignore next */
export class DeviceMeasurementTemplateMasterIdentifier extends GandalfConstant<number> {
	static readonly ESSILOR_VISIOFFICE = new DeviceMeasurementTemplateMasterIdentifier(10, "VisiOffice Device Measurements");
	static readonly OPTIKAM = new DeviceMeasurementTemplateMasterIdentifier(20, "Optikam Device Measurements");
	
	static readonly VALUES: GandalfConstantList<DeviceMeasurementTemplateMasterIdentifier> = {
		label: 'DeviceMeasurementTemplateMasterIdentifier',
		values: [DeviceMeasurementTemplateMasterIdentifier.ESSILOR_VISIOFFICE, DeviceMeasurementTemplateMasterIdentifier.OPTIKAM, ]
	};
}

/** see com.rev360.model.diagnosis.constant.diagnosislocation.DiagnosisLocation */
/* istanbul ignore next */
export class DiagnosisLocation extends GandalfConstant<number> {
	static readonly NOT_APPLICABLE = new DiagnosisLocation(-1, "");
	static readonly UNKNOWN_EYE = new DiagnosisLocation(0, "N/A");
	static readonly RIGHT_EYE = new DiagnosisLocation(1, "OD");
	static readonly LEFT_EYE = new DiagnosisLocation(2, "OS");
	static readonly BOTH_EYES = new DiagnosisLocation(3, "OU");
	
	static readonly VALUES: GandalfConstantList<DiagnosisLocation> = {
		label: 'Diagnosis Location',
		values: [DiagnosisLocation.NOT_APPLICABLE, DiagnosisLocation.UNKNOWN_EYE, DiagnosisLocation.RIGHT_EYE, DiagnosisLocation.LEFT_EYE, DiagnosisLocation.BOTH_EYES, ]
	};
}

/** see com.rev360.model.diagnosis.constant.diagnosislocationqualifier.DiagnosisLocationQualifier */
/* istanbul ignore next */
export class DiagnosisLocationQualifier extends GandalfConstant<string> {
	static readonly OD_LESS_THAN_OS = new DiagnosisLocationQualifier('OD < OS', "OD < OS");
	static readonly OD_EQUALS_OS = new DiagnosisLocationQualifier('OD = OS', "OD = OS");
	static readonly OD_GREATER_THAN_OS = new DiagnosisLocationQualifier('OD > OS', "OD > OS");
	
	static readonly VALUES: GandalfConstantList<DiagnosisLocationQualifier> = {
		label: 'Diagnosis Location Qualifier',
		values: [DiagnosisLocationQualifier.OD_LESS_THAN_OS, DiagnosisLocationQualifier.OD_EQUALS_OS, DiagnosisLocationQualifier.OD_GREATER_THAN_OS, ]
	};
}

/** see com.rev360.model.messaging.constant.directaddressstatus.DirectAddressStatus */
/* istanbul ignore next */
export class DirectAddressStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new DirectAddressStatus(1, "Enabled");
	static readonly INACTIVE = new DirectAddressStatus(0, "Disabled");
	
	static readonly VALUES: GandalfConstantList<DirectAddressStatus> = {
		label: 'Direct Address Status',
		values: [DirectAddressStatus.ACTIVE, DirectAddressStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.messaging.constant.DirectProcessorType */
/* istanbul ignore next */
export class DirectProcessorType extends GandalfConstant<number> {
	static readonly SES_DIRECT = new DirectProcessorType(1, "SES Direct");
	
	static readonly VALUES: GandalfConstantList<DirectProcessorType> = {
		label: 'Direct Processor',
		values: [DirectProcessorType.SES_DIRECT, ]
	};
}

/** see com.rev360.model.messaging.constant.DirectRegistrationType */
/* istanbul ignore next */
export class DirectRegistrationType extends GandalfConstant<number> {
	static readonly SES_DIRECT_INDIVIDUAL = new DirectRegistrationType(1, "Invdividual");
	static readonly SES_DIRECT_PROFESSIONAL = new DirectRegistrationType(2, "Professional");
	static readonly SES_DIRECT_ORGANIZATION = new DirectRegistrationType(3, "Organization");
	
	static readonly VALUES: GandalfConstantList<DirectRegistrationType> = {
		label: 'Direct Registration Type',
		values: [DirectRegistrationType.SES_DIRECT_INDIVIDUAL, DirectRegistrationType.SES_DIRECT_PROFESSIONAL, DirectRegistrationType.SES_DIRECT_ORGANIZATION, ]
	};
}

/** see com.rev360.model.accounting.constant.dosageunitcode.DosageUnitCode */
/* istanbul ignore next */
export class DosageUnitCode extends GandalfConstant<string> {
	static readonly UN = new DosageUnitCode('UN', "Unit");
	static readonly GR = new DosageUnitCode('GR', "Gram");
	static readonly ML = new DosageUnitCode('ML', "Milliliter");
	static readonly ME = new DosageUnitCode('ME', "Milligram");
	static readonly F2 = new DosageUnitCode('F2', "International Unit");
	
	static readonly VALUES: GandalfConstantList<DosageUnitCode> = {
		label: 'Dosage Unit Codes',
		values: [DosageUnitCode.UN, DosageUnitCode.GR, DosageUnitCode.ML, DosageUnitCode.ME, DosageUnitCode.F2, ]
	};
}

/** see com.rev360.model.example.rpg.dragon.constant.dragonscalecolor.DragonScaleColor */
/* istanbul ignore next */
export class DragonType extends GandalfConstant<number> {
	static readonly BLACK = new DragonType(1, "Black");
	static readonly WHITE = new DragonType(2, "White");
	static readonly GREEN = new DragonType(3, "Green");
	static readonly RED = new DragonType(4, "Red");
	static readonly BLUE = new DragonType(5, "Blue");
	
	static readonly VALUES: GandalfConstantList<DragonType> = {
		label: 'Dragon Type',
		values: [DragonType.BLACK, DragonType.WHITE, DragonType.GREEN, DragonType.RED, DragonType.BLUE, ]
	};
}

/** see com.rev360.core.service.prescription.DrugCategoryMasterId */
/* istanbul ignore next */
export class DrugCategoryMasterId extends GandalfConstant<number> {
	static readonly GLAUCOMA = new DrugCategoryMasterId(1, "1");
	
	static readonly VALUES: GandalfConstantList<DrugCategoryMasterId> = {
		label: 'DrugCategoryMasterId',
		values: [DrugCategoryMasterId.GLAUCOMA, ]
	};
}

/** see com.rev360.model.common.constant.durationunit.DurationUnit */
/* istanbul ignore next */
export class DurationUnit extends GandalfConstant<number> {
	static readonly NONE = new DurationUnit(0, "None");
	static readonly SECOND = new DurationUnit(1, "Second(s)");
	static readonly MINUTE = new DurationUnit(2, "Minute(s)");
	static readonly HOUR = new DurationUnit(3, "Hour(s)");
	static readonly DAY = new DurationUnit(4, "Day(s)");
	static readonly WEEK = new DurationUnit(5, "Week(s)");
	static readonly MONTH = new DurationUnit(6, "Month(s)");
	static readonly YEAR = new DurationUnit(7, "Year(s)");
	
	static readonly VALUES: GandalfConstantList<DurationUnit> = {
		label: 'Duration Unit',
		values: [DurationUnit.NONE, DurationUnit.SECOND, DurationUnit.MINUTE, DurationUnit.HOUR, DurationUnit.DAY, DurationUnit.WEEK, DurationUnit.MONTH, DurationUnit.YEAR, ]
	};
}

/** see com.rev360.model.contact.constant.EmergencyContactType */
/* istanbul ignore next */
export class EmergencyContactType extends GandalfConstant<number> {
	static readonly PRIMARY = new EmergencyContactType(1, "Primary");
	static readonly SECONDARY = new EmergencyContactType(2, "Secondary");
	
	static readonly VALUES: GandalfConstantList<EmergencyContactType> = {
		label: 'Emergency Contact Type',
		values: [EmergencyContactType.PRIMARY, EmergencyContactType.SECONDARY, ]
	};
}

/** see com.rev360.model.employee.constant.status.EmployeeStatus */
/* istanbul ignore next */
export class EmployeeStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new EmployeeStatus(0, "Inactive");
	static readonly ACTIVE = new EmployeeStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<EmployeeStatus> = {
		label: 'Status',
		values: [EmployeeStatus.INACTIVE, EmployeeStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.employee.constant.employmentstatus.EmploymentStatus */
/* istanbul ignore next */
export class EmploymentStatus extends GandalfConstant<number> {
	static readonly FULL_TIME = new EmploymentStatus(0, "Full-Time");
	static readonly PART_TIME = new EmploymentStatus(1, "Part-Time");
	static readonly TEMPORARY = new EmploymentStatus(2, "Temporary");
	static readonly GUEST = new EmploymentStatus(3, "Guest");
	
	static readonly VALUES: GandalfConstantList<EmploymentStatus> = {
		label: 'Employment',
		values: [EmploymentStatus.FULL_TIME, EmploymentStatus.PART_TIME, EmploymentStatus.TEMPORARY, EmploymentStatus.GUEST, ]
	};
}

/** see com.rev360.model.encounter.constant.encounterapprovalstatus.EncounterApprovalStatus */
/* istanbul ignore next */
export class EncounterApprovalStatus extends GandalfConstant<number> {
	static readonly APPROVED = new EncounterApprovalStatus(1, "Signed");
	static readonly NOT_APPROVED = new EncounterApprovalStatus(2, "Not Signed");
	
	static readonly VALUES: GandalfConstantList<EncounterApprovalStatus> = {
		label: 'Encounter Approval Status',
		values: [EncounterApprovalStatus.APPROVED, EncounterApprovalStatus.NOT_APPROVED, ]
	};
}

/** see com.rev360.model.encounter.constant.encounterautodiagnosisstatus.EncounterAutoDiagnosisStatus */
/* istanbul ignore next */
export class EncounterAutoDiagnosisStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new EncounterAutoDiagnosisStatus(1, "Active");
	static readonly INACTIVE = new EncounterAutoDiagnosisStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<EncounterAutoDiagnosisStatus> = {
		label: 'Encounter Auto Diagnosis Status',
		values: [EncounterAutoDiagnosisStatus.ACTIVE, EncounterAutoDiagnosisStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.encounter.constant.encounterclassification.EncounterClassification */
/* istanbul ignore next */
export class EncounterClassification extends GandalfConstant<number> {
	static readonly OUTPATIENT = new EncounterClassification(1, "outpatient/ambulatory");
	static readonly INPATIENT = new EncounterClassification(2, "in-patient");
	static readonly EMERGENCY = new EncounterClassification(3, "emergency");
	static readonly PHONE = new EncounterClassification(4, "phone call");
	static readonly EMAIL = new EncounterClassification(5, "email");
	
	static readonly VALUES: GandalfConstantList<EncounterClassification> = {
		label: 'EncounterClassification',
		values: [EncounterClassification.OUTPATIENT, EncounterClassification.INPATIENT, EncounterClassification.EMERGENCY, EncounterClassification.PHONE, EncounterClassification.EMAIL, ]
	};
}

/** see com.rev360.model.encounter.constant.encounterreviewdetailstatus.EncounterReviewDetailStatus */
/* istanbul ignore next */
export class EncounterReviewDetailStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new EncounterReviewDetailStatus(1, "Active");
	static readonly INACTIVE = new EncounterReviewDetailStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<EncounterReviewDetailStatus> = {
		label: 'Encounter Review Detail Status',
		values: [EncounterReviewDetailStatus.ACTIVE, EncounterReviewDetailStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.encounter.constant.encounterscribesessionexternalsource.EncounterScribeSessionExternalSource */
/* istanbul ignore next */
export class EncounterScribeSessionExternalSource extends GandalfConstant<number> {
	static readonly AMBIENT_SCRIBE_WIDGET = new EncounterScribeSessionExternalSource(1, "Ambient Scribe Widget");
	
	static readonly VALUES: GandalfConstantList<EncounterScribeSessionExternalSource> = {
		label: 'Encounter Scribe Session External Source',
		values: [EncounterScribeSessionExternalSource.AMBIENT_SCRIBE_WIDGET, ]
	};
}

/** see com.rev360.pms.service.encounter.constant.EncounterSearchStatus */
/* istanbul ignore next */
export class EncounterSearchStatus extends GandalfConstant<number> {
	static readonly IN_PROGRESS = new EncounterSearchStatus(1, "In Progress");
	static readonly COMPLETE = new EncounterSearchStatus(2, "Complete");
	static readonly CANCELED = new EncounterSearchStatus(3, "Canceled");
	static readonly NON_CANCELLED = new EncounterSearchStatus(100, "Non-Cancelled");
	
	static readonly VALUES: GandalfConstantList<EncounterSearchStatus> = {
		label: 'Encounter Search Status',
		values: [EncounterSearchStatus.IN_PROGRESS, EncounterSearchStatus.COMPLETE, EncounterSearchStatus.CANCELED, EncounterSearchStatus.NON_CANCELLED, ]
	};
}

/** see com.rev360.model.encounter.constant.encounterstatus.EncounterStatus */
/* istanbul ignore next */
export class EncounterStatus extends GandalfConstant<number> {
	static readonly IN_PROGRESS = new EncounterStatus(1, "In Progress");
	static readonly COMPLETE = new EncounterStatus(2, "Complete");
	static readonly CANCELED = new EncounterStatus(3, "Canceled");
	
	static readonly VALUES: GandalfConstantList<EncounterStatus> = {
		label: 'Encounter Status',
		values: [EncounterStatus.IN_PROGRESS, EncounterStatus.COMPLETE, EncounterStatus.CANCELED, ]
	};
}

/** see com.rev360.pms.service.encounter.EncounterValidationResult */
/* istanbul ignore next */
export class EncounterValidationResult extends GandalfConstant<number> {
	static readonly SUCCESSFUL = new EncounterValidationResult(1, "Successful");
	static readonly PASSWORD_INVALID = new EncounterValidationResult(2, "Invalid Password");
	
	static readonly VALUES: GandalfConstantList<EncounterValidationResult> = {
		label: 'Encounter Validation Result',
		values: [EncounterValidationResult.SUCCESSFUL, EncounterValidationResult.PASSWORD_INVALID, ]
	};
}

/** see com.rev360.model.note.constant.entitytype.EntityType */
/* istanbul ignore next */
export class EntityType extends GandalfConstant<string> {
	static readonly CAMPAIGN = new EntityType('Campaign', "Campaign");
	static readonly CLAIM = new EntityType('Claim', "Claim");
	static readonly CUSTOMER = new EntityType('Customer', "Customer");
	static readonly DIAGNOSIS = new EntityType('Diagnosis', "Diagnosis");
	static readonly EMPLOYEE = new EntityType('Employee', "Employee");
	static readonly ENCOUNTER = new EntityType('Encounter', "Encounter");
	static readonly ENCOUNTER_TEST = new EntityType('EncounterTest', "Encounter Test");
	static readonly INSURANCE_ACCOUNT = new EntityType('InsuranceAccount', "Insurance Account");
	static readonly INSURANCE_CARRIER = new EntityType('InsuranceCarrier', "Insurance Carrier");
	static readonly INVOICE = new EntityType('Invoice', "Invoice");
	static readonly ORDER = new EntityType('Order', "Order");
	static readonly PATIENT = new EntityType('Patient', "Patient");
	static readonly PATIENT_ACCOUNT = new EntityType('PatientAccount', "Patient Account");
	static readonly PAYMENT = new EntityType('Payment', "Payment");
	static readonly PERSON_PHARMACY = new EntityType('PersonPharmacy', "Person Pharmacy");
	static readonly PRACTICE = new EntityType('Practice', "Practice");
	static readonly PRESCRIPTION = new EntityType('Prescription', "Prescription");
	static readonly PROVIDER = new EntityType('Provider', "Provider");
	static readonly SCHEDULE_ITEM = new EntityType('ScheduleItem', "Schedule Item");
	static readonly TASK = new EntityType('Task', "Task");
	
	static readonly VALUES: GandalfConstantList<EntityType> = {
		label: 'Entity Type',
		values: [EntityType.CAMPAIGN, EntityType.CLAIM, EntityType.CUSTOMER, EntityType.DIAGNOSIS, EntityType.EMPLOYEE, EntityType.ENCOUNTER, EntityType.ENCOUNTER_TEST, EntityType.INSURANCE_ACCOUNT, EntityType.INSURANCE_CARRIER, EntityType.INVOICE, EntityType.ORDER, EntityType.PATIENT, EntityType.PATIENT_ACCOUNT, EntityType.PAYMENT, EntityType.PERSON_PHARMACY, EntityType.PRACTICE, EntityType.PRESCRIPTION, EntityType.PROVIDER, EntityType.SCHEDULE_ITEM, EntityType.TASK, ]
	};
}

/** see com.rev360.model.patient.constant.establishedstatus.EstablishedStatus */
/* istanbul ignore next */
export class EstablishedStatus extends GandalfConstant<number> {
	static readonly NEW = new EstablishedStatus(0, "New");
	static readonly ESTABLISHED = new EstablishedStatus(1, "Established");
	
	static readonly VALUES: GandalfConstantList<EstablishedStatus> = {
		label: 'Patient Established Status',
		values: [EstablishedStatus.NEW, EstablishedStatus.ESTABLISHED, ]
	};
}

/** see com.rev360.model.patient.constant.externaldatasource.ExternalDataSource */
/* istanbul ignore next */
export class ExternalDataSource extends GandalfConstant<number> {
	static readonly PATIENT = new ExternalDataSource(0, "Patient");
	static readonly OTHER = new ExternalDataSource(1, "Other");
	
	static readonly VALUES: GandalfConstantList<ExternalDataSource> = {
		label: 'External Data Source',
		values: [ExternalDataSource.PATIENT, ExternalDataSource.OTHER, ]
	};
}

/** see com.rev360.model.patient.constant.externaldatastatus.ExternalDataStatus */
/* istanbul ignore next */
export class ExternalDataStatus extends GandalfConstant<number> {
	static readonly SUBMITTED = new ExternalDataStatus(0, "Submitted");
	static readonly RECEIVED = new ExternalDataStatus(1, "Received");
	static readonly REVIEWED = new ExternalDataStatus(2, "Reviewed");
	static readonly DELETED = new ExternalDataStatus(3, "Deleted");
	
	static readonly VALUES: GandalfConstantList<ExternalDataStatus> = {
		label: 'External Data Status',
		values: [ExternalDataStatus.SUBMITTED, ExternalDataStatus.RECEIVED, ExternalDataStatus.REVIEWED, ExternalDataStatus.DELETED, ]
	};
}

/** see com.rev360.model.inventory.product.constant.externalproductsource.ExternalProductSource */
/* istanbul ignore next */
export class ExternalProductSource extends GandalfConstant<string> {
	static readonly EXTERNAL_SOURCE_EYEDOCK = new ExternalProductSource('EYEDOCK', "EyeDock");
	static readonly EXTERNAL_SOURCE_FRAMESDATA = new ExternalProductSource('FRAMESDATA', "FramesData");
	static readonly EXTERNAL_SOURCE_SMARTFLOW = new ExternalProductSource('SMARTFLOW', "SmartFlow");
	static readonly EXTERNAL_SOURCE_TWELVE84 = new ExternalProductSource('TWELVE84', "Twelve84");
	static readonly EXTERNAL_SOURCE_VSP = new ExternalProductSource('VSP', "VSP");
	
	static readonly VALUES: GandalfConstantList<ExternalProductSource> = {
		label: 'ExternalProductSource',
		values: [ExternalProductSource.EXTERNAL_SOURCE_EYEDOCK, ExternalProductSource.EXTERNAL_SOURCE_FRAMESDATA, ExternalProductSource.EXTERNAL_SOURCE_SMARTFLOW, ExternalProductSource.EXTERNAL_SOURCE_TWELVE84, ExternalProductSource.EXTERNAL_SOURCE_VSP, ]
	};
}

/** see com.rev360.model.common.constant.externalsystem.ExternalSystem */
/* istanbul ignore next */
export class ExternalSystem extends GandalfConstant<string> {
	static readonly APEX = new ExternalSystem('APEXEDI', "Apex");
	static readonly TRIZETTO = new ExternalSystem('GATEWAYEDI', "TriZetto");
	static readonly EYEFINITY = new ExternalSystem('EYEFINITY', "Eyefinity");
	static readonly CLINIC_AID = new ExternalSystem('CLINICAID', "ClinicAid");
	static readonly BLUEFIN = new ExternalSystem('BLUEFIN', "Bluefin");
	static readonly RXNT = new ExternalSystem('RXNT', "RXNT");
	
	static readonly VALUES: GandalfConstantList<ExternalSystem> = {
		label: 'External System Constants',
		values: [ExternalSystem.APEX, ExternalSystem.TRIZETTO, ExternalSystem.EYEFINITY, ExternalSystem.CLINIC_AID, ExternalSystem.BLUEFIN, ExternalSystem.RXNT, ]
	};
}

/** see com.rev360.model.common.constant.externalsystem.ExternalSystemType */
/* istanbul ignore next */
export class ExternalSystemType extends GandalfConstant<string> {
	static readonly CLEARINGHOUSE = new ExternalSystemType('Clearing House', "Clearing House");
	static readonly PAYMENT_PROCESSOR = new ExternalSystemType('Payment Processor', "Payment Processor");
	static readonly UNUSED = new ExternalSystemType('Unused', "Unused");
	static readonly ERX = new ExternalSystemType('ERX', "ERX");
	
	static readonly VALUES: GandalfConstantList<ExternalSystemType> = {
		label: 'External System Type Constants',
		values: [ExternalSystemType.CLEARINGHOUSE, ExternalSystemType.PAYMENT_PROCESSOR, ExternalSystemType.UNUSED, ExternalSystemType.ERX, ]
	};
}

/** see com.rev360.model.eyefinity.constant.EyefinityFeeOptionType */
/* istanbul ignore next */
export class EyefinityFeeOptionType extends GandalfConstant<number> {
	static readonly NONE = new EyefinityFeeOptionType(0, "None");
	static readonly SINGLE_VISION = new EyefinityFeeOptionType(1, "Single Vision");
	static readonly MULTIFOCAL = new EyefinityFeeOptionType(2, "Multifocal");
	static readonly PROGRESSIVE = new EyefinityFeeOptionType(3, "Progressive");
	static readonly MISC = new EyefinityFeeOptionType(4, "Miscellaneous");
	
	static readonly VALUES: GandalfConstantList<EyefinityFeeOptionType> = {
		label: 'Eyefinity Fee Option Type',
		values: [EyefinityFeeOptionType.NONE, EyefinityFeeOptionType.SINGLE_VISION, EyefinityFeeOptionType.MULTIFOCAL, EyefinityFeeOptionType.PROGRESSIVE, EyefinityFeeOptionType.MISC, ]
	};
}

/** see com.rev360.model.eyefinity.constant.EyefinityInvoiceDetailType */
/* istanbul ignore next */
export class EyefinityInvoiceDetailType extends GandalfConstant<number> {
	static readonly VSP_PAYS = new EyefinityInvoiceDetailType(1, "VSP Pays");
	static readonly PATIENT_PAYS = new EyefinityInvoiceDetailType(2, "Patient Pays");
	
	static readonly VALUES: GandalfConstantList<EyefinityInvoiceDetailType> = {
		label: 'Eyefinity Invoice Detail Type',
		values: [EyefinityInvoiceDetailType.VSP_PAYS, EyefinityInvoiceDetailType.PATIENT_PAYS, ]
	};
}

/** see com.rev360.pms.service.eyefinity.EyefinityLensLocation */
/* istanbul ignore next */
export class EyefinityLensLocation extends GandalfConstant<string> {
	static readonly OD = new EyefinityLensLocation('OD', "OD");
	static readonly OS = new EyefinityLensLocation('OS', "OS");
	static readonly OU = new EyefinityLensLocation('OU', "OU");
	
	static readonly VALUES: GandalfConstantList<EyefinityLensLocation> = {
		label: 'Eyefinity Lens Location',
		values: [EyefinityLensLocation.OD, EyefinityLensLocation.OS, EyefinityLensLocation.OU, ]
	};
}

/** see com.rev360.pms.service.eyefinity.EyefinityLensTintColor */
/* istanbul ignore next */
export class EyefinityLensTintColor extends GandalfConstant<string> {
	static readonly BROWN_1 = new EyefinityLensTintColor('Brown 1', "Brown 1");
	static readonly BROWN_2 = new EyefinityLensTintColor('Brown 2', "Brown 2");
	static readonly BROWN_3 = new EyefinityLensTintColor('Brown 3', "Brown 3");
	static readonly CRUX_A = new EyefinityLensTintColor('Crux A', "Crux A");
	static readonly CRUX_AX = new EyefinityLensTintColor('Crux AX', "Crux AX");
	static readonly G_15 = new EyefinityLensTintColor('G 15', "G 15");
	static readonly GRAY_1 = new EyefinityLensTintColor('Gray 1', "Gray 1");
	static readonly GRAY_2 = new EyefinityLensTintColor('Gray 2', "Gray 2");
	static readonly GRAY_3 = new EyefinityLensTintColor('Gray 3', "Gray 3");
	static readonly OTHER = new EyefinityLensTintColor('other', "Other (Indicate Tint Not Listed)");
	static readonly PINK_1 = new EyefinityLensTintColor('Pink 1', "Pink 1");
	static readonly PINK_2 = new EyefinityLensTintColor('Pink 2', "Pink 2");
	static readonly PINK_3 = new EyefinityLensTintColor('Pink 3', "Pink 3");
	static readonly ROSE_1 = new EyefinityLensTintColor('Rose 1', "Rose 1");
	static readonly ROSE_2 = new EyefinityLensTintColor('Rose 1', "Rose 1");
	static readonly ROSE_3 = new EyefinityLensTintColor('Rose 1', "Rose 1");
	
	static readonly VALUES: GandalfConstantList<EyefinityLensTintColor> = {
		label: 'Eyefinity Lens Tint Color',
		values: [EyefinityLensTintColor.BROWN_1, EyefinityLensTintColor.BROWN_2, EyefinityLensTintColor.BROWN_3, EyefinityLensTintColor.CRUX_A, EyefinityLensTintColor.CRUX_AX, EyefinityLensTintColor.G_15, EyefinityLensTintColor.GRAY_1, EyefinityLensTintColor.GRAY_2, EyefinityLensTintColor.GRAY_3, EyefinityLensTintColor.OTHER, EyefinityLensTintColor.PINK_1, EyefinityLensTintColor.PINK_2, EyefinityLensTintColor.PINK_3, EyefinityLensTintColor.ROSE_1, EyefinityLensTintColor.ROSE_2, EyefinityLensTintColor.ROSE_3, ]
	};
}

/** see com.rev360.pms.service.eyefinity.EyefinityLensTintSample */
/* istanbul ignore next */
export class EyefinityLensTintSample extends GandalfConstant<string> {
	static readonly NONE = new EyefinityLensTintSample('0', "None");
	static readonly MATCH = new EyefinityLensTintSample('2', "Match");
	static readonly LIGHTEN = new EyefinityLensTintSample('3', "Lighten");
	static readonly DARKEN = new EyefinityLensTintSample('4', "Darken");
	
	static readonly VALUES: GandalfConstantList<EyefinityLensTintSample> = {
		label: 'Eyefinity Lens Tint Sample',
		values: [EyefinityLensTintSample.NONE, EyefinityLensTintSample.MATCH, EyefinityLensTintSample.LIGHTEN, EyefinityLensTintSample.DARKEN, ]
	};
}

/** see com.rev360.pms.service.eyefinity.EyefinityLensType */
/* istanbul ignore next */
export class EyefinityLensType extends GandalfConstant<string> {
	static readonly SINGLE = new EyefinityLensType('0', "Single");
	static readonly BIFOCAL = new EyefinityLensType('1', "Bifocal");
	static readonly TRIFOCAL = new EyefinityLensType('2', "Trifocal");
	static readonly QUAD = new EyefinityLensType('3', "Quad");
	static readonly DOUBLE = new EyefinityLensType('4', "Double");
	static readonly PROGRESSIVE = new EyefinityLensType('5', "Progressive");
	static readonly NEAR_VF = new EyefinityLensType('6', "Near VF");
	static readonly LENTICULAR_SINGLE = new EyefinityLensType('7', "Lenticular Single");
	static readonly LENTICULAR_BIFOCAL = new EyefinityLensType('8', "Lenticular Bifocal");
	static readonly LENTICULAR_TRIFOCAL = new EyefinityLensType('9', "Lenticular Trifocal");
	
	static readonly VALUES: GandalfConstantList<EyefinityLensType> = {
		label: 'Eyefinity Lens Type',
		values: [EyefinityLensType.SINGLE, EyefinityLensType.BIFOCAL, EyefinityLensType.TRIFOCAL, EyefinityLensType.QUAD, EyefinityLensType.DOUBLE, EyefinityLensType.PROGRESSIVE, EyefinityLensType.NEAR_VF, EyefinityLensType.LENTICULAR_SINGLE, EyefinityLensType.LENTICULAR_BIFOCAL, EyefinityLensType.LENTICULAR_TRIFOCAL, ]
	};
}

/** see com.rev360.model.eyefinity.constant.EyefinityListCategoryType */
/* istanbul ignore next */
export class EyefinityListCategoryType extends GandalfConstant<number> {
	static readonly LAB = new EyefinityListCategoryType(1, "Lab");
	static readonly RELATIONSHIP_CODE = new EyefinityListCategoryType(2, "Relationship Code");
	static readonly LENS_TYPE = new EyefinityListCategoryType(3, "Lens Type");
	static readonly LENS_MATERIAL = new EyefinityListCategoryType(4, "Lens Material");
	static readonly LENS_STYLE_1 = new EyefinityListCategoryType(5, "Lens Style 1");
	static readonly LENS_STYLE_2 = new EyefinityListCategoryType(6, "Lens Style 2");
	static readonly LENS_STYLE_3 = new EyefinityListCategoryType(7, "Lens Style 3");
	static readonly LENS_TINTS = new EyefinityListCategoryType(8, "Lens Tints");
	static readonly LENS_TINT_TYPES = new EyefinityListCategoryType(9, "Lens Tint Types");
	static readonly LENS_TINT_TYPE_SAMPLES = new EyefinityListCategoryType(10, "Lens Tint Type Samples");
	static readonly LENS_BEVEL = new EyefinityListCategoryType(11, "Lens Bevel");
	static readonly LENS_EDGE = new EyefinityListCategoryType(12, "Lens Edge");
	static readonly LENS_THICKNESS = new EyefinityListCategoryType(13, "Lens Thickness");
	static readonly REPAIR_REASON = new EyefinityListCategoryType(14, "Repair Reason");
	static readonly CL_MATERIAL = new EyefinityListCategoryType(15, "CL Material");
	static readonly CL_REASONS = new EyefinityListCategoryType(16, "CL Reasons");
	static readonly CL_SERVICES = new EyefinityListCategoryType(17, "CL Services");
	static readonly CL_SUPPLY_PROGRAM = new EyefinityListCategoryType(18, "CL Supply Program");
	static readonly EXAM_TYPES = new EyefinityListCategoryType(19, "Exam Types");
	static readonly CPT_CODES = new EyefinityListCategoryType(20, "CPT Codes");
	static readonly FRAME_SUPPLIER = new EyefinityListCategoryType(21, "Frame Supplier");
	static readonly FRAME_TYPE = new EyefinityListCategoryType(22, "Frame Type");
	static readonly FRAME_SHAPE = new EyefinityListCategoryType(23, "Frame Shape");
	static readonly AR_COATINGS = new EyefinityListCategoryType(24, "AR Coatings");
	static readonly SCRATCH_COATINGS = new EyefinityListCategoryType(25, "Scratch Coatings");
	static readonly GLASS_COATINGS = new EyefinityListCategoryType(26, "Glass Coatings");
	static readonly MIRROR_COATINGS = new EyefinityListCategoryType(27, "Mirror Coatings");
	static readonly UV_COATINGS = new EyefinityListCategoryType(28, "UV Coatings");
	static readonly PRESS_ON_PRISM = new EyefinityListCategoryType(29, "Press-On Prism");
	static readonly NOSE_PADS = new EyefinityListCategoryType(30, "Nose Pads");
	static readonly SLAB_OFF = new EyefinityListCategoryType(31, "Slab Off");
	static readonly MANUFACTURERS = new EyefinityListCategoryType(32, "Manufacturers");
	
	static readonly VALUES: GandalfConstantList<EyefinityListCategoryType> = {
		label: 'Eyefinity List Category Type',
		values: [EyefinityListCategoryType.LAB, EyefinityListCategoryType.RELATIONSHIP_CODE, EyefinityListCategoryType.LENS_TYPE, EyefinityListCategoryType.LENS_MATERIAL, EyefinityListCategoryType.LENS_STYLE_1, EyefinityListCategoryType.LENS_STYLE_2, EyefinityListCategoryType.LENS_STYLE_3, EyefinityListCategoryType.LENS_TINTS, EyefinityListCategoryType.LENS_TINT_TYPES, EyefinityListCategoryType.LENS_TINT_TYPE_SAMPLES, EyefinityListCategoryType.LENS_BEVEL, EyefinityListCategoryType.LENS_EDGE, EyefinityListCategoryType.LENS_THICKNESS, EyefinityListCategoryType.REPAIR_REASON, EyefinityListCategoryType.CL_MATERIAL, EyefinityListCategoryType.CL_REASONS, EyefinityListCategoryType.CL_SERVICES, EyefinityListCategoryType.CL_SUPPLY_PROGRAM, EyefinityListCategoryType.EXAM_TYPES, EyefinityListCategoryType.CPT_CODES, EyefinityListCategoryType.FRAME_SUPPLIER, EyefinityListCategoryType.FRAME_TYPE, EyefinityListCategoryType.FRAME_SHAPE, EyefinityListCategoryType.AR_COATINGS, EyefinityListCategoryType.SCRATCH_COATINGS, EyefinityListCategoryType.GLASS_COATINGS, EyefinityListCategoryType.MIRROR_COATINGS, EyefinityListCategoryType.UV_COATINGS, EyefinityListCategoryType.PRESS_ON_PRISM, EyefinityListCategoryType.NOSE_PADS, EyefinityListCategoryType.SLAB_OFF, EyefinityListCategoryType.MANUFACTURERS, ]
	};
}

/** see com.rev360.model.eyefinity.constant.EyefinityOrderItemType */
/* istanbul ignore next */
export class EyefinityOrderItemType extends GandalfConstant<number> {
	static readonly UNKNOWN = new EyefinityOrderItemType(0, "Unknown");
	static readonly VSP_LENS = new EyefinityOrderItemType(1, "Base Lens");
	static readonly VSP_FRAME = new EyefinityOrderItemType(2, "Frame");
	static readonly VSP_CONTACTS = new EyefinityOrderItemType(3, "Contacts");
	static readonly ENCOUNTER_SERVICE = new EyefinityOrderItemType(4, "Exam");
	static readonly OTHER = new EyefinityOrderItemType(5, "Other");
	static readonly VSP_LENS_OPTION = new EyefinityOrderItemType(6, "Lens Option");
	static readonly CL_FITTING_SERVICE = new EyefinityOrderItemType(7, "Fitting");
	
	static readonly VALUES: GandalfConstantList<EyefinityOrderItemType> = {
		label: 'Eyefinity Order Item Type',
		values: [EyefinityOrderItemType.UNKNOWN, EyefinityOrderItemType.VSP_LENS, EyefinityOrderItemType.VSP_FRAME, EyefinityOrderItemType.VSP_CONTACTS, EyefinityOrderItemType.ENCOUNTER_SERVICE, EyefinityOrderItemType.OTHER, EyefinityOrderItemType.VSP_LENS_OPTION, EyefinityOrderItemType.CL_FITTING_SERVICE, ]
	};
}

/** see com.rev360.model.common.constant.facilitytype.FacilityType */
/* istanbul ignore next */
export class FacilityType extends GandalfConstant<string> {
	static readonly NONE = new FacilityType('', "");
	static readonly OFFICE = new FacilityType('11', "Office");
	static readonly PHARMACY = new FacilityType('01', "Pharmacy");
	static readonly TELEHEALTH = new FacilityType('02', "Telehealth Provided Other than in Patient's Home");
	static readonly SCHOOL = new FacilityType('03', "School");
	static readonly HOMELESS_SHELTER = new FacilityType('04', "Homeless Shelter");
	static readonly INDIAN_HEALTH_SERVICE_FREE_STANDING = new FacilityType('05', "Indian Health Service Free-standing Facility");
	static readonly INDIAN_HEALTH_SERVICE_PROVIDER_BASED_FACILITY = new FacilityType('06', "Indian Health Service Provider-based Facility");
	static readonly TRIBAL_638_FREE_STANDING_FACILITY = new FacilityType('07', "Tribal 638 Free-standing Facility");
	static readonly TRIBAL_638_PROVIDER_BASED_FACILITY = new FacilityType('08', "Tribal 638 Provider-based Facility");
	static readonly PRISON_CORRECTIONAL_FACILITY = new FacilityType('09', "Prison/Correctional Facility");
	static readonly TELEHEALTH_PATIENT_HOME = new FacilityType('10', "Telehealth Provided in Patient's Home");
	static readonly HOME = new FacilityType('12', "Home");
	static readonly ASSISTED_LIVING_FACILITY = new FacilityType('13', "Assisted Living Facility");
	static readonly GROUP_HOME = new FacilityType('14', "Group Home");
	static readonly MOBILE_UNIT = new FacilityType('15', "Mobile Unit");
	static readonly TEMPORARY_LODGING = new FacilityType('16', "Temporary Lodging");
	static readonly WALK_IN_RETAIL_HEALTH_CLINIC = new FacilityType('17', "Walk-in Retail Health Clinic");
	static readonly PLACE_OF_EMPLOYMENT_WORKSITE = new FacilityType('18', "Place of Employment-Worksite");
	static readonly OFF_CAMPUS_OUTPATIENT_HOSPITAL = new FacilityType('19', "Off Campus-Outpatient Hospital");
	static readonly URGENT_CARE_FACILITY = new FacilityType('20', "Urgent Care Facility");
	static readonly INPATIENT_HOSPITAL = new FacilityType('21', "Inpatient Hospital");
	static readonly OUTPATIENT_HOSPITAL = new FacilityType('22', "Outpatient Hospital");
	static readonly EMERGENCY_ROOM_HOSPITAL = new FacilityType('23', "Emergency Room - Hospital");
	static readonly AMBULATOR_SURGICAL_CENTER = new FacilityType('24', "Ambulator Surgical Center");
	static readonly BIRTHING_CENTER = new FacilityType('25', "Birthing Center");
	static readonly MILITARY_TREATMENT_FACILITY = new FacilityType('26', "Military Treatment Facility");
	static readonly SKILLED_NURSING_FACILITY = new FacilityType('31', "Skilled Nursing Facility");
	static readonly NURSING_FACILITY = new FacilityType('32', "Nursing Facility");
	static readonly CUSTODIAL_CARE_FACILITY = new FacilityType('33', "Custodial Care Facility");
	static readonly HOSPICE = new FacilityType('34', "Hospice");
	static readonly AMBULANCE_LAND = new FacilityType('41', "Ambulance - Land");
	static readonly AMBULANCE_AIR_OR_WATER = new FacilityType('42', "Ambulance - Air or Water");
	static readonly INDEPENDENT_CLINIC = new FacilityType('49', "Independent Clinic");
	static readonly FEDERALLY_QUALIFIED_HEALTH_CENTER = new FacilityType('50', "Federally Qualified Health Center");
	static readonly INPATIENT_PSYCHIATRIC = new FacilityType('51', "Inpatient Psychiatric");
	static readonly PSYCHIATRIC_FACILITY_PARTIAL_HOSPITALIZATION = new FacilityType('52', "Psychiatric Facility - Partial Hospitalization");
	static readonly COMMUNITY_MENTAL_HEALTH_CENTER = new FacilityType('53', "Community Mental Health Center");
	static readonly INTERMEDIATE_CARE_FACILITY_MENTALLY_RETARDED = new FacilityType('54', "Intermediate Care Facility/Mentally Retarded");
	static readonly RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY = new FacilityType('55', "Residential Substance Abuse Treatment Facility");
	static readonly PSYCHIATRIC_RESIDENTIAL_TREATMENT_CENTER = new FacilityType('56', "Psychiatric Residential Treatment Center");
	static readonly NONRESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY = new FacilityType('57', "Non-residential Substance Abuse Treatment Facility");
	static readonly MASS_IMMUNIZATION_CENTER = new FacilityType('60', "Mass Immunization Center");
	static readonly COMPREHENSIVE_INPATIENT_REHABILITATION_FACILITY = new FacilityType('61', "Comprehensive Inpatient Rehabilitation Facility");
	static readonly COMPREHENSIVE_OUTPATIENT_REHABILITATION_FACILITY = new FacilityType('62', "Comprehensive Outpatient Rehabilitation Facility");
	static readonly END_STATE_RENAL_DISEASE_TREATMENT_FACILITY = new FacilityType('65', "End-State Renal Disease Treatment Facility");
	static readonly PUBLIC_HEALTH_CLINIC = new FacilityType('71', "Public Health Clinic");
	static readonly RURAL_HEALTH_CLINIC = new FacilityType('72', "Rural Health Clinic");
	static readonly INDEPENDENT_LABORATORY = new FacilityType('81', "Independent Laboratory");
	static readonly OTHER_PLACE_OF_SERVICE = new FacilityType('99', "Other Place of Service");
	
	static readonly VALUES: GandalfConstantList<FacilityType> = {
		label: 'Facility Type',
		values: [FacilityType.NONE, FacilityType.OFFICE, FacilityType.PHARMACY, FacilityType.TELEHEALTH, FacilityType.SCHOOL, FacilityType.HOMELESS_SHELTER, FacilityType.INDIAN_HEALTH_SERVICE_FREE_STANDING, FacilityType.INDIAN_HEALTH_SERVICE_PROVIDER_BASED_FACILITY, FacilityType.TRIBAL_638_FREE_STANDING_FACILITY, FacilityType.TRIBAL_638_PROVIDER_BASED_FACILITY, FacilityType.PRISON_CORRECTIONAL_FACILITY, FacilityType.TELEHEALTH_PATIENT_HOME, FacilityType.HOME, FacilityType.ASSISTED_LIVING_FACILITY, FacilityType.GROUP_HOME, FacilityType.MOBILE_UNIT, FacilityType.TEMPORARY_LODGING, FacilityType.WALK_IN_RETAIL_HEALTH_CLINIC, FacilityType.PLACE_OF_EMPLOYMENT_WORKSITE, FacilityType.OFF_CAMPUS_OUTPATIENT_HOSPITAL, FacilityType.URGENT_CARE_FACILITY, FacilityType.INPATIENT_HOSPITAL, FacilityType.OUTPATIENT_HOSPITAL, FacilityType.EMERGENCY_ROOM_HOSPITAL, FacilityType.AMBULATOR_SURGICAL_CENTER, FacilityType.BIRTHING_CENTER, FacilityType.MILITARY_TREATMENT_FACILITY, FacilityType.SKILLED_NURSING_FACILITY, FacilityType.NURSING_FACILITY, FacilityType.CUSTODIAL_CARE_FACILITY, FacilityType.HOSPICE, FacilityType.AMBULANCE_LAND, FacilityType.AMBULANCE_AIR_OR_WATER, FacilityType.INDEPENDENT_CLINIC, FacilityType.FEDERALLY_QUALIFIED_HEALTH_CENTER, FacilityType.INPATIENT_PSYCHIATRIC, FacilityType.PSYCHIATRIC_FACILITY_PARTIAL_HOSPITALIZATION, FacilityType.COMMUNITY_MENTAL_HEALTH_CENTER, FacilityType.INTERMEDIATE_CARE_FACILITY_MENTALLY_RETARDED, FacilityType.RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY, FacilityType.PSYCHIATRIC_RESIDENTIAL_TREATMENT_CENTER, FacilityType.NONRESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY, FacilityType.MASS_IMMUNIZATION_CENTER, FacilityType.COMPREHENSIVE_INPATIENT_REHABILITATION_FACILITY, FacilityType.COMPREHENSIVE_OUTPATIENT_REHABILITATION_FACILITY, FacilityType.END_STATE_RENAL_DISEASE_TREATMENT_FACILITY, FacilityType.PUBLIC_HEALTH_CLINIC, FacilityType.RURAL_HEALTH_CLINIC, FacilityType.INDEPENDENT_LABORATORY, FacilityType.OTHER_PLACE_OF_SERVICE, ]
	};
}

/** see com.rev360.model.familyhealthhistory.constant.familyhealthhistoryconditiontype.FamilyHealthHistoryConditionType */
/* istanbul ignore next */
export class FamilyHealthHistoryConditionType extends GandalfConstant<string> {
	static readonly MEDICAL = new FamilyHealthHistoryConditionType('medical', "Medical");
	static readonly OCULAR = new FamilyHealthHistoryConditionType('ocular', "Ocular");
	
	static readonly VALUES: GandalfConstantList<FamilyHealthHistoryConditionType> = {
		label: 'Family Health History Condition Type',
		values: [FamilyHealthHistoryConditionType.MEDICAL, FamilyHealthHistoryConditionType.OCULAR, ]
	};
}

/** see com.rev360.model.familyhealthhistory.constant.familyhealthhistoryhealthcondition.FamilyHealthHistoryHealthCondition */
/* istanbul ignore next */
export class FamilyHealthHistoryHealthCondition extends GandalfConstant<number> {
	static readonly UNKNOWN = new FamilyHealthHistoryHealthCondition(-1, "Unkn");
	static readonly NO = new FamilyHealthHistoryHealthCondition(0, "No");
	static readonly YES = new FamilyHealthHistoryHealthCondition(1, "Yes");
	static readonly NOT_RECORDED = new FamilyHealthHistoryHealthCondition(-2, "N/R");
	
	static readonly VALUES: GandalfConstantList<FamilyHealthHistoryHealthCondition> = {
		label: 'Family Health History Health Condition',
		values: [FamilyHealthHistoryHealthCondition.UNKNOWN, FamilyHealthHistoryHealthCondition.NO, FamilyHealthHistoryHealthCondition.YES, FamilyHealthHistoryHealthCondition.NOT_RECORDED, ]
	};
}

/** see com.rev360.model.feature.constant.featureflagaccess.FeatureFlagAccess */
/* istanbul ignore next */
export class FeatureFlagAccess extends GandalfConstant<number> {
	static readonly OFF = new FeatureFlagAccess(0, "Off");
	static readonly OPTIONAL = new FeatureFlagAccess(1, "Opt-In");
	static readonly ON = new FeatureFlagAccess(2, "On");
	
	static readonly VALUES: GandalfConstantList<FeatureFlagAccess> = {
		label: 'Feature Flag Access',
		values: [FeatureFlagAccess.OFF, FeatureFlagAccess.OPTIONAL, FeatureFlagAccess.ON, ]
	};
}

/** see com.rev360.model.feature.constant.featureflagapplication.FeatureFlagApplication */
/* istanbul ignore next */
export class FeatureFlagApplication extends GandalfConstant<number> {
	static readonly PMS = new FeatureFlagApplication(0, "PMS");
	static readonly PHR = new FeatureFlagApplication(1, "PHR");
	static readonly CUSTOMER_CARE = new FeatureFlagApplication(2, "Customer Care");
	static readonly PRODUCT_PORTAL = new FeatureFlagApplication(3, "Product Portal");
	static readonly MYREV = new FeatureFlagApplication(4, "MyRev");
	
	static readonly VALUES: GandalfConstantList<FeatureFlagApplication> = {
		label: 'Feature Flag Application',
		values: [FeatureFlagApplication.PMS, FeatureFlagApplication.PHR, FeatureFlagApplication.CUSTOMER_CARE, FeatureFlagApplication.PRODUCT_PORTAL, FeatureFlagApplication.MYREV, ]
	};
}

/** see com.rev360.core.service.feature.constants.FeatureFlagApplicationKey */
/* istanbul ignore next */
export class FeatureFlagApplicationKey extends GandalfConstant<string> {
	static readonly TESTING = new FeatureFlagApplicationKey('TESTING', "");
	static readonly ADMIN_MENU_VENDORS_PARTNERS_OPEN_EDGE = new FeatureFlagApplicationKey('admin.menu.VendorsPartners.OpenEdge', "Admin Menu Vendors Partners Global Payments");
	static readonly ORDERS_TWELVE84 = new FeatureFlagApplicationKey('orders.twelve84.EyeglassOrder', "Orders Dashboard: twelve84 Eyeglass Order");
	static readonly PRESCRIPTION_MONO_PD = new FeatureFlagApplicationKey('OCE.rx.monoPd', "Rx: Mono PD");
	static readonly SCHEDULE_APPOINTMENT_DETAILS_INSURANCE_VERIFICATION = new FeatureFlagApplicationKey('QOL.appointment.details.insurance.verification', "Appointment Details: Edit Insurance Verification");
	static readonly REV_CLEAR = new FeatureFlagApplicationKey('QOL.revClear', "RevClear");
	static readonly REV_CLEAR_AUTOPOSTING = new FeatureFlagApplicationKey('APV1.payment.revclear.autoposting', "Payments: Auto-Posting");
	static readonly RXNT_MULTIPLE_LOCATION_CREDENTIALS = new FeatureFlagApplicationKey('PINT.rxnt.multiple.location.credentials', "RxNT Multiple Location Credentials");
	static readonly AUTOPOSTING_X12_ASSOCIATIONS = new FeatureFlagApplicationKey('APV2.autoposting.x12.associations', "Auto-Posting: X12 Associations");
	static readonly ACCOUNTING_ERA_AUTOPOSTING_PAYMENT_GROUP_LOCATION = new FeatureFlagApplicationKey('APV2.payment.group.location', "Auto-Posting: Payment Grouping by Location");
	static readonly EMERGENCY_CONTACT = new FeatureFlagApplicationKey('ECON.emergency.contact.information', "Emergency Contact Information");
	static readonly MESSAGING_MODULE = new FeatureFlagApplicationKey('module.messaging', "Module: Messaging");
	static readonly REVCONNECT_TWO_WAY_TEXT_MESSAGING = new FeatureFlagApplicationKey('TWT.revconnect.twoWayText.messaging', "RevConnect: Two Way Text Messaging");
	static readonly REVCONNECT_ANTI_SPAM = new FeatureFlagApplicationKey('CXT.revconnect.anti.spam', "RevConnect Anti-Spam Enhancements");
	static readonly REVBILLING_CLAIMS_DASHBOARD = new FeatureFlagApplicationKey('RCM.claims.dashboard.enhancements', "Claims & EClaims Dashboard Enhancements");
	static readonly REVBILLING_PAYMENT_TASK = new FeatureFlagApplicationKey('RCM.payment.task.enhancements', "Payment Task Enhancements");
	static readonly AUTOPOSTING_TASK_ASSIGNMENT = new FeatureFlagApplicationKey('APV2.autoposting.task.assignment', "Auto-Posting: Task Assignment");
	static readonly FILE_S3_UPLIFT_PATIENT_FILE = new FeatureFlagApplicationKey('ARCH.file.s3uplift.patientFile', "File Uplift: Patient File Access");
	static readonly FAMILY_CONTACTS_PERFORMANCE_ENHANCEMENT = new FeatureFlagApplicationKey('QOL.family.contacts.performance.enhancement', "Family/Contacts Performance Enhancements");
	static readonly FHIR_API_LAUNCH = new FeatureFlagApplicationKey('FHIR.api.launch', "FHIR API Launch");
	static readonly REVENGAGE_USER_ROLES = new FeatureFlagApplicationKey('REV.revengage.user.roles', "RevEngage User Roles");
	static readonly ORDERS_ARRELLIO_PROCESSOR_DEFAULT = new FeatureFlagApplicationKey('REV.arrellio.default-processor', "Arrellio Default Processor");
	static readonly FREE_APPT_REMINDERS = new FeatureFlagApplicationKey('REV.revconnect.freeApptReminders', "Free Appt Reminders");
	static readonly NEW_PHR = new FeatureFlagApplicationKey('REV.new.phr', "PHR");
	static readonly AI_SCRIBE = new FeatureFlagApplicationKey('REV.scribe', "AI Scribe");
	static readonly PATIENT_PORTAL_MVP = new FeatureFlagApplicationKey('REV.patient.portal.mvp', "Patient Portal MVP");
	static readonly REVPAY_REFUND_VOID = new FeatureFlagApplicationKey('REV.revpay.refund.void', "RevPay Refund/Void");
	
	static readonly VALUES: GandalfConstantList<FeatureFlagApplicationKey> = {
		label: 'Feature Flag Application Key',
		values: [FeatureFlagApplicationKey.TESTING, FeatureFlagApplicationKey.ADMIN_MENU_VENDORS_PARTNERS_OPEN_EDGE, FeatureFlagApplicationKey.ORDERS_TWELVE84, FeatureFlagApplicationKey.PRESCRIPTION_MONO_PD, FeatureFlagApplicationKey.SCHEDULE_APPOINTMENT_DETAILS_INSURANCE_VERIFICATION, FeatureFlagApplicationKey.REV_CLEAR, FeatureFlagApplicationKey.REV_CLEAR_AUTOPOSTING, FeatureFlagApplicationKey.RXNT_MULTIPLE_LOCATION_CREDENTIALS, FeatureFlagApplicationKey.AUTOPOSTING_X12_ASSOCIATIONS, FeatureFlagApplicationKey.ACCOUNTING_ERA_AUTOPOSTING_PAYMENT_GROUP_LOCATION, FeatureFlagApplicationKey.EMERGENCY_CONTACT, FeatureFlagApplicationKey.MESSAGING_MODULE, FeatureFlagApplicationKey.REVCONNECT_TWO_WAY_TEXT_MESSAGING, FeatureFlagApplicationKey.REVCONNECT_ANTI_SPAM, FeatureFlagApplicationKey.REVBILLING_CLAIMS_DASHBOARD, FeatureFlagApplicationKey.REVBILLING_PAYMENT_TASK, FeatureFlagApplicationKey.AUTOPOSTING_TASK_ASSIGNMENT, FeatureFlagApplicationKey.FILE_S3_UPLIFT_PATIENT_FILE, FeatureFlagApplicationKey.FAMILY_CONTACTS_PERFORMANCE_ENHANCEMENT, FeatureFlagApplicationKey.FHIR_API_LAUNCH, FeatureFlagApplicationKey.REVENGAGE_USER_ROLES, FeatureFlagApplicationKey.ORDERS_ARRELLIO_PROCESSOR_DEFAULT, FeatureFlagApplicationKey.FREE_APPT_REMINDERS, FeatureFlagApplicationKey.NEW_PHR, FeatureFlagApplicationKey.AI_SCRIBE, FeatureFlagApplicationKey.PATIENT_PORTAL_MVP, FeatureFlagApplicationKey.REVPAY_REFUND_VOID, ]
	};
}

/** see com.rev360.model.accounting.feeschedule.constant.feescheduleitemtype.FeeScheduleItemType */
/* istanbul ignore next */
export class FeeScheduleItemType extends GandalfConstant<number> {
	static readonly PRODUCT = new FeeScheduleItemType(1, "Product");
	static readonly SERVICE = new FeeScheduleItemType(2, "Service");
	
	static readonly VALUES: GandalfConstantList<FeeScheduleItemType> = {
		label: 'Fee Schedule Item Type',
		values: [FeeScheduleItemType.PRODUCT, FeeScheduleItemType.SERVICE, ]
	};
}

/** see com.rev360.model.accounting.feeschedule.constant.feeschedulerangecomputedstatus.FeeScheduleRangeComputedStatus */
/* istanbul ignore next */
export class FeeScheduleRangeComputedStatus extends GandalfConstant<number> {
	static readonly ALL = new FeeScheduleRangeComputedStatus(0, "All");
	static readonly CURRENT = new FeeScheduleRangeComputedStatus(1, "Current");
	static readonly FUTURE = new FeeScheduleRangeComputedStatus(2, "Future");
	static readonly PAST = new FeeScheduleRangeComputedStatus(3, "Past");
	
	static readonly VALUES: GandalfConstantList<FeeScheduleRangeComputedStatus> = {
		label: 'Fee Schedule Range Computed Status',
		values: [FeeScheduleRangeComputedStatus.ALL, FeeScheduleRangeComputedStatus.CURRENT, FeeScheduleRangeComputedStatus.FUTURE, FeeScheduleRangeComputedStatus.PAST, ]
	};
}

/** see com.rev360.model.accounting.feeschedule.constant.feeschedulerangestatus.FeeScheduleRangeStatus */
/* istanbul ignore next */
export class FeeScheduleRangeStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new FeeScheduleRangeStatus(0, "Inactive");
	static readonly ACTIVE = new FeeScheduleRangeStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<FeeScheduleRangeStatus> = {
		label: 'Fee Schedule Range Status',
		values: [FeeScheduleRangeStatus.INACTIVE, FeeScheduleRangeStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.accounting.feeschedule.constant.feeschedulestatus.FeeScheduleStatus */
/* istanbul ignore next */
export class FeeScheduleStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new FeeScheduleStatus(0, "Inactive");
	static readonly ACTIVE = new FeeScheduleStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<FeeScheduleStatus> = {
		label: 'Fee Schedule Status',
		values: [FeeScheduleStatus.INACTIVE, FeeScheduleStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.accounting.feeschedule.constant.feetype.FeeType */
/* istanbul ignore next */
export class FeeType extends GandalfConstant<number> {
	static readonly CPT_SERVICES = new FeeType(1, "CPT Services");
	static readonly OTHER_SERVICES = new FeeType(2, "Other Services");
	static readonly PRODUCTS = new FeeType(3, "Products");
	
	static readonly VALUES: GandalfConstantList<FeeType> = {
		label: 'Fee Type',
		values: [FeeType.CPT_SERVICES, FeeType.OTHER_SERVICES, FeeType.PRODUCTS, ]
	};
}

/** see com.rev360.model.field.constant.fielddatatype.FieldDataType */
/* istanbul ignore next */
export class FieldDataType extends GandalfConstant<number> {
	static readonly NONE = new FieldDataType(0, "None");
	static readonly BOOLEAN = new FieldDataType(1, "Boolean");
	static readonly DATE = new FieldDataType(2, "Date");
	static readonly DECIMAL = new FieldDataType(3, "Decimal");
	static readonly NUMBER = new FieldDataType(4, "Number");
	static readonly SELECTION = new FieldDataType(5, "Selection");
	static readonly STRING = new FieldDataType(6, "String");
	static readonly TIME = new FieldDataType(7, "Time");
	
	static readonly VALUES: GandalfConstantList<FieldDataType> = {
		label: 'Data Type',
		values: [FieldDataType.NONE, FieldDataType.BOOLEAN, FieldDataType.DATE, FieldDataType.DECIMAL, FieldDataType.NUMBER, FieldDataType.SELECTION, FieldDataType.STRING, FieldDataType.TIME, ]
	};
}

/** see com.rev360.model.field.constant.fieldstatus.FieldDefinitionStatus */
/* istanbul ignore next */
export class FieldDefinitionStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new FieldDefinitionStatus(0, "Inactive");
	static readonly ACTIVE = new FieldDefinitionStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<FieldDefinitionStatus> = {
		label: 'Field Definition Status',
		values: [FieldDefinitionStatus.INACTIVE, FieldDefinitionStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.field.constant.fielduicomponenttype.FieldUIComponentType */
/* istanbul ignore next */
export class FieldUIComponentType extends GandalfConstant<number> {
	static readonly NONE = new FieldUIComponentType(0, "None");
	static readonly TEXT = new FieldUIComponentType(1, "Text");
	static readonly TEXTAREA = new FieldUIComponentType(2, "Textarea");
	static readonly SELECTION = new FieldUIComponentType(3, "Single-Selection");
	static readonly MULTI_SELECTION = new FieldUIComponentType(4, "Multi-Selection");
	static readonly DATE = new FieldUIComponentType(5, "Date");
	static readonly TIME = new FieldUIComponentType(6, "Time");
	static readonly NUMBER_STEPPER = new FieldUIComponentType(7, "Number Stepper");
	static readonly CHECKBOX = new FieldUIComponentType(8, "Checkbox");
	static readonly OK_NOT_OK = new FieldUIComponentType(9, "Ok, Not Ok");
	static readonly RADIO = new FieldUIComponentType(10, "Radio");
	
	static readonly VALUES: GandalfConstantList<FieldUIComponentType> = {
		label: 'UI Component Type',
		values: [FieldUIComponentType.NONE, FieldUIComponentType.TEXT, FieldUIComponentType.TEXTAREA, FieldUIComponentType.SELECTION, FieldUIComponentType.MULTI_SELECTION, FieldUIComponentType.DATE, FieldUIComponentType.TIME, FieldUIComponentType.NUMBER_STEPPER, FieldUIComponentType.CHECKBOX, FieldUIComponentType.OK_NOT_OK, FieldUIComponentType.RADIO, ]
	};
}

/** see com.rev360.core.service.file.constant.fileextensionblacklist.FileExtensionBlacklist */
/* istanbul ignore next */
export class FileExtensionBlacklist extends GandalfConstant<string> {
	static readonly ACTION = new FileExtensionBlacklist('action', "ACTION");
	static readonly APK = new FileExtensionBlacklist('apk', "APK");
	static readonly APP = new FileExtensionBlacklist('app', "APP");
	static readonly BAT = new FileExtensionBlacklist('bat', "BAT");
	static readonly BIN = new FileExtensionBlacklist('bin', "BIN");
	static readonly CMD = new FileExtensionBlacklist('cmd', "CMD");
	static readonly COM = new FileExtensionBlacklist('com', "COM");
	static readonly COMMAND = new FileExtensionBlacklist('command', "COMMAND");
	static readonly CPL = new FileExtensionBlacklist('cpl', "CPL");
	static readonly CSH = new FileExtensionBlacklist('csh', "CSH");
	static readonly EXE = new FileExtensionBlacklist('exe', "EXE");
	static readonly GADGET = new FileExtensionBlacklist('gadget', "GADGET");
	static readonly INF = new FileExtensionBlacklist('inf', "INF");
	static readonly INS = new FileExtensionBlacklist('ins', "INS");
	static readonly INX = new FileExtensionBlacklist('inx', "INX");
	static readonly IPA = new FileExtensionBlacklist('ipa', "IPA");
	static readonly ISU = new FileExtensionBlacklist('isu', "ISU");
	static readonly JOB = new FileExtensionBlacklist('job', "JOB");
	static readonly JAR = new FileExtensionBlacklist('jar', "JAR");
	static readonly JSE = new FileExtensionBlacklist('jse', "JSE");
	static readonly KSH = new FileExtensionBlacklist('ksh', "KSH");
	static readonly LNK = new FileExtensionBlacklist('lnk', "LNK");
	static readonly MSC = new FileExtensionBlacklist('msc', "MSC");
	static readonly MSI = new FileExtensionBlacklist('msi', "MSI");
	static readonly MSP = new FileExtensionBlacklist('msp', "MSP");
	static readonly MST = new FileExtensionBlacklist('mst', "MST");
	static readonly OSX = new FileExtensionBlacklist('osx', "OSX");
	static readonly OUT = new FileExtensionBlacklist('out', "OUT");
	static readonly PAF = new FileExtensionBlacklist('paf', "PAF");
	static readonly PIF = new FileExtensionBlacklist('pif', "PIF");
	static readonly PKG = new FileExtensionBlacklist('pkg', "PKG");
	static readonly PRG = new FileExtensionBlacklist('prg', "PRG");
	static readonly PS1 = new FileExtensionBlacklist('ps1', "PS1");
	static readonly REG = new FileExtensionBlacklist('reg', "REG");
	static readonly RGS = new FileExtensionBlacklist('rgs', "RGS");
	static readonly RUN = new FileExtensionBlacklist('run', "RUN");
	static readonly SCR = new FileExtensionBlacklist('scr', "SCR");
	static readonly SCT = new FileExtensionBlacklist('sct', "SCT");
	static readonly SH = new FileExtensionBlacklist('sh', "SH");
	static readonly SHB = new FileExtensionBlacklist('shb', "SHB");
	static readonly SHS = new FileExtensionBlacklist('shs', "SHS");
	static readonly U3P = new FileExtensionBlacklist('u3p', "U3P");
	static readonly VB = new FileExtensionBlacklist('vb', "VB");
	static readonly VBE = new FileExtensionBlacklist('vbe', "VBE");
	static readonly VBS = new FileExtensionBlacklist('vbs', "VBS");
	static readonly VBSCRIPT = new FileExtensionBlacklist('vbscript', "VBSCRIPT");
	static readonly WORKFLOW = new FileExtensionBlacklist('workflow', "WORKFLOW");
	static readonly WS = new FileExtensionBlacklist('ws', "WS");
	static readonly WSF = new FileExtensionBlacklist('wsf', "WSF");
	static readonly WSH = new FileExtensionBlacklist('wsh', "WSH");
	
	static readonly VALUES: GandalfConstantList<FileExtensionBlacklist> = {
		label: 'FileExtensionBlacklist',
		values: [FileExtensionBlacklist.ACTION, FileExtensionBlacklist.APK, FileExtensionBlacklist.APP, FileExtensionBlacklist.BAT, FileExtensionBlacklist.BIN, FileExtensionBlacklist.CMD, FileExtensionBlacklist.COM, FileExtensionBlacklist.COMMAND, FileExtensionBlacklist.CPL, FileExtensionBlacklist.CSH, FileExtensionBlacklist.EXE, FileExtensionBlacklist.GADGET, FileExtensionBlacklist.INF, FileExtensionBlacklist.INS, FileExtensionBlacklist.INX, FileExtensionBlacklist.IPA, FileExtensionBlacklist.ISU, FileExtensionBlacklist.JOB, FileExtensionBlacklist.JAR, FileExtensionBlacklist.JSE, FileExtensionBlacklist.KSH, FileExtensionBlacklist.LNK, FileExtensionBlacklist.MSC, FileExtensionBlacklist.MSI, FileExtensionBlacklist.MSP, FileExtensionBlacklist.MST, FileExtensionBlacklist.OSX, FileExtensionBlacklist.OUT, FileExtensionBlacklist.PAF, FileExtensionBlacklist.PIF, FileExtensionBlacklist.PKG, FileExtensionBlacklist.PRG, FileExtensionBlacklist.PS1, FileExtensionBlacklist.REG, FileExtensionBlacklist.RGS, FileExtensionBlacklist.RUN, FileExtensionBlacklist.SCR, FileExtensionBlacklist.SCT, FileExtensionBlacklist.SH, FileExtensionBlacklist.SHB, FileExtensionBlacklist.SHS, FileExtensionBlacklist.U3P, FileExtensionBlacklist.VB, FileExtensionBlacklist.VBE, FileExtensionBlacklist.VBS, FileExtensionBlacklist.VBSCRIPT, FileExtensionBlacklist.WORKFLOW, FileExtensionBlacklist.WS, FileExtensionBlacklist.WSF, FileExtensionBlacklist.WSH, ]
	};
}

/** see com.rev360.model.file.constant.FileInfoStorageStatus */
/* istanbul ignore next */
export class FileInfoStatus extends GandalfConstant<number> {
	static readonly FILE_STORAGE_TRACKED = new FileInfoStatus(1, "File Storage Tracked");
	static readonly FILE_ACCESS_ERROR = new FileInfoStatus(2, "File Access Error");
	
	static readonly VALUES: GandalfConstantList<FileInfoStatus> = {
		label: 'File Status',
		values: [FileInfoStatus.FILE_STORAGE_TRACKED, FileInfoStatus.FILE_ACCESS_ERROR, ]
	};
}

/** see com.rev360.model.file.filestorage.masterfilestorage.storagetype.FileStorageType */
/* istanbul ignore next */
export class FileStorageType extends GandalfConstant<number> {
	static readonly FILE_SYSTEM = new FileStorageType(1, "File System");
	static readonly S3 = new FileStorageType(2, "S3");
	
	static readonly VALUES: GandalfConstantList<FileStorageType> = {
		label: 'File Storage Type',
		values: [FileStorageType.FILE_SYSTEM, FileStorageType.S3, ]
	};
}

/** see com.rev360.model.accounting.financecharge.constant.financechargeplanstatus.FinanceChargePlanStatus */
/* istanbul ignore next */
export class FinanceChargePlanStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new FinanceChargePlanStatus(-1, "Inactive");
	static readonly ACTIVE = new FinanceChargePlanStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<FinanceChargePlanStatus> = {
		label: 'Finance Charge Plan Status',
		values: [FinanceChargePlanStatus.INACTIVE, FinanceChargePlanStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.accounting.financecharge.constant.financechargetriggerstatus.FinanceChargeTriggerStatus */
/* istanbul ignore next */
export class FinanceChargeTriggerStatus extends GandalfConstant<number> {
	static readonly NEW = new FinanceChargeTriggerStatus(1, "New");
	static readonly PENDING = new FinanceChargeTriggerStatus(2, "Pending");
	static readonly IN_PROGRESS = new FinanceChargeTriggerStatus(3, "In Progress");
	static readonly FAILED = new FinanceChargeTriggerStatus(4, "Failed");
	static readonly COMPLETED = new FinanceChargeTriggerStatus(5, "Completed");
	static readonly WILL_NOT_DO_INVOICE_STATUS = new FinanceChargeTriggerStatus(10, "Will Not Do - Invoice Status");
	static readonly WILL_NOT_DO_INVOICE_UNAPPROVED = new FinanceChargeTriggerStatus(11, "Will Not Do - Invoice Unapproved");
	static readonly WILL_NOT_DO_MINIMUM_BALANCE = new FinanceChargeTriggerStatus(12, "Will Not Do - Minimum Balance");
	static readonly WILL_NOT_DO_BAD_DATES = new FinanceChargeTriggerStatus(13, "Will Not Do - Bad Dates");
	static readonly WILL_NOT_DO_MISSING_FCP = new FinanceChargeTriggerStatus(14, "Will Not Do - Missing FCP");
	static readonly WILL_NOT_DO_UNKNOWN = new FinanceChargeTriggerStatus(50, "Will Not Do - Unknown");
	
	static readonly VALUES: GandalfConstantList<FinanceChargeTriggerStatus> = {
		label: 'Finance Charge Trigger Status',
		values: [FinanceChargeTriggerStatus.NEW, FinanceChargeTriggerStatus.PENDING, FinanceChargeTriggerStatus.IN_PROGRESS, FinanceChargeTriggerStatus.FAILED, FinanceChargeTriggerStatus.COMPLETED, FinanceChargeTriggerStatus.WILL_NOT_DO_INVOICE_STATUS, FinanceChargeTriggerStatus.WILL_NOT_DO_INVOICE_UNAPPROVED, FinanceChargeTriggerStatus.WILL_NOT_DO_MINIMUM_BALANCE, FinanceChargeTriggerStatus.WILL_NOT_DO_BAD_DATES, FinanceChargeTriggerStatus.WILL_NOT_DO_MISSING_FCP, FinanceChargeTriggerStatus.WILL_NOT_DO_UNKNOWN, ]
	};
}

/** see com.rev360.core.service.encounter.dynamic.constant.FormFieldDefaultNormal */
/* istanbul ignore next */
export class FormFieldDefaultNormal extends GandalfConstant<string> {
	static readonly TODAY = new FormFieldDefaultNormal('TODAY', "Today");
	static readonly NOW = new FormFieldDefaultNormal('NOW', "Now");
	static readonly NONE = new FormFieldDefaultNormal('none', "None");
	static readonly TRUE = new FormFieldDefaultNormal('true', "True");
	static readonly FALSE = new FormFieldDefaultNormal('false', "False");
	
	static readonly VALUES: GandalfConstantList<FormFieldDefaultNormal> = {
		label: 'Form Field Default Normal',
		values: [FormFieldDefaultNormal.TODAY, FormFieldDefaultNormal.NOW, FormFieldDefaultNormal.NONE, FormFieldDefaultNormal.TRUE, FormFieldDefaultNormal.FALSE, ]
	};
}

/** see com.rev360.model.ws.framesdata.constant.framesdatasubscriptionstatus.FramesDataSubscriptionStatus */
/* istanbul ignore next */
export class FramesDataSubscriptionStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new FramesDataSubscriptionStatus(1, "Active");
	static readonly EXPIRED = new FramesDataSubscriptionStatus(2, "Expired");
	static readonly DISABLED = new FramesDataSubscriptionStatus(3, "Disabled");
	
	static readonly VALUES: GandalfConstantList<FramesDataSubscriptionStatus> = {
		label: 'Frames Data Subscription Status',
		values: [FramesDataSubscriptionStatus.ACTIVE, FramesDataSubscriptionStatus.EXPIRED, FramesDataSubscriptionStatus.DISABLED, ]
	};
}

/** see com.rev360.gandalf.core.constant.GandalfCacheKey */
/* istanbul ignore next */
export class GandalfCacheKey extends GandalfConstant<string> {
	static readonly REFERENCE_DATA = new GandalfCacheKey('reference_data', "Reference Data");
	static readonly PROVIDERS = new GandalfCacheKey('providers', "Providers");
	static readonly ENVIRONMENT_DATA = new GandalfCacheKey('environment_data', "Environment Data");
	static readonly TWELVE84 = new GandalfCacheKey('twelve84', "twelve84");
	static readonly ORDER_PROCESSOR_VENDORS = new GandalfCacheKey('order_processor_vendors', "Order Processor Vendors");
	static readonly SCHEDULE_GET_OFFICE_HORUS = new GandalfCacheKey('get_office_hours', "Schedule Get Office Hours");
	static readonly STATE_PROVINCES = new GandalfCacheKey('state_provinces', "States/Provinces");
	static readonly EMPLOYEES = new GandalfCacheKey('employees', "Employees");
	static readonly LOCATIONS = new GandalfCacheKey('locations', "Locations");
	static readonly ENCOUNTER_TEMPLATES = new GandalfCacheKey('encounter_templates', "Encounter Template");
	static readonly SECURITY_ROLES = new GandalfCacheKey('security_roles', "Security Roles");
	static readonly INSURANCE_COMPANIES = new GandalfCacheKey('insurance_companies', "Insurance Companies");
	static readonly VISIONWEB_SUPPLIERS = new GandalfCacheKey('visionweb_suppliers', "VisionWeb Suppliers");
	static readonly DOCUMENT_TEMPLATE_CATEGORIES = new GandalfCacheKey('document_template_categories', "Document Template Categories");
	static readonly SCRIBABLE_TESTS = new GandalfCacheKey('scribable_tests', "Scribable Tests");
	
	static readonly VALUES: GandalfConstantList<GandalfCacheKey> = {
		label: 'Gandalf Cache Key',
		values: [GandalfCacheKey.REFERENCE_DATA, GandalfCacheKey.PROVIDERS, GandalfCacheKey.ENVIRONMENT_DATA, GandalfCacheKey.TWELVE84, GandalfCacheKey.ORDER_PROCESSOR_VENDORS, GandalfCacheKey.SCHEDULE_GET_OFFICE_HORUS, GandalfCacheKey.STATE_PROVINCES, GandalfCacheKey.EMPLOYEES, GandalfCacheKey.LOCATIONS, GandalfCacheKey.ENCOUNTER_TEMPLATES, GandalfCacheKey.SECURITY_ROLES, GandalfCacheKey.INSURANCE_COMPANIES, GandalfCacheKey.VISIONWEB_SUPPLIERS, GandalfCacheKey.DOCUMENT_TEMPLATE_CATEGORIES, GandalfCacheKey.SCRIBABLE_TESTS, ]
	};
}

/** see com.rev360.model.person.constant.gender.Gender */
/* istanbul ignore next */
export class Gender extends GandalfConstant<number> {
	static readonly NO_INFORMATION = new Gender(0, "None Entered");
	static readonly UNKNOWN = new Gender(3, "Unknown");
	static readonly MALE = new Gender(1, "Male");
	static readonly FEMALE = new Gender(2, "Female");
	
	static readonly VALUES: GandalfConstantList<Gender> = {
		label: 'Gender',
		values: [Gender.NO_INFORMATION, Gender.UNKNOWN, Gender.MALE, Gender.FEMALE, ]
	};
}

/** see com.rev360.model.data.constant.genderidentity.GenderIdentity */
/* istanbul ignore next */
export class GenderIdentity extends GandalfConstant<number> {
	static readonly MALE = new GenderIdentity(21000, "Identifies as Male");
	static readonly FEMALE = new GenderIdentity(21001, "Identifies as Female");
	static readonly FEMALE_TO_MALE = new GenderIdentity(21002, "Female-to-Male (FTM)/Transgender Male/Trans Man");
	static readonly MALE_TO_FEMALE = new GenderIdentity(21003, "Male-to-Female (MTF)/Transgender Female/Trans Woman");
	static readonly GENDERQUEER = new GenderIdentity(21004, "Genderqueer, neither exclusively male nor female");
	static readonly ADDITIONAL_GENDER = new GenderIdentity(21005, "Additional gender category or other, please specify");
	static readonly UNDISCLOSED = new GenderIdentity(21006, "Choose not to disclose");
	
	static readonly VALUES: GandalfConstantList<GenderIdentity> = {
		label: 'Gender Identity',
		values: [GenderIdentity.MALE, GenderIdentity.FEMALE, GenderIdentity.FEMALE_TO_MALE, GenderIdentity.MALE_TO_FEMALE, GenderIdentity.GENDERQUEER, GenderIdentity.ADDITIONAL_GENDER, GenderIdentity.UNDISCLOSED, ]
	};
}

/** see com.rev360.pms.service.reporting.constant.GenderSearch */
/* istanbul ignore next */
export class GenderSearch extends GandalfConstant<number> {
	static readonly ALL = new GenderSearch(null, "All");
	static readonly MALE = new GenderSearch(1, "Male");
	static readonly FEMALE = new GenderSearch(2, "Female");
	static readonly UNKNOWN = new GenderSearch(3, "Unknown");
	
	static readonly VALUES: GandalfConstantList<GenderSearch> = {
		label: 'Gender Search',
		values: [GenderSearch.ALL, GenderSearch.MALE, GenderSearch.FEMALE, GenderSearch.UNKNOWN, ]
	};
}

/** see com.rev360.model.patient.constant.gradelevel.GradeLevel */
/* istanbul ignore next */
export class GradeLevel extends GandalfConstant<number> {
	static readonly GRADE_0 = new GradeLevel(0, "0");
	static readonly GRADE_1 = new GradeLevel(1, "1");
	static readonly GRADE_2 = new GradeLevel(2, "2");
	static readonly GRADE_3 = new GradeLevel(3, "3");
	static readonly GRADE_4 = new GradeLevel(4, "4");
	static readonly GRADE_5 = new GradeLevel(5, "5");
	
	static readonly VALUES: GandalfConstantList<GradeLevel> = {
		label: 'Grade Level',
		values: [GradeLevel.GRADE_0, GradeLevel.GRADE_1, GradeLevel.GRADE_2, GradeLevel.GRADE_3, GradeLevel.GRADE_4, GradeLevel.GRADE_5, ]
	};
}

/** see com.rev360.model.insurance.constant.groupnumberqualifier.GroupNumberQualifier */
/* istanbul ignore next */
export class GroupNumberQualifier extends GandalfConstant<string> {
	static readonly NONE = new GroupNumberQualifier('', "");
	static readonly STATE_LICENSE = new GroupNumberQualifier('0B', "0B-State License Number");
	static readonly BLUE_SHIELD_PROVIDER = new GroupNumberQualifier('1B', "1B-Blue Shield Provider Number");
	static readonly MEDICARE_PROVIDER = new GroupNumberQualifier('1C', "1C-Medicare Provider Number");
	static readonly MEDICAID_PROVIDER = new GroupNumberQualifier('1D', "1D-Medicaid Provider Number");
	static readonly PROVIDER_UPIN = new GroupNumberQualifier('1G', "1G-Provider UPIN");
	static readonly CHAMPUS_ID = new GroupNumberQualifier('1H', "1H-CHAMPUS Id Number");
	static readonly EMPLOYERS_ID = new GroupNumberQualifier('E1', "E1-Employer Id Number");
	static readonly PROVIDER_COMMERCIAL = new GroupNumberQualifier('G2', "G2-Provider Commercial Number");
	static readonly LOCATION_NUMBER = new GroupNumberQualifier('LU', "LU-Location Number");
	static readonly PROVIDER_PLAN_NETWORK = new GroupNumberQualifier('N5', "N5-Provider Plan Network Id Number");
	static readonly SOCIAL_SECURITY = new GroupNumberQualifier('SY', "SY-Social Security Number");
	static readonly STATE_INDUSTRIAL_ACCIDENT_PROVIDER = new GroupNumberQualifier('X5', "X5-State Industrial Accident Provider Number");
	static readonly PROVIDER_TAXONOMY_ZZ = new GroupNumberQualifier('ZZ', "ZZ-Provider Taxonomy");
	static readonly PROVIDER_TAXONOMY_PXC = new GroupNumberQualifier('PXC', "PXC-Provider Taxonomy");
	static readonly BILLING_NPI = new GroupNumberQualifier('NPI', "NPI-Billing NPI");
	static readonly BILLING_NPI_ENTITY_TYPE = new GroupNumberQualifier('NET', "NET-Billing NPI Entity Type");
	
	static readonly VALUES: GandalfConstantList<GroupNumberQualifier> = {
		label: 'Group Number Qualifier',
		values: [GroupNumberQualifier.NONE, GroupNumberQualifier.STATE_LICENSE, GroupNumberQualifier.BLUE_SHIELD_PROVIDER, GroupNumberQualifier.MEDICARE_PROVIDER, GroupNumberQualifier.MEDICAID_PROVIDER, GroupNumberQualifier.PROVIDER_UPIN, GroupNumberQualifier.CHAMPUS_ID, GroupNumberQualifier.EMPLOYERS_ID, GroupNumberQualifier.PROVIDER_COMMERCIAL, GroupNumberQualifier.LOCATION_NUMBER, GroupNumberQualifier.PROVIDER_PLAN_NETWORK, GroupNumberQualifier.SOCIAL_SECURITY, GroupNumberQualifier.STATE_INDUSTRIAL_ACCIDENT_PROVIDER, GroupNumberQualifier.PROVIDER_TAXONOMY_ZZ, GroupNumberQualifier.PROVIDER_TAXONOMY_PXC, GroupNumberQualifier.BILLING_NPI, GroupNumberQualifier.BILLING_NPI_ENTITY_TYPE, ]
	};
}

/** see com.rev360.pms.service.surveillance.constant.Hl7ValueSetOid */
/* istanbul ignore next */
export class Hl7ValueSetOid extends GandalfConstant<string> {
	static readonly STATE = new Hl7ValueSetOid('2.16.840.1.114222.4.11.830', "State");
	static readonly COUNTY = new Hl7ValueSetOid('2.16.840.1.114222.4.11.829', "County");
	static readonly JURISDICTION = new Hl7ValueSetOid('2.16.840.1.114222.4.11.3236', "National Reporting Jurisdiction");
	static readonly NAME_TYPE = new Hl7ValueSetOid('2.16.840.1.114222.4.11.810', "Name Type (HL7)");
	static readonly CASE_STATUS = new Hl7ValueSetOid('2.16.840.1.114222.4.11.968', "Case Classification Status");
	static readonly NOTIFICATION_TYPE = new Hl7ValueSetOid('2.16.840.1.114222.4.11.1107', "Notification Section Header");
	static readonly DISEASE_COND = new Hl7ValueSetOid('2.16.840.1.114222.4.11.1015', "Nationally Notifiable Disease Surveillance System (NNDSS) & Other Conditions of Public Health Importance");
	static readonly ADMINISTER_SITE = new Hl7ValueSetOid('2.16.840.1.114222.4.11.3370', "Administrative Site");
	static readonly ADMINISTER_ROUTE = new Hl7ValueSetOid('2.16.840.1.114222.4.11.816', "Route Of Administration");
	
	static readonly VALUES: GandalfConstantList<Hl7ValueSetOid> = {
		label: 'HL7 Value Set OID',
		values: [Hl7ValueSetOid.STATE, Hl7ValueSetOid.COUNTY, Hl7ValueSetOid.JURISDICTION, Hl7ValueSetOid.NAME_TYPE, Hl7ValueSetOid.CASE_STATUS, Hl7ValueSetOid.NOTIFICATION_TYPE, Hl7ValueSetOid.DISEASE_COND, Hl7ValueSetOid.ADMINISTER_SITE, Hl7ValueSetOid.ADMINISTER_ROUTE, ]
	};
}

/** see com.rev360.model.prescription.constant.horizontalprismorientation.HorizontalPrismOrientation */
/* istanbul ignore next */
export class HorizontalPrismOrientation extends GandalfConstant<string> {
	static readonly BASE_IN = new HorizontalPrismOrientation('BI', "BI");
	static readonly BASE_OUT = new HorizontalPrismOrientation('BO', "BO");
	static readonly BLANK = new HorizontalPrismOrientation(' ', "");
	static readonly NONE = new HorizontalPrismOrientation('', "");
	
	static readonly VALUES: GandalfConstantList<HorizontalPrismOrientation> = {
		label: 'Horizontal Prism Orientation',
		values: [HorizontalPrismOrientation.BASE_IN, HorizontalPrismOrientation.BASE_OUT, HorizontalPrismOrientation.BLANK, HorizontalPrismOrientation.NONE, ]
	};
}

/** see com.rev360.model.imaging.constant.imagingfiledomain.ImagingFileDomain */
/* istanbul ignore next */
export class ImagingFileDomain extends GandalfConstant<number> {
	static readonly CLERICAL = new ImagingFileDomain(1, "Clerical");
	static readonly CLINICAL = new ImagingFileDomain(2, "Clinical");
	
	static readonly VALUES: GandalfConstantList<ImagingFileDomain> = {
		label: 'Imaging File Domain',
		values: [ImagingFileDomain.CLERICAL, ImagingFileDomain.CLINICAL, ]
	};
}

/** see com.rev360.model.patient.constant.implantabledevicestatus.ImplantableDeviceStatus */
/* istanbul ignore next */
export class ImplantableDeviceStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new ImplantableDeviceStatus(0, "Inactive");
	static readonly ACTIVE = new ImplantableDeviceStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<ImplantableDeviceStatus> = {
		label: 'Implantable Device Status',
		values: [ImplantableDeviceStatus.INACTIVE, ImplantableDeviceStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.interoperability.constant.importtaskfileownertype.ImportTaskFileOwnerType */
/* istanbul ignore next */
export class ImportTaskFileOwnerType extends GandalfConstant<number> {
	static readonly PATIENT = new ImportTaskFileOwnerType(0, "Patient");
	static readonly PRACTICE = new ImportTaskFileOwnerType(1, "Practice");
	
	static readonly VALUES: GandalfConstantList<ImportTaskFileOwnerType> = {
		label: 'Import Task File Owner Type',
		values: [ImportTaskFileOwnerType.PATIENT, ImportTaskFileOwnerType.PRACTICE, ]
	};
}

/** see com.rev360.model.common.constant.informationrequestdeliveryformat.InformationRequestDeliveryFormat */
/* istanbul ignore next */
export class InformationRequestDeliveryFormat extends GandalfConstant<number> {
	static readonly PHYSICAL_DOCUMENT = new InformationRequestDeliveryFormat(1, "Physical Document");
	static readonly ELECTRONIC_FILE = new InformationRequestDeliveryFormat(2, "Electronic File");
	
	static readonly VALUES: GandalfConstantList<InformationRequestDeliveryFormat> = {
		label: 'InformationRequestDeliveryFormat',
		values: [InformationRequestDeliveryFormat.PHYSICAL_DOCUMENT, InformationRequestDeliveryFormat.ELECTRONIC_FILE, ]
	};
}

/** see com.rev360.model.common.constant.informationrequestdeliverymechanism.InformationRequestDeliveryMechanism */
/* istanbul ignore next */
export class InformationRequestDeliveryMechanism extends GandalfConstant<number> {
	static readonly UNKNOWN = new InformationRequestDeliveryMechanism(0, "Unknown");
	static readonly PHONE = new InformationRequestDeliveryMechanism(1, "Phone");
	static readonly EMAIL = new InformationRequestDeliveryMechanism(2, "Email");
	static readonly FAX = new InformationRequestDeliveryMechanism(3, "Fax");
	static readonly TEXT = new InformationRequestDeliveryMechanism(4, "Text");
	static readonly INSTANT_MESSAGING = new InformationRequestDeliveryMechanism(5, "Instant Messaging");
	static readonly IN_PERSON = new InformationRequestDeliveryMechanism(6, "Person");
	static readonly MAIL = new InformationRequestDeliveryMechanism(7, "Mail");
	
	static readonly VALUES: GandalfConstantList<InformationRequestDeliveryMechanism> = {
		label: 'Information Request Delivery Mechanism',
		values: [InformationRequestDeliveryMechanism.UNKNOWN, InformationRequestDeliveryMechanism.PHONE, InformationRequestDeliveryMechanism.EMAIL, InformationRequestDeliveryMechanism.FAX, InformationRequestDeliveryMechanism.TEXT, InformationRequestDeliveryMechanism.INSTANT_MESSAGING, InformationRequestDeliveryMechanism.IN_PERSON, InformationRequestDeliveryMechanism.MAIL, ]
	};
}

/** see com.rev360.model.common.constant.informationrequestrequestedbytype.InformationRequestRequestedByType */
/* istanbul ignore next */
export class InformationRequestRequestedByType extends GandalfConstant<number> {
	static readonly PATIENT = new InformationRequestRequestedByType(1, "Patient");
	static readonly PROVIDER = new InformationRequestRequestedByType(2, "Provider");
	static readonly OTHER = new InformationRequestRequestedByType(10, "Other");
	
	static readonly VALUES: GandalfConstantList<InformationRequestRequestedByType> = {
		label: 'Information Request Requested By Type',
		values: [InformationRequestRequestedByType.PATIENT, InformationRequestRequestedByType.PROVIDER, InformationRequestRequestedByType.OTHER, ]
	};
}

/** see com.rev360.model.common.constant.informationrequesttype.InformationRequestType */
/* istanbul ignore next */
export class InformationRequestType extends GandalfConstant<number> {
	static readonly CLINICAL = new InformationRequestType(1, "Clinical");
	
	static readonly VALUES: GandalfConstantList<InformationRequestType> = {
		label: 'InformationRequestType',
		values: [InformationRequestType.CLINICAL, ]
	};
}

/** see com.rev360.model.insurance.constant.insuranceclaimprocessorname.InsuranceClaimProcessorName */
/* istanbul ignore next */
export class InsuranceClaimProcessorName extends GandalfConstant<number> {
	static readonly TRIZETTO = new InsuranceClaimProcessorName(1, "TriZetto");
	static readonly VSP = new InsuranceClaimProcessorName(2, "VSP");
	static readonly BLUE_CROSS_BLUE_SHIELD = new InsuranceClaimProcessorName(3, "Blue Cross Blue Shield");
	static readonly LOCAL_837_5010 = new InsuranceClaimProcessorName(4, "Local 837 (5010)");
	static readonly LOCAL_1500_HCFA = new InsuranceClaimProcessorName(5, "Local 1500 (HCFA)");
	static readonly LOCAL_SENDER_837_5010 = new InsuranceClaimProcessorName(6, "Local Sender 837 (5010)");
	static readonly CABMD = new InsuranceClaimProcessorName(10, "CabMd");
	static readonly APEX_EDI = new InsuranceClaimProcessorName(11, "Apex EDI");
	static readonly CLINIC_AID = new InsuranceClaimProcessorName(12, "Clinic Aid");
	
	static readonly VALUES: GandalfConstantList<InsuranceClaimProcessorName> = {
		label: 'Insurance Claim Processor Name',
		values: [InsuranceClaimProcessorName.TRIZETTO, InsuranceClaimProcessorName.VSP, InsuranceClaimProcessorName.BLUE_CROSS_BLUE_SHIELD, InsuranceClaimProcessorName.LOCAL_837_5010, InsuranceClaimProcessorName.LOCAL_1500_HCFA, InsuranceClaimProcessorName.LOCAL_SENDER_837_5010, InsuranceClaimProcessorName.CABMD, InsuranceClaimProcessorName.APEX_EDI, InsuranceClaimProcessorName.CLINIC_AID, ]
	};
}

/** see com.rev360.model.insurance.constant.insuranceclaimprocessorstatus.InsuranceClaimProcessorStatus */
/* istanbul ignore next */
export class InsuranceClaimProcessorStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new InsuranceClaimProcessorStatus(0, "Inactive");
	static readonly ACTIVE = new InsuranceClaimProcessorStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<InsuranceClaimProcessorStatus> = {
		label: 'Insurance Claim Processor Status',
		values: [InsuranceClaimProcessorStatus.INACTIVE, InsuranceClaimProcessorStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.insurance.constant.insuranceclaimstatus.InsuranceClaimStatus */
/* istanbul ignore next */
export class InsuranceClaimStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new InsuranceClaimStatus(0, "Inactive");
	static readonly ACTIVE = new InsuranceClaimStatus(1, "Active");
	static readonly REJECTED = new InsuranceClaimStatus(2, "Rejected");
	static readonly APPROVED = new InsuranceClaimStatus(3, "Approved");
	static readonly COMPLETE = new InsuranceClaimStatus(4, "Complete");
	static readonly DELETED = new InsuranceClaimStatus(5, "Deleted");
	static readonly CANCELED = new InsuranceClaimStatus(6, "Canceled");
	
	static readonly VALUES: GandalfConstantList<InsuranceClaimStatus> = {
		label: 'Claim Status',
		values: [InsuranceClaimStatus.INACTIVE, InsuranceClaimStatus.ACTIVE, InsuranceClaimStatus.REJECTED, InsuranceClaimStatus.APPROVED, InsuranceClaimStatus.COMPLETE, InsuranceClaimStatus.DELETED, InsuranceClaimStatus.CANCELED, ]
	};
}

/** see com.rev360.model.data.constant.insuranceclassification.InsuranceClassification */
/* istanbul ignore next */
export class InsuranceClassification extends GandalfConstant<number> {
	static readonly MEDICARE = new InsuranceClassification(1900, "Medicare");
	static readonly MEDICAID = new InsuranceClassification(1901, "Medicaid");
	static readonly TRICARE = new InsuranceClassification(1902, "Tricare");
	static readonly CHAMPVA = new InsuranceClassification(1903, "Champva");
	static readonly GROUP = new InsuranceClassification(1904, "Group Health Plan");
	static readonly FECA = new InsuranceClassification(1905, "FECA Black Lung");
	static readonly OTHER = new InsuranceClassification(1906, "Other");
	static readonly VSP = new InsuranceClassification(1920, "VSP");
	static readonly OHIP = new InsuranceClassification(1921, "OHIP");
	static readonly CANADA_BC_MSP = new InsuranceClassification(1922, "Canada BC MSP");
	static readonly CANADA_AB = new InsuranceClassification(1923, "Canada AB");
	
	static readonly VALUES: GandalfConstantList<InsuranceClassification> = {
		label: 'Insurance Classification',
		values: [InsuranceClassification.MEDICARE, InsuranceClassification.MEDICAID, InsuranceClassification.TRICARE, InsuranceClassification.CHAMPVA, InsuranceClassification.GROUP, InsuranceClassification.FECA, InsuranceClassification.OTHER, InsuranceClassification.VSP, InsuranceClassification.OHIP, InsuranceClassification.CANADA_BC_MSP, InsuranceClassification.CANADA_AB, ]
	};
}

/** see com.rev360.model.insurance.constant.insurancecompanystatus.InsuranceCompanyStatus */
/* istanbul ignore next */
export class InsuranceCompanyStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new InsuranceCompanyStatus(0, "Inactive");
	static readonly ACTIVE = new InsuranceCompanyStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<InsuranceCompanyStatus> = {
		label: 'Insurance Company Status',
		values: [InsuranceCompanyStatus.INACTIVE, InsuranceCompanyStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.insurance.constant.insurancepayertypecode.InsurancePayerTypeCode */
/* istanbul ignore next */
export class InsurancePayerTypeCode extends GandalfConstant<number> {
	static readonly MEDICARE = new InsurancePayerTypeCode(1, "MEDICARE");
	static readonly MEDICARE_MANAGED_CARE_INCLUDES_MEDICARE_ADVANTAGE_PLANS = new InsurancePayerTypeCode(11, "Medicare Managed Care (Includes Medicare Advantage Plans)");
	static readonly MEDICARE_CHRONIC_CONDITION_SPECIAL_NEEDS_PLAN_C_SNP = new InsurancePayerTypeCode(1111, "Medicare Chronic Condition Special Needs Plan (C-SNP)");
	static readonly MEDICARE_PPO = new InsurancePayerTypeCode(112, "Medicare PPO");
	static readonly MEDICARE_POS = new InsurancePayerTypeCode(113, "Medicare POS");
	static readonly MEDICARE_MANAGED_CARE_OTHER = new InsurancePayerTypeCode(119, "Medicare Managed Care Other");
	static readonly MEDICARE_NON_MANAGED_CARE = new InsurancePayerTypeCode(12, "Medicare (Non-managed Care)");
	static readonly MEDICARE_FFS = new InsurancePayerTypeCode(121, "Medicare FFS");
	static readonly MEDICARE_DRUG_BENEFIT = new InsurancePayerTypeCode(122, "Medicare Drug Benefit");
	static readonly MEDICARE_MEDICAL_SAVINGS_ACCOUNT_MSA = new InsurancePayerTypeCode(123, "Medicare Medical Savings Account (MSA)");
	static readonly MEDICARE_NON_MANAGED_CARE_OTHER = new InsurancePayerTypeCode(129, "Medicare Non-managed Care Other");
	static readonly MEDICARE_HOSPICE = new InsurancePayerTypeCode(13, "Medicare Hospice");
	static readonly DUAL_ELIGIBILITY_MEDICARE_MEDICAID_ORGANIZATION = new InsurancePayerTypeCode(14, "Dual Eligibility Medicare/Medicaid Organization");
	static readonly DUAL_ELIGIBLE_SPECIAL_NEEDS_PLAN_D_SNP = new InsurancePayerTypeCode(141, "Dual Eligible Special Needs Plan (D-SNP)");
	static readonly FULLY_INTEGRATED_DUAL_ELIGIBLE_SPECIAL_NEEDS_PLAN_FIDE_SNP = new InsurancePayerTypeCode(142, "Fully Integrated Dual Eligible Special Needs Plan (FIDE-SNP)");
	static readonly MEDICARE_OTHER = new InsurancePayerTypeCode(19, "Medicare Other");
	static readonly MEDICARE_PHARMACY_BENEFIT_MANAGER = new InsurancePayerTypeCode(191, "Medicare Pharmacy Benefit Manager");
	static readonly MEDICAID = new InsurancePayerTypeCode(2, "MEDICAID");
	static readonly MEDICAID_MANAGED_CARE = new InsurancePayerTypeCode(21, "Medicaid (Managed Care)");
	static readonly MEDICAID_HMO = new InsurancePayerTypeCode(211, "Medicaid HMO");
	static readonly MEDICAID_PPO = new InsurancePayerTypeCode(212, "Medicaid PPO");
	static readonly MEDICAID_PCCM_PRIMARY_CARE_CASE_MANAGEMENT = new InsurancePayerTypeCode(213, "Medicaid PCCM (Primary Care Case Management)");
	static readonly MEDICAID_MANAGED_CARE_OTHER = new InsurancePayerTypeCode(219, "Medicaid Managed Care Other");
	static readonly MEDICAID_NON_MANAGED_CARE_PLAN = new InsurancePayerTypeCode(22, "Medicaid (Non-managed Care Plan)");
	static readonly MEDICAID_SCHIP = new InsurancePayerTypeCode(23, "Medicaid/SCHIP");
	static readonly MEDICAID_OUT_OF_STATE = new InsurancePayerTypeCode(25, "Medicaid - Out of State");
	static readonly MEDICAID_LONG_TERM_CARE = new InsurancePayerTypeCode(26, "Medicaid - Long Term Care");
	static readonly MEDICAID_OTHER = new InsurancePayerTypeCode(29, "Medicaid Other");
	static readonly MEDICAID_PHARMACY_BENEFIT_MANAGER = new InsurancePayerTypeCode(291, "Medicaid Pharmacy Benefit Manager");
	static readonly MEDICAID_DENTAL = new InsurancePayerTypeCode(299, "Medicaid - Dental");
	static readonly OTHER_GOVERNMENT_FEDERAL_STATE_LOCAL_EXCLUDING_DEPARTMENT_OF_CORRECTIONS = new InsurancePayerTypeCode(3, "OTHER GOVERNMENT (Federal/State/Local) (excluding Department of Corrections)");
	static readonly DEPARTMENT_OF_DEFENSE = new InsurancePayerTypeCode(31, "Department of Defense");
	static readonly TRICARE_CHAMPUS = new InsurancePayerTypeCode(311, "TRICARE (CHAMPUS)");
	static readonly TRICARE_STANDARD_FEE_FOR_SERVICE = new InsurancePayerTypeCode(3113, "TRICARE Standard - Fee For Service");
	static readonly MILITARY_TREATMENT_FACILITY = new InsurancePayerTypeCode(312, "Military Treatment Facility");
	static readonly TRICARE_FOR_LIFE_TFL = new InsurancePayerTypeCode(3123, "TRICARE For Life (TFL)");
	static readonly DENTAL_STAND_ALONE = new InsurancePayerTypeCode(313, "Dental --Stand Alone");
	static readonly DEPARTMENT_OF_VETERANS_AFFAIRS = new InsurancePayerTypeCode(32, "Department of Veterans Affairs");
	static readonly VETERAN_CARE_CARE_PROVIDED_TO_VETERANS = new InsurancePayerTypeCode(321, "Veteran care-Care provided to Veterans");
	static readonly NON_VETERAN_CARE = new InsurancePayerTypeCode(322, "Non-veteran care");
	static readonly CIVILIAN_HEALTH_AND_MEDICAL_PROGRAM_FOR_THE_VA_CHAMPVA = new InsurancePayerTypeCode(3221, "Civilian Health and Medical Program for the VA (CHAMPVA)");
	static readonly INDIAN_HEALTH_SERVICE_OR_TRIBE = new InsurancePayerTypeCode(33, "Indian Health Service or Tribe");
	static readonly INDIAN_HEALTH_SERVICE_REGULAR = new InsurancePayerTypeCode(331, "Indian Health Service - Regular");
	static readonly INDIAN_HEALTH_SERVICE_CONTRACT = new InsurancePayerTypeCode(332, "Indian Health Service - Contract");
	static readonly INDIAN_HEALTH_SERVICE_MANAGED_CARE = new InsurancePayerTypeCode(333, "Indian Health Service - Managed Care");
	static readonly INDIAN_TRIBE_SPONSORED_COVERAGE = new InsurancePayerTypeCode(334, "Indian Tribe - Sponsored Coverage");
	static readonly HRSA_PROGRAM = new InsurancePayerTypeCode(34, "HRSA Program");
	static readonly TITLE_V_MCH_BLOCK_GRANT = new InsurancePayerTypeCode(341, "Title V (MCH Block Grant)");
	static readonly MIGRANT_HEALTH_PROGRAM = new InsurancePayerTypeCode(342, "Migrant Health Program");
	static readonly RYAN_WHITE_ACT = new InsurancePayerTypeCode(343, "Ryan White Act");
	static readonly DISASTER_RELATED_INCLUDES_COVID_19 = new InsurancePayerTypeCode(344, "Disaster-related (includes Covid-19)");
	static readonly OTHER = new InsurancePayerTypeCode(349, "Other");
	static readonly BLACK_LUNG = new InsurancePayerTypeCode(35, "Black Lung");
	static readonly STATE_GOVERNMENT = new InsurancePayerTypeCode(36, "State Government");
	static readonly STATE_SCHIP_PROGRAM_CODES_FOR_INDIVIDUAL_STATES = new InsurancePayerTypeCode(361, "State SCHIP program (codes for individual states)");
	static readonly SPECIFIC_STATE_PROGRAMS_LIST_LOCAL_CODE = new InsurancePayerTypeCode(362, "Specific state programs (list/ local code)");
	static readonly STATE_NOT_OTHERWISE_SPECIFIED_OTHER_STATE = new InsurancePayerTypeCode(369, "State, not otherwise specified (other state)");
	static readonly LOCAL_GOVERNMENT = new InsurancePayerTypeCode(37, "Local Government");
	static readonly LOCAL_MANAGED_CARE = new InsurancePayerTypeCode(371, "Local - Managed care");
	static readonly FFS_INDEMNITY = new InsurancePayerTypeCode(372, "FFS/Indemnity");
	static readonly LOCAL_NOT_OTHERWISE_SPECIFIED_OTHER_LOCAL_COUNTY = new InsurancePayerTypeCode(379, "Local, not otherwise specified (other local, county)");
	static readonly OTHER_GOVERNMENT_FEDERAL_STATE_LOCAL_NOT_SPECIFIED = new InsurancePayerTypeCode(38, "Other Government (Federal, State, Local not specified)");
	static readonly FEDERAL_STATE_LOCAL_NOT_SPECIFIED_MANAGED_CARE = new InsurancePayerTypeCode(381, "Federal, State, Local not specified managed care");
	static readonly FEDERAL_STATE_LOCAL_NOT_SPECIFIED_FFS = new InsurancePayerTypeCode(382, "Federal, State, Local not specified - FFS");
	static readonly FEDERAL_STATE_LOCAL_NOT_SPECIFIED_OTHER = new InsurancePayerTypeCode(389, "Federal, State, Local not specified - Other");
	static readonly OTHER_FEDERAL = new InsurancePayerTypeCode(39, "Other Federal");
	static readonly FEDERAL_EMPLOYEE_HEALTH_PLAN_USE_WHEN_KNOWN = new InsurancePayerTypeCode(391, "Federal Employee Health Plan - Use when known");
	static readonly DEPARTMENTS_OF_CORRECTIONS = new InsurancePayerTypeCode(4, "DEPARTMENTS OF CORRECTIONS");
	static readonly CORRECTIONS_FEDERAL = new InsurancePayerTypeCode(41, "Corrections Federal");
	static readonly CORRECTIONS_STATE = new InsurancePayerTypeCode(42, "Corrections State");
	static readonly CORRECTIONS_LOCAL = new InsurancePayerTypeCode(43, "Corrections Local");
	static readonly CORRECTIONS_UNKNOWN_LEVEL = new InsurancePayerTypeCode(44, "Corrections Unknown Level");
	static readonly PRIVATE_HEALTH_INSURANCE = new InsurancePayerTypeCode(5, "PRIVATE HEALTH INSURANCE");
	static readonly MANAGED_CARE_PRIVATE = new InsurancePayerTypeCode(51, "Managed Care (Private)");
	static readonly COMMERCIAL_MANAGED_CARE_HMO = new InsurancePayerTypeCode(511, "Commercial Managed Care - HMO");
	static readonly COMMERCIAL_MANAGED_CARE_PPO = new InsurancePayerTypeCode(512, "Commercial Managed Care - PPO");
	static readonly COMMERCIAL_MANAGED_CARE_POS = new InsurancePayerTypeCode(513, "Commercial Managed Care - POS");
	static readonly EXCLUSIVE_PROVIDER_ORGANIZATION = new InsurancePayerTypeCode(514, "Exclusive Provider Organization");
	static readonly GATEKEEPER_PPO_GPPO = new InsurancePayerTypeCode(515, "Gatekeeper PPO (GPPO)");
	static readonly COMMERCIAL_MANAGED_CARE_PHARMACY_BENEFIT_MANAGER = new InsurancePayerTypeCode(516, "Commercial Managed Care - Pharmacy Benefit Manager");
	static readonly COMMERCIAL_MANAGED_CARE_DENTAL = new InsurancePayerTypeCode(517, "Commercial Managed Care - Dental");
	static readonly MANAGED_CARE_OTHER_NON_HMO = new InsurancePayerTypeCode(519, "Managed Care, Other (non HMO)");
	static readonly PRIVATE_HEALTH_INSURANCE_INDEMNITY = new InsurancePayerTypeCode(52, "Private Health Insurance - Indemnity");
	static readonly COMMERCIAL_INDEMNITY = new InsurancePayerTypeCode(521, "Commercial Indemnity");
	static readonly SELF_INSURED_ERISA_ADMINISTRATIVE_SERVICES_ONLY_ASO_PLAN = new InsurancePayerTypeCode(522, "Self-insured (ERISA) Administrative Services Only (ASO) plan");
	static readonly MEDICARE_SUPPLEMENTAL_POLICY_AS_SECOND_PAYER = new InsurancePayerTypeCode(523, "Medicare supplemental policy (as second payer)");
	static readonly INDEMNITY_INSURANCE_DENTAL = new InsurancePayerTypeCode(524, "Indemnity Insurance - Dental");
	static readonly PRIVATE_HEALTH_INSURANCE_OTHER_COMMERCIAL_INDEMNITY = new InsurancePayerTypeCode(529, "Private health insurance--other commercial Indemnity");
	static readonly MANAGED_CARE_PRIVATE_OR_PRIVATE_HEALTH_INSURANCE_INDEMNITY_NOT_OTHERWISE_SPECIFIED = new InsurancePayerTypeCode(53, "Managed Care (private) or private health insurance (indemnity), not otherwise specified");
	static readonly ORGANIZED_DELIVERY_SYSTEM = new InsurancePayerTypeCode(54, "Organized Delivery System");
	static readonly SMALL_EMPLOYER_PURCHASING_GROUP = new InsurancePayerTypeCode(55, "Small Employer Purchasing Group");
	static readonly SPECIALIZED_STAND_ALONE_PLAN = new InsurancePayerTypeCode(56, "Specialized Stand-Alone Plan");
	static readonly DENTAL = new InsurancePayerTypeCode(561, "Dental");
	static readonly VISION = new InsurancePayerTypeCode(562, "Vision");
	static readonly OTHER_PRIVATE_INSURANCE = new InsurancePayerTypeCode(59, "Other Private Insurance");
	static readonly MANAGED_CARE_UNSPECIFIED_TO_BE_USED_ONLY_IF_ONE_CAN_T_DISTINGUISH_PUBLIC_FROM_PRIVATE = new InsurancePayerTypeCode(7, "MANAGED CARE, UNSPECIFIED (to be used only if one can't distinguish public from private)");
	static readonly HMO = new InsurancePayerTypeCode(71, "HMO");
	static readonly PPO = new InsurancePayerTypeCode(72, "PPO");
	static readonly POS = new InsurancePayerTypeCode(73, "POS");
	static readonly OTHER_MANAGED_CARE = new InsurancePayerTypeCode(79, "Other Managed Care");
	static readonly NO_PAYMENT_FROM_AN_ORGANIZATION_AGENCY_PROGRAM_PRIVATE_PAYER_LISTED = new InsurancePayerTypeCode(8, "NO PAYMENT from an Organization/Agency/Program/Private Payer Listed");
	static readonly SELF_PAY_INCLUDES_APPLICANTS_FOR_INSURANCE_AND_MEDICAID_APPLICANTS = new InsurancePayerTypeCode(81, "Self-pay (Includes applicants for insurance and Medicaid applicants)");
	static readonly NO_CHARGE = new InsurancePayerTypeCode(82, "No Charge");
	static readonly CHARITY = new InsurancePayerTypeCode(821, "Charity");
	static readonly PROFESSIONAL_COURTESY = new InsurancePayerTypeCode(822, "Professional Courtesy");
	static readonly RESEARCH_CLINICAL_TRIAL = new InsurancePayerTypeCode(823, "Research/Clinical Trial");
	static readonly REFUSAL_TO_PAY_BAD_DEBT = new InsurancePayerTypeCode(83, "Refusal to Pay/Bad Debt");
	static readonly HILL_BURTON_FREE_CARE = new InsurancePayerTypeCode(84, "Hill Burton Free Care");
	static readonly RESEARCH_DONOR = new InsurancePayerTypeCode(85, "Research/Donor");
	static readonly NO_PAYMENT_OTHER = new InsurancePayerTypeCode(89, "No Payment, Other");
	static readonly MISCELLANEOUS_OTHER = new InsurancePayerTypeCode(9, "MISCELLANEOUS/OTHER");
	static readonly FOREIGN_NATIONAL = new InsurancePayerTypeCode(91, "Foreign National");
	static readonly OTHER_NON_GOVERNMENT = new InsurancePayerTypeCode(92, "Other (Non-government)");
	static readonly DISABILITY_INSURANCE = new InsurancePayerTypeCode(93, "Disability Insurance");
	static readonly LONG_TERM_CARE_INSURANCE = new InsurancePayerTypeCode(94, "Long-term Care Insurance");
	static readonly WORKER_S_COMPENSATION = new InsurancePayerTypeCode(95, "Worker's Compensation");
	static readonly WORKER_S_COMP_HMO = new InsurancePayerTypeCode(951, "Worker's Comp HMO");
	static readonly WORKER_S_COMP_FEE_FOR_SERVICE = new InsurancePayerTypeCode(953, "Worker's Comp Fee-for-Service");
	static readonly WORKER_S_COMP_OTHER_MANAGED_CARE = new InsurancePayerTypeCode(954, "Worker's Comp Other Managed Care");
	static readonly WORKER_S_COMP_OTHER_UNSPECIFIED = new InsurancePayerTypeCode(959, "Worker's Comp, Other unspecified");
	static readonly AUTO_INSURANCE_INCLUDES_NO_FAULT = new InsurancePayerTypeCode(96, "Auto Insurance (includes no fault)");
	static readonly LEGAL_LIABILITY_LIABILITY_INSURANCE = new InsurancePayerTypeCode(97, "Legal Liability / Liability Insurance");
	static readonly OTHER_SPECIFIED_BUT_NOT_OTHERWISE_CLASSIFIABLE_INCLUDES_HOSPICE_UNSPECIFIED_PLAN = new InsurancePayerTypeCode(98, "Other specified but not otherwise classifiable (includes Hospice - Unspecified plan)");
	static readonly NO_TYPOLOGY_CODE_AVAILABLE_FOR_PAYMENT_SOURCE = new InsurancePayerTypeCode(99, "No Typology Code available for payment source");
	static readonly UNAVAILABLE_NO_PAYER_SPECIFIED_BLANK = new InsurancePayerTypeCode(9999, "Unavailable / No Payer Specified / Blank");
	
	static readonly VALUES: GandalfConstantList<InsurancePayerTypeCode> = {
		label: 'Insurance Payer Type Code',
		values: [InsurancePayerTypeCode.MEDICARE, InsurancePayerTypeCode.MEDICARE_MANAGED_CARE_INCLUDES_MEDICARE_ADVANTAGE_PLANS, InsurancePayerTypeCode.MEDICARE_CHRONIC_CONDITION_SPECIAL_NEEDS_PLAN_C_SNP, InsurancePayerTypeCode.MEDICARE_PPO, InsurancePayerTypeCode.MEDICARE_POS, InsurancePayerTypeCode.MEDICARE_MANAGED_CARE_OTHER, InsurancePayerTypeCode.MEDICARE_NON_MANAGED_CARE, InsurancePayerTypeCode.MEDICARE_FFS, InsurancePayerTypeCode.MEDICARE_DRUG_BENEFIT, InsurancePayerTypeCode.MEDICARE_MEDICAL_SAVINGS_ACCOUNT_MSA, InsurancePayerTypeCode.MEDICARE_NON_MANAGED_CARE_OTHER, InsurancePayerTypeCode.MEDICARE_HOSPICE, InsurancePayerTypeCode.DUAL_ELIGIBILITY_MEDICARE_MEDICAID_ORGANIZATION, InsurancePayerTypeCode.DUAL_ELIGIBLE_SPECIAL_NEEDS_PLAN_D_SNP, InsurancePayerTypeCode.FULLY_INTEGRATED_DUAL_ELIGIBLE_SPECIAL_NEEDS_PLAN_FIDE_SNP, InsurancePayerTypeCode.MEDICARE_OTHER, InsurancePayerTypeCode.MEDICARE_PHARMACY_BENEFIT_MANAGER, InsurancePayerTypeCode.MEDICAID, InsurancePayerTypeCode.MEDICAID_MANAGED_CARE, InsurancePayerTypeCode.MEDICAID_HMO, InsurancePayerTypeCode.MEDICAID_PPO, InsurancePayerTypeCode.MEDICAID_PCCM_PRIMARY_CARE_CASE_MANAGEMENT, InsurancePayerTypeCode.MEDICAID_MANAGED_CARE_OTHER, InsurancePayerTypeCode.MEDICAID_NON_MANAGED_CARE_PLAN, InsurancePayerTypeCode.MEDICAID_SCHIP, InsurancePayerTypeCode.MEDICAID_OUT_OF_STATE, InsurancePayerTypeCode.MEDICAID_LONG_TERM_CARE, InsurancePayerTypeCode.MEDICAID_OTHER, InsurancePayerTypeCode.MEDICAID_PHARMACY_BENEFIT_MANAGER, InsurancePayerTypeCode.MEDICAID_DENTAL, InsurancePayerTypeCode.OTHER_GOVERNMENT_FEDERAL_STATE_LOCAL_EXCLUDING_DEPARTMENT_OF_CORRECTIONS, InsurancePayerTypeCode.DEPARTMENT_OF_DEFENSE, InsurancePayerTypeCode.TRICARE_CHAMPUS, InsurancePayerTypeCode.TRICARE_STANDARD_FEE_FOR_SERVICE, InsurancePayerTypeCode.MILITARY_TREATMENT_FACILITY, InsurancePayerTypeCode.TRICARE_FOR_LIFE_TFL, InsurancePayerTypeCode.DENTAL_STAND_ALONE, InsurancePayerTypeCode.DEPARTMENT_OF_VETERANS_AFFAIRS, InsurancePayerTypeCode.VETERAN_CARE_CARE_PROVIDED_TO_VETERANS, InsurancePayerTypeCode.NON_VETERAN_CARE, InsurancePayerTypeCode.CIVILIAN_HEALTH_AND_MEDICAL_PROGRAM_FOR_THE_VA_CHAMPVA, InsurancePayerTypeCode.INDIAN_HEALTH_SERVICE_OR_TRIBE, InsurancePayerTypeCode.INDIAN_HEALTH_SERVICE_REGULAR, InsurancePayerTypeCode.INDIAN_HEALTH_SERVICE_CONTRACT, InsurancePayerTypeCode.INDIAN_HEALTH_SERVICE_MANAGED_CARE, InsurancePayerTypeCode.INDIAN_TRIBE_SPONSORED_COVERAGE, InsurancePayerTypeCode.HRSA_PROGRAM, InsurancePayerTypeCode.TITLE_V_MCH_BLOCK_GRANT, InsurancePayerTypeCode.MIGRANT_HEALTH_PROGRAM, InsurancePayerTypeCode.RYAN_WHITE_ACT, InsurancePayerTypeCode.DISASTER_RELATED_INCLUDES_COVID_19, InsurancePayerTypeCode.OTHER, InsurancePayerTypeCode.BLACK_LUNG, InsurancePayerTypeCode.STATE_GOVERNMENT, InsurancePayerTypeCode.STATE_SCHIP_PROGRAM_CODES_FOR_INDIVIDUAL_STATES, InsurancePayerTypeCode.SPECIFIC_STATE_PROGRAMS_LIST_LOCAL_CODE, InsurancePayerTypeCode.STATE_NOT_OTHERWISE_SPECIFIED_OTHER_STATE, InsurancePayerTypeCode.LOCAL_GOVERNMENT, InsurancePayerTypeCode.LOCAL_MANAGED_CARE, InsurancePayerTypeCode.FFS_INDEMNITY, InsurancePayerTypeCode.LOCAL_NOT_OTHERWISE_SPECIFIED_OTHER_LOCAL_COUNTY, InsurancePayerTypeCode.OTHER_GOVERNMENT_FEDERAL_STATE_LOCAL_NOT_SPECIFIED, InsurancePayerTypeCode.FEDERAL_STATE_LOCAL_NOT_SPECIFIED_MANAGED_CARE, InsurancePayerTypeCode.FEDERAL_STATE_LOCAL_NOT_SPECIFIED_FFS, InsurancePayerTypeCode.FEDERAL_STATE_LOCAL_NOT_SPECIFIED_OTHER, InsurancePayerTypeCode.OTHER_FEDERAL, InsurancePayerTypeCode.FEDERAL_EMPLOYEE_HEALTH_PLAN_USE_WHEN_KNOWN, InsurancePayerTypeCode.DEPARTMENTS_OF_CORRECTIONS, InsurancePayerTypeCode.CORRECTIONS_FEDERAL, InsurancePayerTypeCode.CORRECTIONS_STATE, InsurancePayerTypeCode.CORRECTIONS_LOCAL, InsurancePayerTypeCode.CORRECTIONS_UNKNOWN_LEVEL, InsurancePayerTypeCode.PRIVATE_HEALTH_INSURANCE, InsurancePayerTypeCode.MANAGED_CARE_PRIVATE, InsurancePayerTypeCode.COMMERCIAL_MANAGED_CARE_HMO, InsurancePayerTypeCode.COMMERCIAL_MANAGED_CARE_PPO, InsurancePayerTypeCode.COMMERCIAL_MANAGED_CARE_POS, InsurancePayerTypeCode.EXCLUSIVE_PROVIDER_ORGANIZATION, InsurancePayerTypeCode.GATEKEEPER_PPO_GPPO, InsurancePayerTypeCode.COMMERCIAL_MANAGED_CARE_PHARMACY_BENEFIT_MANAGER, InsurancePayerTypeCode.COMMERCIAL_MANAGED_CARE_DENTAL, InsurancePayerTypeCode.MANAGED_CARE_OTHER_NON_HMO, InsurancePayerTypeCode.PRIVATE_HEALTH_INSURANCE_INDEMNITY, InsurancePayerTypeCode.COMMERCIAL_INDEMNITY, InsurancePayerTypeCode.SELF_INSURED_ERISA_ADMINISTRATIVE_SERVICES_ONLY_ASO_PLAN, InsurancePayerTypeCode.MEDICARE_SUPPLEMENTAL_POLICY_AS_SECOND_PAYER, InsurancePayerTypeCode.INDEMNITY_INSURANCE_DENTAL, InsurancePayerTypeCode.PRIVATE_HEALTH_INSURANCE_OTHER_COMMERCIAL_INDEMNITY, InsurancePayerTypeCode.MANAGED_CARE_PRIVATE_OR_PRIVATE_HEALTH_INSURANCE_INDEMNITY_NOT_OTHERWISE_SPECIFIED, InsurancePayerTypeCode.ORGANIZED_DELIVERY_SYSTEM, InsurancePayerTypeCode.SMALL_EMPLOYER_PURCHASING_GROUP, InsurancePayerTypeCode.SPECIALIZED_STAND_ALONE_PLAN, InsurancePayerTypeCode.DENTAL, InsurancePayerTypeCode.VISION, InsurancePayerTypeCode.OTHER_PRIVATE_INSURANCE, InsurancePayerTypeCode.MANAGED_CARE_UNSPECIFIED_TO_BE_USED_ONLY_IF_ONE_CAN_T_DISTINGUISH_PUBLIC_FROM_PRIVATE, InsurancePayerTypeCode.HMO, InsurancePayerTypeCode.PPO, InsurancePayerTypeCode.POS, InsurancePayerTypeCode.OTHER_MANAGED_CARE, InsurancePayerTypeCode.NO_PAYMENT_FROM_AN_ORGANIZATION_AGENCY_PROGRAM_PRIVATE_PAYER_LISTED, InsurancePayerTypeCode.SELF_PAY_INCLUDES_APPLICANTS_FOR_INSURANCE_AND_MEDICAID_APPLICANTS, InsurancePayerTypeCode.NO_CHARGE, InsurancePayerTypeCode.CHARITY, InsurancePayerTypeCode.PROFESSIONAL_COURTESY, InsurancePayerTypeCode.RESEARCH_CLINICAL_TRIAL, InsurancePayerTypeCode.REFUSAL_TO_PAY_BAD_DEBT, InsurancePayerTypeCode.HILL_BURTON_FREE_CARE, InsurancePayerTypeCode.RESEARCH_DONOR, InsurancePayerTypeCode.NO_PAYMENT_OTHER, InsurancePayerTypeCode.MISCELLANEOUS_OTHER, InsurancePayerTypeCode.FOREIGN_NATIONAL, InsurancePayerTypeCode.OTHER_NON_GOVERNMENT, InsurancePayerTypeCode.DISABILITY_INSURANCE, InsurancePayerTypeCode.LONG_TERM_CARE_INSURANCE, InsurancePayerTypeCode.WORKER_S_COMPENSATION, InsurancePayerTypeCode.WORKER_S_COMP_HMO, InsurancePayerTypeCode.WORKER_S_COMP_FEE_FOR_SERVICE, InsurancePayerTypeCode.WORKER_S_COMP_OTHER_MANAGED_CARE, InsurancePayerTypeCode.WORKER_S_COMP_OTHER_UNSPECIFIED, InsurancePayerTypeCode.AUTO_INSURANCE_INCLUDES_NO_FAULT, InsurancePayerTypeCode.LEGAL_LIABILITY_LIABILITY_INSURANCE, InsurancePayerTypeCode.OTHER_SPECIFIED_BUT_NOT_OTHERWISE_CLASSIFIABLE_INCLUDES_HOSPICE_UNSPECIFIED_PLAN, InsurancePayerTypeCode.NO_TYPOLOGY_CODE_AVAILABLE_FOR_PAYMENT_SOURCE, InsurancePayerTypeCode.UNAVAILABLE_NO_PAYER_SPECIFIED_BLANK, ]
	};
}

/** see com.rev360.model.data.constant.insurancepriority.InsurancePriority */
/* istanbul ignore next */
export class InsurancePriority extends GandalfConstant<number> {
	static readonly PRIMARY = new InsurancePriority(1610, "Primary");
	static readonly SECONDARY = new InsurancePriority(1611, "Secondary");
	static readonly TERTIARY = new InsurancePriority(1612, "Tertiary");
	static readonly FOURTH = new InsurancePriority(1613, "Fourth");
	static readonly FIFTH = new InsurancePriority(1614, "Fifth");
	
	static readonly VALUES: GandalfConstantList<InsurancePriority> = {
		label: 'Insurance Priority',
		values: [InsurancePriority.PRIMARY, InsurancePriority.SECONDARY, InsurancePriority.TERTIARY, InsurancePriority.FOURTH, InsurancePriority.FIFTH, ]
	};
}

/** see com.rev360.model.insurance.remittanceconversionstatus.InsuranceRemittanceConversionStatus */
/* istanbul ignore next */
export class InsuranceRemittanceConversionStatus extends GandalfConstant<number> {
	static readonly UNCONVERTED = new InsuranceRemittanceConversionStatus(1, "Unconverted");
	static readonly QUEUED = new InsuranceRemittanceConversionStatus(2, "Queued");
	static readonly PROCESSING = new InsuranceRemittanceConversionStatus(3, "Processing");
	static readonly COMPLETE = new InsuranceRemittanceConversionStatus(4, "Complete");
	static readonly FAILURE = new InsuranceRemittanceConversionStatus(5, "Failure");
	
	static readonly VALUES: GandalfConstantList<InsuranceRemittanceConversionStatus> = {
		label: 'Insurance Remittance Conversion Status',
		values: [InsuranceRemittanceConversionStatus.UNCONVERTED, InsuranceRemittanceConversionStatus.QUEUED, InsuranceRemittanceConversionStatus.PROCESSING, InsuranceRemittanceConversionStatus.COMPLETE, InsuranceRemittanceConversionStatus.FAILURE, ]
	};
}

/** see com.rev360.model.insurance.remittancepaymentstatus.InsuranceRemittancePaymentStatus */
/* istanbul ignore next */
export class InsuranceRemittancePaymentStatus extends GandalfConstant<number> {
	static readonly NOT_READY = new InsuranceRemittancePaymentStatus(1, "Not Ready");
	static readonly READY = new InsuranceRemittancePaymentStatus(2, "Ready");
	static readonly QUEUED = new InsuranceRemittancePaymentStatus(3, "Queued");
	static readonly PROCESSED = new InsuranceRemittancePaymentStatus(4, "Processed");
	static readonly FAILED = new InsuranceRemittancePaymentStatus(5, "Failed");
	static readonly DO_NOT_PROCESS = new InsuranceRemittancePaymentStatus(6, "Do not Process");
	
	static readonly VALUES: GandalfConstantList<InsuranceRemittancePaymentStatus> = {
		label: 'Insurance Remittance Payment Status',
		values: [InsuranceRemittancePaymentStatus.NOT_READY, InsuranceRemittancePaymentStatus.READY, InsuranceRemittancePaymentStatus.QUEUED, InsuranceRemittancePaymentStatus.PROCESSED, InsuranceRemittancePaymentStatus.FAILED, InsuranceRemittancePaymentStatus.DO_NOT_PROCESS, ]
	};
}

/** see com.rev360.model.data.constant.insurancetype.InsuranceType */
/* istanbul ignore next */
export class InsuranceType extends GandalfConstant<number> {
	static readonly MEDICAL = new InsuranceType(1620, "Medical");
	static readonly VISION = new InsuranceType(1621, "Vision");
	static readonly MEDICAL_AND_VISION = new InsuranceType(1622, "Medical and Vision");
	static readonly DISCOUNT_ONLY = new InsuranceType(1623, "Discount Only");
	
	static readonly VALUES: GandalfConstantList<InsuranceType> = {
		label: 'Insurance Type',
		values: [InsuranceType.MEDICAL, InsuranceType.VISION, InsuranceType.MEDICAL_AND_VISION, InsuranceType.DISCOUNT_ONLY, ]
	};
}

/** see com.rev360.pms.service.reporting.constant.InsuranceVerifiedStatusSearch */
/* istanbul ignore next */
export class InsuranceVerifiedStatusSearch extends GandalfConstant<number> {
	static readonly NOT_VERIFIED = new InsuranceVerifiedStatusSearch(0, "Not Verified");
	static readonly VERIFIED_VALID = new InsuranceVerifiedStatusSearch(1, "Valid");
	static readonly VERIFIED_INVALID = new InsuranceVerifiedStatusSearch(2, "Invalid");
	
	static readonly VALUES: GandalfConstantList<InsuranceVerifiedStatusSearch> = {
		label: 'Insurance Verified Status Search',
		values: [InsuranceVerifiedStatusSearch.NOT_VERIFIED, InsuranceVerifiedStatusSearch.VERIFIED_VALID, InsuranceVerifiedStatusSearch.VERIFIED_INVALID, ]
	};
}

/** see com.rev360.model.intake.constant.intakereconciledstatus.IntakeReconciledStatus */
/* istanbul ignore next */
export class IntakeReconciledStatus extends GandalfConstant<number> {
	static readonly PENDING = new IntakeReconciledStatus(1, "Pending");
	static readonly ACCEPTED = new IntakeReconciledStatus(2, "Accepted");
	static readonly DECLINED = new IntakeReconciledStatus(3, "Declined");
	
	static readonly VALUES: GandalfConstantList<IntakeReconciledStatus> = {
		label: 'Intake Reconciled Status',
		values: [IntakeReconciledStatus.PENDING, IntakeReconciledStatus.ACCEPTED, IntakeReconciledStatus.DECLINED, ]
	};
}

/** see com.rev360.model.intake.constant.intakestatus.IntakeStatus */
/* istanbul ignore next */
export class IntakeStatus extends GandalfConstant<number> {
	static readonly NEW = new IntakeStatus(1, "New");
	static readonly VERIFIED = new IntakeStatus(2, "Information Verified");
	static readonly DISCONTINUED = new IntakeStatus(3, "Discontinued");
	
	static readonly VALUES: GandalfConstantList<IntakeStatus> = {
		label: 'Intake Status',
		values: [IntakeStatus.NEW, IntakeStatus.VERIFIED, IntakeStatus.DISCONTINUED, ]
	};
}

/** see com.rev360.pms.service.file.constant.interopfileformat.InteropFileFormat */
/* istanbul ignore next */
export class InteropFileFormat extends GandalfConstant<number> {
	static readonly NONE = new InteropFileFormat(0, "None");
	static readonly HL7 = new InteropFileFormat(1, "HL7");
	static readonly CDA = new InteropFileFormat(2, "CDA");
	static readonly CCDA = new InteropFileFormat(3, "CCDA");
	static readonly CCD = new InteropFileFormat(4, "CCD");
	static readonly CDA_XML = new InteropFileFormat(5, "XML");
	static readonly CDA_HTML = new InteropFileFormat(6, "HTML");
	static readonly CDA_PDF = new InteropFileFormat(7, "PDF");
	static readonly QRDA_CAT_1 = new InteropFileFormat(8, "QRDA CAT 1");
	static readonly QRDA_CAT_3 = new InteropFileFormat(9, "QRDA CAT 3");
	
	static readonly VALUES: GandalfConstantList<InteropFileFormat> = {
		label: 'File Format Type',
		values: [InteropFileFormat.NONE, InteropFileFormat.HL7, InteropFileFormat.CDA, InteropFileFormat.CCDA, InteropFileFormat.CCD, InteropFileFormat.CDA_XML, InteropFileFormat.CDA_HTML, InteropFileFormat.CDA_PDF, InteropFileFormat.QRDA_CAT_1, InteropFileFormat.QRDA_CAT_3, ]
	};
}

/** see com.rev360.model.interoperability.constant.interoperabilitytaskstatus.InteroperabilityTaskStatus */
/* istanbul ignore next */
export class InteroperabilityTaskStatus extends GandalfConstant<number> {
	static readonly NEW = new InteroperabilityTaskStatus(0, "New");
	static readonly CONFIGURATION_PENDING = new InteroperabilityTaskStatus(1, "Configuration Pending");
	static readonly CONFIGURATION_COMPLETE = new InteroperabilityTaskStatus(2, "Configuration Complete");
	static readonly CONTEXT_PENDING = new InteroperabilityTaskStatus(3, "Context Pending");
	static readonly CONTEXT_COMPLETE = new InteroperabilityTaskStatus(4, "Context Complete");
	static readonly PENDING = new InteroperabilityTaskStatus(5, "Pending");
	static readonly COMPLETED = new InteroperabilityTaskStatus(6, "Completed");
	static readonly CANCELED = new InteroperabilityTaskStatus(7, "Canceled");
	static readonly ERROR = new InteroperabilityTaskStatus(8, "Error");
	
	static readonly VALUES: GandalfConstantList<InteroperabilityTaskStatus> = {
		label: 'Interoperability Task Status',
		values: [InteroperabilityTaskStatus.NEW, InteroperabilityTaskStatus.CONFIGURATION_PENDING, InteroperabilityTaskStatus.CONFIGURATION_COMPLETE, InteroperabilityTaskStatus.CONTEXT_PENDING, InteroperabilityTaskStatus.CONTEXT_COMPLETE, InteroperabilityTaskStatus.PENDING, InteroperabilityTaskStatus.COMPLETED, InteroperabilityTaskStatus.CANCELED, InteroperabilityTaskStatus.ERROR, ]
	};
}

/** see com.rev360.model.encounter.constant.interviewstatus.InterviewStatus */
/* istanbul ignore next */
export class InterviewStatus extends GandalfConstant<number> {
	static readonly NOT_STARTED = new InterviewStatus(0, "Interview Not Started");
	static readonly COMPLETED = new InterviewStatus(1, "Interview Completed");
	static readonly INCOMPLETE = new InterviewStatus(2, "Interview In Progress");
	
	static readonly VALUES: GandalfConstantList<InterviewStatus> = {
		label: 'Interview Status',
		values: [InterviewStatus.NOT_STARTED, InterviewStatus.COMPLETED, InterviewStatus.INCOMPLETE, ]
	};
}

/** see com.rev360.core.service.workflow.InterviewWorkflowTestTemplateMasterId */
/* istanbul ignore next */
export class InterviewWorkflowTestTemplateMasterId extends GandalfConstant<number> {
	static readonly PATIENT_RFV = new InterviewWorkflowTestTemplateMasterId(2001, "Patient RFV");
	
	static readonly VALUES: GandalfConstantList<InterviewWorkflowTestTemplateMasterId> = {
		label: 'InterviewWorkflowTestTemplateMasterId',
		values: [InterviewWorkflowTestTemplateMasterId.PATIENT_RFV, ]
	};
}

/** see com.rev360.model.inventory.item.constant.itemstatus.InventoryItemStatus */
/* istanbul ignore next */
export class InventoryItemStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new InventoryItemStatus(1, "Active");
	static readonly INACTIVE = new InventoryItemStatus(0, "Inactive");
	
	static readonly VALUES: GandalfConstantList<InventoryItemStatus> = {
		label: 'Product item status',
		values: [InventoryItemStatus.ACTIVE, InventoryItemStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.inventory.transfer.constant.inventorytransferrequestitemstatus.InventoryTransferRequestItemStatus */
/* istanbul ignore next */
export class InventoryTransferRequestItemStatus extends GandalfConstant<number> {
	static readonly NEW = new InventoryTransferRequestItemStatus(0, "New");
	static readonly PICKED = new InventoryTransferRequestItemStatus(1, "Picked");
	static readonly WILL_NOT_FULFILL = new InventoryTransferRequestItemStatus(2, "Will not fulfill");
	static readonly SHIPPED = new InventoryTransferRequestItemStatus(3, "Shipped");
	static readonly RECEIVED = new InventoryTransferRequestItemStatus(4, "Received");
	static readonly NOT_RECEIVED = new InventoryTransferRequestItemStatus(5, "Not Received");
	
	static readonly VALUES: GandalfConstantList<InventoryTransferRequestItemStatus> = {
		label: 'Inventory Transfer Request Item Status',
		values: [InventoryTransferRequestItemStatus.NEW, InventoryTransferRequestItemStatus.PICKED, InventoryTransferRequestItemStatus.WILL_NOT_FULFILL, InventoryTransferRequestItemStatus.SHIPPED, InventoryTransferRequestItemStatus.RECEIVED, InventoryTransferRequestItemStatus.NOT_RECEIVED, ]
	};
}

/** see com.rev360.model.inventory.transfer.constant.inventorytransferrequeststatus.InventoryTransferRequestStatus */
/* istanbul ignore next */
export class InventoryTransferRequestStatus extends GandalfConstant<number> {
	static readonly IN_PROCESS = new InventoryTransferRequestStatus(-2147483648, "In Process");
	static readonly OPEN = new InventoryTransferRequestStatus(0, "Open");
	static readonly REQUESTED = new InventoryTransferRequestStatus(1, "Requested");
	static readonly PROCESSING = new InventoryTransferRequestStatus(2, "Processing");
	static readonly FULFILLED = new InventoryTransferRequestStatus(3, "Fulfilled");
	static readonly SHIPPED = new InventoryTransferRequestStatus(4, "Shipped");
	static readonly RECEIVED = new InventoryTransferRequestStatus(5, "Received");
	static readonly CANCELED = new InventoryTransferRequestStatus(6, "Canceled");
	
	static readonly VALUES: GandalfConstantList<InventoryTransferRequestStatus> = {
		label: 'Inventory Transfer Request Status',
		values: [InventoryTransferRequestStatus.IN_PROCESS, InventoryTransferRequestStatus.OPEN, InventoryTransferRequestStatus.REQUESTED, InventoryTransferRequestStatus.PROCESSING, InventoryTransferRequestStatus.FULFILLED, InventoryTransferRequestStatus.SHIPPED, InventoryTransferRequestStatus.RECEIVED, InventoryTransferRequestStatus.CANCELED, ]
	};
}

/** see com.rev360.model.accounting.constant.invoiceitemadjustmentstatus.InvoiceItemAdjustmentStatus */
/* istanbul ignore next */
export class InvoiceItemAdjustmentStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new InvoiceItemAdjustmentStatus(1, "Active");
	static readonly REMOVED = new InvoiceItemAdjustmentStatus(2, "Removed");
	static readonly VOIDED = new InvoiceItemAdjustmentStatus(3, "Voided");
	
	static readonly VALUES: GandalfConstantList<InvoiceItemAdjustmentStatus> = {
		label: 'Invoice Item Adjustment Status',
		values: [InvoiceItemAdjustmentStatus.ACTIVE, InvoiceItemAdjustmentStatus.REMOVED, InvoiceItemAdjustmentStatus.VOIDED, ]
	};
}

/** see com.rev360.model.accounting.constant.invoiceitemadjustmenttype.InvoiceItemAdjustmentType */
/* istanbul ignore next */
export class InvoiceItemAdjustmentType extends GandalfConstant<number> {
	static readonly OTHER = new InvoiceItemAdjustmentType(0, "Other");
	static readonly DISCOUNT = new InvoiceItemAdjustmentType(1, "Discount");
	static readonly WRITEOFF = new InvoiceItemAdjustmentType(2, "Writeoff");
	static readonly FEE_SCHEDULE = new InvoiceItemAdjustmentType(3, "Fee Schedule");
	static readonly PATIENT_TAX = new InvoiceItemAdjustmentType(4, "Tax Billed to Patient");
	static readonly INSURANCE_BILLED = new InvoiceItemAdjustmentType(5, "Billed to Insurance");
	static readonly TRANSFER_IN = new InvoiceItemAdjustmentType(6, "Transfer In");
	static readonly TRANSFER_OUT = new InvoiceItemAdjustmentType(7, "Transfer Out");
	static readonly OTHER_BILLED = new InvoiceItemAdjustmentType(8, "Billed to Other Payer");
	
	static readonly VALUES: GandalfConstantList<InvoiceItemAdjustmentType> = {
		label: 'Invoice Item Adjustment Types',
		values: [InvoiceItemAdjustmentType.OTHER, InvoiceItemAdjustmentType.DISCOUNT, InvoiceItemAdjustmentType.WRITEOFF, InvoiceItemAdjustmentType.FEE_SCHEDULE, InvoiceItemAdjustmentType.PATIENT_TAX, InvoiceItemAdjustmentType.INSURANCE_BILLED, InvoiceItemAdjustmentType.TRANSFER_IN, InvoiceItemAdjustmentType.TRANSFER_OUT, InvoiceItemAdjustmentType.OTHER_BILLED, ]
	};
}

/** see com.rev360.model.accounting.constant.invoiceitemcode.InvoiceItemCode */
/* istanbul ignore next */
export class InvoiceItemCode extends GandalfConstant<string> {
	static readonly OTHER = new InvoiceItemCode('MISC', "Other/Misc");
	static readonly PROMO = new InvoiceItemCode('PROMO', "Promotion");
	static readonly COPAY = new InvoiceItemCode('CO-PAY', "Copay");
	static readonly DISCOUNT = new InvoiceItemCode('DISCOUNT', "Discount");
	static readonly CREDIT = new InvoiceItemCode('CREDIT', "Credit");
	static readonly BALANCE_TRANSFER = new InvoiceItemCode('TRANSFER-IN', "Balance transfer");
	static readonly COINSURANCE = new InvoiceItemCode('CO-INS', "Coinsurance");
	static readonly DEDUCTIBLE = new InvoiceItemCode('DEDUCTIBLE', "Deductible");
	static readonly TRANSFER_TAX = new InvoiceItemCode('PATIENT-TAX', "Transfer tax");
	static readonly WRITE_OFF = new InvoiceItemCode('WRITEOFF', "Writeoff");
	static readonly TRANSFER_OUT = new InvoiceItemCode('TRANSFER-OUT', "Transfer out");
	static readonly REFUND = new InvoiceItemCode('REFUND', "Refund");
	static readonly INFO = new InvoiceItemCode('INFO', "Info");
	static readonly FINANCE_CHARGE = new InvoiceItemCode('FIN-CHG', "Finance Charge");
	
	static readonly VALUES: GandalfConstantList<InvoiceItemCode> = {
		label: 'InvoiceItemCode',
		values: [InvoiceItemCode.OTHER, InvoiceItemCode.PROMO, InvoiceItemCode.COPAY, InvoiceItemCode.DISCOUNT, InvoiceItemCode.CREDIT, InvoiceItemCode.BALANCE_TRANSFER, InvoiceItemCode.COINSURANCE, InvoiceItemCode.DEDUCTIBLE, InvoiceItemCode.TRANSFER_TAX, InvoiceItemCode.WRITE_OFF, InvoiceItemCode.TRANSFER_OUT, InvoiceItemCode.REFUND, InvoiceItemCode.INFO, InvoiceItemCode.FINANCE_CHARGE, ]
	};
}

/** see com.rev360.model.accounting.constant.invoiceitemstatus.InvoiceItemStatus */
/* istanbul ignore next */
export class InvoiceItemStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new InvoiceItemStatus(1, "Active");
	static readonly REMOVED = new InvoiceItemStatus(2, "Removed");
	static readonly VOIDED = new InvoiceItemStatus(3, "Voided");
	
	static readonly VALUES: GandalfConstantList<InvoiceItemStatus> = {
		label: 'Invoice Item Status',
		values: [InvoiceItemStatus.ACTIVE, InvoiceItemStatus.REMOVED, InvoiceItemStatus.VOIDED, ]
	};
}

/** see com.rev360.model.accounting.constant.invoiceitemtype.InvoiceItemType */
/* istanbul ignore next */
export class InvoiceItemType extends GandalfConstant<number> {
	static readonly OTHER = new InvoiceItemType(0, "Other");
	static readonly PRODUCT = new InvoiceItemType(1, "Product");
	static readonly SERVICE = new InvoiceItemType(2, "Service");
	static readonly PROMOTION = new InvoiceItemType(3, "Promotion");
	static readonly COPAY = new InvoiceItemType(4, "Co-Pay");
	static readonly DISCOUNT = new InvoiceItemType(5, "Discount");
	static readonly CREDIT = new InvoiceItemType(6, "Credit");
	static readonly BALANCE_TRANSFER = new InvoiceItemType(7, "Balance Transfer");
	static readonly COINSURANCE = new InvoiceItemType(8, "Co-Insurance");
	static readonly DEDUCTIBLE = new InvoiceItemType(9, "Deductible");
	static readonly COPAY_FOR_INSURANCE = new InvoiceItemType(10, "Insurance Co-Pay");
	static readonly COINSURANCE_FOR_INSURANCE = new InvoiceItemType(11, "Insurance Co-Insurance");
	static readonly DEDUCTIBLE_FOR_INSURANCE = new InvoiceItemType(12, "Insurance Deductible");
	static readonly TRANSFER_TAX = new InvoiceItemType(13, "Taxes Billed to Patient");
	static readonly WRITE_OFF = new InvoiceItemType(15, "Writeoff");
	static readonly TRANSFER_OUT = new InvoiceItemType(16, "Transfer Balance Out");
	static readonly TRANSFER_IN = new InvoiceItemType(18, "Transfer Balance In");
	static readonly REFUND = new InvoiceItemType(20, "Refund");
	static readonly INFO = new InvoiceItemType(30, "Info");
	static readonly AD_HOC = new InvoiceItemType(40, "Adhoc");
	static readonly FINANCE_CHARGE = new InvoiceItemType(50, "Finance Charge");
	
	static readonly VALUES: GandalfConstantList<InvoiceItemType> = {
		label: 'Invoice Item Types',
		values: [InvoiceItemType.OTHER, InvoiceItemType.PRODUCT, InvoiceItemType.SERVICE, InvoiceItemType.PROMOTION, InvoiceItemType.COPAY, InvoiceItemType.DISCOUNT, InvoiceItemType.CREDIT, InvoiceItemType.BALANCE_TRANSFER, InvoiceItemType.COINSURANCE, InvoiceItemType.DEDUCTIBLE, InvoiceItemType.COPAY_FOR_INSURANCE, InvoiceItemType.COINSURANCE_FOR_INSURANCE, InvoiceItemType.DEDUCTIBLE_FOR_INSURANCE, InvoiceItemType.TRANSFER_TAX, InvoiceItemType.WRITE_OFF, InvoiceItemType.TRANSFER_OUT, InvoiceItemType.TRANSFER_IN, InvoiceItemType.REFUND, InvoiceItemType.INFO, InvoiceItemType.AD_HOC, InvoiceItemType.FINANCE_CHARGE, ]
	};
}

/** see com.rev360.pms.service.accounting.InvoiceSearchAgeRange */
/* istanbul ignore next */
export class InvoiceSearchAgeRange extends GandalfConstant<number> {
	static readonly ZERO_TO_THIRTY = new InvoiceSearchAgeRange(1, "0-30");
	static readonly THIRTYONE_TO_SIXY = new InvoiceSearchAgeRange(2, "31-60");
	static readonly SIXTYONE_TO_NINETY = new InvoiceSearchAgeRange(3, "61-90");
	static readonly NINETYONE_TO_ONETWENTY = new InvoiceSearchAgeRange(4, "91-120");
	static readonly OVER_ONETWENTY = new InvoiceSearchAgeRange(5, "Over 120");
	static readonly CUSTOM = new InvoiceSearchAgeRange(10, "Custom");
	
	static readonly VALUES: GandalfConstantList<InvoiceSearchAgeRange> = {
		label: 'Age',
		values: [InvoiceSearchAgeRange.ZERO_TO_THIRTY, InvoiceSearchAgeRange.THIRTYONE_TO_SIXY, InvoiceSearchAgeRange.SIXTYONE_TO_NINETY, InvoiceSearchAgeRange.NINETYONE_TO_ONETWENTY, InvoiceSearchAgeRange.OVER_ONETWENTY, InvoiceSearchAgeRange.CUSTOM, ]
	};
}

/** see com.rev360.pms.service.accounting.InvoiceSearchAuthorization */
/* istanbul ignore next */
export class InvoiceSearchAuthorization extends GandalfConstant<number> {
	static readonly ALL = new InvoiceSearchAuthorization(0, "All");
	static readonly AUTHORIZED = new InvoiceSearchAuthorization(1, "Authorized");
	static readonly PENDING = new InvoiceSearchAuthorization(2, "Pending");
	
	static readonly VALUES: GandalfConstantList<InvoiceSearchAuthorization> = {
		label: 'Authorization',
		values: [InvoiceSearchAuthorization.ALL, InvoiceSearchAuthorization.AUTHORIZED, InvoiceSearchAuthorization.PENDING, ]
	};
}

/** see com.rev360.model.accounting.constant.invoicesearchorigin.InvoiceSearchOrigin */
/* istanbul ignore next */
export class InvoiceSearchOrigin extends GandalfConstant<number> {
	static readonly MANUAL = new InvoiceSearchOrigin(1, "Manual");
	static readonly ENCOUNTER = new InvoiceSearchOrigin(2, "Encounter");
	static readonly ORDER = new InvoiceSearchOrigin(3, "Order");
	static readonly APPOINTMENT = new InvoiceSearchOrigin(4, "Appointment");
	
	static readonly VALUES: GandalfConstantList<InvoiceSearchOrigin> = {
		label: 'Origin',
		values: [InvoiceSearchOrigin.MANUAL, InvoiceSearchOrigin.ENCOUNTER, InvoiceSearchOrigin.ORDER, InvoiceSearchOrigin.APPOINTMENT, ]
	};
}

/** see com.rev360.pms.service.accounting.InvoiceSearchStatus */
/* istanbul ignore next */
export class InvoiceSearchStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new InvoiceSearchStatus(1, "Active");
	static readonly VOIDED = new InvoiceSearchStatus(2, "Voided");
	static readonly PAID = new InvoiceSearchStatus(3, "Paid");
	static readonly ON_HOLD = new InvoiceSearchStatus(5, "On Hold");
	static readonly NON_VOIDED = new InvoiceSearchStatus(100, "Non-Voided");
	
	static readonly VALUES: GandalfConstantList<InvoiceSearchStatus> = {
		label: 'Status',
		values: [InvoiceSearchStatus.ACTIVE, InvoiceSearchStatus.VOIDED, InvoiceSearchStatus.PAID, InvoiceSearchStatus.ON_HOLD, InvoiceSearchStatus.NON_VOIDED, ]
	};
}

/** see com.rev360.model.accounting.constant.invoicestatus.InvoiceStatus */
/* istanbul ignore next */
export class InvoiceStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new InvoiceStatus(1, "Active");
	static readonly VOIDED = new InvoiceStatus(2, "Void");
	static readonly PAID = new InvoiceStatus(3, "Paid");
	static readonly COLLECTIONS = new InvoiceStatus(4, "Collections");
	static readonly ON_HOLD = new InvoiceStatus(5, "On Hold");
	
	static readonly VALUES: GandalfConstantList<InvoiceStatus> = {
		label: 'Invoice Status',
		values: [InvoiceStatus.ACTIVE, InvoiceStatus.VOIDED, InvoiceStatus.PAID, InvoiceStatus.COLLECTIONS, InvoiceStatus.ON_HOLD, ]
	};
}

/** see com.rev360.model.history.constant.isdrinker.IsDrinker */
/* istanbul ignore next */
export class IsDrinker extends GandalfConstant<number> {
	static readonly UNKNOWN = new IsDrinker(0, "Unknown");
	static readonly YES = new IsDrinker(1, "Yes");
	static readonly NO = new IsDrinker(2, "No");
	
	static readonly VALUES: GandalfConstantList<IsDrinker> = {
		label: 'Value',
		values: [IsDrinker.UNKNOWN, IsDrinker.YES, IsDrinker.NO, ]
	};
}

/** see com.rev360.model.history.constant.issmoker.IsSmoker */
/* istanbul ignore next */
export class IsSmoker extends GandalfConstant<number> {
	static readonly UNKNOWN = new IsSmoker(0, "Unknown");
	static readonly YES = new IsSmoker(1, "Yes");
	static readonly NO = new IsSmoker(2, "No");
	
	static readonly VALUES: GandalfConstantList<IsSmoker> = {
		label: 'Value',
		values: [IsSmoker.UNKNOWN, IsSmoker.YES, IsSmoker.NO, ]
	};
}

/** see com.rev360.model.laborder.constant.laborderinterpretationstatus.LabOrderInterpretationStatus */
/* istanbul ignore next */
export class LabOrderInterpretationStatus extends GandalfConstant<number> {
	static readonly OTHER = new LabOrderInterpretationStatus(0, "Other");
	static readonly NORMAL = new LabOrderInterpretationStatus(1, "Normal");
	static readonly ABNORMAL = new LabOrderInterpretationStatus(2, "Abnormal");
	
	static readonly VALUES: GandalfConstantList<LabOrderInterpretationStatus> = {
		label: 'Lab Order Interpretation Status',
		values: [LabOrderInterpretationStatus.OTHER, LabOrderInterpretationStatus.NORMAL, LabOrderInterpretationStatus.ABNORMAL, ]
	};
}

/** see com.rev360.model.laborder.constant.laborderlabtype.LabOrderLabType */
/* istanbul ignore next */
export class LabOrderLabType extends GandalfConstant<number> {
	static readonly LABORATORY = new LabOrderLabType(1, "Laboratory");
	static readonly RADIOLOGY = new LabOrderLabType(2, "Diagnostic Imaging");
	
	static readonly VALUES: GandalfConstantList<LabOrderLabType> = {
		label: 'Lab Order Lab Type',
		values: [LabOrderLabType.LABORATORY, LabOrderLabType.RADIOLOGY, ]
	};
}

/** see com.rev360.model.laborder.constant.laborderresultstatus.LabOrderResultStatus */
/* istanbul ignore next */
export class LabOrderResultStatus extends GandalfConstant<number> {
	static readonly UNKNOWN = new LabOrderResultStatus(0, "Unknown");
	static readonly NORMAL = new LabOrderResultStatus(1, "Normal");
	static readonly ABNORMAL = new LabOrderResultStatus(2, "Abnormal");
	
	static readonly VALUES: GandalfConstantList<LabOrderResultStatus> = {
		label: 'Lab Order Result Status',
		values: [LabOrderResultStatus.UNKNOWN, LabOrderResultStatus.NORMAL, LabOrderResultStatus.ABNORMAL, ]
	};
}

/** see com.rev360.model.laborder.constant.laborderresulttype.LabOrderResultType */
/* istanbul ignore next */
export class LabOrderResultType extends GandalfConstant<number> {
	static readonly UNKNOWN = new LabOrderResultType(0, "Unknown");
	static readonly POSITIVE_OR_NEGATIVE = new LabOrderResultType(1, "Normal/Abnormal");
	static readonly NUMERIC = new LabOrderResultType(2, "Numeric");
	static readonly IMAGE = new LabOrderResultType(3, "Image");
	static readonly OTHER = new LabOrderResultType(4, "Other");
	
	static readonly VALUES: GandalfConstantList<LabOrderResultType> = {
		label: 'Lab Order Result Type',
		values: [LabOrderResultType.UNKNOWN, LabOrderResultType.POSITIVE_OR_NEGATIVE, LabOrderResultType.NUMERIC, LabOrderResultType.IMAGE, LabOrderResultType.OTHER, ]
	};
}

/** see com.rev360.model.laborder.constant.laborderstatus.LabOrderStatus */
/* istanbul ignore next */
export class LabOrderStatus extends GandalfConstant<number> {
	static readonly REJECTED = new LabOrderStatus(-3, "Rejected");
	static readonly DELETED = new LabOrderStatus(-2, "Deleted");
	static readonly CANCELED = new LabOrderStatus(-1, "Canceled");
	static readonly NEW = new LabOrderStatus(1, "New");
	static readonly APPROVED = new LabOrderStatus(2, "Approved");
	static readonly COMPLETED = new LabOrderStatus(3, "Completed");
	
	static readonly VALUES: GandalfConstantList<LabOrderStatus> = {
		label: 'Lab Order Status',
		values: [LabOrderStatus.REJECTED, LabOrderStatus.DELETED, LabOrderStatus.CANCELED, LabOrderStatus.NEW, LabOrderStatus.APPROVED, LabOrderStatus.COMPLETED, ]
	};
}

/** see com.rev360.model.laborder.constant.labordertype.LabOrderType */
/* istanbul ignore next */
export class LabOrderType extends GandalfConstant<number> {
	static readonly INTERNAL = new LabOrderType(1, "Internal");
	static readonly EXTERNAL = new LabOrderType(2, "External");
	
	static readonly VALUES: GandalfConstantList<LabOrderType> = {
		label: 'Lab Order Type',
		values: [LabOrderType.INTERNAL, LabOrderType.EXTERNAL, ]
	};
}

/** see com.rev360.model.accounting.ledger.constant.ledgerpostingtype.LedgerPostingType */
/* istanbul ignore next */
export class LedgerPostingType extends GandalfConstant<number> {
	static readonly OTHER = new LedgerPostingType(0, "Other");
	static readonly PRODUCT = new LedgerPostingType(1, "Product");
	static readonly SERVICE = new LedgerPostingType(2, "Service");
	static readonly PROMOTION = new LedgerPostingType(3, "Promotion");
	static readonly DISCOUNT = new LedgerPostingType(4, "Discount");
	static readonly BALANCE_TRANSFER = new LedgerPostingType(5, "Balance Transfer");
	static readonly WRITEOFF = new LedgerPostingType(6, "Writeoff");
	static readonly REFUND = new LedgerPostingType(7, "Refund");
	static readonly ADHOC = new LedgerPostingType(8, "Adhoc");
	static readonly FINANCE_CHARGE = new LedgerPostingType(9, "Finance Charge");
	static readonly PAYMENT_CASH = new LedgerPostingType(20, "Cash Payment");
	static readonly PAYMENT_CHECK = new LedgerPostingType(21, "Check Payment");
	static readonly PAYMENT_CREDIT = new LedgerPostingType(22, "Credit Payment");
	static readonly PAYMENT_CREDIT_CARD = new LedgerPostingType(23, "Credit Card Payment");
	static readonly PAYMENT_ECHECK = new LedgerPostingType(24, "Echeck Payment");
	static readonly PAYMENT_EFT = new LedgerPostingType(25, "EFT Payment");
	static readonly PAYMENT_PAYPAL = new LedgerPostingType(26, "PayPal Payment");
	static readonly PAYMENT_CARE_CREDIT = new LedgerPostingType(27, "Care Credit Payment");
	static readonly PAYMENT_EASYPAY = new LedgerPostingType(28, "EasyPay Payment");
	static readonly PAYMENT_OTHER = new LedgerPostingType(29, "Other Payment");
	static readonly INFORMATION = new LedgerPostingType(30, "Information");
	static readonly LOCATION_DUE = new LedgerPostingType(40, "Location Due");
	static readonly REFUND_CASH = new LedgerPostingType(50, "Cash Refund");
	static readonly REFUND_CHECK = new LedgerPostingType(51, "Check Refund");
	static readonly REFUND_CREDIT_CARD = new LedgerPostingType(52, "Credit Card Refund");
	static readonly REFUND_OTHER = new LedgerPostingType(53, "Other Refund");
	static readonly REFUND_CARE_CREDIT = new LedgerPostingType(54, "Care Credit Refund");
	static readonly CREDIT_OFFICE = new LedgerPostingType(60, "Office Credit");
	static readonly ADJUSTMENT = new LedgerPostingType(100, "Adjustment");
	static readonly PAYMENT_APPLE_PAY = new LedgerPostingType(113, "Apple Pay Payment");
	static readonly REFUND_APPLE_PAY = new LedgerPostingType(121, "Apple Pay Refund");
	static readonly PAYMENT_GIFT_CERTIFICATE = new LedgerPostingType(114, "Gift Certificate Payment");
	static readonly PAYMENT_VENMO = new LedgerPostingType(115, "Venmo Payment");
	static readonly PAYMENT_SUNBIT = new LedgerPostingType(116, "Sunbit Payment");
	static readonly PAYMENT_ONLINE_PAYMENT = new LedgerPostingType(117, "Online Payment");
	static readonly PAYMENT_COFI = new LedgerPostingType(118, "CoFi Payment");
	static readonly PAYMENT_CRYPTO_CURRENCY = new LedgerPostingType(119, "Crypto Currency Payment");
	static readonly PAYMENT_CASH_APP = new LedgerPostingType(120, "Cash App Payment");
	static readonly REFUND_GIFT_CERTIFICATE = new LedgerPostingType(122, "Gift Certificate Refund");
	static readonly REFUND_VENMO = new LedgerPostingType(123, "Venmo Refund");
	static readonly REFUND_SUNBIT = new LedgerPostingType(124, "Sunbit Refund");
	static readonly REFUND_ONLINE_PAYMENT = new LedgerPostingType(125, "Online Payment Refund");
	static readonly REFUND_COFI = new LedgerPostingType(126, "CoFi Refund");
	static readonly REFUND_CRYPTO_CURRENCY = new LedgerPostingType(127, "Crypto Currency Refund");
	static readonly REFUND_CASH_APP = new LedgerPostingType(128, "Cash App Refund");
	
	static readonly VALUES: GandalfConstantList<LedgerPostingType> = {
		label: 'Ledger Posting Type',
		values: [LedgerPostingType.OTHER, LedgerPostingType.PRODUCT, LedgerPostingType.SERVICE, LedgerPostingType.PROMOTION, LedgerPostingType.DISCOUNT, LedgerPostingType.BALANCE_TRANSFER, LedgerPostingType.WRITEOFF, LedgerPostingType.REFUND, LedgerPostingType.ADHOC, LedgerPostingType.FINANCE_CHARGE, LedgerPostingType.PAYMENT_CASH, LedgerPostingType.PAYMENT_CHECK, LedgerPostingType.PAYMENT_CREDIT, LedgerPostingType.PAYMENT_CREDIT_CARD, LedgerPostingType.PAYMENT_ECHECK, LedgerPostingType.PAYMENT_EFT, LedgerPostingType.PAYMENT_PAYPAL, LedgerPostingType.PAYMENT_CARE_CREDIT, LedgerPostingType.PAYMENT_EASYPAY, LedgerPostingType.PAYMENT_OTHER, LedgerPostingType.INFORMATION, LedgerPostingType.LOCATION_DUE, LedgerPostingType.REFUND_CASH, LedgerPostingType.REFUND_CHECK, LedgerPostingType.REFUND_CREDIT_CARD, LedgerPostingType.REFUND_OTHER, LedgerPostingType.REFUND_CARE_CREDIT, LedgerPostingType.CREDIT_OFFICE, LedgerPostingType.ADJUSTMENT, LedgerPostingType.PAYMENT_APPLE_PAY, LedgerPostingType.REFUND_APPLE_PAY, LedgerPostingType.PAYMENT_GIFT_CERTIFICATE, LedgerPostingType.PAYMENT_VENMO, LedgerPostingType.PAYMENT_SUNBIT, LedgerPostingType.PAYMENT_ONLINE_PAYMENT, LedgerPostingType.PAYMENT_COFI, LedgerPostingType.PAYMENT_CRYPTO_CURRENCY, LedgerPostingType.PAYMENT_CASH_APP, LedgerPostingType.REFUND_GIFT_CERTIFICATE, LedgerPostingType.REFUND_VENMO, LedgerPostingType.REFUND_SUNBIT, LedgerPostingType.REFUND_ONLINE_PAYMENT, LedgerPostingType.REFUND_COFI, LedgerPostingType.REFUND_CRYPTO_CURRENCY, LedgerPostingType.REFUND_CASH_APP, ]
	};
}

/** see com.rev360.model.accounting.ledger.constant.ledger.LedgerType */
/* istanbul ignore next */
export class LedgerType extends GandalfConstant<number> {
	static readonly RECEIPTS = new LedgerType(1, "Receipts");
	static readonly ACCOUNTS_RECEIVABLE = new LedgerType(2, "Accounts Receivable");
	static readonly SALES = new LedgerType(3, "Sales");
	static readonly SALES_DISCOUNTS = new LedgerType(4, "Sales Discounts");
	static readonly SALES_WRITEOFFS = new LedgerType(5, "Sales Writeoffs");
	static readonly SALES_REFUNDS = new LedgerType(6, "Sales Refunds");
	static readonly LOCATION_DUE = new LedgerType(7, "Location Due");
	static readonly SALES_CREDITS = new LedgerType(8, "Sales Credits");
	static readonly OFFICE_CREDIT = new LedgerType(9, "Office Credit");
	
	static readonly VALUES: GandalfConstantList<LedgerType> = {
		label: 'LedgerType',
		values: [LedgerType.RECEIPTS, LedgerType.ACCOUNTS_RECEIVABLE, LedgerType.SALES, LedgerType.SALES_DISCOUNTS, LedgerType.SALES_WRITEOFFS, LedgerType.SALES_REFUNDS, LedgerType.LOCATION_DUE, LedgerType.SALES_CREDITS, LedgerType.OFFICE_CREDIT, ]
	};
}

/** see com.rev360.model.customer.constant.licensestatus.LicenseStatus */
/* istanbul ignore next */
export class LicenseStatus extends GandalfConstant<number> {
	static readonly EVALUATION = new LicenseStatus(0, "Evaluation");
	static readonly FULL = new LicenseStatus(1, "Full");
	
	static readonly VALUES: GandalfConstantList<LicenseStatus> = {
		label: 'License Status',
		values: [LicenseStatus.EVALUATION, LicenseStatus.FULL, ]
	};
}

/** see com.rev360.model.common.constant.locationstatus.LocationStatus */
/* istanbul ignore next */
export class LocationStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new LocationStatus(0, "Inactive");
	static readonly ACTIVE = new LocationStatus(1, "Active");
	static readonly DELETED = new LocationStatus(2, "Deleted");
	
	static readonly VALUES: GandalfConstantList<LocationStatus> = {
		label: 'Location Status',
		values: [LocationStatus.INACTIVE, LocationStatus.ACTIVE, LocationStatus.DELETED, ]
	};
}

/** see com.rev360.model.bridge.constant.lookupcodecategory.LookupCodeCategory */
/* istanbul ignore next */
export class LookupCodeCategory extends GandalfConstant<string> {
	static readonly TASK_STATUS = new LookupCodeCategory('Task Status', "Task Status");
	static readonly TOKEN_STATUS = new LookupCodeCategory('Token Status', "Token Status");
	static readonly TASK_TYPE = new LookupCodeCategory('Task Type', "Task Type");
	
	static readonly VALUES: GandalfConstantList<LookupCodeCategory> = {
		label: 'Lookup Code Category',
		values: [LookupCodeCategory.TASK_STATUS, LookupCodeCategory.TOKEN_STATUS, LookupCodeCategory.TASK_TYPE, ]
	};
}

/** see com.rev360.model.example.rpg.spell.constant.magicschool.MagicSchool */
/* istanbul ignore next */
export class MagicSchool extends GandalfConstant<number> {
	static readonly ABJURATION = new MagicSchool(1, "Abjuration");
	static readonly CONJURATION = new MagicSchool(2, "Conjuration");
	static readonly DIVINATION = new MagicSchool(3, "Divination");
	static readonly ENCHANTMENT = new MagicSchool(4, "Enchantment");
	static readonly EVOCATION = new MagicSchool(5, "Evocation");
	static readonly ILLUSION = new MagicSchool(6, "Illusion");
	static readonly NECROMANCY = new MagicSchool(7, "Necromancy");
	static readonly TRANSMUTATION = new MagicSchool(8, "Transmutation");
	
	static readonly VALUES: GandalfConstantList<MagicSchool> = {
		label: 'Magic School',
		values: [MagicSchool.ABJURATION, MagicSchool.CONJURATION, MagicSchool.DIVINATION, MagicSchool.ENCHANTMENT, MagicSchool.EVOCATION, MagicSchool.ILLUSION, MagicSchool.NECROMANCY, MagicSchool.TRANSMUTATION, ]
	};
}

/** see com.rev360.model.data.constant.maritalstatus.MaritalStatus */
/* istanbul ignore next */
export class MaritalStatus extends GandalfConstant<number> {
	static readonly SINGLE = new MaritalStatus(70, "Single");
	static readonly MARRIED = new MaritalStatus(71, "Married");
	static readonly OTHER = new MaritalStatus(72, "Other");
	
	static readonly VALUES: GandalfConstantList<MaritalStatus> = {
		label: 'Marital Status',
		values: [MaritalStatus.SINGLE, MaritalStatus.MARRIED, MaritalStatus.OTHER, ]
	};
}

/** see com.rev360.model.device.constant.masterdevicekey.MasterDeviceKey */
/* istanbul ignore next */
export class MasterDeviceKey extends GandalfConstant<string> {
	static readonly CANON_RK_F2 = new MasterDeviceKey('CANON RK-F2', "Canon RK-F2");
	static readonly ESSILOR_AKR = new MasterDeviceKey('Essilor AKR', "Essilor AKR");
	static readonly ESSILOR_ALM = new MasterDeviceKey('Essilor ALM', "Essilor ALM");
	static readonly ESSILOR_APH = new MasterDeviceKey('Essilor APH', "Essilor APH");
	static readonly EZER_ELM = new MasterDeviceKey('Ezer ELM', "Ezer ELM");
	static readonly EZER_ERK = new MasterDeviceKey('Ezer ERK', "Ezer ERK");
	static readonly HUVITZ_HLM = new MasterDeviceKey('Huvitz HLM', "Huvitz HLM");
	static readonly HUVITZ_HNT = new MasterDeviceKey('Huvitz HNT', "Huvitz HNT");
	static readonly HUVITZ_HRK = new MasterDeviceKey('Huvitz HRK', "Huvitz HRK");
	static readonly NIDEK_LM600 = new MasterDeviceKey('Nidek_LM-600', "Nidek LM-600");
	static readonly NIDEK_RT5100 = new MasterDeviceKey('Nidek_RT-5100', "Nidek RT-5100");
	static readonly NIDEK_TONOREF3 = new MasterDeviceKey('Nidek_Tonoref3', "Nidek Tonoref3");
	static readonly TOPCON_CL_STD1 = new MasterDeviceKey('TOPCON CL STD1', "TOPCON CL STD1");
	static readonly TOPCON_CL_100 = new MasterDeviceKey('TOPCON CL-100', "TOPCON CL-100");
	static readonly TOPCON_CL_200 = new MasterDeviceKey('TOPCON CL-200', "TOPCON CL-200");
	static readonly TOPCON_CL_300 = new MasterDeviceKey('TOPCON CL-300', "TOPCON CL-300");
	static readonly TOPCON_CT_80 = new MasterDeviceKey('TOPCON CT-80', "TOPCON CT-80");
	static readonly TOPCON_CV_2500 = new MasterDeviceKey('TOPCON CV-2500', "TOPCON CV-2500");
	static readonly TOPCON_CV_3000 = new MasterDeviceKey('TOPCON CV-3000', "TOPCON CV-3000");
	static readonly TOPCON_CV_5000 = new MasterDeviceKey('TOPCON CV-5000', "TOPCON CV-5000");
	static readonly TOPCON_KR_STD1 = new MasterDeviceKey('TOPCON KR STD1', "TOPCON KR STD1");
	static readonly TOPCON_KR_1 = new MasterDeviceKey('TOPCON KR-1', "TOPCON KR-1");
	static readonly TOPCON_KR_800 = new MasterDeviceKey('TOPCON KR-800', "TOPCON KR-800");
	static readonly TOPCON_KR_8000 = new MasterDeviceKey('TOPCON KR-8000', "TOPCON KR-8000");
	static readonly TOPCON_KR_8800 = new MasterDeviceKey('TOPCON KR-8800', "TOPCON KR-8800");
	static readonly TOPCON_KR_8900 = new MasterDeviceKey('TOPCON KR-8900', "TOPCON KR-8900");
	static readonly TOPCON_TRK_1P = new MasterDeviceKey('TOPCON TRK-1P', "TOPCON TRK-1P");
	static readonly TOPCON_TRK_2P = new MasterDeviceKey('TOPCON TRK-2P', "TOPCON TRK-2P");
	static readonly VISIONIX_REFKER_WAVELINE = new MasterDeviceKey('Visionix RefKer-Waveline', "Visionix RefKer-Waveline");
	static readonly VISIONIX_SERIAL = new MasterDeviceKey('VisionixSerial', "Visionix Serial");
	static readonly ESSILOR_ACTIVISU = new MasterDeviceKey('Essilor Activisu', "Essilor VisiOffice / m'eyeFit");
	static readonly OPTIKAM_OPTIKAM_PAD = new MasterDeviceKey('Optikam OptikamPad', "Optikam OptikamPad");
	static readonly ESSILOR_CBOX_XML = new MasterDeviceKey('Essilor CBOX XML', "Essilor CBOX XML");
	static readonly HUVITZ_CDR_HDR_MATE = new MasterDeviceKey('Huvitz CDR-Mate/HDR-Mate', "Huvitz CDR-Mate/HDR-Mate");
	static readonly REICHERT_CAPTURE = new MasterDeviceKey('ReichertCapture', "ReichertCapture");
	static readonly VEATCH_DIGITAL_REFRACTION = new MasterDeviceKey('Veatch Digital Refraction', "Veatch Digital Refraction");
	static readonly VEATCH_PDRMate = new MasterDeviceKey('Veatch PDRMate', "Veatch PDRMate");
	static readonly VISIONIX_VXBOX = new MasterDeviceKey('VisionixVXBox', "Visionix VXBox");
	static readonly ZEISS_SRU = new MasterDeviceKey('Zeiss SRU', "Zeiss SRU");
	static readonly VISION_CENTER_2020_NOW = new MasterDeviceKey('VisionCenter 20/20 Now Refraction', "VisionCenter 20/20 Now Refraction");
	
	static readonly VALUES: GandalfConstantList<MasterDeviceKey> = {
		label: 'Master Device Key',
		values: [MasterDeviceKey.CANON_RK_F2, MasterDeviceKey.ESSILOR_AKR, MasterDeviceKey.ESSILOR_ALM, MasterDeviceKey.ESSILOR_APH, MasterDeviceKey.EZER_ELM, MasterDeviceKey.EZER_ERK, MasterDeviceKey.HUVITZ_HLM, MasterDeviceKey.HUVITZ_HNT, MasterDeviceKey.HUVITZ_HRK, MasterDeviceKey.NIDEK_LM600, MasterDeviceKey.NIDEK_RT5100, MasterDeviceKey.NIDEK_TONOREF3, MasterDeviceKey.TOPCON_CL_STD1, MasterDeviceKey.TOPCON_CL_100, MasterDeviceKey.TOPCON_CL_200, MasterDeviceKey.TOPCON_CL_300, MasterDeviceKey.TOPCON_CT_80, MasterDeviceKey.TOPCON_CV_2500, MasterDeviceKey.TOPCON_CV_3000, MasterDeviceKey.TOPCON_CV_5000, MasterDeviceKey.TOPCON_KR_STD1, MasterDeviceKey.TOPCON_KR_1, MasterDeviceKey.TOPCON_KR_800, MasterDeviceKey.TOPCON_KR_8000, MasterDeviceKey.TOPCON_KR_8800, MasterDeviceKey.TOPCON_KR_8900, MasterDeviceKey.TOPCON_TRK_1P, MasterDeviceKey.TOPCON_TRK_2P, MasterDeviceKey.VISIONIX_REFKER_WAVELINE, MasterDeviceKey.VISIONIX_SERIAL, MasterDeviceKey.ESSILOR_ACTIVISU, MasterDeviceKey.OPTIKAM_OPTIKAM_PAD, MasterDeviceKey.ESSILOR_CBOX_XML, MasterDeviceKey.HUVITZ_CDR_HDR_MATE, MasterDeviceKey.REICHERT_CAPTURE, MasterDeviceKey.VEATCH_DIGITAL_REFRACTION, MasterDeviceKey.VEATCH_PDRMate, MasterDeviceKey.VISIONIX_VXBOX, MasterDeviceKey.ZEISS_SRU, MasterDeviceKey.VISION_CENTER_2020_NOW, ]
	};
}

/** see com.rev360.model.device.constant.masterdeviceworkflowtype.MasterDeviceWorkflowType */
/* istanbul ignore next */
export class MasterDeviceWorkflowType extends GandalfConstant<number> {
	static readonly EMR = new MasterDeviceWorkflowType(1, "EMR Device");
	static readonly OPTICAL = new MasterDeviceWorkflowType(2, "Optical Device");
	
	static readonly VALUES: GandalfConstantList<MasterDeviceWorkflowType> = {
		label: 'MasterDeviceWorkflowType',
		values: [MasterDeviceWorkflowType.EMR, MasterDeviceWorkflowType.OPTICAL, ]
	};
}

/** see com.rev360.model.messaging.constant.mastermesssagefolder.MasterMessageFolder */
/* istanbul ignore next */
export class MasterMessageFolder extends GandalfConstant<number> {
	static readonly INBOX = new MasterMessageFolder(1, "Inbox");
	static readonly SENT = new MasterMessageFolder(2, "Sent");
	static readonly TRASH = new MasterMessageFolder(3, "Trash");
	
	static readonly VALUES: GandalfConstantList<MasterMessageFolder> = {
		label: 'Master Message Folder',
		values: [MasterMessageFolder.INBOX, MasterMessageFolder.SENT, MasterMessageFolder.TRASH, ]
	};
}

/** see com.rev360.model.order.processors.constant.masterorderprocessorstatus.MasterOrderProcessorStatus */
/* istanbul ignore next */
export class MasterOrderProcessorStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new MasterOrderProcessorStatus(0, "Inactive");
	static readonly ACTIVE = new MasterOrderProcessorStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<MasterOrderProcessorStatus> = {
		label: 'Master Order Processor Status',
		values: [MasterOrderProcessorStatus.INACTIVE, MasterOrderProcessorStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.inventory.product.constant.masterproductcategory.MasterProductCategory */
/* istanbul ignore next */
export class MasterProductCategory extends GandalfConstant<number> {
	static readonly CONTACT_LENSES = new MasterProductCategory(1, "Contact Lenses");
	static readonly CONTACT_LENS_SOLUTION = new MasterProductCategory(2, "Contact Lens Solution");
	static readonly EYEGLASS_LENSES = new MasterProductCategory(3, "Eyeglass Lenses");
	static readonly EYEGLASS_LENS_TREATMENT = new MasterProductCategory(4, "Eyeglass Lens Treatments");
	static readonly EYEGLASS_FRAMES = new MasterProductCategory(5, "Eyeglass Frames");
	static readonly NON_RX_EYEGLASS_FRAMES = new MasterProductCategory(6, "Non Rx Eyeglass Frames");
	static readonly EYEGLASS_LENS_CLEANERS = new MasterProductCategory(7, "Eyeglass Lens Cleaners");
	static readonly EYEGLASS_CASES = new MasterProductCategory(8, "Eyeglass Cases");
	static readonly EYE_DROPS = new MasterProductCategory(9, "Eye Drops");
	static readonly MISCELLANEOUS = new MasterProductCategory(10, "Miscellaneous");
	static readonly VSP_LENS_STYLE = new MasterProductCategory(100, "Lens Style");
	static readonly VSP_LENS_MATERIAL = new MasterProductCategory(101, "Lens Material");
	static readonly VSP_LENS_BEVEL = new MasterProductCategory(102, "Lens Bevel");
	static readonly VSP_LENS_EDGE = new MasterProductCategory(103, "Lens Edge");
	static readonly VSP_AR_COATING = new MasterProductCategory(104, "AR Coating");
	static readonly VSP_SCRATCH_COATING = new MasterProductCategory(105, "Scratch Coating");
	static readonly VSP_GLASS_COATING = new MasterProductCategory(106, "Glass Coating");
	static readonly VSP_MIRROR_COATING = new MasterProductCategory(107, "Mirror Coating");
	static readonly VSP_UV_COATING = new MasterProductCategory(108, "UV Coating");
	static readonly VSP_TINT_TYPE = new MasterProductCategory(109, "Tint Type");
	
	static readonly VALUES: GandalfConstantList<MasterProductCategory> = {
		label: 'Master Product Category',
		values: [MasterProductCategory.CONTACT_LENSES, MasterProductCategory.CONTACT_LENS_SOLUTION, MasterProductCategory.EYEGLASS_LENSES, MasterProductCategory.EYEGLASS_LENS_TREATMENT, MasterProductCategory.EYEGLASS_FRAMES, MasterProductCategory.NON_RX_EYEGLASS_FRAMES, MasterProductCategory.EYEGLASS_LENS_CLEANERS, MasterProductCategory.EYEGLASS_CASES, MasterProductCategory.EYE_DROPS, MasterProductCategory.MISCELLANEOUS, MasterProductCategory.VSP_LENS_STYLE, MasterProductCategory.VSP_LENS_MATERIAL, MasterProductCategory.VSP_LENS_BEVEL, MasterProductCategory.VSP_LENS_EDGE, MasterProductCategory.VSP_AR_COATING, MasterProductCategory.VSP_SCRATCH_COATING, MasterProductCategory.VSP_GLASS_COATING, MasterProductCategory.VSP_MIRROR_COATING, MasterProductCategory.VSP_UV_COATING, MasterProductCategory.VSP_TINT_TYPE, ]
	};
}

/** see com.rev360.model.user.constant.mastersecureresource.MasterSecureResourceId */
/* istanbul ignore next */
export class MasterSecureResourceId extends GandalfConstant<number> {
	static readonly VIEW_PATIENTS = new MasterSecureResourceId(1, "View patients");
	static readonly PATIENTS_VIEW_PATIENT_SSN = new MasterSecureResourceId(2, "View patient SSN");
	static readonly PATIENTS_OVERRIDE_NOTES = new MasterSecureResourceId(3, "Override Notes");
	static readonly PATIENTS_ADD_EXTERNAL_PROVIDER = new MasterSecureResourceId(4, "Add External Provider");
	static readonly PATIENTS_ADD_INSURANCE_COMPANY = new MasterSecureResourceId(5, "Add Insurance Company");
	static readonly PATIENTS_ADD_GENERAL_MEDICATIONS = new MasterSecureResourceId(6, "Add General Medications");
	static readonly PATIENTS_VIEW_CDS_INTERVENTIONS = new MasterSecureResourceId(10, "View CDS Interventions");
	static readonly PATIENTS_ADD_FOLDER = new MasterSecureResourceId(20, "Add Folder");
	static readonly PATIENTS_DELETE_FOLDER = new MasterSecureResourceId(21, "Delete Folder");
	static readonly PATIENTS_CUT_PASTE_FOLDER = new MasterSecureResourceId(22, "Cut/Paste Folder");
	static readonly PATIENTS_RENAME_FOLDER = new MasterSecureResourceId(23, "Rename Folder");
	static readonly MANAGE_ENCOUNTER_TIMER_AND_TOTAL = new MasterSecureResourceId(24, "Manage Encounter Timer and Total");
	static readonly ACCESS_ENCOUNTER_PULL_FORWARD = new MasterSecureResourceId(25, "Access Encounter Pull Forward");
	static readonly VIEW_ENCOUNTER_TIMER_AND_TOTAL = new MasterSecureResourceId(26, "View Encounter Timer and Total");
	static readonly CREATE_MULTIPLE_EYEGLASS_RX = new MasterSecureResourceId(27, "Create Multiple Eyeglass Rx");
	static readonly VIEW_SAVED_CARDS = new MasterSecureResourceId(28, "View Saved Cards");
	static readonly MANAGE_SAVED_CARDS = new MasterSecureResourceId(29, "Manage Saved Cards");
	static readonly VIEW_SCHEDULE = new MasterSecureResourceId(101, "View schedule");
	static readonly SCHEDULE_BOOK_APPOINTMENTS = new MasterSecureResourceId(102, "Book appointments");
	static readonly SCHEDULE_CANCEL_APPOINTMENTS = new MasterSecureResourceId(103, "Cancel appointments");
	static readonly SCHEDULE_RESCHEDULE_APPOINTMENTS = new MasterSecureResourceId(104, "Reschedule appointments");
	static readonly SCHEDULE_CREATE_SLOT = new MasterSecureResourceId(105, "Create Slot");
	static readonly SCHEDULE_EDIT_SLOT = new MasterSecureResourceId(106, "Edit Slot");
	static readonly SCHEDULE_DELETE_SLOT = new MasterSecureResourceId(107, "Delete Slot");
	static readonly SCHEDULE_CREATE_BUSY_TIME = new MasterSecureResourceId(108, "Create Busy Time");
	static readonly SCHEDULE_EDIT_BUSY_TIME = new MasterSecureResourceId(109, "Edit Busy Time");
	static readonly SCHEDULE_DELETE_BUSY_TIME = new MasterSecureResourceId(110, "Delete Busy Time");
	static readonly SCHEDULE_CREATE_OFFICE_CLOSED = new MasterSecureResourceId(111, "Create Office Closed");
	static readonly SCHEDULE_EDIT_OFFICE_CLOSED = new MasterSecureResourceId(112, "Edit Office Closed");
	static readonly SCHEDULE_DELETE_OFFICE_CLOSED = new MasterSecureResourceId(113, "Delete Office Closed");
	static readonly SCHEDULE_CREATE_EMPLOYEE_HOURS = new MasterSecureResourceId(114, "Create Employee Hours");
	static readonly SCHEDULE_EDIT_EMPLOYEE_HOURS = new MasterSecureResourceId(115, "Edit Employee Hours");
	static readonly SCHEDULE_DELETE_EMPLOYEE_HOURS = new MasterSecureResourceId(116, "Delete Employee Hours");
	static readonly SCHEDULE_REPORTS = new MasterSecureResourceId(117, "Schedule Reports");
	static readonly SCHEDULE_MODIFY_OWN_EMPLOYEE_HOURS = new MasterSecureResourceId(118, "Modify Own Employee Hours");
	static readonly VIEW_INVOICES = new MasterSecureResourceId(201, "View Invoices");
	static readonly VIEW_PAYMENTS = new MasterSecureResourceId(228, "View Payments");
	static readonly VIEW_CLAIMS = new MasterSecureResourceId(250, "View Claims");
	static readonly ACCOUNTING_CREATE_INVOICE = new MasterSecureResourceId(202, "Create Invoice");
	static readonly ACCOUNTING_VOID_INVOICE = new MasterSecureResourceId(203, "Void Invoice");
	static readonly ACCOUNTING_RECEIVE_PAYMENT = new MasterSecureResourceId(204, "Receive Payment");
	static readonly ACCOUNTING_EDIT_PAYMENT = new MasterSecureResourceId(249, "Edit Applied Payment");
	static readonly ACCOUNTING_VOID_PAYMENT = new MasterSecureResourceId(205, "Void Payment");
	static readonly ACCOUNTING_VOID_OPENEDGE_PAYMENT = new MasterSecureResourceId(246, "Void Credit Card Payment via Payment Processor");
	static readonly ACCOUNTING_REFUND_OPENEDGE_PAYMENT = new MasterSecureResourceId(247, "Refund Credit Card via Payment Processor");
	static readonly ACCOUNTING_VOID_OPENEDGE_REFUND = new MasterSecureResourceId(248, "Void Credit Card Refund via Payment Processor");
	static readonly ACCOUNTING_ADD_DISCOUNT = new MasterSecureResourceId(206, "Add Discount");
	static readonly ACCOUNTING_ADD_WRITEOFF = new MasterSecureResourceId(207, "Add Writeoff");
	static readonly ACCOUNTING_ISSUE_REFUND = new MasterSecureResourceId(208, "Issue Refund");
	static readonly ACCOUNTING_ISSUE_CREDIT = new MasterSecureResourceId(209, "Issue Credit");
	static readonly ACCOUNTING_VOID_CREDIT = new MasterSecureResourceId(212, "Void Credit");
	static readonly ACCOUNTING_VOID_REFUND = new MasterSecureResourceId(213, "Void Refund");
	static readonly ACCOUNTING_SEND_STATEMENT = new MasterSecureResourceId(214, "Send Statement");
	static readonly ACCOUNTING_REMOVE_ITEM = new MasterSecureResourceId(215, "Remove Item");
	static readonly ACCOUNTING_EDIT_INVOICE_FINANCE_CHARGE_PLAN = new MasterSecureResourceId(226, "Edit Invoice Finance Charge Plan");
	static readonly ACCOUNTING_UNAUTHORIZE_INVOICE_WITH_FINANCE_CHARGES = new MasterSecureResourceId(227, "Unauthorize Invoice with Finance Charges");
	static readonly ACCOUNTING_CHANGE_INVOICE_ENCOUNTER = new MasterSecureResourceId(229, "Change Invoice Encounter");
	static readonly ACCOUNTING_CHANGE_INVOICE_DATE = new MasterSecureResourceId(230, "Change Invoice Date");
	static readonly ACCOUNTING_CHANGE_INVOICE_PROVIDER = new MasterSecureResourceId(231, "Change Invoice Provider");
	static readonly ACCOUNTING_VIEW_BILLING = new MasterSecureResourceId(232, "View Billing");
	static readonly ACCOUNTING_SET_INVOICE_FREEZE_DATE = new MasterSecureResourceId(240, "Set Invoice Freeze Date");
	static readonly ACCOUNTING_OVERRIDE_INVOICE_FREEZE_DATE = new MasterSecureResourceId(241, "Override Invoice Freeze Date");
	static readonly ACCOUNTING_ADD_ADHOC = new MasterSecureResourceId(245, "Add Adhoc");
	static readonly VIEW_INVENTORY = new MasterSecureResourceId(301, "View Inventory");
	static readonly EDIT_INVENTORY = new MasterSecureResourceId(308, "Edit Inventory");
	static readonly INVENTORY_EDIT_INDIVIDUAL_INVENTORY_PRICE = new MasterSecureResourceId(302, "Edit Individual Inventory Price");
	static readonly INVENTORY_EDIT_INVENTORY_QUANTITY = new MasterSecureResourceId(303, "Edit Inventory Quantity");
	static readonly INVENTORY_COPY_PRODUCTS = new MasterSecureResourceId(304, "Copy Products");
	static readonly INVENTORY_COPY_SERVICES = new MasterSecureResourceId(305, "Copy Services");
	static readonly INVENTORY_UPDATE_PROPERTIES_IN_BULK = new MasterSecureResourceId(306, "Update Properties");
	static readonly INVENTORY_UPDATE_PRICING_IN_BULK = new MasterSecureResourceId(307, "Update Pricing");
	static readonly INVENTORY_VIEW_ACTUAL_UNIT_COST = new MasterSecureResourceId(309, "View Actual/Unit Cost");
	static readonly VIEW_ORDERS = new MasterSecureResourceId(401, "View Orders");
	static readonly ORDERS_CREATE_ORDER = new MasterSecureResourceId(402, "Create Order");
	static readonly ORDERS_CANCEL_ORDER = new MasterSecureResourceId(403, "Cancel Order");
	static readonly ORDERS_EDIT_ORDER = new MasterSecureResourceId(404, "Edit Order");
	static readonly ORDERS_CHANGE_ORDER = new MasterSecureResourceId(405, "Change Order");
	static readonly ORDERS_COMPLETE_ORDER = new MasterSecureResourceId(406, "Complete Order");
	static readonly ORDERS_DUPLICATE_ORDER = new MasterSecureResourceId(407, "Duplicate Order");
	static readonly ORDERS_UPDATE_ORDER_STATUS = new MasterSecureResourceId(408, "Update Order Status");
	static readonly ORDERS_REMAKE_ORDER = new MasterSecureResourceId(409, "Remake Order");
	static readonly ORDERS_MARK_NON_BILLABLE = new MasterSecureResourceId(410, "Mark Non-billable");
	static readonly ORDERS_EDIT_ORDER_STATUS = new MasterSecureResourceId(411, "Edit Order Status");
	static readonly ORDERS_VIEW_ORDER_COSTS = new MasterSecureResourceId(412, "View Order Cost(s)");
	static readonly ORDERS_VIEW_EDIT_ORDER_COSTS = new MasterSecureResourceId(413, "View/Edit Order Cost(s)");
	static readonly ORDERS_RETURN_ORDER = new MasterSecureResourceId(414, "Return Order");
	static readonly ORDERS_ON_HOLD = new MasterSecureResourceId(415, "On Hold Order");
	static readonly VIEW_REPORTS = new MasterSecureResourceId(501, "View Reports");
	static readonly REPORTS_VIEW_PATIENT_REPORTS = new MasterSecureResourceId(511, "View Patient Reporots");
	static readonly REPORTS_CREATE_PATIENT_SEARCH = new MasterSecureResourceId(502, "Create Patient Search");
	static readonly REPORTS_EDIT_PATIENT_SEARCH = new MasterSecureResourceId(503, "Edit Patient Search");
	static readonly REPORTS_DELETE_PATIENT_SEARCH = new MasterSecureResourceId(504, "Delete Patient Search");
	static readonly REPORTS_EXECUTE_PATIENT_SEARCH = new MasterSecureResourceId(505, "Execute Patient Search");
	static readonly REPORTS_VIEW_SCHEDULE_REPORTS = new MasterSecureResourceId(506, "View Schedule Reports");
	static readonly REPORTS_VIEW_APPOINTMENTS_REPORT = new MasterSecureResourceId(512, "View Appointments Report");
	static readonly REPORTS_VIEW_SCHEDULE_SEARCH_REPORTS = new MasterSecureResourceId(513, "View Schedule Search Reports");
	static readonly REPORTS_VIEW_ENCOUNTERS_REPORT = new MasterSecureResourceId(514, "View Encounters Report");
	static readonly REPORTS_VIEW_ENCOUNTER_SEARCH_REPORTS = new MasterSecureResourceId(515, "View Encounter Search Reports");
	static readonly REPORTS_VIEW_SCHEDULE_CUSTOM_REPORTS = new MasterSecureResourceId(516, "View Schedule Custom Reports");
	static readonly REPORTS_VIEW_ACCOUNTING_REPORTS = new MasterSecureResourceId(210, "View Accounting Reports");
	static readonly REPORTS_VIEW_SALES_REPORT = new MasterSecureResourceId(221, "View Sales Report");
	static readonly REPORTS_VIEW_RECEIPTS_REPORT = new MasterSecureResourceId(222, "View Receipts Report");
	static readonly REPORTS_VIEW_REFUNDS_REPORT = new MasterSecureResourceId(223, "View Refunds Report");
	static readonly REPORTS_VIEW_UNASSIGNED_ITEMS_REPORT = new MasterSecureResourceId(216, "View Unassigned Items Report");
	static readonly REPORTS_VIEW_AGING_REPORT = new MasterSecureResourceId(217, "View Aging Report");
	static readonly REPORTS_VIEW_DEPOSITS_REPORT = new MasterSecureResourceId(218, "View Deposits Report");
	static readonly REPORTS_VIEW_LEDGER_POSTING_REPORT = new MasterSecureResourceId(211, "View Ledger Posting Report");
	static readonly REPORTS_VIEW_LEDGER_REPORT = new MasterSecureResourceId(219, "View Ledger Report");
	static readonly REPORTS_VIEW_LEDGER_DAILY_REPORT = new MasterSecureResourceId(220, "View Ledger Daily Report");
	static readonly REPORTS_VIEW_INVOICE_SEARCH = new MasterSecureResourceId(224, "View Invoice Search");
	static readonly REPORTS_VIEW_INVOICE_ITEM_SEARCH = new MasterSecureResourceId(225, "View Invoice Item Search");
	static readonly REPORTS_VIEW_ORDER_REPORTS = new MasterSecureResourceId(507, "View Order Reports");
	static readonly REPORTS_VIEW_TASK_REPORTS = new MasterSecureResourceId(508, "View Task Reports");
	static readonly REPORTS_VIEW_INVENTORY_REPORTS = new MasterSecureResourceId(509, "View Inventory Reports");
	static readonly REPORTS_VIEW_ADMIN_REPORTS = new MasterSecureResourceId(510, "View Admin Reports");
	static readonly VIEW_ADMINISTRATION = new MasterSecureResourceId(601, "View Administration");
	static readonly ADMINISTRATION_GENERAL = new MasterSecureResourceId(602, "General");
	static readonly ADMINISTRATION_EMPLOYEE_ROLES = new MasterSecureResourceId(603, "Employee/Roles");
	static readonly ADMINISTRATION_DATA_CONFIGURATION = new MasterSecureResourceId(604, "Data Configuration");
	static readonly ADMINISTRATION_TASKS = new MasterSecureResourceId(605, "Tasks");
	static readonly ADMINISTRATION_ENCOUNTERS = new MasterSecureResourceId(606, "Encounters");
	static readonly ADMINISTRATION_DOCUMENTS_AND_FORMS = new MasterSecureResourceId(607, "Documents and Forms");
	static readonly ADMINISTRATION_COMMUNICATION_TEMPLATES = new MasterSecureResourceId(608, "Communication Templates");
	static readonly ADMINISTRATION_VENDORS_PARTNERS = new MasterSecureResourceId(609, "Vendors/Partners");
	static readonly ADMINISTRATION_PATIENT_MANAGEMENT = new MasterSecureResourceId(610, "Patient Management");
	static readonly ADMINISTRATION_ACCOUNTING = new MasterSecureResourceId(611, "Accounting");
	static readonly ADMINISTRATION_SYSTEM_RULES = new MasterSecureResourceId(612, "Patient Triggers");
	static readonly ADMINISTRATION_EDIT_PRACTICE_CLAIMS_PROCESSING = new MasterSecureResourceId(620, "Edit Practice Claims Processing Info");
	static readonly ADMINISTRATION_EXPORT_PATIENT_CCDA_FILES = new MasterSecureResourceId(621, "Export Patient C-CDA Filees");
	static readonly ADMINISTRATION_IMPORT_QRDA_FILES = new MasterSecureResourceId(622, "Import QRDA Files");
	static readonly ADMINISTRATION_EMPLOYEE_LIMITED_VIEW = new MasterSecureResourceId(623, "Employees - Limited Access (reset password only)");
	static readonly EDIT_PAYMENT_PROCESSOR_INFO = new MasterSecureResourceId(630, "Edit Payment Processor Info");
	static readonly EDIT_REVDIRECT_INFO = new MasterSecureResourceId(631, "Edit RevDirect Info");
	static readonly EDIT_CLEARINGHOUSE_INFO = new MasterSecureResourceId(632, "Edit Clearinghouse Info");
	static readonly ADMINISTRATION_EDIT_EMPLOYEE_USERNAME = new MasterSecureResourceId(633, "Edit Employee Username");
	static readonly ADMINISTRATION_SOLUTIONS = new MasterSecureResourceId(634, "Solutions");
	static readonly ADMINISTRATION_VIEW_PARTNER_INTEGRATIONS = new MasterSecureResourceId(635, "View Partner Integrations");
	static readonly ADMINISTRATION_VIEW_REVCONNECT_REGISTRATION = new MasterSecureResourceId(636, "View RevConnect Registration");
	static readonly VIEW_REVCONNECT = new MasterSecureResourceId(801, "View RevConnect");
	static readonly REVCONNECT_VIEW_DASHBOARD = new MasterSecureResourceId(802, "View Dashboard");
	static readonly REVCONNECT_VIEW_SETTINGS = new MasterSecureResourceId(803, "View Settings");
	static readonly REVCONNECT_EDIT_SETTINGS = new MasterSecureResourceId(804, "Edit Settings");
	static readonly REVCONNECT_COPY_LOCATIONS = new MasterSecureResourceId(805, "Copy Locations");
	static readonly REVCONNECT_VIEW_CAMPAIGNS = new MasterSecureResourceId(806, "View Campaigns");
	static readonly REVCONNECT_CREATE_AND_SEND_CAMPAIGNS = new MasterSecureResourceId(807, "Create & Send Campaigns");
	static readonly REVCONNECT_VIEW_TWO_WAY_TEXTING = new MasterSecureResourceId(808, "View Two-way Texting");
	static readonly REVENGAGE_ADMIN = new MasterSecureResourceId(901, "Admin - Patient communication, campaigns, and all settings");
	static readonly REVENGAGE_SPECIALIST = new MasterSecureResourceId(902, "Specialist - Patient communication, and campaigns");
	static readonly REVENGAGE_STAFF = new MasterSecureResourceId(903, "Staff - Patient communication only");
	
	static readonly VALUES: GandalfConstantList<MasterSecureResourceId> = {
		label: 'MasterSecureResourceId',
		values: [MasterSecureResourceId.VIEW_PATIENTS, MasterSecureResourceId.PATIENTS_VIEW_PATIENT_SSN, MasterSecureResourceId.PATIENTS_OVERRIDE_NOTES, MasterSecureResourceId.PATIENTS_ADD_EXTERNAL_PROVIDER, MasterSecureResourceId.PATIENTS_ADD_INSURANCE_COMPANY, MasterSecureResourceId.PATIENTS_ADD_GENERAL_MEDICATIONS, MasterSecureResourceId.PATIENTS_VIEW_CDS_INTERVENTIONS, MasterSecureResourceId.PATIENTS_ADD_FOLDER, MasterSecureResourceId.PATIENTS_DELETE_FOLDER, MasterSecureResourceId.PATIENTS_CUT_PASTE_FOLDER, MasterSecureResourceId.PATIENTS_RENAME_FOLDER, MasterSecureResourceId.MANAGE_ENCOUNTER_TIMER_AND_TOTAL, MasterSecureResourceId.ACCESS_ENCOUNTER_PULL_FORWARD, MasterSecureResourceId.VIEW_ENCOUNTER_TIMER_AND_TOTAL, MasterSecureResourceId.CREATE_MULTIPLE_EYEGLASS_RX, MasterSecureResourceId.VIEW_SAVED_CARDS, MasterSecureResourceId.MANAGE_SAVED_CARDS, MasterSecureResourceId.VIEW_SCHEDULE, MasterSecureResourceId.SCHEDULE_BOOK_APPOINTMENTS, MasterSecureResourceId.SCHEDULE_CANCEL_APPOINTMENTS, MasterSecureResourceId.SCHEDULE_RESCHEDULE_APPOINTMENTS, MasterSecureResourceId.SCHEDULE_CREATE_SLOT, MasterSecureResourceId.SCHEDULE_EDIT_SLOT, MasterSecureResourceId.SCHEDULE_DELETE_SLOT, MasterSecureResourceId.SCHEDULE_CREATE_BUSY_TIME, MasterSecureResourceId.SCHEDULE_EDIT_BUSY_TIME, MasterSecureResourceId.SCHEDULE_DELETE_BUSY_TIME, MasterSecureResourceId.SCHEDULE_CREATE_OFFICE_CLOSED, MasterSecureResourceId.SCHEDULE_EDIT_OFFICE_CLOSED, MasterSecureResourceId.SCHEDULE_DELETE_OFFICE_CLOSED, MasterSecureResourceId.SCHEDULE_CREATE_EMPLOYEE_HOURS, MasterSecureResourceId.SCHEDULE_EDIT_EMPLOYEE_HOURS, MasterSecureResourceId.SCHEDULE_DELETE_EMPLOYEE_HOURS, MasterSecureResourceId.SCHEDULE_REPORTS, MasterSecureResourceId.SCHEDULE_MODIFY_OWN_EMPLOYEE_HOURS, MasterSecureResourceId.VIEW_INVOICES, MasterSecureResourceId.VIEW_PAYMENTS, MasterSecureResourceId.VIEW_CLAIMS, MasterSecureResourceId.ACCOUNTING_CREATE_INVOICE, MasterSecureResourceId.ACCOUNTING_VOID_INVOICE, MasterSecureResourceId.ACCOUNTING_RECEIVE_PAYMENT, MasterSecureResourceId.ACCOUNTING_EDIT_PAYMENT, MasterSecureResourceId.ACCOUNTING_VOID_PAYMENT, MasterSecureResourceId.ACCOUNTING_VOID_OPENEDGE_PAYMENT, MasterSecureResourceId.ACCOUNTING_REFUND_OPENEDGE_PAYMENT, MasterSecureResourceId.ACCOUNTING_VOID_OPENEDGE_REFUND, MasterSecureResourceId.ACCOUNTING_ADD_DISCOUNT, MasterSecureResourceId.ACCOUNTING_ADD_WRITEOFF, MasterSecureResourceId.ACCOUNTING_ISSUE_REFUND, MasterSecureResourceId.ACCOUNTING_ISSUE_CREDIT, MasterSecureResourceId.ACCOUNTING_VOID_CREDIT, MasterSecureResourceId.ACCOUNTING_VOID_REFUND, MasterSecureResourceId.ACCOUNTING_SEND_STATEMENT, MasterSecureResourceId.ACCOUNTING_REMOVE_ITEM, MasterSecureResourceId.ACCOUNTING_EDIT_INVOICE_FINANCE_CHARGE_PLAN, MasterSecureResourceId.ACCOUNTING_UNAUTHORIZE_INVOICE_WITH_FINANCE_CHARGES, MasterSecureResourceId.ACCOUNTING_CHANGE_INVOICE_ENCOUNTER, MasterSecureResourceId.ACCOUNTING_CHANGE_INVOICE_DATE, MasterSecureResourceId.ACCOUNTING_CHANGE_INVOICE_PROVIDER, MasterSecureResourceId.ACCOUNTING_VIEW_BILLING, MasterSecureResourceId.ACCOUNTING_SET_INVOICE_FREEZE_DATE, MasterSecureResourceId.ACCOUNTING_OVERRIDE_INVOICE_FREEZE_DATE, MasterSecureResourceId.ACCOUNTING_ADD_ADHOC, MasterSecureResourceId.VIEW_INVENTORY, MasterSecureResourceId.EDIT_INVENTORY, MasterSecureResourceId.INVENTORY_EDIT_INDIVIDUAL_INVENTORY_PRICE, MasterSecureResourceId.INVENTORY_EDIT_INVENTORY_QUANTITY, MasterSecureResourceId.INVENTORY_COPY_PRODUCTS, MasterSecureResourceId.INVENTORY_COPY_SERVICES, MasterSecureResourceId.INVENTORY_UPDATE_PROPERTIES_IN_BULK, MasterSecureResourceId.INVENTORY_UPDATE_PRICING_IN_BULK, MasterSecureResourceId.INVENTORY_VIEW_ACTUAL_UNIT_COST, MasterSecureResourceId.VIEW_ORDERS, MasterSecureResourceId.ORDERS_CREATE_ORDER, MasterSecureResourceId.ORDERS_CANCEL_ORDER, MasterSecureResourceId.ORDERS_EDIT_ORDER, MasterSecureResourceId.ORDERS_CHANGE_ORDER, MasterSecureResourceId.ORDERS_COMPLETE_ORDER, MasterSecureResourceId.ORDERS_DUPLICATE_ORDER, MasterSecureResourceId.ORDERS_UPDATE_ORDER_STATUS, MasterSecureResourceId.ORDERS_REMAKE_ORDER, MasterSecureResourceId.ORDERS_MARK_NON_BILLABLE, MasterSecureResourceId.ORDERS_EDIT_ORDER_STATUS, MasterSecureResourceId.ORDERS_VIEW_ORDER_COSTS, MasterSecureResourceId.ORDERS_VIEW_EDIT_ORDER_COSTS, MasterSecureResourceId.ORDERS_RETURN_ORDER, MasterSecureResourceId.ORDERS_ON_HOLD, MasterSecureResourceId.VIEW_REPORTS, MasterSecureResourceId.REPORTS_VIEW_PATIENT_REPORTS, MasterSecureResourceId.REPORTS_CREATE_PATIENT_SEARCH, MasterSecureResourceId.REPORTS_EDIT_PATIENT_SEARCH, MasterSecureResourceId.REPORTS_DELETE_PATIENT_SEARCH, MasterSecureResourceId.REPORTS_EXECUTE_PATIENT_SEARCH, MasterSecureResourceId.REPORTS_VIEW_SCHEDULE_REPORTS, MasterSecureResourceId.REPORTS_VIEW_APPOINTMENTS_REPORT, MasterSecureResourceId.REPORTS_VIEW_SCHEDULE_SEARCH_REPORTS, MasterSecureResourceId.REPORTS_VIEW_ENCOUNTERS_REPORT, MasterSecureResourceId.REPORTS_VIEW_ENCOUNTER_SEARCH_REPORTS, MasterSecureResourceId.REPORTS_VIEW_SCHEDULE_CUSTOM_REPORTS, MasterSecureResourceId.REPORTS_VIEW_ACCOUNTING_REPORTS, MasterSecureResourceId.REPORTS_VIEW_SALES_REPORT, MasterSecureResourceId.REPORTS_VIEW_RECEIPTS_REPORT, MasterSecureResourceId.REPORTS_VIEW_REFUNDS_REPORT, MasterSecureResourceId.REPORTS_VIEW_UNASSIGNED_ITEMS_REPORT, MasterSecureResourceId.REPORTS_VIEW_AGING_REPORT, MasterSecureResourceId.REPORTS_VIEW_DEPOSITS_REPORT, MasterSecureResourceId.REPORTS_VIEW_LEDGER_POSTING_REPORT, MasterSecureResourceId.REPORTS_VIEW_LEDGER_REPORT, MasterSecureResourceId.REPORTS_VIEW_LEDGER_DAILY_REPORT, MasterSecureResourceId.REPORTS_VIEW_INVOICE_SEARCH, MasterSecureResourceId.REPORTS_VIEW_INVOICE_ITEM_SEARCH, MasterSecureResourceId.REPORTS_VIEW_ORDER_REPORTS, MasterSecureResourceId.REPORTS_VIEW_TASK_REPORTS, MasterSecureResourceId.REPORTS_VIEW_INVENTORY_REPORTS, MasterSecureResourceId.REPORTS_VIEW_ADMIN_REPORTS, MasterSecureResourceId.VIEW_ADMINISTRATION, MasterSecureResourceId.ADMINISTRATION_GENERAL, MasterSecureResourceId.ADMINISTRATION_EMPLOYEE_ROLES, MasterSecureResourceId.ADMINISTRATION_DATA_CONFIGURATION, MasterSecureResourceId.ADMINISTRATION_TASKS, MasterSecureResourceId.ADMINISTRATION_ENCOUNTERS, MasterSecureResourceId.ADMINISTRATION_DOCUMENTS_AND_FORMS, MasterSecureResourceId.ADMINISTRATION_COMMUNICATION_TEMPLATES, MasterSecureResourceId.ADMINISTRATION_VENDORS_PARTNERS, MasterSecureResourceId.ADMINISTRATION_PATIENT_MANAGEMENT, MasterSecureResourceId.ADMINISTRATION_ACCOUNTING, MasterSecureResourceId.ADMINISTRATION_SYSTEM_RULES, MasterSecureResourceId.ADMINISTRATION_EDIT_PRACTICE_CLAIMS_PROCESSING, MasterSecureResourceId.ADMINISTRATION_EXPORT_PATIENT_CCDA_FILES, MasterSecureResourceId.ADMINISTRATION_IMPORT_QRDA_FILES, MasterSecureResourceId.ADMINISTRATION_EMPLOYEE_LIMITED_VIEW, MasterSecureResourceId.EDIT_PAYMENT_PROCESSOR_INFO, MasterSecureResourceId.EDIT_REVDIRECT_INFO, MasterSecureResourceId.EDIT_CLEARINGHOUSE_INFO, MasterSecureResourceId.ADMINISTRATION_EDIT_EMPLOYEE_USERNAME, MasterSecureResourceId.ADMINISTRATION_SOLUTIONS, MasterSecureResourceId.ADMINISTRATION_VIEW_PARTNER_INTEGRATIONS, MasterSecureResourceId.ADMINISTRATION_VIEW_REVCONNECT_REGISTRATION, MasterSecureResourceId.VIEW_REVCONNECT, MasterSecureResourceId.REVCONNECT_VIEW_DASHBOARD, MasterSecureResourceId.REVCONNECT_VIEW_SETTINGS, MasterSecureResourceId.REVCONNECT_EDIT_SETTINGS, MasterSecureResourceId.REVCONNECT_COPY_LOCATIONS, MasterSecureResourceId.REVCONNECT_VIEW_CAMPAIGNS, MasterSecureResourceId.REVCONNECT_CREATE_AND_SEND_CAMPAIGNS, MasterSecureResourceId.REVCONNECT_VIEW_TWO_WAY_TEXTING, MasterSecureResourceId.REVENGAGE_ADMIN, MasterSecureResourceId.REVENGAGE_SPECIALIST, MasterSecureResourceId.REVENGAGE_STAFF, ]
	};
}

/** see com.rev360.model.user.constant.mastersecurityrole.MasterSecurityRoleId */
/* istanbul ignore next */
export class MasterSecurityRoleEnum extends GandalfConstant<number> {
	static readonly SYSTEM_ADMINISTRATOR = new MasterSecurityRoleEnum(1, "System Administrator");
	static readonly OFFICE_ADMINISTRATOR = new MasterSecurityRoleEnum(2, "Office Administrator");
	static readonly OPTOMETRIST = new MasterSecurityRoleEnum(3, "Optometrist");
	static readonly OPHTHALMOLOGIST = new MasterSecurityRoleEnum(4, "Ophthalmologist");
	static readonly OPTICIAN = new MasterSecurityRoleEnum(5, "Optician");
	static readonly RECEPTIONIST = new MasterSecurityRoleEnum(6, "Receptionist");
	static readonly NURSE = new MasterSecurityRoleEnum(7, "Nurse");
	static readonly TECHNICIAN = new MasterSecurityRoleEnum(8, "Technician");
	
	static readonly VALUES: GandalfConstantList<MasterSecurityRoleEnum> = {
		label: 'Master Security Role Enum',
		values: [MasterSecurityRoleEnum.SYSTEM_ADMINISTRATOR, MasterSecurityRoleEnum.OFFICE_ADMINISTRATOR, MasterSecurityRoleEnum.OPTOMETRIST, MasterSecurityRoleEnum.OPHTHALMOLOGIST, MasterSecurityRoleEnum.OPTICIAN, MasterSecurityRoleEnum.RECEPTIONIST, MasterSecurityRoleEnum.NURSE, MasterSecurityRoleEnum.TECHNICIAN, ]
	};
}

/** see com.rev360.model.accounting.statements.constant.masterstatementprocessorstatus.MasterStatementProcessorStatus */
/* istanbul ignore next */
export class MasterStatementProcessorStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new MasterStatementProcessorStatus(0, "Inactive");
	static readonly ACTIVE = new MasterStatementProcessorStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<MasterStatementProcessorStatus> = {
		label: 'MasterStatementProcessorStatus',
		values: [MasterStatementProcessorStatus.INACTIVE, MasterStatementProcessorStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.query.constant.mastertriggeroutcomestatus.MasterTriggerOutcomeStatus */
/* istanbul ignore next */
export class MasterTriggerOutcomeStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new MasterTriggerOutcomeStatus(1, "Active");
	static readonly INACTIVE = new MasterTriggerOutcomeStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<MasterTriggerOutcomeStatus> = {
		label: 'Master Trigger Outcome Status',
		values: [MasterTriggerOutcomeStatus.ACTIVE, MasterTriggerOutcomeStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.query.constant.mastertriggeroutcometype.MasterTriggerOutcomeType */
/* istanbul ignore next */
export class MasterTriggerOutcomeType extends GandalfConstant<number> {
	static readonly CARE_PLAN_ITEM = new MasterTriggerOutcomeType(2, "Care Plan Item");
	
	static readonly VALUES: GandalfConstantList<MasterTriggerOutcomeType> = {
		label: 'Master Trigger Outcome Type',
		values: [MasterTriggerOutcomeType.CARE_PLAN_ITEM, ]
	};
}

/** see com.rev360.model.provider.constant.meaningfuluselogentitytype.MeaningfulUseLogEntityType */
/* istanbul ignore next */
export class MeaningfulUseLogEntityType extends GandalfConstant<string> {
	static readonly DIAGNOSIS = new MeaningfulUseLogEntityType('Dx', "Diagnosis");
	static readonly DIAGNOSIS_HISTORY = new MeaningfulUseLogEntityType('DxHistory', "Diagnosis History");
	static readonly MEDICATION_PRESCRIPTION = new MeaningfulUseLogEntityType('MedRx', "Medication Prescription");
	static readonly MEDICATION_HISTORY = new MeaningfulUseLogEntityType('MedHistory', "Medication History");
	static readonly MEDICATION_ALLERGY = new MeaningfulUseLogEntityType('MedAllergy', "Medication Allergy");
	static readonly MEDICATION_ALLERGY_HISTORY = new MeaningfulUseLogEntityType('MedAllergyHistory', "Medication Allergy History");
	static readonly DEMOGRAPHICS = new MeaningfulUseLogEntityType('Demographics', "Demographics");
	static readonly VITAL_SIGNS = new MeaningfulUseLogEntityType('Vitals', "Vital Signs");
	static readonly SMOKING_STATUS = new MeaningfulUseLogEntityType('Smoking', "Smoking Status");
	static readonly PATIENT_LIST = new MeaningfulUseLogEntityType('PatList', "Patient List");
	static readonly ENCOUNTER = new MeaningfulUseLogEntityType('Encounter', "Encounter");
	static readonly LAB_ORDER = new MeaningfulUseLogEntityType('LabOrder', "Lab Order");
	static readonly EDUCATION = new MeaningfulUseLogEntityType('Education', "Education");
	static readonly REFERRAL = new MeaningfulUseLogEntityType('Referral', "Referral");
	static readonly APPOINTMENT = new MeaningfulUseLogEntityType('Appointment', "Appointment");
	static readonly MESSAGE = new MeaningfulUseLogEntityType('Message', "Message");
	static readonly RECALL = new MeaningfulUseLogEntityType('Recall', "Recall");
	static readonly FAMILY_HISTORY = new MeaningfulUseLogEntityType('FamHistory', "Family History");
	static readonly FAMILY_REVIEW = new MeaningfulUseLogEntityType('FamReview', "Family Review");
	static readonly EXTERNAL_DATA = new MeaningfulUseLogEntityType('ExternalData', "External Data");
	
	static readonly VALUES: GandalfConstantList<MeaningfulUseLogEntityType> = {
		label: 'Meaningful Use Log Entity Type',
		values: [MeaningfulUseLogEntityType.DIAGNOSIS, MeaningfulUseLogEntityType.DIAGNOSIS_HISTORY, MeaningfulUseLogEntityType.MEDICATION_PRESCRIPTION, MeaningfulUseLogEntityType.MEDICATION_HISTORY, MeaningfulUseLogEntityType.MEDICATION_ALLERGY, MeaningfulUseLogEntityType.MEDICATION_ALLERGY_HISTORY, MeaningfulUseLogEntityType.DEMOGRAPHICS, MeaningfulUseLogEntityType.VITAL_SIGNS, MeaningfulUseLogEntityType.SMOKING_STATUS, MeaningfulUseLogEntityType.PATIENT_LIST, MeaningfulUseLogEntityType.ENCOUNTER, MeaningfulUseLogEntityType.LAB_ORDER, MeaningfulUseLogEntityType.EDUCATION, MeaningfulUseLogEntityType.REFERRAL, MeaningfulUseLogEntityType.APPOINTMENT, MeaningfulUseLogEntityType.MESSAGE, MeaningfulUseLogEntityType.RECALL, MeaningfulUseLogEntityType.FAMILY_HISTORY, MeaningfulUseLogEntityType.FAMILY_REVIEW, MeaningfulUseLogEntityType.EXTERNAL_DATA, ]
	};
}

/** see com.rev360.model.provider.constant.meaningfuluselogmeasuretype.MeaningfulUseLogMeasureType */
/* istanbul ignore next */
export class MeaningfulUseLogMeasureType extends GandalfConstant<number> {
	static readonly MEANINGFUL_USE_MEASURE_CPOE = new MeaningfulUseLogMeasureType(1, "CPOE");
	static readonly MEANINGFUL_USE_MEASURE_DRUG_INTERACTION = new MeaningfulUseLogMeasureType(2, "Drug Interaction");
	static readonly MEANINGFUL_USE_MEASURE_PROBLEM_LIST = new MeaningfulUseLogMeasureType(3, "Problem List");
	static readonly MEANINGFUL_USE_MEASURE_ERX = new MeaningfulUseLogMeasureType(4, "eRx");
	static readonly MEANINGFUL_USE_MEASURE_MED_LIST = new MeaningfulUseLogMeasureType(5, "Medication List");
	static readonly MEANINGFUL_USE_MEASURE_ALLERGY_LIST = new MeaningfulUseLogMeasureType(6, "Allergy List");
	static readonly MEANINGFUL_USE_MEASURE_DEMOGRAPHICS = new MeaningfulUseLogMeasureType(7, "Demographics");
	static readonly MEANINGFUL_USE_MEASURE_VITAL_SIGNS = new MeaningfulUseLogMeasureType(8, "Vital Signs");
	static readonly MEANINGFUL_USE_MEASURE_SMOKING_STATUS = new MeaningfulUseLogMeasureType(9, "Smoking Status");
	static readonly MEANINGFUL_USE_MEASURE_CLINICAL_QUALITY = new MeaningfulUseLogMeasureType(10, "Clinical Quality");
	static readonly MEANINGFUL_USE_MEASURE_CDS_RULE = new MeaningfulUseLogMeasureType(11, "Clinical Decision Support");
	static readonly MEANINGFUL_USE_MEASURE_ECOPY_HEALTH = new MeaningfulUseLogMeasureType(12, "eCopy of Health Record");
	static readonly MEANINGFUL_USE_MEASURE_CLINICAL_SUMMARY = new MeaningfulUseLogMeasureType(13, "Clinical Summary");
	static readonly MEANINGFUL_USE_MEASURE_EXCHANGE_CLINICAL = new MeaningfulUseLogMeasureType(14, "Exchange of Clinical Summary");
	static readonly MEANINGFUL_USE_MEASURE_PROTECT_EHR_DATA = new MeaningfulUseLogMeasureType(15, "Protect Data");
	static readonly MEANINGFUL_USE_MEASURE_DRUG_FORMULARY = new MeaningfulUseLogMeasureType(16, "Drug Formulary");
	static readonly MEANINGFUL_USE_MEASURE_LAB_RESULT = new MeaningfulUseLogMeasureType(17, "Lab Result");
	static readonly MEANINGFUL_USE_MEASURE_PATIENT_LIST = new MeaningfulUseLogMeasureType(18, "Patient List");
	static readonly MEANINGFUL_USE_MEASURE_PATIENT_REMINDER = new MeaningfulUseLogMeasureType(19, "Patient Reminder");
	static readonly MEANINGFUL_USE_MEASURE_PATIENT_ACCESS = new MeaningfulUseLogMeasureType(20, "Patient Access");
	static readonly MEANINGFUL_USE_MEASURE_PATIENT_EDUCATION = new MeaningfulUseLogMeasureType(21, "Patient Education");
	static readonly MEANINGFUL_USE_MEASURE_MED_RECONCILIATION = new MeaningfulUseLogMeasureType(22, "Medication Reconciliation");
	static readonly MEANINGFUL_USE_MEASURE_TRANSITION_OF_CARE = new MeaningfulUseLogMeasureType(23, "Transition of Care");
	static readonly MEANINGFUL_USE_MEASURE_IMMUNIZATION_REG = new MeaningfulUseLogMeasureType(24, "Immunization Registry");
	static readonly MEANINGFUL_USE_MEASURE_SYNDROMIC_DATA = new MeaningfulUseLogMeasureType(25, "Syndromic Data");
	static readonly MEANINGFUL_USE_MEASURE_VITAL_SIGNS_BP_ONLY = new MeaningfulUseLogMeasureType(26, "Vital Signs - Blood Pressure");
	static readonly MEANINGFUL_USE_MEASURE_VITAL_SIGNS_HW_ONLY = new MeaningfulUseLogMeasureType(27, "Vital Sign - Height/Weight");
	static readonly MEANINGFUL_USE_MEASURE_VITAL_SIGNS_BOTH = new MeaningfulUseLogMeasureType(28, "Vital Signs");
	static readonly MU_2014_STAGE_2_MEASURE_CPOE = new MeaningfulUseLogMeasureType(201, "CPOE");
	static readonly MU_2014_STAGE_2_MEASURE_CPOE_MED = new MeaningfulUseLogMeasureType(231, "CPOE - Medications");
	static readonly MU_2014_STAGE_2_MEASURE_CPOE_LAB = new MeaningfulUseLogMeasureType(232, "CPOE - Lab Orders");
	static readonly MU_2014_STAGE_2_MEASURE_CPOE_RAD = new MeaningfulUseLogMeasureType(233, "CPOR - Radiology");
	static readonly MU_2014_STAGE_2_MEASURE_ERX = new MeaningfulUseLogMeasureType(202, "eRx");
	static readonly MU_2014_STAGE_2_MEASURE_DEMOGRAPHICS = new MeaningfulUseLogMeasureType(203, "Demographics");
	static readonly MU_2014_STAGE_2_MEASURE_VITAL_SIGNS = new MeaningfulUseLogMeasureType(204, "Vital Signs ");
	static readonly MU_2014_STAGE_2_MEASURE_VITAL_SIGNS_BP = new MeaningfulUseLogMeasureType(234, "Vital Signs - Blood Pressure");
	static readonly MU_2014_STAGE_2_MEASURE_VITAL_SIGNS_HW = new MeaningfulUseLogMeasureType(235, "Vital Sign - Height/Weight");
	static readonly MU_2014_STAGE_2_MEASURE_SMOKING_STATUS = new MeaningfulUseLogMeasureType(205, "Smoking Status");
	static readonly MU_2014_STAGE_2_MEASURE_DECISION_SUPPORT = new MeaningfulUseLogMeasureType(206, "Clinical Decision Support");
	static readonly MU_2014_STAGE_2_MEASURE_DECISION_SUPPORT_RULE = new MeaningfulUseLogMeasureType(236, "Clinical Decision Support - Rule");
	static readonly MU_2014_STAGE_2_MEASURE_DECISION_SUPPORT_DRUG = new MeaningfulUseLogMeasureType(237, "Clinical Decision Support - Drug");
	static readonly MU_2014_STAGE_2_MEASURE_PATIENT_VDT = new MeaningfulUseLogMeasureType(207, "View/Download/Transmit");
	static readonly MU_2014_STAGE_2_MEASURE_PATIENT_VDT_ACCESS = new MeaningfulUseLogMeasureType(238, "Access to eCopy");
	static readonly MU_2014_STAGE_2_MEASURE_PATIENT_VDT_USE = new MeaningfulUseLogMeasureType(239, "Used eCopy");
	static readonly MU_2014_STAGE_2_MEASURE_CLINICAL_SUMMARY = new MeaningfulUseLogMeasureType(208, "Clinical Summary");
	static readonly MU_2014_STAGE_2_MEASURE_PROTECT_EPHI = new MeaningfulUseLogMeasureType(209, "Protect ePHI");
	static readonly MU_2014_STAGE_2_MEASURE_LAB_RESULTS = new MeaningfulUseLogMeasureType(210, "Lab Results");
	static readonly MU_2014_STAGE_2_MEASURE_PATIENT_LIST = new MeaningfulUseLogMeasureType(211, "Patient List");
	static readonly MU_2014_STAGE_2_MEASURE_PATIENT_REMINDERS = new MeaningfulUseLogMeasureType(212, "Patient Reminders");
	static readonly MU_2014_STAGE_2_MEASURE_PATIENT_EDUCATION = new MeaningfulUseLogMeasureType(213, "Patient Education");
	static readonly MU_2014_STAGE_2_MEASURE_MED_RECONCILIATION = new MeaningfulUseLogMeasureType(214, "Medication Reconciliation");
	static readonly MU_2014_STAGE_2_MEASURE_TOC_REFERRAL = new MeaningfulUseLogMeasureType(215, "Transition of Care");
	static readonly MU_2014_STAGE_2_MEASURE_TOC_REFERRAL_BASE = new MeaningfulUseLogMeasureType(240, "Transition of Care");
	static readonly MU_2014_STAGE_2_MEASURE_TOC_REFERRAL_ELECTRONIC = new MeaningfulUseLogMeasureType(241, "Transition of Care - Electronic");
	static readonly MU_2014_STAGE_2_MEASURE_TOC_REFERRAL_TEST = new MeaningfulUseLogMeasureType(242, "Transition of Care - Test");
	static readonly MU_2014_STAGE_2_MEASURE_IMMUNIZATION = new MeaningfulUseLogMeasureType(216, "Immunization Registry");
	static readonly MU_2014_STAGE_2_MEASURE_PATIENT_MESSAGING = new MeaningfulUseLogMeasureType(217, "Patient Messaging");
	static readonly MU_2014_STAGE_2_MEASURE_SYNDROMIC_DATA = new MeaningfulUseLogMeasureType(218, "Syndromic Data");
	static readonly MU_2014_STAGE_2_MEASURE_ELECTRONIC_NOTES = new MeaningfulUseLogMeasureType(219, "Electronic Notes");
	static readonly MU_2014_STAGE_2_MEASURE_IMAGING_RESULTS = new MeaningfulUseLogMeasureType(220, "Imaging Results");
	static readonly MU_2014_STAGE_2_MEASURE_FAMILY_HEALTH_HISTORY = new MeaningfulUseLogMeasureType(221, "Family Health History");
	static readonly MU_2014_STAGE_2_MEASURE_CANCER_REGISTRY = new MeaningfulUseLogMeasureType(222, "Cancer Registry");
	static readonly MU_2014_STAGE_2_MEASURE_SPECIALIZED_REGISTRY = new MeaningfulUseLogMeasureType(223, "Specialize Registry");
	static readonly MU_MODIFIED_MEASURE_IMMUNIZATION = new MeaningfulUseLogMeasureType(301, "Immunization Registry");
	static readonly MU_MODIFIED_MEASURE_SYNDROMIC = new MeaningfulUseLogMeasureType(302, "Syndromic Data");
	static readonly MU_MODIFIED_MEASURE_SPEC1_REGISTRY = new MeaningfulUseLogMeasureType(303, "Specialized Registry");
	static readonly MU_MODIFIED_MEASURE_SPEC2_REGISTRY = new MeaningfulUseLogMeasureType(304, "Specialized Registry");
	static readonly MU_MODIFIED_MEASURE_SECURE_MESSAGING = new MeaningfulUseLogMeasureType(305, "Secure Messaging");
	static readonly MU_STAGE_3_MEASURE_PATIENT_VDT_ACCESS = new MeaningfulUseLogMeasureType(401, "View/Download/Transmit - Access");
	static readonly MU_ACI_MEASURE_CEHRT_RELATED_IMPROVEMENT_ACTIVITY = new MeaningfulUseLogMeasureType(402, "Related Improvement Activity");
	static readonly MU_STAGE_3_MEASURE_CLINICAL_INFORMATION_RECONCILIATION = new MeaningfulUseLogMeasureType(403, "Information Reconciliation");
	static readonly MU_STAGE_3_MEASURE_REQUEST_ACCEPT_SUMMARY_OF_CARE = new MeaningfulUseLogMeasureType(404, "Accept Summary of Care");
	static readonly MU_STAGE_3_MEASURE_PATIENT_GENERATED_HEALTH_DATA = new MeaningfulUseLogMeasureType(405, "Patient Generated Health Data");
	static readonly MU_STAGE_3_MEASURE_PATIENT_EDUCATION = new MeaningfulUseLogMeasureType(406, "Patient Education");
	static readonly MIPS_PI_STAGE_3_ELECTRONIC_CASE_REGISTRY_REPORTING = new MeaningfulUseLogMeasureType(407, "Electronic Case Registry Reporting");
	static readonly MIPS_PI_STAGE_3_CREATE_PUBLIC_HEALTH_REGISTRY_REPORTING = new MeaningfulUseLogMeasureType(408, "Public Health Registry Reporting");
	static readonly MIPS_PI_STAGE_3_CLINICAL_DATA_REGISTRY_REPORTING = new MeaningfulUseLogMeasureType(409, "Clinical Data Registry Reporting");
	
	static readonly VALUES: GandalfConstantList<MeaningfulUseLogMeasureType> = {
		label: 'Meaningful Use Log Measure Type',
		values: [MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_CPOE, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_DRUG_INTERACTION, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_PROBLEM_LIST, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_ERX, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_MED_LIST, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_ALLERGY_LIST, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_DEMOGRAPHICS, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_VITAL_SIGNS, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_SMOKING_STATUS, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_CLINICAL_QUALITY, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_CDS_RULE, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_ECOPY_HEALTH, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_CLINICAL_SUMMARY, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_EXCHANGE_CLINICAL, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_PROTECT_EHR_DATA, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_DRUG_FORMULARY, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_LAB_RESULT, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_PATIENT_LIST, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_PATIENT_REMINDER, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_PATIENT_ACCESS, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_PATIENT_EDUCATION, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_MED_RECONCILIATION, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_TRANSITION_OF_CARE, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_IMMUNIZATION_REG, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_SYNDROMIC_DATA, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_VITAL_SIGNS_BP_ONLY, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_VITAL_SIGNS_HW_ONLY, MeaningfulUseLogMeasureType.MEANINGFUL_USE_MEASURE_VITAL_SIGNS_BOTH, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_CPOE, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_CPOE_MED, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_CPOE_LAB, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_CPOE_RAD, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_ERX, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_DEMOGRAPHICS, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_VITAL_SIGNS, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_VITAL_SIGNS_BP, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_VITAL_SIGNS_HW, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_SMOKING_STATUS, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_DECISION_SUPPORT, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_DECISION_SUPPORT_RULE, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_DECISION_SUPPORT_DRUG, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PATIENT_VDT, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PATIENT_VDT_ACCESS, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PATIENT_VDT_USE, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_CLINICAL_SUMMARY, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PROTECT_EPHI, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_LAB_RESULTS, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PATIENT_LIST, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PATIENT_REMINDERS, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PATIENT_EDUCATION, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_MED_RECONCILIATION, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_TOC_REFERRAL, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_TOC_REFERRAL_BASE, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_TOC_REFERRAL_ELECTRONIC, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_TOC_REFERRAL_TEST, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_IMMUNIZATION, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_PATIENT_MESSAGING, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_SYNDROMIC_DATA, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_ELECTRONIC_NOTES, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_IMAGING_RESULTS, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_FAMILY_HEALTH_HISTORY, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_CANCER_REGISTRY, MeaningfulUseLogMeasureType.MU_2014_STAGE_2_MEASURE_SPECIALIZED_REGISTRY, MeaningfulUseLogMeasureType.MU_MODIFIED_MEASURE_IMMUNIZATION, MeaningfulUseLogMeasureType.MU_MODIFIED_MEASURE_SYNDROMIC, MeaningfulUseLogMeasureType.MU_MODIFIED_MEASURE_SPEC1_REGISTRY, MeaningfulUseLogMeasureType.MU_MODIFIED_MEASURE_SPEC2_REGISTRY, MeaningfulUseLogMeasureType.MU_MODIFIED_MEASURE_SECURE_MESSAGING, MeaningfulUseLogMeasureType.MU_STAGE_3_MEASURE_PATIENT_VDT_ACCESS, MeaningfulUseLogMeasureType.MU_ACI_MEASURE_CEHRT_RELATED_IMPROVEMENT_ACTIVITY, MeaningfulUseLogMeasureType.MU_STAGE_3_MEASURE_CLINICAL_INFORMATION_RECONCILIATION, MeaningfulUseLogMeasureType.MU_STAGE_3_MEASURE_REQUEST_ACCEPT_SUMMARY_OF_CARE, MeaningfulUseLogMeasureType.MU_STAGE_3_MEASURE_PATIENT_GENERATED_HEALTH_DATA, MeaningfulUseLogMeasureType.MU_STAGE_3_MEASURE_PATIENT_EDUCATION, MeaningfulUseLogMeasureType.MIPS_PI_STAGE_3_ELECTRONIC_CASE_REGISTRY_REPORTING, MeaningfulUseLogMeasureType.MIPS_PI_STAGE_3_CREATE_PUBLIC_HEALTH_REGISTRY_REPORTING, MeaningfulUseLogMeasureType.MIPS_PI_STAGE_3_CLINICAL_DATA_REGISTRY_REPORTING, ]
	};
}

/** see com.rev360.model.encounter.constant.medicaldecisionmakingcomplexity.MedicalDecisionMakingComplexity */
/* istanbul ignore next */
export class MedicalDecisionMakingComplexity extends GandalfConstant<number> {
	static readonly UNKNOWN = new MedicalDecisionMakingComplexity(0, "None");
	static readonly MINIMAL = new MedicalDecisionMakingComplexity(1, "Minimal");
	static readonly LIMITED = new MedicalDecisionMakingComplexity(2, "Limited");
	static readonly MODERATE = new MedicalDecisionMakingComplexity(3, "Moderate");
	static readonly EXTENSIVE = new MedicalDecisionMakingComplexity(4, "Extensive");
	
	static readonly VALUES: GandalfConstantList<MedicalDecisionMakingComplexity> = {
		label: 'Medical Decision Making Complexity',
		values: [MedicalDecisionMakingComplexity.UNKNOWN, MedicalDecisionMakingComplexity.MINIMAL, MedicalDecisionMakingComplexity.LIMITED, MedicalDecisionMakingComplexity.MODERATE, MedicalDecisionMakingComplexity.EXTENSIVE, ]
	};
}

/** see com.rev360.model.encounter.constant.medicaldecisionmakingconsultation.MedicalDecisionMakingConsultation */
/* istanbul ignore next */
export class MedicalDecisionMakingConsultation extends GandalfConstant<number> {
	static readonly UNKNOWN = new MedicalDecisionMakingConsultation(0, "None");
	static readonly OFFICE = new MedicalDecisionMakingConsultation(1, "Office");
	static readonly INPATIENT = new MedicalDecisionMakingConsultation(2, "InPatient");
	static readonly CONFIRM = new MedicalDecisionMakingConsultation(3, "Confirm");
	
	static readonly VALUES: GandalfConstantList<MedicalDecisionMakingConsultation> = {
		label: 'Medical Decision Making Consultation',
		values: [MedicalDecisionMakingConsultation.UNKNOWN, MedicalDecisionMakingConsultation.OFFICE, MedicalDecisionMakingConsultation.INPATIENT, MedicalDecisionMakingConsultation.CONFIRM, ]
	};
}

/** see com.rev360.model.encounter.constant.medicaldecisionmakingnumdx.MedicalDecisionMakingNumDx */
/* istanbul ignore next */
export class MedicalDecisionMakingNumDx extends GandalfConstant<number> {
	static readonly UNKNOWN = new MedicalDecisionMakingNumDx(0, "None");
	static readonly MINIMAL = new MedicalDecisionMakingNumDx(1, "Minimal");
	static readonly LOW = new MedicalDecisionMakingNumDx(2, "Low");
	static readonly MODERATE = new MedicalDecisionMakingNumDx(3, "Moderate");
	static readonly HIGH = new MedicalDecisionMakingNumDx(4, "High");
	
	static readonly VALUES: GandalfConstantList<MedicalDecisionMakingNumDx> = {
		label: 'Diagnosis',
		values: [MedicalDecisionMakingNumDx.UNKNOWN, MedicalDecisionMakingNumDx.MINIMAL, MedicalDecisionMakingNumDx.LOW, MedicalDecisionMakingNumDx.MODERATE, MedicalDecisionMakingNumDx.HIGH, ]
	};
}

/** see com.rev360.model.encounter.constant.medicaldecisionmakingrisk.MedicalDecisionMakingRisk */
/* istanbul ignore next */
export class MedicalDecisionMakingRisk extends GandalfConstant<number> {
	static readonly UNKNOWN = new MedicalDecisionMakingRisk(0, "None");
	static readonly MINIMAL = new MedicalDecisionMakingRisk(1, "Minimal");
	static readonly LOW = new MedicalDecisionMakingRisk(2, "Low");
	static readonly MODERATE = new MedicalDecisionMakingRisk(3, "Moderate");
	static readonly HIGH = new MedicalDecisionMakingRisk(4, "High");
	
	static readonly VALUES: GandalfConstantList<MedicalDecisionMakingRisk> = {
		label: 'MedicalDecisionMakingRisk',
		values: [MedicalDecisionMakingRisk.UNKNOWN, MedicalDecisionMakingRisk.MINIMAL, MedicalDecisionMakingRisk.LOW, MedicalDecisionMakingRisk.MODERATE, MedicalDecisionMakingRisk.HIGH, ]
	};
}

/** see com.rev360.model.prescription.constant.MedicationPrescriptionType */
/* istanbul ignore next */
export class MedicationPrescriptionType extends GandalfConstant<number> {
	static readonly GENERAL = new MedicationPrescriptionType(0, "General");
	static readonly INTERNAL = new MedicationPrescriptionType(1, "Internal");
	static readonly EXTERNAL = new MedicationPrescriptionType(2, "External");
	
	static readonly VALUES: GandalfConstantList<MedicationPrescriptionType> = {
		label: 'Prescription Type',
		values: [MedicationPrescriptionType.GENERAL, MedicationPrescriptionType.INTERNAL, MedicationPrescriptionType.EXTERNAL, ]
	};
}

/** see com.rev360.pms.service.messaging.MessageParticipantSortOption */
/* istanbul ignore next */
export class MessageParticipantSortOption extends GandalfConstant<number> {
	static readonly DATE = new MessageParticipantSortOption(1, "Date");
	static readonly PRIORITY = new MessageParticipantSortOption(2, "Priority");
	static readonly SUBJECT = new MessageParticipantSortOption(3, "Subject");
	
	static readonly VALUES: GandalfConstantList<MessageParticipantSortOption> = {
		label: 'Message Participant Sort Option',
		values: [MessageParticipantSortOption.DATE, MessageParticipantSortOption.PRIORITY, MessageParticipantSortOption.SUBJECT, ]
	};
}

/** see com.rev360.model.messaging.constant.messageparticipantstatus.MessageParticipantStatus */
/* istanbul ignore next */
export class MessageParticipantStatus extends GandalfConstant<number> {
	static readonly UNREAD = new MessageParticipantStatus(0, "Unread");
	static readonly READ = new MessageParticipantStatus(1, "Read");
	static readonly DIRECT_PENDING = new MessageParticipantStatus(2, "Direct Pending");
	static readonly DIRECT_SENDING = new MessageParticipantStatus(3, "Direct Sending");
	static readonly DIRECT_FAILED = new MessageParticipantStatus(4, "Direct Failed");
	static readonly DELETED = new MessageParticipantStatus(8, "Deleted");
	static readonly PURGED = new MessageParticipantStatus(9, "Purged");
	
	static readonly VALUES: GandalfConstantList<MessageParticipantStatus> = {
		label: 'Message Participant Status',
		values: [MessageParticipantStatus.UNREAD, MessageParticipantStatus.READ, MessageParticipantStatus.DIRECT_PENDING, MessageParticipantStatus.DIRECT_SENDING, MessageParticipantStatus.DIRECT_FAILED, MessageParticipantStatus.DELETED, MessageParticipantStatus.PURGED, ]
	};
}

/** see com.rev360.model.messaging.constant.messageparticipanttransmissiontype.MessageParticipantTransmissionType */
/* istanbul ignore next */
export class MessageParticipantTransmissionType extends GandalfConstant<number> {
	static readonly DATABASE = new MessageParticipantTransmissionType(0, "Database");
	static readonly DIRECT = new MessageParticipantTransmissionType(1, "Direct");
	
	static readonly VALUES: GandalfConstantList<MessageParticipantTransmissionType> = {
		label: 'Message Participant Transmission Type',
		values: [MessageParticipantTransmissionType.DATABASE, MessageParticipantTransmissionType.DIRECT, ]
	};
}

/** see com.rev360.model.messaging.constant.messageparticipanttype.MessageParticipantType */
/* istanbul ignore next */
export class MessageParticipantType extends GandalfConstant<number> {
	static readonly FROM = new MessageParticipantType(1, "From");
	static readonly TO = new MessageParticipantType(2, "To");
	static readonly CC = new MessageParticipantType(3, "CC");
	static readonly BCC = new MessageParticipantType(4, "BCC");
	
	static readonly VALUES: GandalfConstantList<MessageParticipantType> = {
		label: 'Message Participant Type',
		values: [MessageParticipantType.FROM, MessageParticipantType.TO, MessageParticipantType.CC, MessageParticipantType.BCC, ]
	};
}

/** see com.rev360.model.messaging.constant.messagepriority.MessagePriority */
/* istanbul ignore next */
export class MessagePriority extends GandalfConstant<number> {
	static readonly NORMAL = new MessagePriority(0, "Normal");
	static readonly HIGH = new MessagePriority(100, "High");
	static readonly CRITICAL = new MessagePriority(1000, "Critical");
	
	static readonly VALUES: GandalfConstantList<MessagePriority> = {
		label: 'Message Priority',
		values: [MessagePriority.NORMAL, MessagePriority.HIGH, MessagePriority.CRITICAL, ]
	};
}

/** see com.rev360.model.messaging.constant.messagetype.MessageType */
/* istanbul ignore next */
export class MessageType extends GandalfConstant<number> {
	static readonly DATABASE = new MessageType(0, "Database");
	static readonly DIRECT = new MessageType(1, "Direct");
	
	static readonly VALUES: GandalfConstantList<MessageType> = {
		label: 'Message Type',
		values: [MessageType.DATABASE, MessageType.DIRECT, ]
	};
}

/** see com.rev360.model.schedule.constant.monthselect.MonthSelect */
/* istanbul ignore next */
export class MonthSelect extends GandalfConstant<number> {
	static readonly JANUARY = new MonthSelect(0, "January");
	static readonly FEBRUARY = new MonthSelect(1, "February");
	static readonly MARCH = new MonthSelect(2, "March");
	static readonly APRIL = new MonthSelect(3, "April");
	static readonly MAY = new MonthSelect(4, "May");
	static readonly JUNE = new MonthSelect(5, "June");
	static readonly JULY = new MonthSelect(6, "July");
	static readonly AUGUST = new MonthSelect(7, "August");
	static readonly SEPTEMBER = new MonthSelect(8, "September");
	static readonly OCTOBER = new MonthSelect(9, "October");
	static readonly NOVEMBER = new MonthSelect(10, "November");
	static readonly DECEMBER = new MonthSelect(11, "December");
	
	static readonly VALUES: GandalfConstantList<MonthSelect> = {
		label: 'Month',
		values: [MonthSelect.JANUARY, MonthSelect.FEBRUARY, MonthSelect.MARCH, MonthSelect.APRIL, MonthSelect.MAY, MonthSelect.JUNE, MonthSelect.JULY, MonthSelect.AUGUST, MonthSelect.SEPTEMBER, MonthSelect.OCTOBER, MonthSelect.NOVEMBER, MonthSelect.DECEMBER, ]
	};
}

/** see com.rev360.model.schedule.constant.monthlypatterntype.MonthlyPatternType */
/* istanbul ignore next */
export class MonthlyPatternType extends GandalfConstant<number> {
	static readonly DAY_X_OF_EVERY_Y_MONTHS = new MonthlyPatternType(1, "Day X of every Y Months");
	static readonly THE_X_DAY_OF_EVERY_Y_MONTHS = new MonthlyPatternType(2, "The X Day of every Y Months");
	
	static readonly VALUES: GandalfConstantList<MonthlyPatternType> = {
		label: 'Monthly Pattern Type',
		values: [MonthlyPatternType.DAY_X_OF_EVERY_Y_MONTHS, MonthlyPatternType.THE_X_DAY_OF_EVERY_Y_MONTHS, ]
	};
}

/** see com.rev360.model.history.constant.mood.Mood */
/* istanbul ignore next */
export class Mood extends GandalfConstant<number> {
	static readonly NONE = new Mood(0, "Unknown");
	static readonly NORMAL = new Mood(1, "Normal");
	static readonly ABNORMAL = new Mood(2, "Abnormal");
	
	static readonly VALUES: GandalfConstantList<Mood> = {
		label: 'Mood',
		values: [Mood.NONE, Mood.NORMAL, Mood.ABNORMAL, ]
	};
}

/** see com.rev360.model.note.constant.notestatus.NoteStatus */
/* istanbul ignore next */
export class NoteStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new NoteStatus(1, "Active");
	static readonly INACTIVE = new NoteStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<NoteStatus> = {
		label: 'Note Status',
		values: [NoteStatus.ACTIVE, NoteStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.OngoingCareDefaultTabPreferenceValues */
/* istanbul ignore next */
export class OngoingCareDefaultTabPreferenceValues extends GandalfConstant<string> {
	static readonly REFRACTIVE_CARE = new OngoingCareDefaultTabPreferenceValues('refractions', "Refractive Care");
	static readonly GLAUCOMA_CARE = new OngoingCareDefaultTabPreferenceValues('glaucoma', "Glaucoma Care");
	
	static readonly VALUES: GandalfConstantList<OngoingCareDefaultTabPreferenceValues> = {
		label: 'Ongoing Care Default Tab Preference Values',
		values: [OngoingCareDefaultTabPreferenceValues.REFRACTIVE_CARE, OngoingCareDefaultTabPreferenceValues.GLAUCOMA_CARE, ]
	};
}

/** see com.rev360.openedge.service.payment.openedge.openedgecommonpaymentstatus.OpenEdgeCommonPaymentStatus */
/* istanbul ignore next */
export class OpenEdgeCommonPaymentStatus extends GandalfConstant<number> {
	static readonly APPROVED = new OpenEdgeCommonPaymentStatus(1, "Payment Approved");
	static readonly PARTIAL_APPROVAL_VOIDED = new OpenEdgeCommonPaymentStatus(2, "Partial Payment Voided");
	static readonly PARTIAL_APPROVAL_RETURNED = new OpenEdgeCommonPaymentStatus(3, "Partial Payment Returned");
	static readonly PARTIAL_APPROVAL_ERROR = new OpenEdgeCommonPaymentStatus(4, "Partial Payment Error");
	static readonly ERROR = new OpenEdgeCommonPaymentStatus(5, "Processing Error");
	
	static readonly VALUES: GandalfConstantList<OpenEdgeCommonPaymentStatus> = {
		label: 'Global Payments Payment Status',
		values: [OpenEdgeCommonPaymentStatus.APPROVED, OpenEdgeCommonPaymentStatus.PARTIAL_APPROVAL_VOIDED, OpenEdgeCommonPaymentStatus.PARTIAL_APPROVAL_RETURNED, OpenEdgeCommonPaymentStatus.PARTIAL_APPROVAL_ERROR, OpenEdgeCommonPaymentStatus.ERROR, ]
	};
}

/** see com.rev360.openedge.service.payment.openedge.openedgecommontransactionstatus.OpenEdgeCommonTransactionStatus */
/* istanbul ignore next */
export class OpenEdgeCommonTransactionStatus extends GandalfConstant<number> {
	static readonly APPROVED = new OpenEdgeCommonTransactionStatus(1, "Approved");
	static readonly APPROVED_AVS_MISMATCH = new OpenEdgeCommonTransactionStatus(2, "Approved - AVS Mismatch");
	static readonly APPROVED_CSC_MISMATCH = new OpenEdgeCommonTransactionStatus(3, "Approved - CSC Mismatch");
	static readonly APPROVED_AVS_CSC_MISMATCH = new OpenEdgeCommonTransactionStatus(4, "Approved - AVS & CSC Mismatch");
	static readonly APPROVED_TOKEN_CREATION_FAILED = new OpenEdgeCommonTransactionStatus(5, "Approved - Token Creation Failed");
	static readonly CALL_ISSUER = new OpenEdgeCommonTransactionStatus(6, "Call Issuer");
	static readonly CALL_ISSUER_TOKEN_CREATION_FAILED = new OpenEdgeCommonTransactionStatus(7, "Call Issuer - Token Creation Failed");
	static readonly CAPTURED = new OpenEdgeCommonTransactionStatus(8, "Captured");
	static readonly CLOSED = new OpenEdgeCommonTransactionStatus(9, "Closed");
	static readonly DECLINED = new OpenEdgeCommonTransactionStatus(10, "Declined");
	static readonly DECLINED_TOKEN_CREATION_FAILED = new OpenEdgeCommonTransactionStatus(11, "Declined - Token Creation Failed");
	static readonly PARTIALLY_APPROVED = new OpenEdgeCommonTransactionStatus(12, "Partially Approved");
	static readonly PARTIALLY_APPROVED_AVS_MISMATCH = new OpenEdgeCommonTransactionStatus(13, "Partially Approved - AVS Mismatch");
	static readonly PARTIALLY_APPROVED_CSC_MISMATCH = new OpenEdgeCommonTransactionStatus(14, "Partially Approved - CSC Mismatch");
	static readonly PARTIALLY_APPROVED_AVS_CSC_MISMATCH = new OpenEdgeCommonTransactionStatus(15, "Partially Approved - AVS & CSC Mismatch");
	static readonly VOIDED = new OpenEdgeCommonTransactionStatus(16, "Voided");
	
	static readonly VALUES: GandalfConstantList<OpenEdgeCommonTransactionStatus> = {
		label: 'Global Payments Transaction Status',
		values: [OpenEdgeCommonTransactionStatus.APPROVED, OpenEdgeCommonTransactionStatus.APPROVED_AVS_MISMATCH, OpenEdgeCommonTransactionStatus.APPROVED_CSC_MISMATCH, OpenEdgeCommonTransactionStatus.APPROVED_AVS_CSC_MISMATCH, OpenEdgeCommonTransactionStatus.APPROVED_TOKEN_CREATION_FAILED, OpenEdgeCommonTransactionStatus.CALL_ISSUER, OpenEdgeCommonTransactionStatus.CALL_ISSUER_TOKEN_CREATION_FAILED, OpenEdgeCommonTransactionStatus.CAPTURED, OpenEdgeCommonTransactionStatus.CLOSED, OpenEdgeCommonTransactionStatus.DECLINED, OpenEdgeCommonTransactionStatus.DECLINED_TOKEN_CREATION_FAILED, OpenEdgeCommonTransactionStatus.PARTIALLY_APPROVED, OpenEdgeCommonTransactionStatus.PARTIALLY_APPROVED_AVS_MISMATCH, OpenEdgeCommonTransactionStatus.PARTIALLY_APPROVED_CSC_MISMATCH, OpenEdgeCommonTransactionStatus.PARTIALLY_APPROVED_AVS_CSC_MISMATCH, OpenEdgeCommonTransactionStatus.VOIDED, ]
	};
}

/** see com.rev360.openedge.service.payment.openedge.openedgecommonvoidstatus.OpenEdgeCommonVoidStatus */
/* istanbul ignore next */
export class OpenEdgeCommonVoidStatus extends GandalfConstant<number> {
	static readonly VOIDED = new OpenEdgeCommonVoidStatus(1, "Voided");
	static readonly RETURNED = new OpenEdgeCommonVoidStatus(2, "Returned");
	static readonly ERROR = new OpenEdgeCommonVoidStatus(3, "Error");
	
	static readonly VALUES: GandalfConstantList<OpenEdgeCommonVoidStatus> = {
		label: 'Global Payments Void Status',
		values: [OpenEdgeCommonVoidStatus.VOIDED, OpenEdgeCommonVoidStatus.RETURNED, OpenEdgeCommonVoidStatus.ERROR, ]
	};
}

/** see com.rev360.pms.service.payment.openedge.openedgetransactiontype.OpenEdgeTransactionType */
/* istanbul ignore next */
export class OpenEdgeTransactionType extends GandalfConstant<number> {
	static readonly SALE = new OpenEdgeTransactionType(1, "Credit Sale");
	static readonly DEBIT_SALE = new OpenEdgeTransactionType(2, "Debit Sale");
	static readonly RETURN = new OpenEdgeTransactionType(3, "Credit Return");
	static readonly DEBIT_RETURN = new OpenEdgeTransactionType(4, "Debit Return");
	
	static readonly VALUES: GandalfConstantList<OpenEdgeTransactionType> = {
		label: 'Open Edge Transaction Type',
		values: [OpenEdgeTransactionType.SALE, OpenEdgeTransactionType.DEBIT_SALE, OpenEdgeTransactionType.RETURN, OpenEdgeTransactionType.DEBIT_RETURN, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.OpticalSummaryDefaultViewPreferenceValues */
/* istanbul ignore next */
export class OpticalSummaryDefaultViewPreferenceValues extends GandalfConstant<string> {
	static readonly EYEGLASS_DETAILS = new OpticalSummaryDefaultViewPreferenceValues('optical.summary.default.view.eyeglass.details', "Eyeglass Details");
	static readonly CONTACT_LENS_DETAILS = new OpticalSummaryDefaultViewPreferenceValues('optical.summary.default.view.contactlens.details', "Contact Lens Details");
	
	static readonly VALUES: GandalfConstantList<OpticalSummaryDefaultViewPreferenceValues> = {
		label: 'Optical Summary Default View Preference Values',
		values: [OpticalSummaryDefaultViewPreferenceValues.EYEGLASS_DETAILS, OpticalSummaryDefaultViewPreferenceValues.CONTACT_LENS_DETAILS, ]
	};
}

/** see com.rev360.model.order.constant.orderbatchstatus.OrderBatchStatus */
/* istanbul ignore next */
export class OrderBatchStatus extends GandalfConstant<number> {
	static readonly PENDING = new OrderBatchStatus(1, "Pending");
	static readonly COMPLETE = new OrderBatchStatus(5, "Complete");
	
	static readonly VALUES: GandalfConstantList<OrderBatchStatus> = {
		label: 'Order Batch Status',
		values: [OrderBatchStatus.PENDING, OrderBatchStatus.COMPLETE, ]
	};
}

/** see com.rev360.pms.api.controller.order.OrderDashboardSortField */
/* istanbul ignore next */
export class OrderDashboardSortField extends GandalfConstant<string> {
	static readonly ID = new OrderDashboardSortField('id', "id");
	static readonly PATIENT_LAST_NAME = new OrderDashboardSortField('patientLastName', "patientLastName");
	static readonly CREATED_ON = new OrderDashboardSortField('createdOn', "createdOn");
	static readonly VENDOR_NAME = new OrderDashboardSortField('vendorName', "vendorName");
	static readonly STATUS_DATE = new OrderDashboardSortField('statusDate', "statusDate");
	static readonly DUE_DATE = new OrderDashboardSortField('dueDate', "dueDate");
	static readonly NOTIFICATION_DATE = new OrderDashboardSortField('notificationDate', "notificationDate");
	static readonly ON_HOLD = new OrderDashboardSortField('onHold', "onHold");
	
	static readonly VALUES: GandalfConstantList<OrderDashboardSortField> = {
		label: 'order sort field',
		values: [OrderDashboardSortField.ID, OrderDashboardSortField.PATIENT_LAST_NAME, OrderDashboardSortField.CREATED_ON, OrderDashboardSortField.VENDOR_NAME, OrderDashboardSortField.STATUS_DATE, OrderDashboardSortField.DUE_DATE, OrderDashboardSortField.NOTIFICATION_DATE, OrderDashboardSortField.ON_HOLD, ]
	};
}

/** see com.rev360.model.order.constant.orderframeindication.OrderFrameIndication */
/* istanbul ignore next */
export class OrderFrameIndication extends GandalfConstant<number> {
	static readonly NONE = new OrderFrameIndication(0, "None");
	static readonly INCLUDED = new OrderFrameIndication(1, "Included");
	static readonly TO_COME = new OrderFrameIndication(2, "To Come");
	static readonly DROPSHIP_TO_LAB = new OrderFrameIndication(3, "Dropship to Lab");
	static readonly LAB_SUPPLIED = new OrderFrameIndication(4, "Lab Supplied");
	
	static readonly VALUES: GandalfConstantList<OrderFrameIndication> = {
		label: 'Order Frame Indication',
		values: [OrderFrameIndication.NONE, OrderFrameIndication.INCLUDED, OrderFrameIndication.TO_COME, OrderFrameIndication.DROPSHIP_TO_LAB, OrderFrameIndication.LAB_SUPPLIED, ]
	};
}

/** see com.rev360.model.order.constant.orderframesource.OrderFrameSource */
/* istanbul ignore next */
export class OrderFrameSource extends GandalfConstant<number> {
	static readonly NONE = new OrderFrameSource(0, "None");
	static readonly DOCTOR = new OrderFrameSource(1, "Doctor");
	static readonly PATIENT = new OrderFrameSource(2, "Patient");
	static readonly MANUFACTURER = new OrderFrameSource(3, "Manufacturer");
	
	static readonly VALUES: GandalfConstantList<OrderFrameSource> = {
		label: 'Order Frame Source',
		values: [OrderFrameSource.NONE, OrderFrameSource.DOCTOR, OrderFrameSource.PATIENT, OrderFrameSource.MANUFACTURER, ]
	};
}

/** see com.rev360.model.order.constant.orderlensrequest.OrderLensRequest */
/* istanbul ignore next */
export class OrderLensRequest extends GandalfConstant<number> {
	static readonly NONE = new OrderLensRequest(0, "None");
	static readonly STOCK = new OrderLensRequest(1, "Stock");
	static readonly LENS_ONLY = new OrderLensRequest(2, "Lens Only");
	static readonly REQUEST_FINISHED = new OrderLensRequest(3, "Request Finished");
	static readonly UNCUT = new OrderLensRequest(4, "Uncut");
	
	static readonly VALUES: GandalfConstantList<OrderLensRequest> = {
		label: 'Order Lens Request',
		values: [OrderLensRequest.NONE, OrderLensRequest.STOCK, OrderLensRequest.LENS_ONLY, OrderLensRequest.REQUEST_FINISHED, OrderLensRequest.UNCUT, ]
	};
}

/** see com.rev360.model.order.constant.orderonholdtype.OrderOnHoldType */
/* istanbul ignore next */
export class OrderOnHoldType extends GandalfConstant<number> {
	static readonly ON_HOLD = new OrderOnHoldType(1, "On Hold");
	static readonly HOLD_REMOVED = new OrderOnHoldType(2, "Hold Removed");
	
	static readonly VALUES: GandalfConstantList<OrderOnHoldType> = {
		label: 'Order On Hold Type',
		values: [OrderOnHoldType.ON_HOLD, OrderOnHoldType.HOLD_REMOVED, ]
	};
}

/** see com.rev360.model.order.constant.orderopticalcentertype.OrderOpticalCenterType */
/* istanbul ignore next */
export class OrderOpticalCenterType extends GandalfConstant<number> {
	static readonly FROM_FRAME_BOTTOM = new OrderOpticalCenterType(1, "From frame bottom");
	static readonly GEOMETRIC_CENTER = new OrderOpticalCenterType(2, "Geometric center");
	
	static readonly VALUES: GandalfConstantList<OrderOpticalCenterType> = {
		label: 'Order Optical Center Type',
		values: [OrderOpticalCenterType.FROM_FRAME_BOTTOM, OrderOpticalCenterType.GEOMETRIC_CENTER, ]
	};
}

/** see com.rev360.model.order.constant.orderoptioncategory.OrderOptionCategory */
/* istanbul ignore next */
export class OrderOptionCategory extends GandalfConstant<number> {
	static readonly NONE = new OrderOptionCategory(0, "");
	static readonly MATERIAL = new OrderOptionCategory(10, "Material");
	static readonly TYPE = new OrderOptionCategory(20, "Type");
	static readonly THICKNESS = new OrderOptionCategory(30, "Thickness");
	static readonly SPECIAL_LENS_OPTION = new OrderOptionCategory(40, "Special Option");
	static readonly MOUNTING = new OrderOptionCategory(50, "Mounting Type");
	static readonly EDGE_TREATMENT = new OrderOptionCategory(60, "Edge Treatment");
	static readonly TINT_TYPE = new OrderOptionCategory(70, "Tint Type");
	static readonly TINT_FACTOR = new OrderOptionCategory(80, "Tint Factor");
	static readonly SHADE = new OrderOptionCategory(90, "Shade");
	static readonly DENSITY_PERCENT = new OrderOptionCategory(95, "Density %");
	static readonly PHOTOCHROMIC = new OrderOptionCategory(100, "Photochromic");
	static readonly POLARIZED = new OrderOptionCategory(110, "Polarized");
	static readonly AR_COATING = new OrderOptionCategory(120, "AR Coating");
	static readonly AR_COATING_SIDE = new OrderOptionCategory(130, "AR Coating Side");
	static readonly SCRATCH_COATING = new OrderOptionCategory(140, "Scratch Coating");
	static readonly UV_TREATMENT = new OrderOptionCategory(150, "UV Treatment");
	static readonly MIRROR_COATING = new OrderOptionCategory(160, "Mirror Coating");
	static readonly OTHER_COATING = new OrderOptionCategory(170, "Other Coating");
	static readonly BIFOCAL_SIZE_OD = new OrderOptionCategory(1000, "Bifocal Size");
	static readonly TRIFOCAL_SIZE_OD = new OrderOptionCategory(1001, "Trifocal Size");
	static readonly BIFOCAL_SIZE_OS = new OrderOptionCategory(1002, "Bifocal Size OS");
	static readonly TRIFOCAL_SIZE_OS = new OrderOptionCategory(1003, "Trifocal Size OS");
	static readonly PAL_OD = new OrderOptionCategory(1004, "OD PAL");
	static readonly PAL_OS = new OrderOptionCategory(1005, "OS PAL");
	static readonly SV_OD = new OrderOptionCategory(1006, "SV OD");
	static readonly SV_OS = new OrderOptionCategory(1007, "SV OS");
	static readonly VSP_TYPE = new OrderOptionCategory(2000, "Lens Type");
	static readonly VSP_MATERIAL = new OrderOptionCategory(2001, "Material");
	static readonly VSP_EYE = new OrderOptionCategory(2002, "Eye");
	static readonly VSP_EDGE = new OrderOptionCategory(2003, "Edge");
	static readonly VSP_BEVEL = new OrderOptionCategory(2004, "Bevel");
	static readonly VSP_THICKNESS = new OrderOptionCategory(2005, "Thickness");
	static readonly VSP_POP = new OrderOptionCategory(2006, "Press-on Prism");
	static readonly VSP_NOSE_PADS = new OrderOptionCategory(2007, "Nose Pads");
	static readonly VSP_SLAB_OFF = new OrderOptionCategory(2008, "Slab Off");
	static readonly VSP_POP_TEXT = new OrderOptionCategory(2009, "Press-on Prism Other");
	static readonly VSP_NOSE_PADS_TEXT = new OrderOptionCategory(2010, "Nose Pads Other");
	static readonly VSP_SLAB_OFF_TEXT = new OrderOptionCategory(2011, "Slab Off Other");
	static readonly VSP_COLOR = new OrderOptionCategory(2012, "Color");
	static readonly VSP_COLOR_OTHER = new OrderOptionCategory(2013, "Color Other");
	static readonly VSP_TINT_TYPE = new OrderOptionCategory(2014, "Tint Type");
	static readonly VSP_SAMPLE = new OrderOptionCategory(2015, "Tint Sample");
	static readonly VSP_LIGHT_DARK = new OrderOptionCategory(2023, "Lighten/Darken %");
	static readonly VSP_AR_COATING = new OrderOptionCategory(2017, "AR Coating");
	static readonly VSP_SCRATCH_COATING = new OrderOptionCategory(2018, "Scratch Coating");
	static readonly VSP_GLASS_COATING = new OrderOptionCategory(2019, "Glass Coating");
	static readonly VSP_MIRROR_COATING = new OrderOptionCategory(2020, "Mirror Coating");
	static readonly VSP_UV_COATING = new OrderOptionCategory(2021, "UV Coating");
	static readonly VSP_STYLE = new OrderOptionCategory(2022, "Lens Style");
	static readonly VSP_CONTACT_LENS_REASON = new OrderOptionCategory(2030, "Contact Lens Reason");
	
	static readonly VALUES: GandalfConstantList<OrderOptionCategory> = {
		label: 'Order Option Category',
		values: [OrderOptionCategory.NONE, OrderOptionCategory.MATERIAL, OrderOptionCategory.TYPE, OrderOptionCategory.THICKNESS, OrderOptionCategory.SPECIAL_LENS_OPTION, OrderOptionCategory.MOUNTING, OrderOptionCategory.EDGE_TREATMENT, OrderOptionCategory.TINT_TYPE, OrderOptionCategory.TINT_FACTOR, OrderOptionCategory.SHADE, OrderOptionCategory.DENSITY_PERCENT, OrderOptionCategory.PHOTOCHROMIC, OrderOptionCategory.POLARIZED, OrderOptionCategory.AR_COATING, OrderOptionCategory.AR_COATING_SIDE, OrderOptionCategory.SCRATCH_COATING, OrderOptionCategory.UV_TREATMENT, OrderOptionCategory.MIRROR_COATING, OrderOptionCategory.OTHER_COATING, OrderOptionCategory.BIFOCAL_SIZE_OD, OrderOptionCategory.TRIFOCAL_SIZE_OD, OrderOptionCategory.BIFOCAL_SIZE_OS, OrderOptionCategory.TRIFOCAL_SIZE_OS, OrderOptionCategory.PAL_OD, OrderOptionCategory.PAL_OS, OrderOptionCategory.SV_OD, OrderOptionCategory.SV_OS, OrderOptionCategory.VSP_TYPE, OrderOptionCategory.VSP_MATERIAL, OrderOptionCategory.VSP_EYE, OrderOptionCategory.VSP_EDGE, OrderOptionCategory.VSP_BEVEL, OrderOptionCategory.VSP_THICKNESS, OrderOptionCategory.VSP_POP, OrderOptionCategory.VSP_NOSE_PADS, OrderOptionCategory.VSP_SLAB_OFF, OrderOptionCategory.VSP_POP_TEXT, OrderOptionCategory.VSP_NOSE_PADS_TEXT, OrderOptionCategory.VSP_SLAB_OFF_TEXT, OrderOptionCategory.VSP_COLOR, OrderOptionCategory.VSP_COLOR_OTHER, OrderOptionCategory.VSP_TINT_TYPE, OrderOptionCategory.VSP_SAMPLE, OrderOptionCategory.VSP_LIGHT_DARK, OrderOptionCategory.VSP_AR_COATING, OrderOptionCategory.VSP_SCRATCH_COATING, OrderOptionCategory.VSP_GLASS_COATING, OrderOptionCategory.VSP_MIRROR_COATING, OrderOptionCategory.VSP_UV_COATING, OrderOptionCategory.VSP_STYLE, OrderOptionCategory.VSP_CONTACT_LENS_REASON, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.OrderPdValidationRulePreferenceValues */
/* istanbul ignore next */
export class OrderPdValidationRulePreferenceValues extends GandalfConstant<string> {
	static readonly NONE = new OrderPdValidationRulePreferenceValues('order.pd.validation.rule.none', "None");
	static readonly MONOCULAR = new OrderPdValidationRulePreferenceValues('order.pd.validation.rule.monocular', "Monocular");
	static readonly MONOCULAR_OR_BINOCULAR = new OrderPdValidationRulePreferenceValues('order.pd.validation.rule.monocular.or.binocular', "Monocular or Binocular");
	
	static readonly VALUES: GandalfConstantList<OrderPdValidationRulePreferenceValues> = {
		label: 'Order PD Validation Rule Preference Values',
		values: [OrderPdValidationRulePreferenceValues.NONE, OrderPdValidationRulePreferenceValues.MONOCULAR, OrderPdValidationRulePreferenceValues.MONOCULAR_OR_BINOCULAR, ]
	};
}

/** see com.rev360.model.order.processors.constant.processor.OrderProcessorType */
/* istanbul ignore next */
export class OrderProcessorType extends GandalfConstant<number> {
	static readonly VISIONWEB = new OrderProcessorType(1, "VisionWeb");
	static readonly EYEFINITY = new OrderProcessorType(2, "Eyefinity");
	static readonly EYEFINITY_REV_ASSISTANT = new OrderProcessorType(3, "Eyefinity Rev Assistant");
	static readonly SMARTFLOW = new OrderProcessorType(4, "Smartflow");
	static readonly ARRELLIO = new OrderProcessorType(5, "Arrellio");
	static readonly CLX = new OrderProcessorType(6, "CLX");
	static readonly MARLO = new OrderProcessorType(7, "Marlo");
	
	static readonly VALUES: GandalfConstantList<OrderProcessorType> = {
		label: 'Order Processor Type',
		values: [OrderProcessorType.VISIONWEB, OrderProcessorType.EYEFINITY, OrderProcessorType.EYEFINITY_REV_ASSISTANT, OrderProcessorType.SMARTFLOW, OrderProcessorType.ARRELLIO, OrderProcessorType.CLX, OrderProcessorType.MARLO, ]
	};
}

/** see com.rev360.pms.service.order.constant.OrderSearchStatusCode */
/* istanbul ignore next */
export class OrderSearchStatusCode extends GandalfConstant<number> {
	static readonly IN_PROCESS = new OrderSearchStatusCode(2, "In Process");
	static readonly NEW = new OrderSearchStatusCode(10, "New");
	static readonly QUOTED = new OrderSearchStatusCode(12, "Quoted");
	static readonly APPROVED = new OrderSearchStatusCode(20, "Approved");
	static readonly VENDOR_PROCESSING = new OrderSearchStatusCode(3, "Vendor Processing");
	static readonly TRANSMITTED = new OrderSearchStatusCode(30, "Transmitted");
	static readonly VENDOR_RECEIVED = new OrderSearchStatusCode(40, "Vendor Received");
	static readonly VENDOR_ACCEPTED = new OrderSearchStatusCode(60, "Vendor Accepted");
	static readonly VENDOR_REJECTED = new OrderSearchStatusCode(50, "Vendor Rejected");
	static readonly VENDOR_SHIPPED = new OrderSearchStatusCode(70, "Vendor Shipped");
	static readonly RECEIVED = new OrderSearchStatusCode(80, "Received");
	static readonly VERIFIED = new OrderSearchStatusCode(85, "Verified");
	static readonly DISPENSED = new OrderSearchStatusCode(90, "Dispensed");
	static readonly COMPLETED = new OrderSearchStatusCode(100, "Completed");
	static readonly REMADE = new OrderSearchStatusCode(110, "Remade");
	static readonly RETURNED = new OrderSearchStatusCode(120, "Returned");
	static readonly CANCELED = new OrderSearchStatusCode(11, "Canceled");
	
	static readonly VALUES: GandalfConstantList<OrderSearchStatusCode> = {
		label: 'Order Search Status Code',
		values: [OrderSearchStatusCode.IN_PROCESS, OrderSearchStatusCode.NEW, OrderSearchStatusCode.QUOTED, OrderSearchStatusCode.APPROVED, OrderSearchStatusCode.VENDOR_PROCESSING, OrderSearchStatusCode.TRANSMITTED, OrderSearchStatusCode.VENDOR_RECEIVED, OrderSearchStatusCode.VENDOR_ACCEPTED, OrderSearchStatusCode.VENDOR_REJECTED, OrderSearchStatusCode.VENDOR_SHIPPED, OrderSearchStatusCode.RECEIVED, OrderSearchStatusCode.VERIFIED, OrderSearchStatusCode.DISPENSED, OrderSearchStatusCode.COMPLETED, OrderSearchStatusCode.REMADE, OrderSearchStatusCode.RETURNED, OrderSearchStatusCode.CANCELED, ]
	};
}

/** see com.rev360.pms.service.order.constant.OrderSearchType */
/* istanbul ignore next */
export class OrderSearchType extends GandalfConstant<number> {
	static readonly EYEGLASS = new OrderSearchType(1, "Eyeglass");
	static readonly FRAME_ONLY = new OrderSearchType(4, "Frame Only");
	static readonly CONTACT_LENS = new OrderSearchType(2, "Contact Lens");
	static readonly CONTACT_LENS_TRIAL = new OrderSearchType(5, "Contact Lens Trial");
	static readonly CONTACT_LENS_OR_TRIAL = new OrderSearchType(100, "Contact Lens or Trial");
	
	static readonly VALUES: GandalfConstantList<OrderSearchType> = {
		label: 'Order Search Type',
		values: [OrderSearchType.EYEGLASS, OrderSearchType.FRAME_ONLY, OrderSearchType.CONTACT_LENS, OrderSearchType.CONTACT_LENS_TRIAL, OrderSearchType.CONTACT_LENS_OR_TRIAL, ]
	};
}

/** see com.rev360.model.order.constant.ordersegheighttype.OrderSegHeightType */
/* istanbul ignore next */
export class OrderSegHeightType extends GandalfConstant<number> {
	static readonly FROM_FRAME_BOTTOM = new OrderSegHeightType(1, "From frame bottom");
	static readonly GEOMETRIC_CENTER = new OrderSegHeightType(2, "Geometric center");
	
	static readonly VALUES: GandalfConstantList<OrderSegHeightType> = {
		label: 'Order Seg Height Type',
		values: [OrderSegHeightType.FROM_FRAME_BOTTOM, OrderSegHeightType.GEOMETRIC_CENTER, ]
	};
}

/** see com.rev360.model.order.constant.ordershiptotype.OrderShipToType */
/* istanbul ignore next */
export class OrderShipToType extends GandalfConstant<number> {
	static readonly NONE = new OrderShipToType(0, "None");
	static readonly PATIENT = new OrderShipToType(1, "Patient");
	static readonly OFFICE = new OrderShipToType(2, "Practice");
	static readonly OTHER = new OrderShipToType(3, "Other");
	
	static readonly VALUES: GandalfConstantList<OrderShipToType> = {
		label: 'Order Ship To Type',
		values: [OrderShipToType.NONE, OrderShipToType.PATIENT, OrderShipToType.OFFICE, OrderShipToType.OTHER, ]
	};
}

/** see com.rev360.model.order.constant.ordershipmentcompany.OrderShipmentCompany */
/* istanbul ignore next */
export class OrderShipmentCompany extends GandalfConstant<number> {
	static readonly NONE = new OrderShipmentCompany(0, "None");
	static readonly AIRBORNE_EXPRESS = new OrderShipmentCompany(1, "Airborne Express");
	static readonly DHL = new OrderShipmentCompany(2, "DHL");
	static readonly FEDEX = new OrderShipmentCompany(3, "FedEx");
	static readonly UPS = new OrderShipmentCompany(4, "UPS");
	static readonly USPS = new OrderShipmentCompany(5, "USPS");
	static readonly OTHER = new OrderShipmentCompany(10, "Other");
	
	static readonly VALUES: GandalfConstantList<OrderShipmentCompany> = {
		label: 'Shipping Company',
		values: [OrderShipmentCompany.NONE, OrderShipmentCompany.AIRBORNE_EXPRESS, OrderShipmentCompany.DHL, OrderShipmentCompany.FEDEX, OrderShipmentCompany.UPS, OrderShipmentCompany.USPS, OrderShipmentCompany.OTHER, ]
	};
}

/** see com.rev360.model.order.constant.ordershipmentstatus.OrderShipmentStatus */
/* istanbul ignore next */
export class OrderShipmentStatus extends GandalfConstant<number> {
	static readonly NOT_SHIPPED = new OrderShipmentStatus(0, "Not Shipped");
	static readonly SHIPPED = new OrderShipmentStatus(1, "Shipped");
	static readonly RECEIVED = new OrderShipmentStatus(2, "Received");
	
	static readonly VALUES: GandalfConstantList<OrderShipmentStatus> = {
		label: 'Order Shipment Status',
		values: [OrderShipmentStatus.NOT_SHIPPED, OrderShipmentStatus.SHIPPED, OrderShipmentStatus.RECEIVED, ]
	};
}

/** see com.rev360.model.order.constant.ordershippingspeed.OrderShippingSpeed */
/* istanbul ignore next */
export class OrderShippingSpeed extends GandalfConstant<number> {
	static readonly STANDARD = new OrderShippingSpeed(1, "Standard");
	static readonly ONE_DAY = new OrderShippingSpeed(2, "One Day");
	static readonly TWO_DAY = new OrderShippingSpeed(3, "Two Day");
	
	static readonly VALUES: GandalfConstantList<OrderShippingSpeed> = {
		label: 'Shipping Speed',
		values: [OrderShippingSpeed.STANDARD, OrderShippingSpeed.ONE_DAY, OrderShippingSpeed.TWO_DAY, ]
	};
}

/** see com.rev360.model.data.constant.ordersource.OrderSource */
/* istanbul ignore next */
export class OrderSource extends GandalfConstant<number> {
	static readonly OFFICE = new OrderSource(19180, "Office");
	static readonly PHR = new OrderSource(19181, "PHR");
	static readonly ARRELLIO = new OrderSource(19182, "Arrellio");
	static readonly MARLO = new OrderSource(19183, "Marlo");
	static readonly CLX = new OrderSource(19184, "CLX");
	
	static readonly VALUES: GandalfConstantList<OrderSource> = {
		label: 'Order Source',
		values: [OrderSource.OFFICE, OrderSource.PHR, OrderSource.ARRELLIO, OrderSource.MARLO, OrderSource.CLX, ]
	};
}

/** see com.rev360.model.order.constant.orderstatuscode.OrderStatusCode */
/* istanbul ignore next */
export class OrderStatusCode extends GandalfConstant<number> {
	static readonly NEW = new OrderStatusCode(10, "New");
	static readonly CANCELED = new OrderStatusCode(11, "Canceled");
	static readonly QUOTED = new OrderStatusCode(12, "Quoted");
	static readonly APPROVED = new OrderStatusCode(20, "Approved");
	static readonly TRANSMITTED = new OrderStatusCode(30, "Transmitted");
	static readonly VENDOR_RECEIVED = new OrderStatusCode(40, "Vendor Received");
	static readonly VENDOR_REJECTED = new OrderStatusCode(50, "Vendor Rejected");
	static readonly VENDOR_OK = new OrderStatusCode(60, "Vendor Accepted");
	static readonly VENDOR_SHIPPED = new OrderStatusCode(70, "Vendor Shipped");
	static readonly RECEIVED = new OrderStatusCode(80, "Received");
	static readonly VERIFIED = new OrderStatusCode(85, "Verified");
	static readonly DISPENSED = new OrderStatusCode(90, "Dispensed");
	static readonly COMPLETED = new OrderStatusCode(100, "Completed");
	static readonly REMADE = new OrderStatusCode(110, "Remade");
	static readonly RETURNED = new OrderStatusCode(120, "Returned");
	
	static readonly VALUES: GandalfConstantList<OrderStatusCode> = {
		label: 'Order Status Code',
		values: [OrderStatusCode.NEW, OrderStatusCode.CANCELED, OrderStatusCode.QUOTED, OrderStatusCode.APPROVED, OrderStatusCode.TRANSMITTED, OrderStatusCode.VENDOR_RECEIVED, OrderStatusCode.VENDOR_REJECTED, OrderStatusCode.VENDOR_OK, OrderStatusCode.VENDOR_SHIPPED, OrderStatusCode.RECEIVED, OrderStatusCode.VERIFIED, OrderStatusCode.DISPENSED, OrderStatusCode.COMPLETED, OrderStatusCode.REMADE, OrderStatusCode.RETURNED, ]
	};
}

/** see com.rev360.model.order.constant.ordertype.OrderType */
/* istanbul ignore next */
export class OrderType extends GandalfConstant<number> {
	static readonly EYEGLASS = new OrderType(1, "Eyeglass");
	static readonly CONTACT_LENS = new OrderType(2, "Contact Lens");
	static readonly FRAME_ONLY = new OrderType(4, "Frame Only");
	static readonly CONTACT_LENS_TRIAL = new OrderType(5, "Contact Lens Trial");
	
	static readonly VALUES: GandalfConstantList<OrderType> = {
		label: 'Order Type',
		values: [OrderType.EYEGLASS, OrderType.CONTACT_LENS, OrderType.FRAME_ONLY, OrderType.CONTACT_LENS_TRIAL, ]
	};
}

/** see com.rev360.pms.service.vendor.OrderVendorType */
/* istanbul ignore next */
export class OrderVendorType extends GandalfConstant<number> {
	static readonly LAB = new OrderVendorType(1, "Lab");
	static readonly CONTACT_LENS = new OrderVendorType(2, "Contact Lens");
	static readonly FRAME = new OrderVendorType(3, "Frame");
	
	static readonly VALUES: GandalfConstantList<OrderVendorType> = {
		label: 'Order Vendor Type',
		values: [OrderVendorType.LAB, OrderVendorType.CONTACT_LENS, OrderVendorType.FRAME, ]
	};
}

/** see com.rev360.model.history.constant.orientation.Orientation */
/* istanbul ignore next */
export class Orientation extends GandalfConstant<number> {
	static readonly NONE = new Orientation(0, "Unknown");
	static readonly NORMAL = new Orientation(1, "Normal");
	static readonly ABNORMAL = new Orientation(2, "Abnormal");
	
	static readonly VALUES: GandalfConstantList<Orientation> = {
		label: 'Orientation',
		values: [Orientation.NONE, Orientation.NORMAL, Orientation.ABNORMAL, ]
	};
}

/** see com.rev360.model.order.constant.originalorderreason.OriginalOrderReason */
/* istanbul ignore next */
export class OriginalOrderReason extends GandalfConstant<number> {
	static readonly UNKNOWN = new OriginalOrderReason(0, "Unknown Reason");
	static readonly CHANGE = new OriginalOrderReason(1, "Change Order");
	static readonly REMADE = new OriginalOrderReason(2, "Remade Order");
	
	static readonly VALUES: GandalfConstantList<OriginalOrderReason> = {
		label: 'Original Order Reason',
		values: [OriginalOrderReason.UNKNOWN, OriginalOrderReason.CHANGE, OriginalOrderReason.REMADE, ]
	};
}

/** see com.rev360.model.device.constant.parity.Parity */
/* istanbul ignore next */
export class Parity extends GandalfConstant<string> {
	static readonly NONE = new Parity('none', "none");
	static readonly EVEN = new Parity('even', "even");
	static readonly ODD = new Parity('odd', "odd");
	static readonly MARK = new Parity('mark', "mark");
	static readonly SPACE = new Parity('space', "space");
	
	static readonly VALUES: GandalfConstantList<Parity> = {
		label: 'Parity',
		values: [Parity.NONE, Parity.EVEN, Parity.ODD, Parity.MARK, Parity.SPACE, ]
	};
}

/** see com.rev360.model.patient.ccda.constant.patientccdaexportstatus.PatientCcdaExportStatus */
/* istanbul ignore next */
export class PatientCcdaExportStatus extends GandalfConstant<number> {
	static readonly NOT_READY = new PatientCcdaExportStatus(1, "Not Ready");
	static readonly GENERATION_READY = new PatientCcdaExportStatus(2, "Ready To Generate");
	static readonly GENERATION_ENQUEUED = new PatientCcdaExportStatus(3, "Generate Requested");
	static readonly GENERATION_FAILED = new PatientCcdaExportStatus(4, "Generate Failed");
	static readonly TRANSFER_READY = new PatientCcdaExportStatus(5, "Ready To Transfer");
	static readonly TRANSFER_ENQUEUED = new PatientCcdaExportStatus(6, "Transfer Requested");
	static readonly TRANSFER_FAILED = new PatientCcdaExportStatus(7, "Transfer Failed");
	static readonly TRANSFER_STATUS_READY = new PatientCcdaExportStatus(8, "Transfer Status Ready");
	static readonly TRANSFER_STATUS_ENQUEUED = new PatientCcdaExportStatus(9, "Transfer Status Enqueued");
	static readonly TRANSFER_STATUS_PROCESSED = new PatientCcdaExportStatus(10, "Transfer Status Processed");
	static readonly TRANSFER_STATUS_FAILED = new PatientCcdaExportStatus(11, "Transfer Status Failed");
	
	static readonly VALUES: GandalfConstantList<PatientCcdaExportStatus> = {
		label: 'Patient CCDA Export Status',
		values: [PatientCcdaExportStatus.NOT_READY, PatientCcdaExportStatus.GENERATION_READY, PatientCcdaExportStatus.GENERATION_ENQUEUED, PatientCcdaExportStatus.GENERATION_FAILED, PatientCcdaExportStatus.TRANSFER_READY, PatientCcdaExportStatus.TRANSFER_ENQUEUED, PatientCcdaExportStatus.TRANSFER_FAILED, PatientCcdaExportStatus.TRANSFER_STATUS_READY, PatientCcdaExportStatus.TRANSFER_STATUS_ENQUEUED, PatientCcdaExportStatus.TRANSFER_STATUS_PROCESSED, PatientCcdaExportStatus.TRANSFER_STATUS_FAILED, ]
	};
}

/** see com.rev360.connect.service.patient.PatientCommunicationEligibility */
/* istanbul ignore next */
export class PatientCommunicationEligibility extends GandalfConstant<number> {
	static readonly COMMUNICATION_ALLOWED = new PatientCommunicationEligibility(1, "Communication Allowed");
	static readonly METHOD_OPT_OUT = new PatientCommunicationEligibility(2, "Method Opt Out");
	static readonly CATEGORY_OPT_OUT = new PatientCommunicationEligibility(3, "Category Opt Out");
	static readonly NO_IMPLIED_CONSENT = new PatientCommunicationEligibility(4, "No Implied Consent");
	static readonly NO_EXPLICIT_OPT_IN = new PatientCommunicationEligibility(5, "No Explicit Opt In");
	static readonly ACCOUNT_NOT_REGISTERED = new PatientCommunicationEligibility(6, "Account Not Registered");
	
	static readonly VALUES: GandalfConstantList<PatientCommunicationEligibility> = {
		label: 'Patient Communication Eligibility',
		values: [PatientCommunicationEligibility.COMMUNICATION_ALLOWED, PatientCommunicationEligibility.METHOD_OPT_OUT, PatientCommunicationEligibility.CATEGORY_OPT_OUT, PatientCommunicationEligibility.NO_IMPLIED_CONSENT, PatientCommunicationEligibility.NO_EXPLICIT_OPT_IN, PatientCommunicationEligibility.ACCOUNT_NOT_REGISTERED, ]
	};
}

/** see com.rev360.model.patient.constant.patientcommunicationoptin.PatientCommunicationOptIn */
/* istanbul ignore next */
export class PatientCommunicationOptIn extends GandalfConstant<number> {
	static readonly UNKNOWN = new PatientCommunicationOptIn(0, "Unknown");
	static readonly YES = new PatientCommunicationOptIn(1, "Yes");
	static readonly NO = new PatientCommunicationOptIn(2, "No");
	
	static readonly VALUES: GandalfConstantList<PatientCommunicationOptIn> = {
		label: 'Patient Communication Opt-In',
		values: [PatientCommunicationOptIn.UNKNOWN, PatientCommunicationOptIn.YES, PatientCommunicationOptIn.NO, ]
	};
}

/** see com.rev360.model.consentform.constant.patientconsentmechanism.PatientConsentMechanism */
/* istanbul ignore next */
export class PatientConsentMechanism extends GandalfConstant<number> {
	static readonly PAPER_SIGNATURE = new PatientConsentMechanism(1, "Paper Signature");
	static readonly ELECTRONIC_SIGNATURE = new PatientConsentMechanism(2, "Electronic Signature");
	static readonly ELECTRONIC_CLICK = new PatientConsentMechanism(3, "Electronic Click");
	static readonly VERBAL = new PatientConsentMechanism(4, "Verbal");
	
	static readonly VALUES: GandalfConstantList<PatientConsentMechanism> = {
		label: 'PatientConsentMechanism',
		values: [PatientConsentMechanism.PAPER_SIGNATURE, PatientConsentMechanism.ELECTRONIC_SIGNATURE, PatientConsentMechanism.ELECTRONIC_CLICK, PatientConsentMechanism.VERBAL, ]
	};
}

/** see com.rev360.model.consentform.constant.patientconsentstatus.PatientConsentStatus */
/* istanbul ignore next */
export class PatientConsentStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PatientConsentStatus(0, "Inactive");
	static readonly ACTIVE = new PatientConsentStatus(1, "Active");
	static readonly EXPIRED = new PatientConsentStatus(2, "Expired");
	
	static readonly VALUES: GandalfConstantList<PatientConsentStatus> = {
		label: 'Patient Consent Status',
		values: [PatientConsentStatus.INACTIVE, PatientConsentStatus.ACTIVE, PatientConsentStatus.EXPIRED, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.PatientDefaultSummaryViewPreferenceValues */
/* istanbul ignore next */
export class PatientDefaultSummaryViewPreferenceValues extends GandalfConstant<string> {
	static readonly PATIENT_SUMMARY = new PatientDefaultSummaryViewPreferenceValues('patients.default.summary.view.patientsummary', "Patient Summary");
	static readonly OPTICAL_SUMMARY = new PatientDefaultSummaryViewPreferenceValues('patients.default.summary.view.opticalsummary', "Optical Summary");
	
	static readonly VALUES: GandalfConstantList<PatientDefaultSummaryViewPreferenceValues> = {
		label: 'Patient Default Summary ViewPreference Values',
		values: [PatientDefaultSummaryViewPreferenceValues.PATIENT_SUMMARY, PatientDefaultSummaryViewPreferenceValues.OPTICAL_SUMMARY, ]
	};
}

/** see com.rev360.model.document.constant.patientdocumentrecipienttype.PatientDocumentRecipientType */
/* istanbul ignore next */
export class PatientDocumentRecipientType extends GandalfConstant<number> {
	static readonly PATIENT = new PatientDocumentRecipientType(1, "Patient");
	static readonly INTERNAL_PROVIDER = new PatientDocumentRecipientType(2, "Internal Provider");
	static readonly EXTERNAL_PROVIDER = new PatientDocumentRecipientType(3, "External Provider");
	static readonly FAMILY_MEMBER = new PatientDocumentRecipientType(4, "Family Member");
	static readonly CONTACT = new PatientDocumentRecipientType(5, "Contact");
	
	static readonly VALUES: GandalfConstantList<PatientDocumentRecipientType> = {
		label: 'Patient Document Recipient Type',
		values: [PatientDocumentRecipientType.PATIENT, PatientDocumentRecipientType.INTERNAL_PROVIDER, PatientDocumentRecipientType.EXTERNAL_PROVIDER, PatientDocumentRecipientType.FAMILY_MEMBER, PatientDocumentRecipientType.CONTACT, ]
	};
}

/** see com.rev360.model.document.constant.patientdocumentstatus.PatientDocumentStatus */
/* istanbul ignore next */
export class PatientDocumentStatus extends GandalfConstant<number> {
	static readonly NEW = new PatientDocumentStatus(0, "New");
	static readonly DRAFT = new PatientDocumentStatus(1, "Draft");
	static readonly GENERATED = new PatientDocumentStatus(2, "Generated");
	
	static readonly VALUES: GandalfConstantList<PatientDocumentStatus> = {
		label: 'PatientDocumentStatus',
		values: [PatientDocumentStatus.NEW, PatientDocumentStatus.DRAFT, PatientDocumentStatus.GENERATED, ]
	};
}

/** see com.rev360.pms.service.patient.constant.PatientDuplicateMatchType */
/* istanbul ignore next */
export class PatientDuplicateMatchType extends GandalfConstant<number> {
	static readonly NAME = new PatientDuplicateMatchType(0, "First/Last name match");
	static readonly DOB = new PatientDuplicateMatchType(1, "Last name + DOB match");
	static readonly SSN = new PatientDuplicateMatchType(2, "SSN match");
	static readonly LAST_4_SSN = new PatientDuplicateMatchType(3, "Last name + Last 4 SSN match");
	
	static readonly VALUES: GandalfConstantList<PatientDuplicateMatchType> = {
		label: 'Duplicate Match Type',
		values: [PatientDuplicateMatchType.NAME, PatientDuplicateMatchType.DOB, PatientDuplicateMatchType.SSN, PatientDuplicateMatchType.LAST_4_SSN, ]
	};
}

/** see com.rev360.model.patient.constant.patientemploymentstatus.PatientEmploymentStatus */
/* istanbul ignore next */
export class PatientEmploymentStatus extends GandalfConstant<number> {
	static readonly NONE = new PatientEmploymentStatus(0, "None");
	static readonly EMPLOYED_FULL_TIME = new PatientEmploymentStatus(1, "Employed Full Time");
	static readonly EMPLOYED_PART_TIME = new PatientEmploymentStatus(2, "Employed Part Time");
	static readonly STUDENT_FULL_TIME = new PatientEmploymentStatus(3, "Student Full Time");
	static readonly STUDENT_PART_TIME = new PatientEmploymentStatus(4, "Student Part Time");
	static readonly NOT_EMPLOYED = new PatientEmploymentStatus(5, "Not Employed");
	static readonly RETIRED = new PatientEmploymentStatus(7, "Retired");
	static readonly UNKNOWN = new PatientEmploymentStatus(6, "Unknown");
	static readonly HOMEMAKER = new PatientEmploymentStatus(8, "Homemaker");
	static readonly ACTIVE_MILITARY = new PatientEmploymentStatus(9, "Active Military");
	static readonly DISABLED = new PatientEmploymentStatus(10, "Disabled");
	
	static readonly VALUES: GandalfConstantList<PatientEmploymentStatus> = {
		label: 'Patient Employment Status',
		values: [PatientEmploymentStatus.NONE, PatientEmploymentStatus.EMPLOYED_FULL_TIME, PatientEmploymentStatus.EMPLOYED_PART_TIME, PatientEmploymentStatus.STUDENT_FULL_TIME, PatientEmploymentStatus.STUDENT_PART_TIME, PatientEmploymentStatus.NOT_EMPLOYED, PatientEmploymentStatus.RETIRED, PatientEmploymentStatus.UNKNOWN, PatientEmploymentStatus.HOMEMAKER, PatientEmploymentStatus.ACTIVE_MILITARY, PatientEmploymentStatus.DISABLED, ]
	};
}

/** see com.rev360.model.patient.constant.patientfileentitytype.PatientFileEntityType */
/* istanbul ignore next */
export class PatientFileEntityType extends GandalfConstant<string> {
	static readonly NONE = new PatientFileEntityType('', "None");
	static readonly AMENDMENT = new PatientFileEntityType('Amendment', "Amendment");
	static readonly DOCUMENT = new PatientFileEntityType('Document', "Document");
	static readonly ENCOUNTER_TEST = new PatientFileEntityType('EncTest', "Encounter Test");
	static readonly EXTERNAL_DATA = new PatientFileEntityType('ExternalData', "External Data");
	static readonly INSURANCE_POLICY = new PatientFileEntityType('InsurancePolicy', "Insurance Policy");
	static readonly INVOICE = new PatientFileEntityType('Invoice', "Invoice");
	static readonly LAB_ORDER = new PatientFileEntityType('LabOrder', "Lab Order");
	static readonly ORDER = new PatientFileEntityType('Order', "Order");
	static readonly REFERRAL_RESPONSE = new PatientFileEntityType('ReferralResponse', "Referral");
	static readonly INTAKE = new PatientFileEntityType('Intake', "Intake");
	static readonly INTAKE_INSURANCE = new PatientFileEntityType('IntakeInsurance', "Intake Insurance");
	
	static readonly VALUES: GandalfConstantList<PatientFileEntityType> = {
		label: 'Patient File Entity Type',
		values: [PatientFileEntityType.NONE, PatientFileEntityType.AMENDMENT, PatientFileEntityType.DOCUMENT, PatientFileEntityType.ENCOUNTER_TEST, PatientFileEntityType.EXTERNAL_DATA, PatientFileEntityType.INSURANCE_POLICY, PatientFileEntityType.INVOICE, PatientFileEntityType.LAB_ORDER, PatientFileEntityType.ORDER, PatientFileEntityType.REFERRAL_RESPONSE, PatientFileEntityType.INTAKE, PatientFileEntityType.INTAKE_INSURANCE, ]
	};
}

/** see com.rev360.model.common.constant.patientfolderidentifier.PatientFolderIdentifier */
/* istanbul ignore next */
export class PatientFolderIdentifier extends GandalfConstant<string> {
	static readonly ROOT = new PatientFolderIdentifier('0', "Root");
	static readonly DOCUMENTS = new PatientFolderIdentifier('1', "Documents");
	static readonly IMAGES = new PatientFolderIdentifier('2', "Images");
	static readonly CONSENTS = new PatientFolderIdentifier('4', "Consents");
	static readonly TRANSFERRED_MESSAGES = new PatientFolderIdentifier('7', "Transferred Message Files");
	static readonly INTEROPERABILITY = new PatientFolderIdentifier('8', "Interoperability");
	static readonly IMAGING_THUMBNAILS = new PatientFolderIdentifier('9', "Imaging Thumbnails");
	static readonly IMAGING_CONVERTED = new PatientFolderIdentifier('10', "Imaging Converted Files");
	static readonly DELETED_LETTERS = new PatientFolderIdentifier('11', "Deleted Letters");
	static readonly INTAKE_DOCUMENTS = new PatientFolderIdentifier('12', "Intake Documents");
	static readonly DATA_EXPORT = new PatientFolderIdentifier('13', "Data Exports");
	static readonly DELETED_FILES = new PatientFolderIdentifier('14', "Deleted Files");
	static readonly CONVERSION_FILES = new PatientFolderIdentifier('15', "Conversion Files");
	
	static readonly VALUES: GandalfConstantList<PatientFolderIdentifier> = {
		label: 'PatientFolderIdentifierLabel',
		values: [PatientFolderIdentifier.ROOT, PatientFolderIdentifier.DOCUMENTS, PatientFolderIdentifier.IMAGES, PatientFolderIdentifier.CONSENTS, PatientFolderIdentifier.TRANSFERRED_MESSAGES, PatientFolderIdentifier.INTEROPERABILITY, PatientFolderIdentifier.IMAGING_THUMBNAILS, PatientFolderIdentifier.IMAGING_CONVERTED, PatientFolderIdentifier.DELETED_LETTERS, PatientFolderIdentifier.INTAKE_DOCUMENTS, PatientFolderIdentifier.DATA_EXPORT, PatientFolderIdentifier.DELETED_FILES, PatientFolderIdentifier.CONVERSION_FILES, ]
	};
}

/** see com.rev360.model.patient.healthconcern.constant.patienthealthconcernreporter.PatientHealthConcernReporter */
/* istanbul ignore next */
export class PatientHealthConcernReporter extends GandalfConstant<number> {
	static readonly PROVIDER = new PatientHealthConcernReporter(1, "Provider");
	static readonly PATIENT = new PatientHealthConcernReporter(2, "Patient");
	static readonly REPRESENTATIVE = new PatientHealthConcernReporter(3, "Representative");
	
	static readonly VALUES: GandalfConstantList<PatientHealthConcernReporter> = {
		label: 'PatientHealthConcernReporter',
		values: [PatientHealthConcernReporter.PROVIDER, PatientHealthConcernReporter.PATIENT, PatientHealthConcernReporter.REPRESENTATIVE, ]
	};
}

/** see com.rev360.model.patient.healthconcern.constant.patienthealthconcernstatus.PatientHealthConcernStatus */
/* istanbul ignore next */
export class PatientHealthConcernStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PatientHealthConcernStatus(0, "Inactive");
	static readonly ACTIVE = new PatientHealthConcernStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PatientHealthConcernStatus> = {
		label: 'PatientHealthConcernStatus',
		values: [PatientHealthConcernStatus.INACTIVE, PatientHealthConcernStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.patient.healthconcern.constant.patienthealthconcerntype.PatientHealthConcernType */
/* istanbul ignore next */
export class PatientHealthConcernType extends GandalfConstant<number> {
	static readonly OBSERVATION = new PatientHealthConcernType(1, "Observation");
	static readonly CONCERN = new PatientHealthConcernType(2, "Concern");
	
	static readonly VALUES: GandalfConstantList<PatientHealthConcernType> = {
		label: 'Patient Health Concern Type',
		values: [PatientHealthConcernType.OBSERVATION, PatientHealthConcernType.CONCERN, ]
	};
}

/** see com.rev360.model.patient.healthgoal.constant.patienthealthgoalstatus.PatientHealthGoalStatus */
/* istanbul ignore next */
export class PatientHealthGoalStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PatientHealthGoalStatus(0, "Inactive");
	static readonly ACTIVE = new PatientHealthGoalStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PatientHealthGoalStatus> = {
		label: 'Patient Health Goal Status',
		values: [PatientHealthGoalStatus.INACTIVE, PatientHealthGoalStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.patient.constant.patientmergelogrecordtype.PatientMergeLogRecordType */
/* istanbul ignore next */
export class PatientMergeLogRecordType extends GandalfConstant<string> {
	static readonly PATIENT = new PatientMergeLogRecordType('PATIENT', "Patient");
	static readonly PERSON = new PatientMergeLogRecordType('PERSON', "Person");
	
	static readonly VALUES: GandalfConstantList<PatientMergeLogRecordType> = {
		label: 'Patient Merge Log Record Type',
		values: [PatientMergeLogRecordType.PATIENT, PatientMergeLogRecordType.PERSON, ]
	};
}

/** see com.rev360.model.patient.constant.patientreferralsourcetype.PatientReferralSourceType */
/* istanbul ignore next */
export class PatientReferralSourceType extends GandalfConstant<number> {
	static readonly PATIENT = new PatientReferralSourceType(1, "Patient");
	static readonly PROVIDER = new PatientReferralSourceType(2, "Provider");
	static readonly OTHER = new PatientReferralSourceType(3, "Other");
	
	static readonly VALUES: GandalfConstantList<PatientReferralSourceType> = {
		label: 'PatientReferralSourceType',
		values: [PatientReferralSourceType.PATIENT, PatientReferralSourceType.PROVIDER, PatientReferralSourceType.OTHER, ]
	};
}

/** see com.rev360.model.patient.constant.patientsearchstatus.PatientSearchStatus */
/* istanbul ignore next */
export class PatientSearchStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new PatientSearchStatus(1, "Active");
	static readonly INACTIVE = new PatientSearchStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<PatientSearchStatus> = {
		label: 'Patient Search Status',
		values: [PatientSearchStatus.ACTIVE, PatientSearchStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.patient.constant.patientstatus.PatientStatus */
/* istanbul ignore next */
export class PatientStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PatientStatus(0, "Inactive");
	static readonly ACTIVE = new PatientStatus(1, "Active");
	static readonly DECEASED = new PatientStatus(2, "Deceased");
	
	static readonly VALUES: GandalfConstantList<PatientStatus> = {
		label: 'Patient Status',
		values: [PatientStatus.INACTIVE, PatientStatus.ACTIVE, PatientStatus.DECEASED, ]
	};
}

/** see com.rev360.model.query.constant.patienttriggeroutcomeconfirmation.PatientTriggerOutcomeConfirmation */
/* istanbul ignore next */
export class PatientTriggerOutcomeConfirmation extends GandalfConstant<number> {
	static readonly UNKNOWN = new PatientTriggerOutcomeConfirmation(0, "Unknown");
	static readonly CONFIRMED = new PatientTriggerOutcomeConfirmation(1, "Confirm");
	static readonly DEFERRED = new PatientTriggerOutcomeConfirmation(2, "Defer");
	static readonly NOT_APPLICABLE = new PatientTriggerOutcomeConfirmation(3, "N/A");
	static readonly PRINTED = new PatientTriggerOutcomeConfirmation(11, "Printed");
	static readonly FAXED = new PatientTriggerOutcomeConfirmation(12, "Faxed");
	static readonly EMAILED = new PatientTriggerOutcomeConfirmation(13, "Emailed");
	static readonly IN_OFFICE = new PatientTriggerOutcomeConfirmation(14, "In Office");
	static readonly MESSAGED = new PatientTriggerOutcomeConfirmation(15, "Messaged");
	static readonly PHR = new PatientTriggerOutcomeConfirmation(16, "PHR");
	
	static readonly VALUES: GandalfConstantList<PatientTriggerOutcomeConfirmation> = {
		label: 'Patient Trigger Outcome Confirmation',
		values: [PatientTriggerOutcomeConfirmation.UNKNOWN, PatientTriggerOutcomeConfirmation.CONFIRMED, PatientTriggerOutcomeConfirmation.DEFERRED, PatientTriggerOutcomeConfirmation.NOT_APPLICABLE, PatientTriggerOutcomeConfirmation.PRINTED, PatientTriggerOutcomeConfirmation.FAXED, PatientTriggerOutcomeConfirmation.EMAILED, PatientTriggerOutcomeConfirmation.IN_OFFICE, PatientTriggerOutcomeConfirmation.MESSAGED, PatientTriggerOutcomeConfirmation.PHR, ]
	};
}

/** see com.rev360.model.query.constant.patienttriggeroutcometype.PatientTriggerOutcomeType */
/* istanbul ignore next */
export class PatientTriggerOutcomeType extends GandalfConstant<number> {
	static readonly ALERT = new PatientTriggerOutcomeType(1, "Alert");
	static readonly CARE_PLAN = new PatientTriggerOutcomeType(2, "Care Plan");
	
	static readonly VALUES: GandalfConstantList<PatientTriggerOutcomeType> = {
		label: 'Patient Trigger Outcome Type',
		values: [PatientTriggerOutcomeType.ALERT, PatientTriggerOutcomeType.CARE_PLAN, ]
	};
}

/** see com.rev360.model.accounting.constant.payertype.PayerType */
/* istanbul ignore next */
export class PayerType extends GandalfConstant<number> {
	static readonly NONE = new PayerType(0, "");
	static readonly PATIENT = new PayerType(1, "Patient");
	static readonly INSURANCE = new PayerType(2, "Insurance");
	static readonly ANONYMOUS = new PayerType(3, "Guest");
	static readonly PERSON = new PayerType(4, "Person");
	static readonly BUSINESS = new PayerType(5, "Business");
	static readonly COLLECTIONS = new PayerType(6, "Collections");
	static readonly LOCATION = new PayerType(7, "Location");
	
	static readonly VALUES: GandalfConstantList<PayerType> = {
		label: 'Payer Types',
		values: [PayerType.NONE, PayerType.PATIENT, PayerType.INSURANCE, PayerType.ANONYMOUS, PayerType.PERSON, PayerType.BUSINESS, PayerType.COLLECTIONS, PayerType.LOCATION, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymentgroupsourcetype.PaymentGroupSourceType */
/* istanbul ignore next */
export class PaymentGroupSourceType extends GandalfConstant<number> {
	static readonly NONE = new PaymentGroupSourceType(0, "");
	static readonly PAYER = new PaymentGroupSourceType(1, "Payer");
	static readonly LOCATION = new PaymentGroupSourceType(2, "Location");
	static readonly MANUAL = new PaymentGroupSourceType(3, "Manual");
	static readonly ERA = new PaymentGroupSourceType(4, "ERA");
	static readonly EPAY = new PaymentGroupSourceType(5, "EPAY");
	
	static readonly VALUES: GandalfConstantList<PaymentGroupSourceType> = {
		label: 'PaymentGroupSourceType',
		values: [PaymentGroupSourceType.NONE, PaymentGroupSourceType.PAYER, PaymentGroupSourceType.LOCATION, PaymentGroupSourceType.MANUAL, PaymentGroupSourceType.ERA, PaymentGroupSourceType.EPAY, ]
	};
}

/** see com.rev360.pms.service.accounting.payment.PaymentGroupSourceTypeSearch */
/* istanbul ignore next */
export class PaymentGroupSourceTypeSearch extends GandalfConstant<number> {
	static readonly OFFICE = new PaymentGroupSourceTypeSearch(1, "Office");
	static readonly ONLINE = new PaymentGroupSourceTypeSearch(2, "Online");
	
	static readonly VALUES: GandalfConstantList<PaymentGroupSourceTypeSearch> = {
		label: 'Source Types Search',
		values: [PaymentGroupSourceTypeSearch.OFFICE, PaymentGroupSourceTypeSearch.ONLINE, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymentgroupstatus.PaymentGroupStatus */
/* istanbul ignore next */
export class PaymentGroupStatus extends GandalfConstant<number> {
	static readonly APPROVED = new PaymentGroupStatus(1, "Applied");
	static readonly PENDING = new PaymentGroupStatus(2, "Pending");
	static readonly CANCELED = new PaymentGroupStatus(4, "Canceled");
	static readonly PROCESSING = new PaymentGroupStatus(5, "Processing");
	static readonly FAILED = new PaymentGroupStatus(6, "Failed");
	
	static readonly VALUES: GandalfConstantList<PaymentGroupStatus> = {
		label: 'PaymentGroupStatus',
		values: [PaymentGroupStatus.APPROVED, PaymentGroupStatus.PENDING, PaymentGroupStatus.CANCELED, PaymentGroupStatus.PROCESSING, PaymentGroupStatus.FAILED, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymentmethodcreditcardtype.PaymentMethodCreditCardType */
/* istanbul ignore next */
export class PaymentMethodCreditCardType extends GandalfConstant<number> {
	static readonly UNKNOWN = new PaymentMethodCreditCardType(0, "");
	static readonly VISA = new PaymentMethodCreditCardType(1, "Visa");
	static readonly MASTERCARD = new PaymentMethodCreditCardType(2, "Mastercard");
	static readonly AMEX = new PaymentMethodCreditCardType(3, "Amex");
	static readonly DISCOVER = new PaymentMethodCreditCardType(4, "Discover");
	static readonly DINERS = new PaymentMethodCreditCardType(5, "Diners");
	static readonly JCB = new PaymentMethodCreditCardType(6, "JCB");
	static readonly EN_ROUTE = new PaymentMethodCreditCardType(7, "EnRoute");
	static readonly DEBIT = new PaymentMethodCreditCardType(8, "Debit");
	static readonly OTHER = new PaymentMethodCreditCardType(9, "Other");
	static readonly MILITARY_STAR = new PaymentMethodCreditCardType(10, "Military Star");
	
	static readonly VALUES: GandalfConstantList<PaymentMethodCreditCardType> = {
		label: 'Payment Method Credit Card Type',
		values: [PaymentMethodCreditCardType.UNKNOWN, PaymentMethodCreditCardType.VISA, PaymentMethodCreditCardType.MASTERCARD, PaymentMethodCreditCardType.AMEX, PaymentMethodCreditCardType.DISCOVER, PaymentMethodCreditCardType.DINERS, PaymentMethodCreditCardType.JCB, PaymentMethodCreditCardType.EN_ROUTE, PaymentMethodCreditCardType.DEBIT, PaymentMethodCreditCardType.OTHER, PaymentMethodCreditCardType.MILITARY_STAR, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymentmethodtype.PaymentMethodType */
/* istanbul ignore next */
export class PaymentMethodType extends GandalfConstant<number> {
	static readonly CASH = new PaymentMethodType(1, "Cash");
	static readonly CHECK = new PaymentMethodType(2, "Check");
	static readonly CREDIT_CARD = new PaymentMethodType(3, "Credit Card");
	static readonly CREDIT = new PaymentMethodType(4, "Credit");
	static readonly EFT = new PaymentMethodType(5, "EFT");
	static readonly PAYPAL = new PaymentMethodType(6, "Paypal");
	static readonly ECHECK = new PaymentMethodType(7, "e-Check");
	static readonly CARE_CREDIT = new PaymentMethodType(8, "Care Credit");
	static readonly LOCATION_DUE = new PaymentMethodType(9, "Location Due");
	static readonly EASYPAY = new PaymentMethodType(10, "EasyPay");
	static readonly OTHER = new PaymentMethodType(11, "Other");
	static readonly GRANTED_CREDIT = new PaymentMethodType(12, "Granted Credit");
	static readonly APPLE_PAY = new PaymentMethodType(15, "Apple Pay");
	static readonly GIFT_CERTIFICATE = new PaymentMethodType(16, "Gift Certificate");
	static readonly VENMO = new PaymentMethodType(17, "Venmo");
	static readonly SUNBIT = new PaymentMethodType(18, "Sunbit");
	static readonly ONLINE_PAYMENT = new PaymentMethodType(19, "Online Payment");
	static readonly COFI = new PaymentMethodType(20, "CoFi");
	static readonly CRYPTO_CURRENCY = new PaymentMethodType(21, "Crypto Currency");
	static readonly CASH_APP = new PaymentMethodType(22, "Cash App");
	
	static readonly VALUES: GandalfConstantList<PaymentMethodType> = {
		label: 'PaymentMethodType',
		values: [PaymentMethodType.CASH, PaymentMethodType.CHECK, PaymentMethodType.CREDIT_CARD, PaymentMethodType.CREDIT, PaymentMethodType.EFT, PaymentMethodType.PAYPAL, PaymentMethodType.ECHECK, PaymentMethodType.CARE_CREDIT, PaymentMethodType.LOCATION_DUE, PaymentMethodType.EASYPAY, PaymentMethodType.OTHER, PaymentMethodType.GRANTED_CREDIT, PaymentMethodType.APPLE_PAY, PaymentMethodType.GIFT_CERTIFICATE, PaymentMethodType.VENMO, PaymentMethodType.SUNBIT, PaymentMethodType.ONLINE_PAYMENT, PaymentMethodType.COFI, PaymentMethodType.CRYPTO_CURRENCY, PaymentMethodType.CASH_APP, ]
	};
}

/** see com.rev360.pms.api.controller.accounting.PaymentSearchPayerType */
/* istanbul ignore next */
export class PaymentSearchPayerType extends GandalfConstant<number> {
	static readonly ALL = new PaymentSearchPayerType(0, "All");
	static readonly INSURANCE = new PaymentSearchPayerType(2, "Insurance");
	static readonly PATIENT = new PaymentSearchPayerType(1, "Patient");
	static readonly COLLECTIONS = new PaymentSearchPayerType(6, "Collections");
	
	static readonly VALUES: GandalfConstantList<PaymentSearchPayerType> = {
		label: 'PayerType',
		values: [PaymentSearchPayerType.ALL, PaymentSearchPayerType.INSURANCE, PaymentSearchPayerType.PATIENT, PaymentSearchPayerType.COLLECTIONS, ]
	};
}

/** see com.rev360.pms.service.accounting.payment.PaymentSearchStatus */
/* istanbul ignore next */
export class PaymentSearchStatus extends GandalfConstant<number> {
	static readonly ALL = new PaymentSearchStatus(0, "All");
	static readonly APPLIED = new PaymentSearchStatus(1, "Applied");
	static readonly PENDING = new PaymentSearchStatus(2, "Pending");
	static readonly CANCELED = new PaymentSearchStatus(4, "Canceled");
	static readonly PROCESSING = new PaymentSearchStatus(5, "Processing");
	static readonly FAILED = new PaymentSearchStatus(6, "Failed");
	
	static readonly VALUES: GandalfConstantList<PaymentSearchStatus> = {
		label: 'Authorization',
		values: [PaymentSearchStatus.ALL, PaymentSearchStatus.APPLIED, PaymentSearchStatus.PENDING, PaymentSearchStatus.CANCELED, PaymentSearchStatus.PROCESSING, PaymentSearchStatus.FAILED, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymentstatus.PaymentStatus */
/* istanbul ignore next */
export class PaymentStatus extends GandalfConstant<number> {
	static readonly APPROVED = new PaymentStatus(1, "Applied");
	static readonly PENDING = new PaymentStatus(2, "Pending");
	static readonly VOID = new PaymentStatus(3, "Void");
	static readonly CANCELED = new PaymentStatus(4, "Canceled");
	static readonly PROCESSING = new PaymentStatus(5, "Processing");
	static readonly FAILED = new PaymentStatus(6, "Failed");
	
	static readonly VALUES: GandalfConstantList<PaymentStatus> = {
		label: 'Payment Status',
		values: [PaymentStatus.APPROVED, PaymentStatus.PENDING, PaymentStatus.VOID, PaymentStatus.CANCELED, PaymentStatus.PROCESSING, PaymentStatus.FAILED, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymentstoredtokenstatus.PaymentStoredTokenStatus */
/* istanbul ignore next */
export class PaymentStoredTokenStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new PaymentStoredTokenStatus(1, "Active");
	static readonly INACTIVE = new PaymentStoredTokenStatus(2, "Inactive");
	static readonly DELETED = new PaymentStoredTokenStatus(3, "Deleted");
	
	static readonly VALUES: GandalfConstantList<PaymentStoredTokenStatus> = {
		label: 'Payment Stored Token Status',
		values: [PaymentStoredTokenStatus.ACTIVE, PaymentStoredTokenStatus.INACTIVE, PaymentStoredTokenStatus.DELETED, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymenttransactionmodality.PaymentTransactionModality */
/* istanbul ignore next */
export class PaymentTransactionModality extends GandalfConstant<number> {
	static readonly CREDIT = new PaymentTransactionModality(1, "Credit");
	static readonly DEBIT = new PaymentTransactionModality(2, "Debit");
	
	static readonly VALUES: GandalfConstantList<PaymentTransactionModality> = {
		label: 'Payment Transaction Modality',
		values: [PaymentTransactionModality.CREDIT, PaymentTransactionModality.DEBIT, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymenttransactionprocessor.PaymentTransactionProcessor */
/* istanbul ignore next */
export class PaymentTransactionProcessor extends GandalfConstant<number> {
	static readonly BLUEFIN = new PaymentTransactionProcessor(1, "Bluefin");
	static readonly OPENEDGE = new PaymentTransactionProcessor(2, "Global Payments");
	static readonly PRACTICE_PAY = new PaymentTransactionProcessor(3, "Practice Pay");
	
	static readonly VALUES: GandalfConstantList<PaymentTransactionProcessor> = {
		label: 'Payment Transaction Processor',
		values: [PaymentTransactionProcessor.BLUEFIN, PaymentTransactionProcessor.OPENEDGE, PaymentTransactionProcessor.PRACTICE_PAY, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymenttransactionprocessoraccount.PaymentTransactionProcessorAccount */
/* istanbul ignore next */
export class PaymentTransactionProcessorAccount extends GandalfConstant<number> {
	static readonly OPENEDGE_MOTO = new PaymentTransactionProcessorAccount(1, "Global Payments MOTO Service Account");
	static readonly OPENEDGE_RETAIL = new PaymentTransactionProcessorAccount(2, "Global Payments Retail Service Account");
	
	static readonly VALUES: GandalfConstantList<PaymentTransactionProcessorAccount> = {
		label: 'Payment Transaction Processor Account',
		values: [PaymentTransactionProcessorAccount.OPENEDGE_MOTO, PaymentTransactionProcessorAccount.OPENEDGE_RETAIL, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymenttransactiontype.PaymentTransactionType */
/* istanbul ignore next */
export class PaymentTransactionType extends GandalfConstant<number> {
	static readonly SALE = new PaymentTransactionType(1, "Sale");
	static readonly REFUND = new PaymentTransactionType(2, "Refund");
	static readonly VOID = new PaymentTransactionType(3, "Void");
	
	static readonly VALUES: GandalfConstantList<PaymentTransactionType> = {
		label: 'Payment Transaction Type',
		values: [PaymentTransactionType.SALE, PaymentTransactionType.REFUND, PaymentTransactionType.VOID, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymenttransfermethodtype.PaymentTransferMethodType */
/* istanbul ignore next */
export class PaymentTransferMethodType extends GandalfConstant<number> {
	static readonly WRITEOFF = new PaymentTransferMethodType(1, "Write-off");
	static readonly PATIENT = new PaymentTransferMethodType(2, "Patient Transfer");
	static readonly INSURANCE = new PaymentTransferMethodType(3, "Insurance Transfer");
	static readonly COLLECTIONS = new PaymentTransferMethodType(4, "Collections Transfer");
	
	static readonly VALUES: GandalfConstantList<PaymentTransferMethodType> = {
		label: 'Payment Transfer Method Type',
		values: [PaymentTransferMethodType.WRITEOFF, PaymentTransferMethodType.PATIENT, PaymentTransferMethodType.INSURANCE, PaymentTransferMethodType.COLLECTIONS, ]
	};
}

/** see com.rev360.model.accounting.payment.constant.paymenttransfertype.PaymentTransferType */
/* istanbul ignore next */
export class PaymentTransferType extends GandalfConstant<number> {
	static readonly ITEMS = new PaymentTransferType(1, "Items");
	static readonly INVOICE = new PaymentTransferType(2, "Invoice");
	
	static readonly VALUES: GandalfConstantList<PaymentTransferType> = {
		label: 'Payment Transfer Type',
		values: [PaymentTransferType.ITEMS, PaymentTransferType.INVOICE, ]
	};
}

/** see com.rev360.model.encounter.constant.performedservicetriggerstatus.PerformedServiceTriggerStatus */
/* istanbul ignore next */
export class PerformedServiceTriggerStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new PerformedServiceTriggerStatus(1, "Active");
	static readonly INACTIVE = new PerformedServiceTriggerStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<PerformedServiceTriggerStatus> = {
		label: 'Performed Service Trigger Status',
		values: [PerformedServiceTriggerStatus.ACTIVE, PerformedServiceTriggerStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.person.constant.persondiagnosisstatus.PersonDiagnosisStatus */
/* istanbul ignore next */
export class PersonDiagnosisStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PersonDiagnosisStatus(0, "Inactive");
	static readonly ACTIVE = new PersonDiagnosisStatus(1, "Active");
	static readonly RESOLVED = new PersonDiagnosisStatus(2, "Resolved");
	
	static readonly VALUES: GandalfConstantList<PersonDiagnosisStatus> = {
		label: 'Person Diagnosis Status',
		values: [PersonDiagnosisStatus.INACTIVE, PersonDiagnosisStatus.ACTIVE, PersonDiagnosisStatus.RESOLVED, ]
	};
}

/** see com.rev360.model.person.constant.personinsurancestatus.PersonInsuranceStatus */
/* istanbul ignore next */
export class PersonInsuranceStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PersonInsuranceStatus(0, "Inactive");
	static readonly ACTIVE = new PersonInsuranceStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PersonInsuranceStatus> = {
		label: 'Person Insurance Status',
		values: [PersonInsuranceStatus.INACTIVE, PersonInsuranceStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.person.constant.personinterpreterassistance.PersonInterpreterAssistance */
/* istanbul ignore next */
export class PersonInterpreterAssistance extends GandalfConstant<number> {
	static readonly UNKNOWN = new PersonInterpreterAssistance(0, "Unknown");
	static readonly YES = new PersonInterpreterAssistance(1, "Yes");
	static readonly NO = new PersonInterpreterAssistance(2, "No");
	
	static readonly VALUES: GandalfConstantList<PersonInterpreterAssistance> = {
		label: 'Person Interpreter Assistance',
		values: [PersonInterpreterAssistance.UNKNOWN, PersonInterpreterAssistance.YES, PersonInterpreterAssistance.NO, ]
	};
}

/** see com.rev360.model.person.constant.personpharmacystatus.PersonPharmacyStatus */
/* istanbul ignore next */
export class PersonPharmacyStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PersonPharmacyStatus(0, "Inactive");
	static readonly ACTIVE = new PersonPharmacyStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PersonPharmacyStatus> = {
		label: 'Person Pharmacy Status',
		values: [PersonPharmacyStatus.INACTIVE, PersonPharmacyStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.pharmacy.constant.status.PharmacyStatus */
/* istanbul ignore next */
export class PharmacyStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PharmacyStatus(0, "Inactive");
	static readonly ACTIVE = new PharmacyStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PharmacyStatus> = {
		label: 'Status',
		values: [PharmacyStatus.INACTIVE, PharmacyStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.practice.constant.phrshiptotype.PhrShipToType */
/* istanbul ignore next */
export class PhrShipToType extends GandalfConstant<number> {
	static readonly PATIENT = new PhrShipToType(1, "Patient");
	static readonly PRACTICE = new PhrShipToType(2, "Practice");
	
	static readonly VALUES: GandalfConstantList<PhrShipToType> = {
		label: 'PHR Ship To Type',
		values: [PhrShipToType.PATIENT, PhrShipToType.PRACTICE, ]
	};
}

/** see com.rev360.pms.security.PmsLoginErrorCodes */
/* istanbul ignore next */
export class PmsLoginErrorCodes extends GandalfConstant<string> {
	static readonly GENERIC = new PmsLoginErrorCodes('GENERIC', "GENERIC");
	static readonly NOT_ACTIVE = new PmsLoginErrorCodes('NOT_ACTIVE', "NOT_ACTIVE");
	static readonly OUTSIDE_HOURS = new PmsLoginErrorCodes('OUTSIDE_HOURS', "OUTSIDE_HOURS");
	static readonly ACTIVE_SESSION = new PmsLoginErrorCodes('ACTIVE_SESSION', "ACTIVE_SESSION");
	
	static readonly VALUES: GandalfConstantList<PmsLoginErrorCodes> = {
		label: 'PmsLoginErrorCodes',
		values: [PmsLoginErrorCodes.GENERIC, PmsLoginErrorCodes.NOT_ACTIVE, PmsLoginErrorCodes.OUTSIDE_HOURS, PmsLoginErrorCodes.ACTIVE_SESSION, ]
	};
}

/** see com.rev360.model.person.constant.policyholderrelationship.PolicyHolderRelationship */
/* istanbul ignore next */
export class PolicyHolderRelationship extends GandalfConstant<number> {
	static readonly UNKNOWN = new PolicyHolderRelationship(0, "Unknown");
	static readonly SELF = new PolicyHolderRelationship(1, "Self");
	static readonly SPOUSE = new PolicyHolderRelationship(2, "Spouse");
	static readonly CHILD = new PolicyHolderRelationship(3, "Child");
	static readonly OTHER = new PolicyHolderRelationship(4, "Other");
	static readonly STUDENT = new PolicyHolderRelationship(5, "Student");
	
	static readonly VALUES: GandalfConstantList<PolicyHolderRelationship> = {
		label: 'Policy Holder Relationship',
		values: [PolicyHolderRelationship.UNKNOWN, PolicyHolderRelationship.SELF, PolicyHolderRelationship.SPOUSE, PolicyHolderRelationship.CHILD, PolicyHolderRelationship.OTHER, PolicyHolderRelationship.STUDENT, ]
	};
}

/** see com.rev360.model.consentform.constant.practiceconsentformexpirationtype.PracticeConsentFormExpirationType */
/* istanbul ignore next */
export class PracticeConsentFormExpirationType extends GandalfConstant<number> {
	static readonly NEVER = new PracticeConsentFormExpirationType(1, "Never");
	static readonly ANNUALLY = new PracticeConsentFormExpirationType(2, "Annually");
	static readonly CALENDAR_YEAR = new PracticeConsentFormExpirationType(3, "Calendar Year");
	static readonly EACH_VISIT = new PracticeConsentFormExpirationType(4, "Each Visit");
	static readonly CUSTOM = new PracticeConsentFormExpirationType(10, "Custom");
	
	static readonly VALUES: GandalfConstantList<PracticeConsentFormExpirationType> = {
		label: 'PracticeConsent Form Expriation Type',
		values: [PracticeConsentFormExpirationType.NEVER, PracticeConsentFormExpirationType.ANNUALLY, PracticeConsentFormExpirationType.CALENDAR_YEAR, PracticeConsentFormExpirationType.EACH_VISIT, PracticeConsentFormExpirationType.CUSTOM, ]
	};
}

/** see com.rev360.model.consentform.constant.practiceconsentformrequired.PracticeConsentFormRequired */
/* istanbul ignore next */
export class PracticeConsentFormRequired extends GandalfConstant<number> {
	static readonly NO = new PracticeConsentFormRequired(0, "No");
	static readonly YES = new PracticeConsentFormRequired(1, "Yes");
	static readonly CONDITIONALLY = new PracticeConsentFormRequired(2, "Conditionally");
	
	static readonly VALUES: GandalfConstantList<PracticeConsentFormRequired> = {
		label: 'Practice Consent Form Required',
		values: [PracticeConsentFormRequired.NO, PracticeConsentFormRequired.YES, PracticeConsentFormRequired.CONDITIONALLY, ]
	};
}

/** see com.rev360.model.consentform.constant.practiceconsentformstatus.PracticeConsentFormStatus */
/* istanbul ignore next */
export class PracticeConsentFormStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PracticeConsentFormStatus(0, "Inactive");
	static readonly ACTIVE = new PracticeConsentFormStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PracticeConsentFormStatus> = {
		label: 'Practice ConsentFormStatus',
		values: [PracticeConsentFormStatus.INACTIVE, PracticeConsentFormStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.consentform.constant.practiceconsentformtype.PracticeConsentFormType */
/* istanbul ignore next */
export class PracticeConsentFormType extends GandalfConstant<number> {
	static readonly HIPAA = new PracticeConsentFormType(1, "HIPAA");
	static readonly INSURANCE_SOF = new PracticeConsentFormType(2, "Insurance SOF");
	static readonly MEDICARE_ABN = new PracticeConsentFormType(3, "Medicare ABN");
	static readonly MEDICARE_SOF = new PracticeConsentFormType(4, "Medicare SOF");
	static readonly OTHER = new PracticeConsentFormType(10, "Other");
	static readonly PIPEDA = new PracticeConsentFormType(100, "PIPEDA");
	static readonly CONSENT_TO_TREAT = new PracticeConsentFormType(101, "Consent to Treat");
	
	static readonly VALUES: GandalfConstantList<PracticeConsentFormType> = {
		label: 'PracticeConsentFormType',
		values: [PracticeConsentFormType.HIPAA, PracticeConsentFormType.INSURANCE_SOF, PracticeConsentFormType.MEDICARE_ABN, PracticeConsentFormType.MEDICARE_SOF, PracticeConsentFormType.OTHER, PracticeConsentFormType.PIPEDA, PracticeConsentFormType.CONSENT_TO_TREAT, ]
	};
}

/** see com.rev360.model.practice.constant.practicediagnosisstatus.PracticeDiagnosisStatus */
/* istanbul ignore next */
export class PracticeDiagnosisStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PracticeDiagnosisStatus(0, "Inactive");
	static readonly ACTIVE = new PracticeDiagnosisStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PracticeDiagnosisStatus> = {
		label: 'Practice Diagnosis Status',
		values: [PracticeDiagnosisStatus.INACTIVE, PracticeDiagnosisStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.practice.constant.practiceencounterconfigurationmethod.PracticeEncounterConfigurationMethod */
/* istanbul ignore next */
export class PracticeEncounterConfigurationMethod extends GandalfConstant<number> {
	static readonly ENCOUNTER_CONFIG_XML = new PracticeEncounterConfigurationMethod(1, "encounter-config.xml");
	static readonly ENCOUNTER_CONFIG_MASTER_TABLES_V1 = new PracticeEncounterConfigurationMethod(2, "Master Tables Version 1");
	
	static readonly VALUES: GandalfConstantList<PracticeEncounterConfigurationMethod> = {
		label: 'Practice Encounter Configuration Method',
		values: [PracticeEncounterConfigurationMethod.ENCOUNTER_CONFIG_XML, PracticeEncounterConfigurationMethod.ENCOUNTER_CONFIG_MASTER_TABLES_V1, ]
	};
}

/** see com.rev360.model.utilities.constant.practiceexportstatus.PracticeExportStatus */
/* istanbul ignore next */
export class PracticeExportStatus extends GandalfConstant<number> {
	static readonly READY_TO_QUEUE = new PracticeExportStatus(1, "Ready to queue");
	static readonly PROCESSING = new PracticeExportStatus(3, "Processing");
	static readonly SUCCEEDED = new PracticeExportStatus(4, "Succeeded");
	static readonly FAILED = new PracticeExportStatus(5, "Failed");
	
	static readonly VALUES: GandalfConstantList<PracticeExportStatus> = {
		label: 'Practice Export Status',
		values: [PracticeExportStatus.READY_TO_QUEUE, PracticeExportStatus.PROCESSING, PracticeExportStatus.SUCCEEDED, PracticeExportStatus.FAILED, ]
	};
}

/** see com.rev360.model.common.constant.practicefolderidentifier.PracticeFolderIdentifier */
/* istanbul ignore next */
export class PracticeFolderIdentifier extends GandalfConstant<string> {
	static readonly ROOT = new PracticeFolderIdentifier('0', "Root");
	static readonly OFFICE_POLICIES = new PracticeFolderIdentifier('1', "Office Policies");
	static readonly PATIENT_EDUCATION = new PracticeFolderIdentifier('2', "Patient Education");
	static readonly OTHER_DOCUMENTS = new PracticeFolderIdentifier('3', "Other Documents");
	static readonly CONSENT_FORMS = new PracticeFolderIdentifier('4', "Consent Forms");
	static readonly PATIENT_PHOTOGRAPHS = new PracticeFolderIdentifier('5', "Patient Photographs");
	static readonly EMPLOYEE_PHOTOGRAPHS = new PracticeFolderIdentifier('6', "Employee Photographs");
	static readonly CARE_PLAN_FILES = new PracticeFolderIdentifier('7', "Care Plan Files");
	static readonly INTEROPERABILITY = new PracticeFolderIdentifier('8', "Interoperability");
	static readonly EMPLOYEE_SIGNATURES = new PracticeFolderIdentifier('9', "Employee Signatures");
	static readonly LOCATION_LOGOS = new PracticeFolderIdentifier('10', "Location Logos");
	static readonly CQM_EXPORTS_OR_EMPLOYEE_PROVIDER = new PracticeFolderIdentifier('11', "CQM Exports");
	static readonly JASPER_BATCH_PRINT = new PracticeFolderIdentifier('12', "Jasper Batch Print");
	static readonly ERA_835_FILES = new PracticeFolderIdentifier('13', "835 Files");
	static readonly DELETED_FILES = new PracticeFolderIdentifier('14', "Deleted Files");
	
	static readonly VALUES: GandalfConstantList<PracticeFolderIdentifier> = {
		label: 'PracticeFolderIdentifier',
		values: [PracticeFolderIdentifier.ROOT, PracticeFolderIdentifier.OFFICE_POLICIES, PracticeFolderIdentifier.PATIENT_EDUCATION, PracticeFolderIdentifier.OTHER_DOCUMENTS, PracticeFolderIdentifier.CONSENT_FORMS, PracticeFolderIdentifier.PATIENT_PHOTOGRAPHS, PracticeFolderIdentifier.EMPLOYEE_PHOTOGRAPHS, PracticeFolderIdentifier.CARE_PLAN_FILES, PracticeFolderIdentifier.INTEROPERABILITY, PracticeFolderIdentifier.EMPLOYEE_SIGNATURES, PracticeFolderIdentifier.LOCATION_LOGOS, PracticeFolderIdentifier.CQM_EXPORTS_OR_EMPLOYEE_PROVIDER, PracticeFolderIdentifier.JASPER_BATCH_PRINT, PracticeFolderIdentifier.ERA_835_FILES, PracticeFolderIdentifier.DELETED_FILES, ]
	};
}

/** see com.rev360.model.practice.constant.practicelocationsubscriberstatus.PracticeLocationSubscriberStatus */
/* istanbul ignore next */
export class PracticeLocationSubscriberStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PracticeLocationSubscriberStatus(0, "Inactive");
	static readonly ACTIVE = new PracticeLocationSubscriberStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PracticeLocationSubscriberStatus> = {
		label: 'Practice Location Subscriber Status',
		values: [PracticeLocationSubscriberStatus.INACTIVE, PracticeLocationSubscriberStatus.ACTIVE, ]
	};
}

/** see com.rev360.common.practicepay.service.payment.practicepay.PracticePayCardBrand */
/* istanbul ignore next */
export class PracticePayCardBrand extends GandalfConstant<string> {
	static readonly VISA = new PracticePayCardBrand('visa', "Visa");
	static readonly VISA_GOOGLEPAY = new PracticePayCardBrand('visa_googlepay', "Visa (Google Pay)");
	static readonly VISA_APPLEPAY = new PracticePayCardBrand('visa_applepay', "Visa (Apple Pay)");
	static readonly VISA_SAMSUNGPAY = new PracticePayCardBrand('visa_samsungpay', "Visa (Samsung Pay)");
	static readonly VISA_VIPPS = new PracticePayCardBrand('visa_vipps', "Visa (Vipps)");
	static readonly VISA_MOBILEPAY = new PracticePayCardBrand('visa_mobilepay', "Visa (MobilePay)");
	static readonly VISA_CREDIT = new PracticePayCardBrand('visacredit', "Visa Credit");
	static readonly VISA_DEBIT = new PracticePayCardBrand('visadebit', "Visa Debit");
	static readonly VISA_PLATINUM = new PracticePayCardBrand('visaplatinum', "Visa Platinum");
	static readonly VISA_GOLD = new PracticePayCardBrand('visagold', "Visa Gold");
	static readonly VISA_BUSINESS = new PracticePayCardBrand('visabusiness', "Visa Business");
	static readonly VISA_CLASSIC = new PracticePayCardBrand('visaclassic', "Visa Classic");
	static readonly VISA_CORPORATE = new PracticePayCardBrand('visacorporate', "Visa Corporate");
	static readonly VISA_PREMIUM_CREDIT = new PracticePayCardBrand('visapremiumcredit', "Visa Premium Credit");
	static readonly VISA_PREMIUM_DEBIT = new PracticePayCardBrand('visapremiumdebit', "Visa Premium Debit");
	static readonly VISA_STANDARD_CREDIT = new PracticePayCardBrand('visastandardcredit', "Visa Standard Credit");
	static readonly VISA_STANDARD_DEBIT = new PracticePayCardBrand('visastandarddebit', "Visa Standard Debit");
	static readonly ELECTRON = new PracticePayCardBrand('electron', "Visa Electron");
	static readonly ELECTRON_APPLEPAY = new PracticePayCardBrand('electron_applepay', "Visa Electron (Apple Pay)");
	static readonly VPAY = new PracticePayCardBrand('vpay', "V Pay");
	static readonly MC = new PracticePayCardBrand('mc', "Mastercard");
	static readonly MC_GOOGLEPAY = new PracticePayCardBrand('mc_googlepay', "Mastercard (Google Pay)");
	static readonly MC_APPLEPAY = new PracticePayCardBrand('mc_applepay', "Mastercard (Apple Pay)");
	static readonly MC_SAMSUNGPAY = new PracticePayCardBrand('mc_samsungpay', "Mastercard (Samsung Pay)");
	static readonly MC_VIPPS = new PracticePayCardBrand('mc_vipps', "Mastercard (Vipps)");
	static readonly MC_MOBILEPAY = new PracticePayCardBrand('mc_mobilepay', "Mastercard (MobilePay)");
	static readonly MC_CREDIT = new PracticePayCardBrand('mccredit', "Mastercard Credit");
	static readonly MC_DEBIT = new PracticePayCardBrand('mcdebit', "Mastercard Debit");
	static readonly MC_PREMIUM_CREDIT = new PracticePayCardBrand('mcpremiumcredit', "Mastercard Premium Credit");
	static readonly MC_PREMIUM_DEBIT = new PracticePayCardBrand('mcpremiumdebit', "Mastercard Premium Debit");
	static readonly MC_STANDARD_CREDIT = new PracticePayCardBrand('mcstandardcredit', "Mastercard Standard Credit");
	static readonly MC_STANDARD_DEBIT = new PracticePayCardBrand('mcstandarddebit', "Mastercard Standard Debit");
	static readonly MC_CORPORATE = new PracticePayCardBrand('mccorporate', "Mastercard Corporate");
	static readonly MC_COMMERCIAL_CREDIT = new PracticePayCardBrand('mccommercialcredit', "Mastercard Commercial Credit");
	static readonly MC_COMMERCIAL_DEBIT = new PracticePayCardBrand('mccommercialdebit', "Mastercard Commercial Debit");
	static readonly AMEX = new PracticePayCardBrand('amex', "American Express");
	static readonly AMEX_GOOGLEPAY = new PracticePayCardBrand('amex_googlepay', "Amex (Google Pay)");
	static readonly AMEX_APPLEPAY = new PracticePayCardBrand('amex_applepay', "Amex (Apple Pay)");
	static readonly AMEX_SAMSUNGPAY = new PracticePayCardBrand('amex_samsungpay', "Amex (Samsung Pay)");
	static readonly AMEX_CREDIT = new PracticePayCardBrand('amexcredit', "Amex Credit");
	static readonly AMEX_DEBIT = new PracticePayCardBrand('amexdebit', "Amex Debit");
	static readonly AMEX_COMMERCIAL = new PracticePayCardBrand('amexcommercial', "Amex Commercial");
	static readonly AMEX_CONSUMER = new PracticePayCardBrand('amexconsumer', "Amex Consumer");
	static readonly AMEX_CORPORATE = new PracticePayCardBrand('amexcorporate', "Amex Corporate");
	static readonly AMEX_PREPAID = new PracticePayCardBrand('amexprepaid', "Amex Prepaid");
	static readonly DISCOVER = new PracticePayCardBrand('discover', "Discover");
	static readonly DISCOVER_GOOGLEPAY = new PracticePayCardBrand('discover_googlepay', "Discover (Google Pay)");
	static readonly DISCOVER_APPLEPAY = new PracticePayCardBrand('discover_applepay', "Discover (Apple Pay)");
	static readonly DISCOVER_SAMSUNGPAY = new PracticePayCardBrand('discover_samsungpay', "Discover (Samsung Pay)");
	static readonly DINERS = new PracticePayCardBrand('diners', "Diners Club");
	static readonly JCB = new PracticePayCardBrand('jcb', "JCB");
	static readonly JCB_APPLEPAY = new PracticePayCardBrand('jcb_applepay', "JCB (Apple Pay)");
	static readonly JCB_CREDIT = new PracticePayCardBrand('jcbcredit', "JCB Credit");
	static readonly JCB_DEBIT = new PracticePayCardBrand('jcbdebit', "JCB Debit");
	static readonly JCB_PREPAID = new PracticePayCardBrand('jcbprepaid', "JCB Prepaid");
	static readonly OTHER = new PracticePayCardBrand('other', "Other");
	
	static readonly VALUES: GandalfConstantList<PracticePayCardBrand> = {
		label: 'PracticePay Card Brand',
		values: [PracticePayCardBrand.VISA, PracticePayCardBrand.VISA_GOOGLEPAY, PracticePayCardBrand.VISA_APPLEPAY, PracticePayCardBrand.VISA_SAMSUNGPAY, PracticePayCardBrand.VISA_VIPPS, PracticePayCardBrand.VISA_MOBILEPAY, PracticePayCardBrand.VISA_CREDIT, PracticePayCardBrand.VISA_DEBIT, PracticePayCardBrand.VISA_PLATINUM, PracticePayCardBrand.VISA_GOLD, PracticePayCardBrand.VISA_BUSINESS, PracticePayCardBrand.VISA_CLASSIC, PracticePayCardBrand.VISA_CORPORATE, PracticePayCardBrand.VISA_PREMIUM_CREDIT, PracticePayCardBrand.VISA_PREMIUM_DEBIT, PracticePayCardBrand.VISA_STANDARD_CREDIT, PracticePayCardBrand.VISA_STANDARD_DEBIT, PracticePayCardBrand.ELECTRON, PracticePayCardBrand.ELECTRON_APPLEPAY, PracticePayCardBrand.VPAY, PracticePayCardBrand.MC, PracticePayCardBrand.MC_GOOGLEPAY, PracticePayCardBrand.MC_APPLEPAY, PracticePayCardBrand.MC_SAMSUNGPAY, PracticePayCardBrand.MC_VIPPS, PracticePayCardBrand.MC_MOBILEPAY, PracticePayCardBrand.MC_CREDIT, PracticePayCardBrand.MC_DEBIT, PracticePayCardBrand.MC_PREMIUM_CREDIT, PracticePayCardBrand.MC_PREMIUM_DEBIT, PracticePayCardBrand.MC_STANDARD_CREDIT, PracticePayCardBrand.MC_STANDARD_DEBIT, PracticePayCardBrand.MC_CORPORATE, PracticePayCardBrand.MC_COMMERCIAL_CREDIT, PracticePayCardBrand.MC_COMMERCIAL_DEBIT, PracticePayCardBrand.AMEX, PracticePayCardBrand.AMEX_GOOGLEPAY, PracticePayCardBrand.AMEX_APPLEPAY, PracticePayCardBrand.AMEX_SAMSUNGPAY, PracticePayCardBrand.AMEX_CREDIT, PracticePayCardBrand.AMEX_DEBIT, PracticePayCardBrand.AMEX_COMMERCIAL, PracticePayCardBrand.AMEX_CONSUMER, PracticePayCardBrand.AMEX_CORPORATE, PracticePayCardBrand.AMEX_PREPAID, PracticePayCardBrand.DISCOVER, PracticePayCardBrand.DISCOVER_GOOGLEPAY, PracticePayCardBrand.DISCOVER_APPLEPAY, PracticePayCardBrand.DISCOVER_SAMSUNGPAY, PracticePayCardBrand.DINERS, PracticePayCardBrand.JCB, PracticePayCardBrand.JCB_APPLEPAY, PracticePayCardBrand.JCB_CREDIT, PracticePayCardBrand.JCB_DEBIT, PracticePayCardBrand.JCB_PREPAID, PracticePayCardBrand.OTHER, ]
	};
}

/** see com.rev360.common.practicepay.service.payment.practicepay.PracticePayHorizontalAlign */
/* istanbul ignore next */
export class PracticePayHorizontalAlign extends GandalfConstant<string> {
	static readonly LEFT = new PracticePayHorizontalAlign('left', "Left");
	static readonly CENTER = new PracticePayHorizontalAlign('center', "Center");
	static readonly RIGHT = new PracticePayHorizontalAlign('right', "Right");
	
	static readonly VALUES: GandalfConstantList<PracticePayHorizontalAlign> = {
		label: 'Horizontal Alignment',
		values: [PracticePayHorizontalAlign.LEFT, PracticePayHorizontalAlign.CENTER, PracticePayHorizontalAlign.RIGHT, ]
	};
}

/** see com.rev360.common.practicepay.service.payment.practicepay.PracticePayVerticalAlign */
/* istanbul ignore next */
export class PracticePayVerticalAlign extends GandalfConstant<string> {
	static readonly TOP = new PracticePayVerticalAlign('top', "Top");
	static readonly CENTER = new PracticePayVerticalAlign('center', "Center");
	
	static readonly VALUES: GandalfConstantList<PracticePayVerticalAlign> = {
		label: 'Vertical Alignment',
		values: [PracticePayVerticalAlign.TOP, PracticePayVerticalAlign.CENTER, ]
	};
}

/** see com.rev360.model.practice.practicereportgroupstatus.PracticeReportGroupStatus */
/* istanbul ignore next */
export class PracticeReportGroupStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new PracticeReportGroupStatus(1, "Active");
	static readonly INACTIVE = new PracticeReportGroupStatus(2, "Inactive");
	static readonly DELETED = new PracticeReportGroupStatus(3, "Deleted");
	
	static readonly VALUES: GandalfConstantList<PracticeReportGroupStatus> = {
		label: 'Practice Report Group Status',
		values: [PracticeReportGroupStatus.ACTIVE, PracticeReportGroupStatus.INACTIVE, PracticeReportGroupStatus.DELETED, ]
	};
}

/** see com.rev360.model.practice.constant.Status */
/* istanbul ignore next */
export class PracticeStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new PracticeStatus(0, "Inactive");
	static readonly ACTIVE = new PracticeStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<PracticeStatus> = {
		label: 'Practice Status',
		values: [PracticeStatus.INACTIVE, PracticeStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.document.constant.practicetemplatestatus.PracticeTemplateStatus */
/* istanbul ignore next */
export class PracticeTemplateStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new PracticeTemplateStatus(0, "Active");
	static readonly DELETED = new PracticeTemplateStatus(1, "Deleted");
	static readonly INACTIVE = new PracticeTemplateStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<PracticeTemplateStatus> = {
		label: 'Practice Template Status',
		values: [PracticeTemplateStatus.ACTIVE, PracticeTemplateStatus.DELETED, PracticeTemplateStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.PreferenceDefaults */
/* istanbul ignore next */
export class PreferenceDefaults extends GandalfConstant<string> {
	static readonly OPTIKAM_MEASUREMENTS_ENABLED = new PreferenceDefaults('false', "No");
	static readonly ORDER_EYEGLASS_LAB_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly PRESCRIPTION_MED_EXP_MONTHS = new PreferenceDefaults('12', "12 months");
	static readonly PRESCRIPTION_SPEC_EXP_MONTHS = new PreferenceDefaults('12', "12 months");
	static readonly PRESCRIPTION_CL_EXP_MONTHS = new PreferenceDefaults('12', "12 months");
	static readonly PROVIDER_ALWAYS_USE_SIGNATURE_IMAGE = new PreferenceDefaults('true', "Yes");
	static readonly PROVIDER_EYEGLASS_USE_SIGNATURE_IMAGE = new PreferenceDefaults('false', "No");
	static readonly PROVIDER_CONTACT_LENS_USE_SIGNATURE_IMAGE = new PreferenceDefaults('false', "No");
	static readonly PROVIDER_MEDICATION_USE_SIGNATURE_IMAGE = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_ALLOW_SPLIT_BUTTON = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_ALLOW_DISCOUNT_BUTTON = new PreferenceDefaults('false', "No");
	static readonly ALLOW_ASSIGNING_APPOINTMENT_TO_INVOICE = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_STATEMENTS_FORMAT = new PreferenceDefaults('1', "PDF");
	static readonly ACCOUNTING_TRANSFER_BY_ITEM = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_ALLOW_PORTION_BUTTON = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_ALLOW_REFUND_BUTTON = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_ALLOW_WALK_INS = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_PAY_BY_ITEM = new PreferenceDefaults('required', "Required");
	static readonly CCDA_CLINICALSUMMARY_DEFAULT_SECTIONS = new PreferenceDefaults('<filter><sections><section id="25"/><section id="37"/><section id="16"/><section id="13"/><section id="17"/><section id="18"/><section id="5"/></sections></filter>', "");
	static readonly CCDA_CLINICALSUMMARY_PHR_SECTIONS = new PreferenceDefaults('<filter><sections><section id="25"/><section id="37"/><section id="16"/><section id="13"/><section id="17"/><section id="18"/><section id="5"/></sections></filter>', "");
	static readonly CCDA_PATIENTRECORD_DEFAULT_SECTIONS = new PreferenceDefaults('<filter><sections><section id="12"/><section id="13"/><section id="15"/><section id="19"/><section id="24"/><section id="26"/><section id="38"/><section id="39"/></sections></filter>', "");
	static readonly CCDA_PATIENTRECORD_PHR_SECTIONS = new PreferenceDefaults('<filter><sections><section id="39"/><section id="38"/><section id="26"/><section id="24"/><section id="19"/><section id="15"/><section id="13"/><section id="12"/></sections></filter>', "");
	static readonly CCDA_TRANSITIONOFCARE_DEFAULT_SECTIONS = new PreferenceDefaults('<filter><sections><section id="39"/><section id="38"/><section id="26"/><section id="24"/><section id="19"/><section id="15"/><section id="13"/><section id="12"/></sections></filter>', "");
	static readonly CCDA_TRANSITIONOFCARE_PHR_SECTIONS = new PreferenceDefaults('<filter><sections><section id="39"/><section id="38"/><section id="26"/><section id="24"/><section id="19"/><section id="15"/><section id="13"/><section id="12"/></sections></filter>', "");
	static readonly DEMOGRAPHICS_ADDRESS_REQUIRED = new PreferenceDefaults('true', "Yes");
	static readonly DEMOGRAPHICS_EMPLOYER_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_EMAIL_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_EMPLOYER_CITY_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_EMPLOYMENT_SCHOOL_STATUS_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_SPOKEN_LANGUAGE_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_WRITTEN_LANGUAGE_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_RACE_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_ETHNICITY_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_INTERPRETER_ASSISTANCE_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_ALTERNATEID_ENABLED = new PreferenceDefaults('false', "No");
	static readonly DEMOGRAPHICS_REFERREDBY_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly ENCOUNTER_FORWARD_TEST_NOTES = new PreferenceDefaults('false', "No");
	static readonly ENCOUNTER_ROLES_ENABLED = new PreferenceDefaults('false', "No");
	static readonly VISIOFFICE_MEASUREMENTS_ENABLED = new PreferenceDefaults('false', "No");
	static readonly ORDER_EYEGLASS_MATERIAL_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly ORDER_EYEGLASS_MOUNTINGTYPE_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly ORDER_EYEGLASS_FRAMESOURCEINDICATOR_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly ORDER_EYEGLASS_FRAMESOURCE_REQUIRED = new PreferenceDefaults('false', "No");
	static readonly ORDER_PD_VALIDATION_RULE = new PreferenceDefaults('order.pd.validation.rule.none', "None");
	static readonly RECALL_ASSIGNMENT_OPTION = new PreferenceDefaults('recall.assignment.option.location.and.recall.reason', "Location and Recall Reason");
	static readonly AUTODX_DEFAULT_ASSESSMENT_TAB = new PreferenceDefaults('master', "Master Dx");
	static readonly PFSH_FAMILY_HEALTH_HISTORY_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_PORTAL_DISPLAY_MESSAGING_MESSAGE = new PreferenceDefaults('false', "No");
	static readonly PATIENT_PORTAL_MESSAGING_MESSAGE = new PreferenceDefaults('', "");
	static readonly PHR_PATIENT_CONTACT_LENS_ENABLED = new PreferenceDefaults('false', "No");
	static readonly PRESCRIPTION_MED_PRINT_FILE = new PreferenceDefaults('', "Default Format");
	static readonly PRESCRIPTION_CL_PRINT_FILE = new PreferenceDefaults('', "Default Format");
	static readonly PRESCRIPTION_SPEC_PRINT_FILE = new PreferenceDefaults('', "Default Format");
	static readonly SCHEDULE_LAYOUT = new PreferenceDefaults('horizontal', "Horizontal");
	static readonly SCHEDULE_VIEW = new PreferenceDefaults('day', "Day");
	static readonly SCHEDULE_INCREMENT = new PreferenceDefaults('15', "15 minute increments");
	static readonly SCHEDULE_GROUPING_ENABLED = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_ERA_AUTOPOSTING = new PreferenceDefaults('false', "No");
	static readonly ACCOUNTING_ERA_AUTOPOSTING_PAYMENT_GROUP_LOCATION = new PreferenceDefaults('false', "No");
	static readonly RECALL_LOCATION_MAPPING_ENABLED = new PreferenceDefaults('false', "No");
	static readonly FOCUS_BARCODE_SEARCH_CONTACTLENS = new PreferenceDefaults('false', "No");
	static readonly ONGOINGCARE_DEFAULT_TAB = new PreferenceDefaults('refractions', "Refractive Care");
	static readonly VIEW_ENCOUNTER_TIMER_AND_TOTAL = new PreferenceDefaults('true', "Yes");
	static readonly INCLUDE_TOTAL_PROFESSIONAL_TIME_ON_EXAM_PRINTOUT = new PreferenceDefaults('false', "No");
	static readonly ALLOW_ERA_AUTO_POSTING = new PreferenceDefaults('false', "No");
	static readonly DATE_TIME_DISPLAY_SECONDS = new PreferenceDefaults('false', "No");
	static readonly PATIENT_POD_FAMILYCONTACTS_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_RX_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_EXAMHISTORY_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_ACCOUNT_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_NOTES_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_INSURANCE_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_DIAGNOSISHISTORY_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_RECALL_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_LABORDERS_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_OPTICALORDERS_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_TASKS_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly PATIENT_POD_CONNECT_ENABLED = new PreferenceDefaults('true', "Yes");
	static readonly FHIR_API_ENABLED = new PreferenceDefaults('false', "No");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_COLORS_ENABLED = new PreferenceDefaults('false', "No");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_HIGH = new PreferenceDefaults('24', "24 months");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_LOW = new PreferenceDefaults('12', "12 months");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_OK = new PreferenceDefaults('6', "6 months");
	static readonly TWO_WAY_TEXT_NOTIFICATIONS = new PreferenceDefaults('false', "No");
	static readonly AI_SCRIBE_ENABLED = new PreferenceDefaults('false', "No");
	
	static readonly VALUES: GandalfConstantList<PreferenceDefaults> = {
		label: 'PreferenceDefaults',
		values: [PreferenceDefaults.OPTIKAM_MEASUREMENTS_ENABLED, PreferenceDefaults.ORDER_EYEGLASS_LAB_REQUIRED, PreferenceDefaults.PRESCRIPTION_MED_EXP_MONTHS, PreferenceDefaults.PRESCRIPTION_SPEC_EXP_MONTHS, PreferenceDefaults.PRESCRIPTION_CL_EXP_MONTHS, PreferenceDefaults.PROVIDER_ALWAYS_USE_SIGNATURE_IMAGE, PreferenceDefaults.PROVIDER_EYEGLASS_USE_SIGNATURE_IMAGE, PreferenceDefaults.PROVIDER_CONTACT_LENS_USE_SIGNATURE_IMAGE, PreferenceDefaults.PROVIDER_MEDICATION_USE_SIGNATURE_IMAGE, PreferenceDefaults.ACCOUNTING_ALLOW_SPLIT_BUTTON, PreferenceDefaults.ACCOUNTING_ALLOW_DISCOUNT_BUTTON, PreferenceDefaults.ALLOW_ASSIGNING_APPOINTMENT_TO_INVOICE, PreferenceDefaults.ACCOUNTING_STATEMENTS_FORMAT, PreferenceDefaults.ACCOUNTING_TRANSFER_BY_ITEM, PreferenceDefaults.ACCOUNTING_ALLOW_PORTION_BUTTON, PreferenceDefaults.ACCOUNTING_ALLOW_REFUND_BUTTON, PreferenceDefaults.ACCOUNTING_ALLOW_WALK_INS, PreferenceDefaults.ACCOUNTING_PAY_BY_ITEM, PreferenceDefaults.CCDA_CLINICALSUMMARY_DEFAULT_SECTIONS, PreferenceDefaults.CCDA_CLINICALSUMMARY_PHR_SECTIONS, PreferenceDefaults.CCDA_PATIENTRECORD_DEFAULT_SECTIONS, PreferenceDefaults.CCDA_PATIENTRECORD_PHR_SECTIONS, PreferenceDefaults.CCDA_TRANSITIONOFCARE_DEFAULT_SECTIONS, PreferenceDefaults.CCDA_TRANSITIONOFCARE_PHR_SECTIONS, PreferenceDefaults.DEMOGRAPHICS_ADDRESS_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_EMPLOYER_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_EMAIL_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_EMPLOYER_CITY_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_EMPLOYMENT_SCHOOL_STATUS_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_SPOKEN_LANGUAGE_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_WRITTEN_LANGUAGE_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_RACE_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_ETHNICITY_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_INTERPRETER_ASSISTANCE_REQUIRED, PreferenceDefaults.DEMOGRAPHICS_ALTERNATEID_ENABLED, PreferenceDefaults.DEMOGRAPHICS_REFERREDBY_REQUIRED, PreferenceDefaults.ENCOUNTER_FORWARD_TEST_NOTES, PreferenceDefaults.ENCOUNTER_ROLES_ENABLED, PreferenceDefaults.VISIOFFICE_MEASUREMENTS_ENABLED, PreferenceDefaults.ORDER_EYEGLASS_MATERIAL_REQUIRED, PreferenceDefaults.ORDER_EYEGLASS_MOUNTINGTYPE_REQUIRED, PreferenceDefaults.ORDER_EYEGLASS_FRAMESOURCEINDICATOR_REQUIRED, PreferenceDefaults.ORDER_EYEGLASS_FRAMESOURCE_REQUIRED, PreferenceDefaults.ORDER_PD_VALIDATION_RULE, PreferenceDefaults.RECALL_ASSIGNMENT_OPTION, PreferenceDefaults.AUTODX_DEFAULT_ASSESSMENT_TAB, PreferenceDefaults.PFSH_FAMILY_HEALTH_HISTORY_ENABLED, PreferenceDefaults.PATIENT_PORTAL_DISPLAY_MESSAGING_MESSAGE, PreferenceDefaults.PATIENT_PORTAL_MESSAGING_MESSAGE, PreferenceDefaults.PHR_PATIENT_CONTACT_LENS_ENABLED, PreferenceDefaults.PRESCRIPTION_MED_PRINT_FILE, PreferenceDefaults.PRESCRIPTION_CL_PRINT_FILE, PreferenceDefaults.PRESCRIPTION_SPEC_PRINT_FILE, PreferenceDefaults.SCHEDULE_LAYOUT, PreferenceDefaults.SCHEDULE_VIEW, PreferenceDefaults.SCHEDULE_INCREMENT, PreferenceDefaults.SCHEDULE_GROUPING_ENABLED, PreferenceDefaults.ACCOUNTING_ERA_AUTOPOSTING, PreferenceDefaults.ACCOUNTING_ERA_AUTOPOSTING_PAYMENT_GROUP_LOCATION, PreferenceDefaults.RECALL_LOCATION_MAPPING_ENABLED, PreferenceDefaults.FOCUS_BARCODE_SEARCH_CONTACTLENS, PreferenceDefaults.ONGOINGCARE_DEFAULT_TAB, PreferenceDefaults.VIEW_ENCOUNTER_TIMER_AND_TOTAL, PreferenceDefaults.INCLUDE_TOTAL_PROFESSIONAL_TIME_ON_EXAM_PRINTOUT, PreferenceDefaults.ALLOW_ERA_AUTO_POSTING, PreferenceDefaults.DATE_TIME_DISPLAY_SECONDS, PreferenceDefaults.PATIENT_POD_FAMILYCONTACTS_ENABLED, PreferenceDefaults.PATIENT_POD_RX_ENABLED, PreferenceDefaults.PATIENT_POD_EXAMHISTORY_ENABLED, PreferenceDefaults.PATIENT_POD_ACCOUNT_ENABLED, PreferenceDefaults.PATIENT_POD_NOTES_ENABLED, PreferenceDefaults.PATIENT_POD_INSURANCE_ENABLED, PreferenceDefaults.PATIENT_POD_DIAGNOSISHISTORY_ENABLED, PreferenceDefaults.PATIENT_POD_RECALL_ENABLED, PreferenceDefaults.PATIENT_POD_LABORDERS_ENABLED, PreferenceDefaults.PATIENT_POD_OPTICALORDERS_ENABLED, PreferenceDefaults.PATIENT_POD_TASKS_ENABLED, PreferenceDefaults.PATIENT_POD_CONNECT_ENABLED, PreferenceDefaults.FHIR_API_ENABLED, PreferenceDefaults.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_COLORS_ENABLED, PreferenceDefaults.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_HIGH, PreferenceDefaults.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_LOW, PreferenceDefaults.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_OK, PreferenceDefaults.TWO_WAY_TEXT_NOTIFICATIONS, PreferenceDefaults.AI_SCRIBE_ENABLED, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.PreferenceName */
/* istanbul ignore next */
export class PreferenceName extends GandalfConstant<string> {
	static readonly ACCOUNTING_ALLOW_DISCOUNT_BUTTON = new PreferenceName('accounting.allow.discount.button', "Allow Discount Button");
	static readonly ACCOUNTING_ALLOW_INVOICE_APPOINTMENT = new PreferenceName('accounting.allow.invoice.appointment', "Assigning Appointment to Invoice");
	static readonly ACCOUNTING_ALLOW_PORTION_BUTTON = new PreferenceName('accounting.allow.portion.button', "Allow Patient Portion Button");
	static readonly ACCOUNTING_ALLOW_REFUND_BUTTON = new PreferenceName('accounting.allow.refund.button', "Allow Issue Refund Button");
	static readonly ACCOUNTING_ALLOW_SPLIT_BUTTON = new PreferenceName('accounting.allow.split.button', "Allow Split Button");
	static readonly ACCOUNTING_ALLOW_WALK_INS = new PreferenceName('accounting.allow.walk.ins', "Allow Walk-ins");
	static readonly ACCOUNTING_ERA_AUTOPOSTING = new PreferenceName('accounting.era.autoposting', "Allow ERA Auto-posting");
	static readonly ACCOUNTING_INV_HIDE_ADJUSTMENTS = new PreferenceName('accounting.inv.hide.adjustments', "Hide adjustments on receipts");
	static readonly ACCOUNTING_INV_HIDE_TIN = new PreferenceName('accounting.inv.hide.tin', "Hide tax identification number (TIN)");
	static readonly ACCOUNTING_INVOICE_MESSAGE = new PreferenceName('accounting.invoice.message', "Invoice message");
	static readonly ACCOUNTING_INVOICE_TRANSFER_ITEMS_DEFAULT_INCLUDE_ALL_ITEMS = new PreferenceName('accounting.invoice.transfer.items.default.include.all.items', "Include All Items for Transfer Items");
	static readonly ACCOUNTING_PAY_BY_ITEM = new PreferenceName('accounting.pay.by.item', "Payment by line item");
	static readonly ACCOUNTING_REP_HIDE_CHART = new PreferenceName('accounting.rep.hide.chart', "Hide charts on reports");
	static readonly ACCOUNTING_STATEMENTS_FORMAT = new PreferenceName('accounting.statements.format', "Statements Format");
	static readonly ACCOUNTING_TRANSFER_BY_ITEM = new PreferenceName('accounting.transfer.by.item', "Use Item Transfers on Payments");
	static readonly ACCOUNTING_ERA_AUTOPOSTING_PAYMENT_GROUP_LOCATION = new PreferenceName('autoposting.payment.group.location', "ERA Auto-Posting Payment Location Consolidation");
	static readonly ADDRESS_PRINT_UPPER_CASE = new PreferenceName('address.print.upper.case', "Print address labels in upper case");
	static readonly ALLOW_ERA_AUTO_POSTING = new PreferenceName('allow.era.autoposting', "Allow ERA Auto-Posting");
	static readonly AUDIT_REPORT_PAGING_ENABLED = new PreferenceName('audit.report.paging.enabled', "Enable Audit Report Paging");
	static readonly AUTODX_DEFAULT_ASSESSMENT_TAB = new PreferenceName('autodx.default.assessment.tab', "Default tab for Assessment Screen");
	static readonly AUTODX_MASTER_RULESET_ID = new PreferenceName('autodx.master.ruleset.id', "Rule Set for Auto-Dx");
	static readonly AUTOMATOR_VSP_ELIGIBILITY_ENABLED = new PreferenceName('automator.vsp.eligibility.enabled', "Enable Eyefinity Automation");
	static readonly BARCODE_PRINTER_INTEGRATION = new PreferenceName('barcode.printer.integration', "Use Barcode Printing Integration");
	static readonly BULK_PRODUCT_PRICE_STYLE = new PreferenceName('bulk.product.price.style', "Bulk Product Price Style");
	static readonly CCDA_CLINICALSUMMARY_DEFAULT_FOLDER = new PreferenceName('ccda.clinicalsummary.default.folder', "Clinical Summary Default Folder");
	static readonly CCDA_CLINICALSUMMARY_DEFAULT_SECTIONS = new PreferenceName('ccda.clinicalsummary.default.sections', "Clinical Summary Default Sections");
	static readonly CCDA_CLINICALSUMMARY_PHR_FOLDER = new PreferenceName('ccda.clinicalsummary.phr.folder', "PHR Clinical Summary Default Folder");
	static readonly CCDA_CLINICALSUMMARY_PHR_SECTIONS = new PreferenceName('ccda.clinicalsummary.phr.sections', "PHR Clinical Summary Default Sections");
	static readonly CCDA_PATIENTRECORD_DEFAULT_FOLDER = new PreferenceName('ccda.patientrecord.default.folder', "Patient Record Default Folder");
	static readonly CCDA_PATIENTRECORD_DEFAULT_SECTIONS = new PreferenceName('ccda.patientrecord.default.sections', "Patient Record Default Sections");
	static readonly CCDA_PATIENTRECORD_PHR_FOLDER = new PreferenceName('ccda.patientrecord.phr.folder', "PHR Patient Record Default Folder");
	static readonly CCDA_PATIENTRECORD_PHR_SECTIONS = new PreferenceName('ccda.patientrecord.phr.sections', "PHR Patient Record Sections");
	static readonly CCDA_TRANSITIONOFCARE_DEFAULT_FOLDER = new PreferenceName('ccda.transitionofcare.default.folder', "Transition of Care Default Folder");
	static readonly CCDA_TRANSITIONOFCARE_DEFAULT_SECTIONS = new PreferenceName('ccda.transitionofcare.default.sections', "Transition of Care Default Sections");
	static readonly CCDA_TRANSITIONOFCARE_PHR_FOLDER = new PreferenceName('ccda.transitionofcare.phr.folder', "PHR Transition of Care Default Folder");
	static readonly CCDA_TRANSITIONOFCARE_PHR_SECTIONS = new PreferenceName('ccda.transitionofcare.phr.sections', "PHR Transition of Care Default Sections");
	static readonly DATE_TIME_DISPLAY_SECONDS = new PreferenceName('date.time.display.seconds', "Display seconds in the Date/Time display");
	static readonly DEMOGRAPHICS_ADDRESS_REQUIRED = new PreferenceName('demographics.address.required', "Require Address");
	static readonly DEMOGRAPHICS_ALTERNATEID_ENABLED = new PreferenceName('demographics.alternateId.enabled', "Enable AlternateId");
	static readonly DEMOGRAPHICS_EMAIL_REQUIRED = new PreferenceName('demographics.email.required', "Require Email");
	static readonly DEMOGRAPHICS_EMPLOYER_CITY_REQUIRED = new PreferenceName('demographics.employer.city.required', "Require Employer City");
	static readonly DEMOGRAPHICS_EMPLOYER_REQUIRED = new PreferenceName('demographics.employer.required', "Require Employer");
	static readonly DEMOGRAPHICS_EMPLOYMENT_SCHOOL_STATUS_REQUIRED = new PreferenceName('demographics.employment.school.status.required', "Require Employment/School status");
	static readonly DEMOGRAPHICS_ETHNICITY_REQUIRED = new PreferenceName('demographics.ethnicity.required', "Require Ethnicity");
	static readonly DEMOGRAPHICS_INTERPRETER_ASSISTANCE_REQUIRED = new PreferenceName('demographics.interpreter.assistance.required', "Require Interpreter Assistance");
	static readonly DEMOGRAPHICS_SPOKEN_LANGUAGE_REQUIRED = new PreferenceName('demographics.language.required', "Require Spoken Language");
	static readonly DEMOGRAPHICS_WRITTEN_LANGUAGE_REQUIRED = new PreferenceName('demographics.written.language.required', "Require Written Language");
	static readonly DEMOGRAPHICS_RACE_REQUIRED = new PreferenceName('demographics.race.required', "Require Race");
	static readonly DEMOGRAPHICS_REFERREDBY_REQUIRED = new PreferenceName('demographics.referredBy.required', "Require Referred By");
	static readonly DOCUMENTS_DISPLAY_DETAILED_VIEW = new PreferenceName('documents.display.detailed.view', "Display documents in detailed view");
	static readonly EMPLOYEE_CCDA_DISPLAY = new PreferenceName('employee.ccda.display', "C-CDA Display");
	static readonly ENCOUNTER_FORWARD_TEST_NOTES = new PreferenceName('encounter.forward.test.notes', "Bring forward test notes");
	static readonly ENCOUNTER_INCL_INTERPRETER_ON_PRINTOUT = new PreferenceName('encounter.incl.interpreter.on.printout', "Include Interpreter Assistance on exam printout");
	static readonly ENCOUNTER_INCL_LANGUAGE_ON_PRINTOUT = new PreferenceName('encounter.incl.language.on.printout', "Include Language on exam printout");
	static readonly ENCOUNTER_INCL_RACE_ON_PRINTOUT = new PreferenceName('encounter.incl.race.on.printout', "Include Race on exam printout");
	static readonly ENCOUNTER_ROLES_ENABLED = new PreferenceName('encounter.roles.enabled', "Enable Encounter Roles/Ancillary Participants");
	static readonly ENCOUNTER_TEST_HISTORY_GRID = new PreferenceName('encounter.test.history.grid', "Display test history in grid view");
	static readonly FAX_NUMBER_IN_PRINT_PRESCRIPTIONS = new PreferenceName('prescription.print.fax', "Include fax number");
	static readonly FOCUS_BARCODE_SEARCH_CONTACTLENS = new PreferenceName('focus.barcode.search.contactlens', "Focus when searching Contact Lens");
	static readonly FOCUS_BARCODE_SEARCH_EYEGLASSLENS = new PreferenceName('focus.barcode.search.eyeglasslens', "Focus when searching Eyeglass Lens");
	static readonly FOCUS_BARCODE_SEARCH_FRAMES = new PreferenceName('focus.barcode.search.frames', "Focus when searching Frames");
	static readonly FOCUS_BARCODE_SEARCH_LENSTREATMENTS = new PreferenceName('focus.barcode.search.lenstreatments', "Focus when searching Lens Treatments");
	static readonly FOCUS_BARCODE_SEARCH_MISC = new PreferenceName('focus.barcode.search.misc', "Focus when searching miscellaneous items");
	static readonly IMAGING_AUTOMATIC_OPEN_ENABLED = new PreferenceName('imaging.automatic.open.enabled', "Enable Imaging");
	static readonly VIEW_ENCOUNTER_TIMER_AND_TOTAL = new PreferenceName('view.encounter.timer.and.total', "View Encounter Timer and Total");
	static readonly INCLUDE_TOTAL_PROFESSIONAL_TIME_ON_EXAM_PRINTOUT = new PreferenceName('include.total.professional.time.on.exam.printout', "Include Total Professional Time on exam printout");
	static readonly INVENTORY_MANAGEMENT_ENABLED = new PreferenceName('inventory.management.enabled', "Enable Inventory Management");
	static readonly INVENTORY_QUANTITY_REASON_REQUIRED = new PreferenceName('inventory.quantity.reason.required', "Require Inventory Quantity Reason");
	static readonly IP_ACCESS_RULES_ENABLED = new PreferenceName('ip.access.rules.enabled', "Enable IP Access Rules");
	static readonly MED_SCREEN_AUTO_WIDTH = new PreferenceName('med.screen.auto.width', "Auto change screen width");
	static readonly MED_SCREEN_ORIENTATION = new PreferenceName('med.screen.orientation', "Screen Orientation");
	static readonly NWPD_20_20_EXPORT_ENABLED = new PreferenceName('NWPD.20.20.export.enabled', "Enable 20/20 Export");
	static readonly ONGOINGCARE_DEFAULT_TAB = new PreferenceName('ongoingcare.default.tab', "Ongoing Care Default Tab");
	static readonly OPTICAL_SUMMARY_DEFAULT_VIEW = new PreferenceName('optical.summary.default.view', "Optical Summary Default View");
	static readonly OPTIKAM_MEASUREMENTS_ENABLED = new PreferenceName('optikam.measurements.enabled', "Enable Optikam Integration");
	static readonly OPTOMAP_EXPORT_ENABLED = new PreferenceName('optomap.export.enabled', "Enable Optomap Export");
	static readonly OPTOVUE_REVUE_EXPORT_ENABLED = new PreferenceName('optovue.revue.export.enabled', "Enable Optovue Export");
	static readonly ORDER_APPROVAL_VALIDATION_ENABLED = new PreferenceName('order.approval.validation.enabled', "Validate order before approval");
	static readonly ORDER_COSTS_ENABLED = new PreferenceName('order.costs.enabled', "Enable Order Costs Tab");
	static readonly ORDER_EYEGLASS_FRAMESOURCE_REQUIRED = new PreferenceName('order.eyeglass.frameSource.required', "Require Frame Source");
	static readonly ORDER_EYEGLASS_FRAMESOURCEINDICATOR_REQUIRED = new PreferenceName('order.eyeglass.frameSourceIndicator.required', "Require Frame Source Indicator");
	static readonly ORDER_EYEGLASS_LAB_REQUIRED = new PreferenceName('order.eyeglass.lab.required', "Require Lab Name");
	static readonly ORDER_EYEGLASS_MATERIAL_REQUIRED = new PreferenceName('order.eyeglass.material.required', "Require Material");
	static readonly ORDER_EYEGLASS_MOUNTINGTYPE_REQUIRED = new PreferenceName('order.eyeglass.mountingType.required', "Require Mounting Type");
	static readonly ORDER_PD_VALIDATION_RULE = new PreferenceName('order.pd.validation.rule', "PD Validation");
	static readonly PAT_SUMM_ADDL_MESSAGE = new PreferenceName('pat.summ.addl.message', "Additional message");
	static readonly PAT_SUMM_INCLUDE_PAT_BENEFITS = new PreferenceName('pat.summ.include.pat.benefits', "Include patient benefits");
	static readonly PATIENT_POD_ACCOUNT_ENABLED = new PreferenceName('patient.pod.account.enabled', "Show Account Pod");
	static readonly PATIENT_POD_CONNECT_ENABLED = new PreferenceName('patient.pod.connect.enabled', "Show RevConnect Pod");
	static readonly PATIENT_POD_DEMOGRAPHICS_ENABLED = new PreferenceName('patient.pod.demographics.enabled', "Show Demographics Pod");
	static readonly PATIENT_POD_DIAGNOSISHISTORY_ENABLED = new PreferenceName('patient.pod.diagnosishistory.enabled', "Show Diagnosis History Pod");
	static readonly PATIENT_POD_EXAMHISTORY_ENABLED = new PreferenceName('patient.pod.examhistory.enabled', "Show Exam History Pod");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_COLORS_ENABLED = new PreferenceName('patient.pod.family.contacts.comp.enc.colors.enabled', "Highlight Last Comprehensive Encounter");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_HIGH = new PreferenceName('patient.pod.family.contacts.comp.enc.range.high', "Date range for ORANGE highlight");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_LOW = new PreferenceName('patient.pod.family.contacts.comp.enc.range.low', "Date range for BLUE highlight");
	static readonly PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_OK = new PreferenceName('patient.pod.family.contacts.comp.enc.range.ok', "Date range for GREEN highlight");
	static readonly PATIENT_POD_FAMILYCONTACTS_ENABLED = new PreferenceName('patient.pod.familycontacts.enabled', "Show Family/Contacts Pod");
	static readonly PATIENT_POD_INSURANCE_ENABLED = new PreferenceName('patient.pod.insurance.enabled', "Show Insurance Pod");
	static readonly PATIENT_POD_LABORDERS_ENABLED = new PreferenceName('patient.pod.laborders.enabled', "Show Orders-Medical Pod");
	static readonly PATIENT_POD_NOTES_ENABLED = new PreferenceName('patient.pod.notes.enabled', "Show Notes Pod");
	static readonly PATIENT_POD_OPTICALORDERS_ENABLED = new PreferenceName('patient.pod.opticalorders.enabled', "Show Orders-Optical Pod");
	static readonly PATIENT_POD_RECALL_ENABLED = new PreferenceName('patient.pod.recall.enabled', "Show Recall Pod");
	static readonly PATIENT_POD_RX_ENABLED = new PreferenceName('patient.pod.rx.enabled', "Show Rx Pod");
	static readonly PATIENT_POD_TASKS_ENABLED = new PreferenceName('patient.pod.tasks.enabled', "Show Tasks Pod");
	static readonly PATIENTS_DEFAULT_SUMMARY_VIEW = new PreferenceName('patients.default.summary.view', "Patients Default Summary View");
	static readonly PFSH_FAMILY_HEALTH_HISTORY_ENABLED = new PreferenceName('pfsh.family.health.history.enabled', "Enable PFSH Family Health History");
	static readonly PHR_PATIENT_CONTACT_LENS_ENABLED = new PreferenceName('phr.patient.contact.lens.enabled', "Include patient contact lens Rx in PHR");
	static readonly PATIENT_PORTAL_DISPLAY_MESSAGING_MESSAGE = new PreferenceName('patient.portal.display.messaging.message', "Display Message to Patient");
	static readonly PATIENT_PORTAL_MESSAGING_MESSAGE = new PreferenceName('patient.portal.messaging.message', "Message to Patient");
	static readonly PHR_PATIENT_EDIT_ENABLED = new PreferenceName('phr.patient.edit.enabled', "Allow patients to edit demographics");
	static readonly PHR_PATIENT_EYEGLASS_RX_ENABLED = new PreferenceName('phr.patient.eyeglass.rx.enabled', "Include patient eyeglass Rx in PHR");
	static readonly PHR_PATIENT_RECALLS_ENABLED = new PreferenceName('phr.patient.recalls.enabled', "Include recalls in the PHR");
	static readonly PHR_PATIENT_SUMMARIES_DISABLED = new PreferenceName('phr.patient.summaries.disabled', "Disable patient record/clinical summaries in PHR");
	static readonly PRACTICE_INVOICE_FREEZE_DATE = new PreferenceName('practice.invoice.freeze.date', "Invoice Freeze Date");
	static readonly PRESCRIPTION_CL_CUSTOM_MSG = new PreferenceName('prescription.cl.custom.msg', "Contact Lens Rx message");
	static readonly PRESCRIPTION_CL_EXP_MONTHS = new PreferenceName('prescription.cl.exp.months', "Contact Lens Rx expiration");
	static readonly PRESCRIPTION_CL_PRINT_FILE = new PreferenceName('prescription.cl.print.file', "Contact Lens Rx print format");
	static readonly PRESCRIPTION_MED_EXP_MONTHS = new PreferenceName('prescription.med.exp.months', "Med Rx expiration");
	static readonly PRESCRIPTION_MED_INCLUDE_NPI = new PreferenceName('prescription.med.include.npi', "Display NPI on Med Rx");
	static readonly PRESCRIPTION_MED_PRINT_FILE = new PreferenceName('prescription.med.print.file', "Med Rx print format");
	static readonly PRESCRIPTION_SPEC_CUSTOM_MSG = new PreferenceName('prescription.spec.custom.msg', "Eyeglass Rx message");
	static readonly PRESCRIPTION_SPEC_EXP_MONTHS = new PreferenceName('prescription.spec.exp.months', "Eyeglass Rx expiration");
	static readonly PRESCRIPTION_SPEC_PRINT_FILE = new PreferenceName('prescription.spec.print.file', "Eyeglass Rx print format");
	static readonly PRODUCT_LABEL_LAST_BARCODE_SOURCE = new PreferenceName('product.label.last.barcode.source', "Barcode Label Source");
	static readonly PRODUCT_LABEL_LAST_ELEMENT_IDS = new PreferenceName('product.label.last.element.ids', "Barcode Label ElementIds");
	static readonly PRODUCT_LABEL_LAST_FORMAT_PRICE = new PreferenceName('product.label.last.format.price', "Barcode Label Format Price");
	static readonly PRODUCT_LABEL_LAST_LABEL_ID = new PreferenceName('product.label.last.label.id', "Barcode Label Id");
	static readonly PRODUCT_LABEL_LAST_SHEET_COLUMN = new PreferenceName('product.label.last.sheet.column', "Barcode Label Sheet Column");
	static readonly PRODUCT_LABEL_LAST_SHEET_ROW = new PreferenceName('product.label.last.sheet.row', "Barcode Label Sheet Row");
	static readonly PROVIDER_ALWAYS_USE_SIGNATURE_IMAGE = new PreferenceName('provider.always.use.signature.image', "Always use my signature image on Rx printouts");
	static readonly PROVIDER_EYEGLASS_USE_SIGNATURE_IMAGE = new PreferenceName('provider.eyeglass.use.signature.image', "Use signature image on Eyeglass Rx printouts");
	static readonly PROVIDER_CONTACT_LENS_USE_SIGNATURE_IMAGE = new PreferenceName('provider.contact.lens.use.signature.image', "Use signature image on Contact Lens Rx printouts");
	static readonly PROVIDER_MEDICATION_USE_SIGNATURE_IMAGE = new PreferenceName('provider.medication.use.signature.image', "Use signature image on Medication Rx printouts");
	static readonly RECALL_ASSIGNMENT_OPTION = new PreferenceName('recall.assignment.option', "Recalls assigned based on");
	static readonly RECALL_LOCATION_MAPPING_ENABLED = new PreferenceName('recall.location.mapping.enabled', "Allow assigning a location to a recall");
	static readonly REMOVE_USERNAME_ON_LOGOUT = new PreferenceName('remove.username.on.logout', "Remove username on logout");
	static readonly VSP_PRODUCT_CATALOG_ENABLED = new PreferenceName('revassistant.rx.lens.details.enabled', "Enable VSP Product Catalog");
	static readonly REV_INTEGRATOR_EXPORT_ENABLED = new PreferenceName('revIntegrator.export.enabled', "Enable RevIntegrator HL7 Export");
	static readonly SCANNING_ENABLED = new PreferenceName('scanning.enabled', "Enable Scanning Integration");
	static readonly FHIR_API_ENABLED = new PreferenceName('fhir.api.enabled', "Enable FHIR API Integration");
	static readonly SCHEDULE_BUSY_TIME = new PreferenceName('schedule.busy.time', "Validate busy times");
	static readonly SCHEDULE_EMPLOYEE_HOURS = new PreferenceName('schedule.employee.hours', "Validate employee hours");
	static readonly SCHEDULE_LAYOUT = new PreferenceName('schedule.layout', "Schedule Layout");
	static readonly SCHEDULE_VIEW = new PreferenceName('schedule.view', "Schedule View");
	static readonly SCHEDULE_INCREMENT = new PreferenceName('schedule.increment', "Schedule Increment");
	static readonly SCHEDULE_GROUPING_ENABLED = new PreferenceName('schedule.grouping.enabled', "Schedule grouping");
	static readonly SCHEDULE_MULTIPLE_ACTIVE_APPOINTMENTS = new PreferenceName('schedule.multiple.active.appointments', "Validate duplicate appointments");
	static readonly SCHEDULE_MY_PATIENTS_ONLY = new PreferenceName('schedule.my.patients.only', "Today's list shows my patients only");
	static readonly SCHEDULE_OFFICE_HOURS = new PreferenceName('schedule.office.hours', "Validate office hours");
	static readonly SCHEDULE_VALIDATION_ENABLED = new PreferenceName('schedule.validation.enabled', "Validate appointment times");
	static readonly SCHEDULEPOD_TAB = new PreferenceName('schedulepod.tab', "Schedule Pod Default Tab");
	static readonly STEPPERS_TEXT_ENABLED = new PreferenceName('steppers.text.enabled', "Enable stepper text");
	static readonly TOAST_MESSAGES_DURATION = new PreferenceName('toast.messages.duration', "Banner Message Duration");
	static readonly TOAST_MESSAGES_ENABLED = new PreferenceName('toast.messages.enabled', "Banner Message Enabled");
	static readonly TOAST_MESSAGES_POSITION = new PreferenceName('toast.messages.position', "Banner Message Position");
	static readonly TWO_WAY_TEXT_NOTIFICATIONS = new PreferenceName('two.way.text.notifications', "Two-Way Text Notifications");
	static readonly VISIOFFICE_MEASUREMENTS_ENABLED = new PreferenceName('visioffice.measurements.enabled', "Enable VisiOffice / m'eyeFit Integration");
	static readonly VW_TRANSMIT_NEW_ORDERS_ENABLED = new PreferenceName('vw.transmit.new.orders.enabled', "VisionWeb Transmit");
	static readonly ZEISS_FORUM_ENABLED = new PreferenceName('zeiss.forum.enabled', "Enable Zeiss Forum");
	static readonly AI_SCRIBE_ENABLED = new PreferenceName('ai.scribe.enabled', "Enable AI Scribe");
	
	static readonly VALUES: GandalfConstantList<PreferenceName> = {
		label: 'Brief description of preference',
		values: [PreferenceName.ACCOUNTING_ALLOW_DISCOUNT_BUTTON, PreferenceName.ACCOUNTING_ALLOW_INVOICE_APPOINTMENT, PreferenceName.ACCOUNTING_ALLOW_PORTION_BUTTON, PreferenceName.ACCOUNTING_ALLOW_REFUND_BUTTON, PreferenceName.ACCOUNTING_ALLOW_SPLIT_BUTTON, PreferenceName.ACCOUNTING_ALLOW_WALK_INS, PreferenceName.ACCOUNTING_ERA_AUTOPOSTING, PreferenceName.ACCOUNTING_INV_HIDE_ADJUSTMENTS, PreferenceName.ACCOUNTING_INV_HIDE_TIN, PreferenceName.ACCOUNTING_INVOICE_MESSAGE, PreferenceName.ACCOUNTING_INVOICE_TRANSFER_ITEMS_DEFAULT_INCLUDE_ALL_ITEMS, PreferenceName.ACCOUNTING_PAY_BY_ITEM, PreferenceName.ACCOUNTING_REP_HIDE_CHART, PreferenceName.ACCOUNTING_STATEMENTS_FORMAT, PreferenceName.ACCOUNTING_TRANSFER_BY_ITEM, PreferenceName.ACCOUNTING_ERA_AUTOPOSTING_PAYMENT_GROUP_LOCATION, PreferenceName.ADDRESS_PRINT_UPPER_CASE, PreferenceName.ALLOW_ERA_AUTO_POSTING, PreferenceName.AUDIT_REPORT_PAGING_ENABLED, PreferenceName.AUTODX_DEFAULT_ASSESSMENT_TAB, PreferenceName.AUTODX_MASTER_RULESET_ID, PreferenceName.AUTOMATOR_VSP_ELIGIBILITY_ENABLED, PreferenceName.BARCODE_PRINTER_INTEGRATION, PreferenceName.BULK_PRODUCT_PRICE_STYLE, PreferenceName.CCDA_CLINICALSUMMARY_DEFAULT_FOLDER, PreferenceName.CCDA_CLINICALSUMMARY_DEFAULT_SECTIONS, PreferenceName.CCDA_CLINICALSUMMARY_PHR_FOLDER, PreferenceName.CCDA_CLINICALSUMMARY_PHR_SECTIONS, PreferenceName.CCDA_PATIENTRECORD_DEFAULT_FOLDER, PreferenceName.CCDA_PATIENTRECORD_DEFAULT_SECTIONS, PreferenceName.CCDA_PATIENTRECORD_PHR_FOLDER, PreferenceName.CCDA_PATIENTRECORD_PHR_SECTIONS, PreferenceName.CCDA_TRANSITIONOFCARE_DEFAULT_FOLDER, PreferenceName.CCDA_TRANSITIONOFCARE_DEFAULT_SECTIONS, PreferenceName.CCDA_TRANSITIONOFCARE_PHR_FOLDER, PreferenceName.CCDA_TRANSITIONOFCARE_PHR_SECTIONS, PreferenceName.DATE_TIME_DISPLAY_SECONDS, PreferenceName.DEMOGRAPHICS_ADDRESS_REQUIRED, PreferenceName.DEMOGRAPHICS_ALTERNATEID_ENABLED, PreferenceName.DEMOGRAPHICS_EMAIL_REQUIRED, PreferenceName.DEMOGRAPHICS_EMPLOYER_CITY_REQUIRED, PreferenceName.DEMOGRAPHICS_EMPLOYER_REQUIRED, PreferenceName.DEMOGRAPHICS_EMPLOYMENT_SCHOOL_STATUS_REQUIRED, PreferenceName.DEMOGRAPHICS_ETHNICITY_REQUIRED, PreferenceName.DEMOGRAPHICS_INTERPRETER_ASSISTANCE_REQUIRED, PreferenceName.DEMOGRAPHICS_SPOKEN_LANGUAGE_REQUIRED, PreferenceName.DEMOGRAPHICS_WRITTEN_LANGUAGE_REQUIRED, PreferenceName.DEMOGRAPHICS_RACE_REQUIRED, PreferenceName.DEMOGRAPHICS_REFERREDBY_REQUIRED, PreferenceName.DOCUMENTS_DISPLAY_DETAILED_VIEW, PreferenceName.EMPLOYEE_CCDA_DISPLAY, PreferenceName.ENCOUNTER_FORWARD_TEST_NOTES, PreferenceName.ENCOUNTER_INCL_INTERPRETER_ON_PRINTOUT, PreferenceName.ENCOUNTER_INCL_LANGUAGE_ON_PRINTOUT, PreferenceName.ENCOUNTER_INCL_RACE_ON_PRINTOUT, PreferenceName.ENCOUNTER_ROLES_ENABLED, PreferenceName.ENCOUNTER_TEST_HISTORY_GRID, PreferenceName.FAX_NUMBER_IN_PRINT_PRESCRIPTIONS, PreferenceName.FOCUS_BARCODE_SEARCH_CONTACTLENS, PreferenceName.FOCUS_BARCODE_SEARCH_EYEGLASSLENS, PreferenceName.FOCUS_BARCODE_SEARCH_FRAMES, PreferenceName.FOCUS_BARCODE_SEARCH_LENSTREATMENTS, PreferenceName.FOCUS_BARCODE_SEARCH_MISC, PreferenceName.IMAGING_AUTOMATIC_OPEN_ENABLED, PreferenceName.VIEW_ENCOUNTER_TIMER_AND_TOTAL, PreferenceName.INCLUDE_TOTAL_PROFESSIONAL_TIME_ON_EXAM_PRINTOUT, PreferenceName.INVENTORY_MANAGEMENT_ENABLED, PreferenceName.INVENTORY_QUANTITY_REASON_REQUIRED, PreferenceName.IP_ACCESS_RULES_ENABLED, PreferenceName.MED_SCREEN_AUTO_WIDTH, PreferenceName.MED_SCREEN_ORIENTATION, PreferenceName.NWPD_20_20_EXPORT_ENABLED, PreferenceName.ONGOINGCARE_DEFAULT_TAB, PreferenceName.OPTICAL_SUMMARY_DEFAULT_VIEW, PreferenceName.OPTIKAM_MEASUREMENTS_ENABLED, PreferenceName.OPTOMAP_EXPORT_ENABLED, PreferenceName.OPTOVUE_REVUE_EXPORT_ENABLED, PreferenceName.ORDER_APPROVAL_VALIDATION_ENABLED, PreferenceName.ORDER_COSTS_ENABLED, PreferenceName.ORDER_EYEGLASS_FRAMESOURCE_REQUIRED, PreferenceName.ORDER_EYEGLASS_FRAMESOURCEINDICATOR_REQUIRED, PreferenceName.ORDER_EYEGLASS_LAB_REQUIRED, PreferenceName.ORDER_EYEGLASS_MATERIAL_REQUIRED, PreferenceName.ORDER_EYEGLASS_MOUNTINGTYPE_REQUIRED, PreferenceName.ORDER_PD_VALIDATION_RULE, PreferenceName.PAT_SUMM_ADDL_MESSAGE, PreferenceName.PAT_SUMM_INCLUDE_PAT_BENEFITS, PreferenceName.PATIENT_POD_ACCOUNT_ENABLED, PreferenceName.PATIENT_POD_CONNECT_ENABLED, PreferenceName.PATIENT_POD_DEMOGRAPHICS_ENABLED, PreferenceName.PATIENT_POD_DIAGNOSISHISTORY_ENABLED, PreferenceName.PATIENT_POD_EXAMHISTORY_ENABLED, PreferenceName.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_COLORS_ENABLED, PreferenceName.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_HIGH, PreferenceName.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_LOW, PreferenceName.PATIENT_POD_FAMILY_CONTACTS_COMP_ENC_RANGE_OK, PreferenceName.PATIENT_POD_FAMILYCONTACTS_ENABLED, PreferenceName.PATIENT_POD_INSURANCE_ENABLED, PreferenceName.PATIENT_POD_LABORDERS_ENABLED, PreferenceName.PATIENT_POD_NOTES_ENABLED, PreferenceName.PATIENT_POD_OPTICALORDERS_ENABLED, PreferenceName.PATIENT_POD_RECALL_ENABLED, PreferenceName.PATIENT_POD_RX_ENABLED, PreferenceName.PATIENT_POD_TASKS_ENABLED, PreferenceName.PATIENTS_DEFAULT_SUMMARY_VIEW, PreferenceName.PFSH_FAMILY_HEALTH_HISTORY_ENABLED, PreferenceName.PHR_PATIENT_CONTACT_LENS_ENABLED, PreferenceName.PATIENT_PORTAL_DISPLAY_MESSAGING_MESSAGE, PreferenceName.PATIENT_PORTAL_MESSAGING_MESSAGE, PreferenceName.PHR_PATIENT_EDIT_ENABLED, PreferenceName.PHR_PATIENT_EYEGLASS_RX_ENABLED, PreferenceName.PHR_PATIENT_RECALLS_ENABLED, PreferenceName.PHR_PATIENT_SUMMARIES_DISABLED, PreferenceName.PRACTICE_INVOICE_FREEZE_DATE, PreferenceName.PRESCRIPTION_CL_CUSTOM_MSG, PreferenceName.PRESCRIPTION_CL_EXP_MONTHS, PreferenceName.PRESCRIPTION_CL_PRINT_FILE, PreferenceName.PRESCRIPTION_MED_EXP_MONTHS, PreferenceName.PRESCRIPTION_MED_INCLUDE_NPI, PreferenceName.PRESCRIPTION_MED_PRINT_FILE, PreferenceName.PRESCRIPTION_SPEC_CUSTOM_MSG, PreferenceName.PRESCRIPTION_SPEC_EXP_MONTHS, PreferenceName.PRESCRIPTION_SPEC_PRINT_FILE, PreferenceName.PRODUCT_LABEL_LAST_BARCODE_SOURCE, PreferenceName.PRODUCT_LABEL_LAST_ELEMENT_IDS, PreferenceName.PRODUCT_LABEL_LAST_FORMAT_PRICE, PreferenceName.PRODUCT_LABEL_LAST_LABEL_ID, PreferenceName.PRODUCT_LABEL_LAST_SHEET_COLUMN, PreferenceName.PRODUCT_LABEL_LAST_SHEET_ROW, PreferenceName.PROVIDER_ALWAYS_USE_SIGNATURE_IMAGE, PreferenceName.PROVIDER_EYEGLASS_USE_SIGNATURE_IMAGE, PreferenceName.PROVIDER_CONTACT_LENS_USE_SIGNATURE_IMAGE, PreferenceName.PROVIDER_MEDICATION_USE_SIGNATURE_IMAGE, PreferenceName.RECALL_ASSIGNMENT_OPTION, PreferenceName.RECALL_LOCATION_MAPPING_ENABLED, PreferenceName.REMOVE_USERNAME_ON_LOGOUT, PreferenceName.VSP_PRODUCT_CATALOG_ENABLED, PreferenceName.REV_INTEGRATOR_EXPORT_ENABLED, PreferenceName.SCANNING_ENABLED, PreferenceName.FHIR_API_ENABLED, PreferenceName.SCHEDULE_BUSY_TIME, PreferenceName.SCHEDULE_EMPLOYEE_HOURS, PreferenceName.SCHEDULE_LAYOUT, PreferenceName.SCHEDULE_VIEW, PreferenceName.SCHEDULE_INCREMENT, PreferenceName.SCHEDULE_GROUPING_ENABLED, PreferenceName.SCHEDULE_MULTIPLE_ACTIVE_APPOINTMENTS, PreferenceName.SCHEDULE_MY_PATIENTS_ONLY, PreferenceName.SCHEDULE_OFFICE_HOURS, PreferenceName.SCHEDULE_VALIDATION_ENABLED, PreferenceName.SCHEDULEPOD_TAB, PreferenceName.STEPPERS_TEXT_ENABLED, PreferenceName.TOAST_MESSAGES_DURATION, PreferenceName.TOAST_MESSAGES_ENABLED, PreferenceName.TOAST_MESSAGES_POSITION, PreferenceName.TWO_WAY_TEXT_NOTIFICATIONS, PreferenceName.VISIOFFICE_MEASUREMENTS_ENABLED, PreferenceName.VW_TRANSMIT_NEW_ORDERS_ENABLED, PreferenceName.ZEISS_FORUM_ENABLED, PreferenceName.AI_SCRIBE_ENABLED, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.PreferenceYesNoOptions */
/* istanbul ignore next */
export class PreferenceYesNoOptions extends GandalfConstant<string> {
	static readonly YES = new PreferenceYesNoOptions('true', "Yes");
	static readonly NO = new PreferenceYesNoOptions('false', "No");
	
	static readonly VALUES: GandalfConstantList<PreferenceYesNoOptions> = {
		label: 'Preference Yes No Options',
		values: [PreferenceYesNoOptions.YES, PreferenceYesNoOptions.NO, ]
	};
}

/** see com.rev360.model.person.constant.preferredphonetypes.PreferredPhoneType */
/* istanbul ignore next */
export class PreferredPhoneType extends GandalfConstant<number> {
	static readonly HOME = new PreferredPhoneType(1, "Home");
	static readonly WORK = new PreferredPhoneType(2, "Work");
	static readonly CELL = new PreferredPhoneType(3, "Cell");
	static readonly OTHER = new PreferredPhoneType(4, "Other");
	static readonly PAGER = new PreferredPhoneType(5, "Pager");
	
	static readonly VALUES: GandalfConstantList<PreferredPhoneType> = {
		label: 'Preferred Phone Numbers',
		values: [PreferredPhoneType.HOME, PreferredPhoneType.WORK, PreferredPhoneType.CELL, PreferredPhoneType.OTHER, PreferredPhoneType.PAGER, ]
	};
}

/** see com.rev360.model.prescription.constant.prescriptionauthorizationtype.PrescriptionAuthorizationType */
/* istanbul ignore next */
export class PrescriptionAuthorizationType extends GandalfConstant<number> {
	static readonly UNKNOWN = new PrescriptionAuthorizationType(0, "Unknown");
	static readonly PROVIDER = new PrescriptionAuthorizationType(1, "Provider");
	static readonly EXTERNAL_PROVIDER = new PrescriptionAuthorizationType(5, "External Provider");
	
	static readonly VALUES: GandalfConstantList<PrescriptionAuthorizationType> = {
		label: 'Prescription Authorization Type',
		values: [PrescriptionAuthorizationType.UNKNOWN, PrescriptionAuthorizationType.PROVIDER, PrescriptionAuthorizationType.EXTERNAL_PROVIDER, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.PrescriptionContactLensPrintFilePreferenceValues */
/* istanbul ignore next */
export class PrescriptionContactLensPrintFilePreferenceValues extends GandalfConstant<string> {
	static readonly DEFAULT = new PrescriptionContactLensPrintFilePreferenceValues('', "Default Format");
	static readonly NJPB = new PrescriptionContactLensPrintFilePreferenceValues('ContactLensRx_NewJerseyPrescriptionBlank.jasper', "NJPB");
	
	static readonly VALUES: GandalfConstantList<PrescriptionContactLensPrintFilePreferenceValues> = {
		label: 'Prescription Contact Lens Print File Preference Values',
		values: [PrescriptionContactLensPrintFilePreferenceValues.DEFAULT, PrescriptionContactLensPrintFilePreferenceValues.NJPB, ]
	};
}

/** see com.rev360.model.prescription.constant.PrescriptionCurrentStatusType */
/* istanbul ignore next */
export class PrescriptionCurrentStatus extends GandalfConstant<string> {
	static readonly PENDING = new PrescriptionCurrentStatus('Pending', "Pending");
	static readonly ACTIVE = new PrescriptionCurrentStatus('Active', "Active");
	static readonly DISCONTINUED = new PrescriptionCurrentStatus('Discontinued', "Discontinued");
	static readonly EXPIRED = new PrescriptionCurrentStatus('Expired', "Expired");
	
	static readonly VALUES: GandalfConstantList<PrescriptionCurrentStatus> = {
		label: 'Prescription Current Status',
		values: [PrescriptionCurrentStatus.PENDING, PrescriptionCurrentStatus.ACTIVE, PrescriptionCurrentStatus.DISCONTINUED, PrescriptionCurrentStatus.EXPIRED, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.PrescriptionMedPrintFilePreferenceValues */
/* istanbul ignore next */
export class PrescriptionMedPrintFilePreferenceValues extends GandalfConstant<string> {
	static readonly DEFAULT = new PrescriptionMedPrintFilePreferenceValues('', "Default Format");
	static readonly SUBSTITUTION_LEFT = new PrescriptionMedPrintFilePreferenceValues('MedRx_SubstitutionLeft.jasper', "Substitution Left");
	static readonly SUBSTITUTION_RIGHT = new PrescriptionMedPrintFilePreferenceValues('MedRx_SubstitutionRight.jasper', "Substitution Right");
	static readonly NJPB = new PrescriptionMedPrintFilePreferenceValues('MedRx_NewJerseyPrescriptionBlank.jasper', "NJPB");
	
	static readonly VALUES: GandalfConstantList<PrescriptionMedPrintFilePreferenceValues> = {
		label: 'Prescription Med Print File Preference Values',
		values: [PrescriptionMedPrintFilePreferenceValues.DEFAULT, PrescriptionMedPrintFilePreferenceValues.SUBSTITUTION_LEFT, PrescriptionMedPrintFilePreferenceValues.SUBSTITUTION_RIGHT, PrescriptionMedPrintFilePreferenceValues.NJPB, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.PrescriptionSpecPrintFilePreferenceValues */
/* istanbul ignore next */
export class PrescriptionSpecPrintFilePreferenceValues extends GandalfConstant<string> {
	static readonly DEFAULT = new PrescriptionSpecPrintFilePreferenceValues('', "Default Format");
	static readonly CONTACT_APPROVAL = new PrescriptionSpecPrintFilePreferenceValues('EyeglassRx_ContactApproval.jasper', "Contact Approval");
	static readonly NJPB = new PrescriptionSpecPrintFilePreferenceValues('EyeglassRx_NewJerseyPrescriptionBlank.jasper', "NJPB");
	static readonly NJPB_NON_GRID = new PrescriptionSpecPrintFilePreferenceValues('EyeglassRx_NewJerseyPrescriptionBlankNonGrid.jasper', "NJPB Non-Grid");
	
	static readonly VALUES: GandalfConstantList<PrescriptionSpecPrintFilePreferenceValues> = {
		label: 'Prescription Spec Print File Preference Values',
		values: [PrescriptionSpecPrintFilePreferenceValues.DEFAULT, PrescriptionSpecPrintFilePreferenceValues.CONTACT_APPROVAL, PrescriptionSpecPrintFilePreferenceValues.NJPB, PrescriptionSpecPrintFilePreferenceValues.NJPB_NON_GRID, ]
	};
}

/** see com.rev360.model.prescription.constant.prescriptionstatus.PrescriptionStatus */
/* istanbul ignore next */
export class PrescriptionStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new PrescriptionStatus(0, "Active");
	static readonly AUTHORIZED = new PrescriptionStatus(1, "Authorized");
	static readonly STOPPED = new PrescriptionStatus(2, "Stopped");
	static readonly EXPIRED = new PrescriptionStatus(3, "Expired");
	
	static readonly VALUES: GandalfConstantList<PrescriptionStatus> = {
		label: 'Prescription Status',
		values: [PrescriptionStatus.ACTIVE, PrescriptionStatus.AUTHORIZED, PrescriptionStatus.STOPPED, PrescriptionStatus.EXPIRED, ]
	};
}

/** see com.rev360.model.data.constant.prescriptionstopreason.PrescriptionStopReason */
/* istanbul ignore next */
export class PrescriptionStopReason extends GandalfConstant<number> {
	static readonly INCORPORATION_OF_DATA = new PrescriptionStopReason(1805, "Incorporation of Data");
	
	static readonly VALUES: GandalfConstantList<PrescriptionStopReason> = {
		label: 'Prescription Stop Reason',
		values: [PrescriptionStopReason.INCORPORATION_OF_DATA, ]
	};
}

/** see com.rev360.model.person.constant.previousnametype.PreviousNameType */
/* istanbul ignore next */
export class PreviousNameType extends GandalfConstant<number> {
	static readonly ADOPTED = new PreviousNameType(1, "Adopted");
	static readonly BIRTH_NAME = new PreviousNameType(2, "Birth Name");
	static readonly SPOUSE = new PreviousNameType(3, "Spouse");
	
	static readonly VALUES: GandalfConstantList<PreviousNameType> = {
		label: 'Previous Name Type',
		values: [PreviousNameType.ADOPTED, PreviousNameType.BIRTH_NAME, PreviousNameType.SPOUSE, ]
	};
}

/** see com.rev360.model.inventory.product.constant.pricingtype.PricingType */
/* istanbul ignore next */
export class PricingType extends GandalfConstant<number> {
	static readonly CALCULATED = new PricingType(0, "Calculated");
	static readonly STATIC = new PricingType(1, "Static");
	static readonly RELATIVE = new PricingType(2, "Relative");
	
	static readonly VALUES: GandalfConstantList<PricingType> = {
		label: 'Pricing Type',
		values: [PricingType.CALCULATED, PricingType.STATIC, PricingType.RELATIVE, ]
	};
}

/** see com.rev360.model.utilities.constant.processorqueueentitytype.ProcessorQueueEntityType */
/* istanbul ignore next */
export class ProcessorQueueEntityType extends GandalfConstant<number> {
	static readonly PAYMENT_GROUP = new ProcessorQueueEntityType(1, "PaymentGroup");
	static readonly FILE_INFO = new ProcessorQueueEntityType(2, "FileInfo");
	static readonly FILE_STORAGE = new ProcessorQueueEntityType(3, "FileStorage");
	static readonly PATIENT_FILE = new ProcessorQueueEntityType(4, "PatientFile");
	static readonly PATIENT = new ProcessorQueueEntityType(5, "Patient");
	
	static readonly VALUES: GandalfConstantList<ProcessorQueueEntityType> = {
		label: 'Processor Queue Entity Type',
		values: [ProcessorQueueEntityType.PAYMENT_GROUP, ProcessorQueueEntityType.FILE_INFO, ProcessorQueueEntityType.FILE_STORAGE, ProcessorQueueEntityType.PATIENT_FILE, ProcessorQueueEntityType.PATIENT, ]
	};
}

/** see com.rev360.model.utilities.constant.processorqueuestatus.ProcessorQueueStatus */
/* istanbul ignore next */
export class ProcessorQueueStatus extends GandalfConstant<number> {
	static readonly READY_TO_QUEUE = new ProcessorQueueStatus(1, "Ready to queue");
	static readonly QUEUED = new ProcessorQueueStatus(2, "Queued");
	static readonly PROCESSING = new ProcessorQueueStatus(3, "Processing");
	static readonly SUCCEEDED = new ProcessorQueueStatus(4, "Succeeded");
	static readonly FAILED = new ProcessorQueueStatus(5, "Failed");
	
	static readonly VALUES: GandalfConstantList<ProcessorQueueStatus> = {
		label: 'Processor Queue Status',
		values: [ProcessorQueueStatus.READY_TO_QUEUE, ProcessorQueueStatus.QUEUED, ProcessorQueueStatus.PROCESSING, ProcessorQueueStatus.SUCCEEDED, ProcessorQueueStatus.FAILED, ]
	};
}

/** see com.rev360.model.utilities.constant.processorqueuetype.ProcessorQueueType */
/* istanbul ignore next */
export class ProcessorQueueType extends GandalfConstant<number> {
	static readonly APPLY_PAYMENTS = new ProcessorQueueType(1, "Payments to be applied");
	static readonly FILE_COPY = new ProcessorQueueType(2, "Copy File to Storage Media");
	static readonly FILE_STORAGE_DELETION = new ProcessorQueueType(3, "Delete File Contents from File Storage");
	static readonly LEGACY_S3_BUCKET_TRANSFER = new ProcessorQueueType(4, "Transfer files from Legacy S3 Bucket to File System");
	static readonly PATIENT_DATA_EXPORT = new ProcessorQueueType(5, "Single patient data export");
	static readonly PRACTICE_PATIENT_DATA_EXPORT = new ProcessorQueueType(6, "Full practice patient data export");
	static readonly FILE_STORAGE_CREATION = new ProcessorQueueType(7, "File Storage creation");
	
	static readonly VALUES: GandalfConstantList<ProcessorQueueType> = {
		label: 'Processor Queue Type',
		values: [ProcessorQueueType.APPLY_PAYMENTS, ProcessorQueueType.FILE_COPY, ProcessorQueueType.FILE_STORAGE_DELETION, ProcessorQueueType.LEGACY_S3_BUCKET_TRANSFER, ProcessorQueueType.PATIENT_DATA_EXPORT, ProcessorQueueType.PRACTICE_PATIENT_DATA_EXPORT, ProcessorQueueType.FILE_STORAGE_CREATION, ]
	};
}

/** see com.rev360.model.inventory.product.constant.productcategorycatalog.ProductCategoryCatalog */
/* istanbul ignore next */
export class ProductCategoryCatalog extends GandalfConstant<string> {
	static readonly MAIN = new ProductCategoryCatalog('MAIN', "Main");
	static readonly VSP = new ProductCategoryCatalog('VSP', "VSP");
	
	static readonly VALUES: GandalfConstantList<ProductCategoryCatalog> = {
		label: 'Product Category Catalog',
		values: [ProductCategoryCatalog.MAIN, ProductCategoryCatalog.VSP, ]
	};
}

/** see com.rev360.model.workflow.constant.productworkflowtesttemplatestatus.ProductWorkflowTestTemplateStatus */
/* istanbul ignore next */
export class ProductWorkflowTestTemplateStatus extends GandalfConstant<number> {
	static readonly SAVED = new ProductWorkflowTestTemplateStatus(1, "Saved");
	static readonly PUBLISHED = new ProductWorkflowTestTemplateStatus(2, "Published");
	static readonly INACTIVE = new ProductWorkflowTestTemplateStatus(3, "Inactive");
	
	static readonly VALUES: GandalfConstantList<ProductWorkflowTestTemplateStatus> = {
		label: 'Product Workflow Test Template Status',
		values: [ProductWorkflowTestTemplateStatus.SAVED, ProductWorkflowTestTemplateStatus.PUBLISHED, ProductWorkflowTestTemplateStatus.INACTIVE, ]
	};
}

/** see com.rev360.pms.service.encounter.timer.ProfessionalTimeCodingLevel */
/* istanbul ignore next */
export class ProfessionalTimeCodingLevel extends GandalfConstant<number> {
	static readonly NONE = new ProfessionalTimeCodingLevel(0, "None");
	static readonly LEVEL_1 = new ProfessionalTimeCodingLevel(1, "Level 1");
	static readonly LEVEL_2 = new ProfessionalTimeCodingLevel(2, "Level 2");
	static readonly LEVEL_3 = new ProfessionalTimeCodingLevel(3, "Level 3");
	static readonly LEVEL_4 = new ProfessionalTimeCodingLevel(4, "Level 4");
	
	static readonly VALUES: GandalfConstantList<ProfessionalTimeCodingLevel> = {
		label: 'Level',
		values: [ProfessionalTimeCodingLevel.NONE, ProfessionalTimeCodingLevel.LEVEL_1, ProfessionalTimeCodingLevel.LEVEL_2, ProfessionalTimeCodingLevel.LEVEL_3, ProfessionalTimeCodingLevel.LEVEL_4, ]
	};
}

/** see com.rev360.model.provider.constant.providerlocationconfigtype.ProviderLocationConfigType */
/* istanbul ignore next */
export class ProviderLocationConfigType extends GandalfConstant<number> {
	static readonly OHIP_GROUP = new ProviderLocationConfigType(1, "Ohip Group");
	static readonly CLINICAID_PAYEE = new ProviderLocationConfigType(2, "ClinicAid Payee");
	static readonly BRITISH_COLUMBIA_RURAL_RETENTION_CODE = new ProviderLocationConfigType(3, "British Columbia Rural Retention Code");
	static readonly BRITISH_COLUMBIA_MEDICAL_SERVICES_PLAN_OPT_IN = new ProviderLocationConfigType(4, "British Columbia Medical Services Plan Opt-in");
	static readonly OHIP_DEPT = new ProviderLocationConfigType(5, "Ohip Department");
	
	static readonly VALUES: GandalfConstantList<ProviderLocationConfigType> = {
		label: 'Provider Location Config Type',
		values: [ProviderLocationConfigType.OHIP_GROUP, ProviderLocationConfigType.CLINICAID_PAYEE, ProviderLocationConfigType.BRITISH_COLUMBIA_RURAL_RETENTION_CODE, ProviderLocationConfigType.BRITISH_COLUMBIA_MEDICAL_SERVICES_PLAN_OPT_IN, ProviderLocationConfigType.OHIP_DEPT, ]
	};
}

/** see com.rev360.model.provider.constant.providerstatus.ProviderStatus */
/* istanbul ignore next */
export class ProviderStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new ProviderStatus(0, "Inactive");
	static readonly ACTIVE = new ProviderStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<ProviderStatus> = {
		label: 'Provider Status',
		values: [ProviderStatus.INACTIVE, ProviderStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.data.constant.providertype.ProviderType */
/* istanbul ignore next */
export class ProviderType extends GandalfConstant<number> {
	static readonly OPTOMETRIST = new ProviderType(1100, "Optometrist");
	static readonly OPHTHALMOLOGIST = new ProviderType(1101, "Ophthalmologist");
	static readonly FAMILY_PRACTITIONER = new ProviderType(1102, "Family Practitioner");
	static readonly INTERNIST = new ProviderType(1103, "Internist");
	static readonly PEDIATRICIAN = new ProviderType(1104, "Pediatrician");
	static readonly NURSE = new ProviderType(1105, "Nurse");
	static readonly PRACTITIONER = new ProviderType(1106, "Nurse Practitioner");
	static readonly PHYSICIAN_ASSISTANT = new ProviderType(1107, "Physician Assistant");
	static readonly DENTIST = new ProviderType(1108, "Dentist");
	static readonly PODIATRIST = new ProviderType(1109, "Podiatrist");
	static readonly PHARMACIST = new ProviderType(1110, "Pharmacist");
	
	static readonly VALUES: GandalfConstantList<ProviderType> = {
		label: 'Provider Type',
		values: [ProviderType.OPTOMETRIST, ProviderType.OPHTHALMOLOGIST, ProviderType.FAMILY_PRACTITIONER, ProviderType.INTERNIST, ProviderType.PEDIATRICIAN, ProviderType.NURSE, ProviderType.PRACTITIONER, ProviderType.PHYSICIAN_ASSISTANT, ProviderType.DENTIST, ProviderType.PODIATRIST, ProviderType.PHARMACIST, ]
	};
}

/** see com.rev360.pms.api.controller.order.pupillarydistance.PupillaryDistanceSource */
/* istanbul ignore next */
export class PupillaryDistanceSource extends GandalfConstant<number> {
	static readonly ORDER = new PupillaryDistanceSource(1, "Order");
	static readonly PRESCRIPTION = new PupillaryDistanceSource(2, "Rx");
	static readonly TEST = new PupillaryDistanceSource(3, "Test");
	
	static readonly VALUES: GandalfConstantList<PupillaryDistanceSource> = {
		label: 'Pupillary Distance Source',
		values: [PupillaryDistanceSource.ORDER, PupillaryDistanceSource.PRESCRIPTION, PupillaryDistanceSource.TEST, ]
	};
}

/** see com.rev360.model.cqm.constant.qrdareportrequestlegalauthenticator.QrdaReportRequestLegalAuthenticator */
/* istanbul ignore next */
export class QrdaReportRequestLegalAuthenticator extends GandalfConstant<number> {
	static readonly UNKNOWN = new QrdaReportRequestLegalAuthenticator(0, "Unknown");
	static readonly PROVIDER = new QrdaReportRequestLegalAuthenticator(1, "Provider");
	static readonly REVASPIRE = new QrdaReportRequestLegalAuthenticator(2, "RevAspire");
	
	static readonly VALUES: GandalfConstantList<QrdaReportRequestLegalAuthenticator> = {
		label: 'QRDA Report Request Legal Authenticator',
		values: [QrdaReportRequestLegalAuthenticator.UNKNOWN, QrdaReportRequestLegalAuthenticator.PROVIDER, QrdaReportRequestLegalAuthenticator.REVASPIRE, ]
	};
}

/** see com.rev360.model.cqm.qrdareportrequestpackagetype.QrdaReportRequestPackageType */
/* istanbul ignore next */
export class QrdaReportRequestPackageType extends GandalfConstant<string> {
	static readonly QRDA1 = new QrdaReportRequestPackageType('QRDA1', "QRDA I");
	static readonly QRDA3 = new QrdaReportRequestPackageType('QRDA3', "QRDA III");
	
	static readonly VALUES: GandalfConstantList<QrdaReportRequestPackageType> = {
		label: 'QRDA Report Request Package Type',
		values: [QrdaReportRequestPackageType.QRDA1, QrdaReportRequestPackageType.QRDA3, ]
	};
}

/** see com.rev360.model.cqm.constant.qrdareportrequestprogram.QrdaReportRequestProgram */
/* istanbul ignore next */
export class QrdaReportRequestProgram extends GandalfConstant<string> {
	static readonly MIPS_GROUP = new QrdaReportRequestProgram('MIPS_GROUP', "MIPS - Group");
	static readonly MIPS_INDIV = new QrdaReportRequestProgram('MIPS_INDIV', "MIPS - Individual");
	static readonly MU_ONLY = new QrdaReportRequestProgram('MU_ONLY', "Meaningful Use Only");
	static readonly PQRS_MU_GROUP = new QrdaReportRequestProgram('PQRS_MU_GROUP', "PQRS Meaningful Use Group");
	static readonly PQRS_MU_INDIVIDUAL = new QrdaReportRequestProgram('PQRS_MU_INDIVIDUAL', "PQRS Meaningful Use Individual");
	static readonly CREATE_QRDA1 = new QrdaReportRequestProgram('CREATE_QRDA1', "Imported QRDA1 Data");
	static readonly CREATE_QRDA3 = new QrdaReportRequestProgram('CREATE_QRDA3', "Imported QRDA3 Data");
	
	static readonly VALUES: GandalfConstantList<QrdaReportRequestProgram> = {
		label: 'QRDA Report Request Program',
		values: [QrdaReportRequestProgram.MIPS_GROUP, QrdaReportRequestProgram.MIPS_INDIV, QrdaReportRequestProgram.MU_ONLY, QrdaReportRequestProgram.PQRS_MU_GROUP, QrdaReportRequestProgram.PQRS_MU_INDIVIDUAL, QrdaReportRequestProgram.CREATE_QRDA1, QrdaReportRequestProgram.CREATE_QRDA3, ]
	};
}

/** see com.rev360.model.cqm.constant.qrdareportrequestsearchtype.QrdaReportRequestSearchType */
/* istanbul ignore next */
export class QrdaReportRequestSearchType extends GandalfConstant<number> {
	static readonly PQRI = new QrdaReportRequestSearchType(0, "PQRI");
	static readonly CQM_PRIMARY = new QrdaReportRequestSearchType(1, "CQM Primary");
	static readonly CQM_EXTENDED = new QrdaReportRequestSearchType(2, "CQM Extended");
	static readonly AOA = new QrdaReportRequestSearchType(3, "AOA");
	static readonly IMPORT = new QrdaReportRequestSearchType(5, "Import");
	
	static readonly VALUES: GandalfConstantList<QrdaReportRequestSearchType> = {
		label: 'QRDA Report Request Search Type',
		values: [QrdaReportRequestSearchType.PQRI, QrdaReportRequestSearchType.CQM_PRIMARY, QrdaReportRequestSearchType.CQM_EXTENDED, QrdaReportRequestSearchType.AOA, QrdaReportRequestSearchType.IMPORT, ]
	};
}

/** see com.rev360.model.cqm.constant.qrdareportrequeststatus.QrdaReportRequestStatus */
/* istanbul ignore next */
export class QrdaReportRequestStatus extends GandalfConstant<number> {
	static readonly ERROR = new QrdaReportRequestStatus(-1, "Error");
	static readonly INITIALIZED = new QrdaReportRequestStatus(0, "Initialized");
	static readonly IN_PROGRESS = new QrdaReportRequestStatus(1, "In Progress");
	static readonly COMPLETE = new QrdaReportRequestStatus(2, "Complete");
	
	static readonly VALUES: GandalfConstantList<QrdaReportRequestStatus> = {
		label: 'QRDA Report Request Status',
		values: [QrdaReportRequestStatus.ERROR, QrdaReportRequestStatus.INITIALIZED, QrdaReportRequestStatus.IN_PROGRESS, QrdaReportRequestStatus.COMPLETE, ]
	};
}

/** see com.rev360.model.cqm.qrda1.constant.qualitydataelementtype.QualityDataElementType */
/* istanbul ignore next */
export class QualityDataElementType extends GandalfConstant<number> {
	static readonly DIAGNOSIS_ACTIVE = new QualityDataElementType(1, "Diagnosis Active");
	static readonly INTERVENTION_PERFORMED = new QualityDataElementType(2, "Intervention Performed");
	static readonly PROCEDURE_PERFORMED = new QualityDataElementType(3, "Procedure Performed");
	static readonly ENCOUNTER_PERFORMED = new QualityDataElementType(4, "Encounter Performed");
	static readonly PHYSICAL_EXAM_PERFORMED = new QualityDataElementType(5, "Physical Exam Performed");
	static readonly MEDICATION_ORDER = new QualityDataElementType(6, "Medication Order");
	static readonly PROVIDER_TO_PROVIDER_COMMUNICATION = new QualityDataElementType(7, "Provider to Provider Communication");
	static readonly DIAGNOSTIC_STUDY_PERFORMED = new QualityDataElementType(8, "Diagnostic Study Performed");
	static readonly MEDICATION_ACTIVE = new QualityDataElementType(9, "Medication Active");
	static readonly PATIENT_CHARACTERISTIC_PAYER = new QualityDataElementType(10, "Patient Characteristic Payer");
	
	static readonly VALUES: GandalfConstantList<QualityDataElementType> = {
		label: 'Quality Data Element Type',
		values: [QualityDataElementType.DIAGNOSIS_ACTIVE, QualityDataElementType.INTERVENTION_PERFORMED, QualityDataElementType.PROCEDURE_PERFORMED, QualityDataElementType.ENCOUNTER_PERFORMED, QualityDataElementType.PHYSICAL_EXAM_PERFORMED, QualityDataElementType.MEDICATION_ORDER, QualityDataElementType.PROVIDER_TO_PROVIDER_COMMUNICATION, QualityDataElementType.DIAGNOSTIC_STUDY_PERFORMED, QualityDataElementType.MEDICATION_ACTIVE, QualityDataElementType.PATIENT_CHARACTERISTIC_PAYER, ]
	};
}

/** see com.rev360.model.inventory.item.constant.quantitychangetype.QuantityChangeType */
/* istanbul ignore next */
export class QuantityChangeType extends GandalfConstant<number> {
	static readonly MANUAL = new QuantityChangeType(1, "Manual");
	static readonly PURCHASE_ORDER = new QuantityChangeType(2, "Receiving");
	static readonly TRANSFER_IN = new QuantityChangeType(3, "Transfer In");
	static readonly CUSTOMER_RETURN = new QuantityChangeType(4, "Customer Return");
	static readonly SALE = new QuantityChangeType(5, "Sale");
	static readonly TRANSFER_OUT = new QuantityChangeType(6, "Transfer Out");
	static readonly SUPPLIER_RETURN = new QuantityChangeType(7, "Supplier Return");
	static readonly TRIAL = new QuantityChangeType(8, "Trial");
	static readonly RECONCILIATION = new QuantityChangeType(9, "Reconciliation");
	
	static readonly VALUES: GandalfConstantList<QuantityChangeType> = {
		label: 'Quantity Change',
		values: [QuantityChangeType.MANUAL, QuantityChangeType.PURCHASE_ORDER, QuantityChangeType.TRANSFER_IN, QuantityChangeType.CUSTOMER_RETURN, QuantityChangeType.SALE, QuantityChangeType.TRANSFER_OUT, QuantityChangeType.SUPPLIER_RETURN, QuantityChangeType.TRIAL, QuantityChangeType.RECONCILIATION, ]
	};
}

/** see com.rev360.model.query.QueryAddressLabelField */
/* istanbul ignore next */
export class QueryAddressLabelField extends GandalfConstant<string> {
	static readonly FIRST_NAME = new QueryAddressLabelField('firstName', "First Name");
	static readonly LAST_NAME = new QueryAddressLabelField('lastName', "Last Name");
	static readonly FULL_NAME = new QueryAddressLabelField('fullName', "Full Name");
	static readonly ADDRESS1 = new QueryAddressLabelField('address1', "Address 1");
	static readonly ADDRESS2 = new QueryAddressLabelField('address2', "Address 2");
	static readonly CITY = new QueryAddressLabelField('city', "City");
	static readonly STATE = new QueryAddressLabelField('state', "State");
	static readonly ZIP_CODE = new QueryAddressLabelField('zipCode', "ZIP Code");
	
	static readonly VALUES: GandalfConstantList<QueryAddressLabelField> = {
		label: 'Address Label Field',
		values: [QueryAddressLabelField.FIRST_NAME, QueryAddressLabelField.LAST_NAME, QueryAddressLabelField.FULL_NAME, QueryAddressLabelField.ADDRESS1, QueryAddressLabelField.ADDRESS2, QueryAddressLabelField.CITY, QueryAddressLabelField.STATE, QueryAddressLabelField.ZIP_CODE, ]
	};
}

/** see com.rev360.pms.service.query.QueryCriteriaBoolean */
/* istanbul ignore next */
export class QueryCriteriaBoolean extends GandalfConstant<string> {
	static readonly TRUE = new QueryCriteriaBoolean('true', "Yes");
	static readonly FALSE = new QueryCriteriaBoolean('false', "No");
	
	static readonly VALUES: GandalfConstantList<QueryCriteriaBoolean> = {
		label: 'boolean',
		values: [QueryCriteriaBoolean.TRUE, QueryCriteriaBoolean.FALSE, ]
	};
}

/** see com.rev360.model.query.QueryCriteriaOperator */
/* istanbul ignore next */
export class QueryCriteriaOperator extends GandalfConstant<string> {
	static readonly EQUALS = new QueryCriteriaOperator('Equals', "Equals");
	static readonly NOT_EQUALS = new QueryCriteriaOperator('Not equals', "Not equals");
	static readonly CONTAINS = new QueryCriteriaOperator('Contains', "Contains");
	static readonly NOT_CONTAINS = new QueryCriteriaOperator('Does not contain', "Does not contain");
	static readonly STARTS_WITH = new QueryCriteriaOperator('Starts with', "Starts with");
	static readonly EMPTY = new QueryCriteriaOperator('Empty', "Empty");
	static readonly NOT_EMPTY = new QueryCriteriaOperator('Not empty', "Not empty");
	static readonly EQUALS_ONE_OF = new QueryCriteriaOperator('Equals one of', "Equals one of");
	static readonly NOT_EQUALS_ONE_OF = new QueryCriteriaOperator('Not equals one of', "Not equals one of");
	static readonly GREATER = new QueryCriteriaOperator('Greater', "Greater than");
	static readonly GREATER_EQUAL = new QueryCriteriaOperator('Greater or equal', "Greater or equal to");
	static readonly LESS = new QueryCriteriaOperator('Less', "Less than");
	static readonly LESS_EQUAL = new QueryCriteriaOperator('Less or equal', "Less or equal to");
	static readonly BETWEEN = new QueryCriteriaOperator('Between', "Between");
	static readonly NOT_BETWEEN = new QueryCriteriaOperator('Not between', "Not between");
	static readonly RANGE = new QueryCriteriaOperator('Standard ranges', "Standard ranges");
	static readonly WITHIN_LAST = new QueryCriteriaOperator('Within last', "Within last");
	static readonly WITHIN_NEXT = new QueryCriteriaOperator('Within next', "Within next");
	static readonly NOT_WITHIN_LAST = new QueryCriteriaOperator('Not within last', "Not within last");
	static readonly NOT_WITHIN_NEXT = new QueryCriteriaOperator('Not within next', "Not within next");
	
	static readonly VALUES: GandalfConstantList<QueryCriteriaOperator> = {
		label: 'Operator',
		values: [QueryCriteriaOperator.EQUALS, QueryCriteriaOperator.NOT_EQUALS, QueryCriteriaOperator.CONTAINS, QueryCriteriaOperator.NOT_CONTAINS, QueryCriteriaOperator.STARTS_WITH, QueryCriteriaOperator.EMPTY, QueryCriteriaOperator.NOT_EMPTY, QueryCriteriaOperator.EQUALS_ONE_OF, QueryCriteriaOperator.NOT_EQUALS_ONE_OF, QueryCriteriaOperator.GREATER, QueryCriteriaOperator.GREATER_EQUAL, QueryCriteriaOperator.LESS, QueryCriteriaOperator.LESS_EQUAL, QueryCriteriaOperator.BETWEEN, QueryCriteriaOperator.NOT_BETWEEN, QueryCriteriaOperator.RANGE, QueryCriteriaOperator.WITHIN_LAST, QueryCriteriaOperator.WITHIN_NEXT, QueryCriteriaOperator.NOT_WITHIN_LAST, QueryCriteriaOperator.NOT_WITHIN_NEXT, ]
	};
}

/** see com.rev360.model.query.QueryCriteriaOuterOperator */
/* istanbul ignore next */
export class QueryCriteriaOuterOperator extends GandalfConstant<string> {
	static readonly AND = new QueryCriteriaOuterOperator('and', "and");
	static readonly OR = new QueryCriteriaOuterOperator('or', "or");
	
	static readonly VALUES: GandalfConstantList<QueryCriteriaOuterOperator> = {
		label: 'Outer Operator',
		values: [QueryCriteriaOuterOperator.AND, QueryCriteriaOuterOperator.OR, ]
	};
}

/** see com.rev360.pms.service.query.QueryCriteriaWithinUnit */
/* istanbul ignore next */
export class QueryCriteriaWithinUnit extends GandalfConstant<number> {
	static readonly DAYS = new QueryCriteriaWithinUnit(1, "Day(s)");
	static readonly WEEKS = new QueryCriteriaWithinUnit(2, "Week(s)");
	static readonly MONTHS = new QueryCriteriaWithinUnit(3, "Month(s)");
	static readonly YEARS = new QueryCriteriaWithinUnit(4, "Year(s)");
	
	static readonly VALUES: GandalfConstantList<QueryCriteriaWithinUnit> = {
		label: 'Within',
		values: [QueryCriteriaWithinUnit.DAYS, QueryCriteriaWithinUnit.WEEKS, QueryCriteriaWithinUnit.MONTHS, QueryCriteriaWithinUnit.YEARS, ]
	};
}

/** see com.rev360.model.query.QueryFieldAlignment */
/* istanbul ignore next */
export class QueryFieldAlignment extends GandalfConstant<string> {
	static readonly LEFT = new QueryFieldAlignment('left', "Left");
	static readonly RIGHT = new QueryFieldAlignment('right', "Right");
	static readonly CENTER = new QueryFieldAlignment('center', "Center");
	
	static readonly VALUES: GandalfConstantList<QueryFieldAlignment> = {
		label: 'Alignment',
		values: [QueryFieldAlignment.LEFT, QueryFieldAlignment.RIGHT, QueryFieldAlignment.CENTER, ]
	};
}

/** see com.rev360.pms.service.query.QueryFieldDataSource */
/* istanbul ignore next */
export class QueryFieldDataSource extends GandalfConstant<string> {
	static readonly INLINE = new QueryFieldDataSource('inline', "Inline");
	static readonly REFERENCE_DATA = new QueryFieldDataSource('practiceRefData', "Practice Data");
	static readonly MASTER_REFERENCE_DATA = new QueryFieldDataSource('masterRefData', "Master Data");
	static readonly CATEGORY = new QueryFieldDataSource('category', "Category");
	static readonly LOCATION = new QueryFieldDataSource('location', "Location");
	static readonly PROVIDER = new QueryFieldDataSource('provider', "Provider");
	static readonly TEMPLATE = new QueryFieldDataSource('template', "Template");
	static readonly EMPLOYEE = new QueryFieldDataSource('employee', "Employee");
	
	static readonly VALUES: GandalfConstantList<QueryFieldDataSource> = {
		label: 'Data Source',
		values: [QueryFieldDataSource.INLINE, QueryFieldDataSource.REFERENCE_DATA, QueryFieldDataSource.MASTER_REFERENCE_DATA, QueryFieldDataSource.CATEGORY, QueryFieldDataSource.LOCATION, QueryFieldDataSource.PROVIDER, QueryFieldDataSource.TEMPLATE, QueryFieldDataSource.EMPLOYEE, ]
	};
}

/** see com.rev360.pms.service.query.QueryFieldDataSourceList */
/* istanbul ignore next */
export class QueryFieldDataSourceList extends GandalfConstant<string> {
	static readonly CATEGORY_TASK = new QueryFieldDataSourceList('taskCategories', "Task");
	static readonly CATEGORY_ALLERGY = new QueryFieldDataSourceList('allergyCategories', "Allergy");
	static readonly REFERENCE_DATA_PERSON_DEMO_ETHNICITY = new QueryFieldDataSourceList('ethnicityTypes', "Person demographics - ethnicity");
	static readonly REFERENCE_DATA_PERSON_DEMO_RACE = new QueryFieldDataSourceList('raceTypes', "Person demographics - race");
	static readonly REFERENCE_DATA_PERSON_DEMO_CITIZENSHIP = new QueryFieldDataSourceList('citizenshipTypes', "Person demographics - citizenship");
	static readonly REFERENCE_DATA_PERSON_DEMO_RELIGION = new QueryFieldDataSourceList('religionTypes', "Person demographics - religion");
	static readonly REFERENCE_DATA_PERSON_DEMO_MARITAL_STATUS = new QueryFieldDataSourceList('maritalStatusTypes', "Person demographics - marital status");
	static readonly REFERENCE_DATA_PERSON_DEMO_TITLE = new QueryFieldDataSourceList('personTitles', "Person demographics - title");
	static readonly REFERENCE_DATA_PERSON_DEMO_LANGUAGE = new QueryFieldDataSourceList('personLanguages', "Person demographics - language");
	static readonly REFERENCE_DATA_PERSON_DOMINANT_EYE = new QueryFieldDataSourceList('dominantEyeTypes', "Person demographics - dominant eye");
	static readonly REFERENCE_DATA_PERSON_DOMINANT_HAND = new QueryFieldDataSourceList('dominantHandTypes', "Person demographics - dominant hand");
	static readonly REFERENCE_DATA_PERSON_DEMO_SEXUAL_ORIENTATION = new QueryFieldDataSourceList('sexualOrientationTypes', "Person demographics - sexual orientation");
	static readonly REFERENCE_DATA_PERSON_DEMO_GENDER_IDENTITY = new QueryFieldDataSourceList('genderIdentityTypes', "Person demographics - gender identity");
	static readonly REFERENCE_DATA_PATIENT_CATEGORIES = new QueryFieldDataSourceList('patientCategories', "Patient categories");
	static readonly REFERENCE_DATA_PATIENT_REFERRAL_SOURCES = new QueryFieldDataSourceList('referralSources', "Referral source");
	static readonly REFERENCE_DATA_PATIENT_REFERRAL_PROGRAMS = new QueryFieldDataSourceList('referralIncentivePrograms', "Referral incentive program");
	static readonly REFERENCE_DATA_PROVIDER_TYPE = new QueryFieldDataSourceList('providerTypes', "Provider types");
	static readonly REFERENCE_DATA_PROVIDER_ROLE = new QueryFieldDataSourceList('providerRoles', "Provider roles");
	static readonly REFERENCE_DATA_INSURANCE_PRIORITY = new QueryFieldDataSourceList('insuranceCarrierPriorities', "Insurance priorities");
	static readonly REFERENCE_DATA_INSURANCE_TYPE = new QueryFieldDataSourceList('insuranceCarrierTypes', "Insurance types");
	static readonly REFERENCE_DATA_MED_DISPENSE_UNIT = new QueryFieldDataSourceList('dispensingUnits', "Med Dispense Unit");
	static readonly REFERENCE_DATA_GENERAL_MEDS = new QueryFieldDataSourceList('generalMedications', "General Medications");
	static readonly REFERENCE_DATA_INSURANCE_CLASS = new QueryFieldDataSourceList('insuranceClassifications', "Insurance Classifications");
	static readonly REFERENCE_DATA_EYEGLASS_RX_USED_FOR_REASONS = new QueryFieldDataSourceList('eyeglassUsedForReasons', "Used For Reasons");
	static readonly REFERENCE_DATA_EYEGLASS_RX_MATERIALS = new QueryFieldDataSourceList('eyeglassMaterials', "Eyeglass Materials");
	static readonly REFERENCE_DATA_EYEGLASS_RX_TINTS = new QueryFieldDataSourceList('eyeglassTints', "Eyeglass Tints");
	static readonly REFERENCE_DATA_EYEGLASS_RX_LENS_TYPES = new QueryFieldDataSourceList('eyeglassLensTypes', "Eyeglass Lens Types");
	static readonly REFERENCE_DATA_CL_RX_ADD_DESIGNATIONS = new QueryFieldDataSourceList('clAddDesignations', "Add Designations");
	static readonly REFERENCE_DATA_CL_SYNERGEYES_DESIGN = new QueryFieldDataSourceList('clSynergeyesDesigns', "SynergEyes Designs");
	static readonly REFERENCE_DATA_CL_SYNERGEYES_SKIRT = new QueryFieldDataSourceList('clSynergeyesSkirt', "SynergEyes Skirt Curve Radius");
	static readonly REFERENCE_DATA_CL_SYNERGEYES_SEGMENTSIZE = new QueryFieldDataSourceList('clSynergeyesSegmentSizes', "SynergEyes Segment Sizes");
	static readonly REFERENCE_DATA_CL_SYNERGEYES_ADDZONESIZE = new QueryFieldDataSourceList('clSynergeyesAddZoneSizes', "SynergEyes Add Zone Sizes");
	static readonly REFERENCE_DATA_LAB_ORDER_TEST_TYPE = new QueryFieldDataSourceList('labOrderTestTypes', "Lab/Imaging Order Test Types");
	static readonly REFERENCE_DATA_LAB_ORDER_SPEC_SOURCE = new QueryFieldDataSourceList('labOrderSpecimenSources', "Lab/Imaging Order Specimen Source");
	static readonly REFERENCE_DATA_LAB_ORDER_RESULT_UNIT = new QueryFieldDataSourceList('labOrderResultUnits', "Lab/Imaging Order Result Unit");
	static readonly REFERENCE_DATA_ORDER_REMAKE_REASONS = new QueryFieldDataSourceList('orderRemakeReasons', "Order Remake Reasons");
	static readonly REFERENCE_DATA_ORDER_RETURN_REASONS = new QueryFieldDataSourceList('orderReturnReasons', "Return Reasons");
	
	static readonly VALUES: GandalfConstantList<QueryFieldDataSourceList> = {
		label: 'Data Source List',
		values: [QueryFieldDataSourceList.CATEGORY_TASK, QueryFieldDataSourceList.CATEGORY_ALLERGY, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_ETHNICITY, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_RACE, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_CITIZENSHIP, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_RELIGION, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_MARITAL_STATUS, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_TITLE, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_LANGUAGE, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DOMINANT_EYE, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DOMINANT_HAND, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_SEXUAL_ORIENTATION, QueryFieldDataSourceList.REFERENCE_DATA_PERSON_DEMO_GENDER_IDENTITY, QueryFieldDataSourceList.REFERENCE_DATA_PATIENT_CATEGORIES, QueryFieldDataSourceList.REFERENCE_DATA_PATIENT_REFERRAL_SOURCES, QueryFieldDataSourceList.REFERENCE_DATA_PATIENT_REFERRAL_PROGRAMS, QueryFieldDataSourceList.REFERENCE_DATA_PROVIDER_TYPE, QueryFieldDataSourceList.REFERENCE_DATA_PROVIDER_ROLE, QueryFieldDataSourceList.REFERENCE_DATA_INSURANCE_PRIORITY, QueryFieldDataSourceList.REFERENCE_DATA_INSURANCE_TYPE, QueryFieldDataSourceList.REFERENCE_DATA_MED_DISPENSE_UNIT, QueryFieldDataSourceList.REFERENCE_DATA_GENERAL_MEDS, QueryFieldDataSourceList.REFERENCE_DATA_INSURANCE_CLASS, QueryFieldDataSourceList.REFERENCE_DATA_EYEGLASS_RX_USED_FOR_REASONS, QueryFieldDataSourceList.REFERENCE_DATA_EYEGLASS_RX_MATERIALS, QueryFieldDataSourceList.REFERENCE_DATA_EYEGLASS_RX_TINTS, QueryFieldDataSourceList.REFERENCE_DATA_EYEGLASS_RX_LENS_TYPES, QueryFieldDataSourceList.REFERENCE_DATA_CL_RX_ADD_DESIGNATIONS, QueryFieldDataSourceList.REFERENCE_DATA_CL_SYNERGEYES_DESIGN, QueryFieldDataSourceList.REFERENCE_DATA_CL_SYNERGEYES_SKIRT, QueryFieldDataSourceList.REFERENCE_DATA_CL_SYNERGEYES_SEGMENTSIZE, QueryFieldDataSourceList.REFERENCE_DATA_CL_SYNERGEYES_ADDZONESIZE, QueryFieldDataSourceList.REFERENCE_DATA_LAB_ORDER_TEST_TYPE, QueryFieldDataSourceList.REFERENCE_DATA_LAB_ORDER_SPEC_SOURCE, QueryFieldDataSourceList.REFERENCE_DATA_LAB_ORDER_RESULT_UNIT, QueryFieldDataSourceList.REFERENCE_DATA_ORDER_REMAKE_REASONS, QueryFieldDataSourceList.REFERENCE_DATA_ORDER_RETURN_REASONS, ]
	};
}

/** see com.rev360.pms.service.query.QueryFieldDatabaseType */
/* istanbul ignore next */
export class QueryFieldDatabaseType extends GandalfConstant<string> {
	static readonly STRING = new QueryFieldDatabaseType('string', "String");
	static readonly INTEGER = new QueryFieldDatabaseType('int', "Integer");
	static readonly LONG = new QueryFieldDatabaseType('long', "Long");
	static readonly BOOLEAN = new QueryFieldDatabaseType('boolean', "Boolean");
	static readonly DOUBLE = new QueryFieldDatabaseType('double', "Double");
	static readonly DATE = new QueryFieldDatabaseType('date', "Date");
	static readonly TIMESTAMP = new QueryFieldDatabaseType('timestamp', "Timestamp");
	
	static readonly VALUES: GandalfConstantList<QueryFieldDatabaseType> = {
		label: 'Database Type',
		values: [QueryFieldDatabaseType.STRING, QueryFieldDatabaseType.INTEGER, QueryFieldDatabaseType.LONG, QueryFieldDatabaseType.BOOLEAN, QueryFieldDatabaseType.DOUBLE, QueryFieldDatabaseType.DATE, QueryFieldDatabaseType.TIMESTAMP, ]
	};
}

/** see com.rev360.pms.service.query.QueryFieldFormat */
/* istanbul ignore next */
export class QueryFieldFormat extends GandalfConstant<string> {
	static readonly MONEY = new QueryFieldFormat('money', "Money");
	static readonly DATE = new QueryFieldFormat('date', "Date");
	static readonly DATE_TIME = new QueryFieldFormat('dateTime', "Date and Time");
	static readonly TIMESTAMP = new QueryFieldFormat('timestamp', "Timestamp");
	static readonly QUAD_NUMERIC_SIGN_2 = new QueryFieldFormat('quadNumericSign2', "Plus Sign and 2 Decimal Places");
	static readonly QUAD_NUMERIC_DIGIT_3 = new QueryFieldFormat('quadNumericDigit3', "000");
	static readonly QUAD_NUMERIC_DEFAULT_1 = new QueryFieldFormat('quadNumericDefault1', "1 Decimal Place");
	static readonly QUAD_NUMERIC_DEFAULT_2 = new QueryFieldFormat('quadNumericDefault2', "2 Decimal Places");
	static readonly SECONDS_TO_MINUTES_TRUNC = new QueryFieldFormat('secondsToMinutesTruncated', "Convert seconds to minutes");
	
	static readonly VALUES: GandalfConstantList<QueryFieldFormat> = {
		label: 'Format',
		values: [QueryFieldFormat.MONEY, QueryFieldFormat.DATE, QueryFieldFormat.DATE_TIME, QueryFieldFormat.TIMESTAMP, QueryFieldFormat.QUAD_NUMERIC_SIGN_2, QueryFieldFormat.QUAD_NUMERIC_DIGIT_3, QueryFieldFormat.QUAD_NUMERIC_DEFAULT_1, QueryFieldFormat.QUAD_NUMERIC_DEFAULT_2, QueryFieldFormat.SECONDS_TO_MINUTES_TRUNC, ]
	};
}

/** see com.rev360.model.query.QueryFieldType */
/* istanbul ignore next */
export class QueryFieldType extends GandalfConstant<string> {
	static readonly STRING = new QueryFieldType('string', "Text");
	static readonly INT = new QueryFieldType('int', "Number");
	static readonly LONG = new QueryFieldType('long', "Large Number or ID");
	static readonly DOUBLE = new QueryFieldType('double', "Decimal");
	static readonly DATE = new QueryFieldType('date', "Date");
	static readonly SELECT = new QueryFieldType('single-select', "Selection");
	static readonly BOOLEAN = new QueryFieldType('boolean', "Conditional");
	
	static readonly VALUES: GandalfConstantList<QueryFieldType> = {
		label: 'data type',
		values: [QueryFieldType.STRING, QueryFieldType.INT, QueryFieldType.LONG, QueryFieldType.DOUBLE, QueryFieldType.DATE, QueryFieldType.SELECT, QueryFieldType.BOOLEAN, ]
	};
}

/** see com.rev360.model.query.QuerySortDirection */
/* istanbul ignore next */
export class QuerySortDirection extends GandalfConstant<string> {
	static readonly ASCENDING = new QuerySortDirection('ASC', "ASC");
	static readonly DESCENDING = new QuerySortDirection('DESC', "DESC");
	
	static readonly VALUES: GandalfConstantList<QuerySortDirection> = {
		label: 'Sort',
		values: [QuerySortDirection.ASCENDING, QuerySortDirection.DESCENDING, ]
	};
}

/** see com.rev360.model.query.constant.templatecategory.QueryTemplateCategory */
/* istanbul ignore next */
export class QueryTemplateCategory extends GandalfConstant<number> {
	static readonly PATIENT_SEARCH = new QueryTemplateCategory(1, "Patient Search");
	static readonly PATIENT_TRIGGER = new QueryTemplateCategory(2, "Patient Triggers");
	static readonly ACCOUNTING_INVOICES = new QueryTemplateCategory(3, "Accounting Invoices");
	static readonly PATIENT_EDUCATION = new QueryTemplateCategory(5, "Patient Education");
	static readonly ACCOUNTING_INVOICE_ITEMS = new QueryTemplateCategory(6, "Accounting Invoice Items");
	static readonly CUSTOM_REPORTS = new QueryTemplateCategory(7, "Custom Reports");
	static readonly SCHEDULE_ITEMS = new QueryTemplateCategory(8, "Schedule Reports");
	static readonly ORDERS = new QueryTemplateCategory(9, "Order Reports");
	static readonly TASKS = new QueryTemplateCategory(10, "Tasks Reports");
	static readonly INVENTORY_PRODUCTS = new QueryTemplateCategory(11, "Inventory Product Reports");
	static readonly INVENTORY_SERVICES = new QueryTemplateCategory(12, "Inventory Service Reports");
	static readonly ENCOUNTERS = new QueryTemplateCategory(14, "Encounter Reports");
	
	static readonly VALUES: GandalfConstantList<QueryTemplateCategory> = {
		label: 'Query Category',
		values: [QueryTemplateCategory.PATIENT_SEARCH, QueryTemplateCategory.PATIENT_TRIGGER, QueryTemplateCategory.ACCOUNTING_INVOICES, QueryTemplateCategory.PATIENT_EDUCATION, QueryTemplateCategory.ACCOUNTING_INVOICE_ITEMS, QueryTemplateCategory.CUSTOM_REPORTS, QueryTemplateCategory.SCHEDULE_ITEMS, QueryTemplateCategory.ORDERS, QueryTemplateCategory.TASKS, QueryTemplateCategory.INVENTORY_PRODUCTS, QueryTemplateCategory.INVENTORY_SERVICES, QueryTemplateCategory.ENCOUNTERS, ]
	};
}

/** see com.rev360.model.query.constant.querytriggerstatus.QueryTriggerStatus */
/* istanbul ignore next */
export class QueryTriggerStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new QueryTriggerStatus(1, "Active");
	static readonly INACTIVE = new QueryTriggerStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<QueryTriggerStatus> = {
		label: 'QueryTriggerStatus',
		values: [QueryTriggerStatus.ACTIVE, QueryTriggerStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.query.constant.type.QueryType */
/* istanbul ignore next */
export class QueryType extends GandalfConstant<number> {
	static readonly NORMAL = new QueryType(1, "Normal");
	static readonly DYNAMIC_SQL = new QueryType(3, "Dynamic SQL");
	
	static readonly VALUES: GandalfConstantList<QueryType> = {
		label: 'Type',
		values: [QueryType.NORMAL, QueryType.DYNAMIC_SQL, ]
	};
}

/** see com.rev360.model.help.constant.questioncategory.QuestionCategory */
/* istanbul ignore next */
export class QuestionCategory extends GandalfConstant<number> {
	static readonly ASK_REVASSURE = new QuestionCategory(1, "Ask RevAssure");
	static readonly ASK_MEANINGFUL_USE = new QuestionCategory(2, "Ask Meaningful Use");
	static readonly ASK_FITIFY = new QuestionCategory(3, "Ask Fitify");
	
	static readonly VALUES: GandalfConstantList<QuestionCategory> = {
		label: 'Question Category',
		values: [QuestionCategory.ASK_REVASSURE, QuestionCategory.ASK_MEANINGFUL_USE, QuestionCategory.ASK_FITIFY, ]
	};
}

/** see com.rev360.model.common.constant.recallassignmentpreferencevalue.RecallAssignmentPreferenceValue */
/* istanbul ignore next */
export class RecallAssignmentPreferenceValue extends GandalfConstant<string> {
	static readonly RECALL_ASSIGNMENT_OPTION_LOCATION_AND_RECALL_REASON = new RecallAssignmentPreferenceValue('recall.assignment.option.location.and.recall.reason', "Location and Recall Reason");
	static readonly RECALL_ASSIGNMENT_OPTION_RECALL_REASON = new RecallAssignmentPreferenceValue('recall.assignment.option.recall.reason', "Recall Reason");
	
	static readonly VALUES: GandalfConstantList<RecallAssignmentPreferenceValue> = {
		label: 'Recall Assignment Preference Value',
		values: [RecallAssignmentPreferenceValue.RECALL_ASSIGNMENT_OPTION_LOCATION_AND_RECALL_REASON, RecallAssignmentPreferenceValue.RECALL_ASSIGNMENT_OPTION_RECALL_REASON, ]
	};
}

/** see com.rev360.pms.service.patient.constant.RecallSearchType */
/* istanbul ignore next */
export class RecallSearchType extends GandalfConstant<number> {
	static readonly PATIENT_RECALL = new RecallSearchType(1, "Patient Recall");
	static readonly ENCOUNTER = new RecallSearchType(2, "Encounter");
	static readonly LAST_ENCOUNTER = new RecallSearchType(3, "Last Encounter");
	static readonly LAST_ENCOUNTER_NO_APPT = new RecallSearchType(4, "Last Encounter No Appt");
	static readonly APPOINTMENT = new RecallSearchType(5, "Appointment");
	
	static readonly VALUES: GandalfConstantList<RecallSearchType> = {
		label: 'Search Type',
		values: [RecallSearchType.PATIENT_RECALL, RecallSearchType.ENCOUNTER, RecallSearchType.LAST_ENCOUNTER, RecallSearchType.LAST_ENCOUNTER_NO_APPT, RecallSearchType.APPOINTMENT, ]
	};
}

/** see com.rev360.model.patient.constant.recallstatus.RecallStatus */
/* istanbul ignore next */
export class RecallStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new RecallStatus(1, "Active");
	static readonly ASSIGNED = new RecallStatus(2, "Assigned");
	static readonly DELETED = new RecallStatus(3, "Deleted");
	
	static readonly VALUES: GandalfConstantList<RecallStatus> = {
		label: 'Recall status',
		values: [RecallStatus.ACTIVE, RecallStatus.ASSIGNED, RecallStatus.DELETED, ]
	};
}

/** see com.rev360.pms.service.reporting.accounting.constants.receiptsreporttype.ReceiptsReportType */
/* istanbul ignore next */
export class ReceiptsReportType extends GandalfConstant<string> {
	static readonly RECEIPTS_BY_PAYER = new ReceiptsReportType('receiptsByPayor', "Receipts by Payer");
	static readonly RECEIPTS_BY_METHOD = new ReceiptsReportType('receiptsByMethod', "Receipts by Method");
	static readonly RECEIPTS_BY_PAYMENT = new ReceiptsReportType('receiptsByPayment', "Receipts by Method/Payment");
	static readonly RECEIPTS_BY_PROVIDER = new ReceiptsReportType('receiptsByProvider', "Receipts by Provider");
	static readonly RECEIPTS_BY_PATIENT = new ReceiptsReportType('receiptsByPatient', "Receipts by Patient");
	static readonly RECEIPTS_BY_CREDIT_CARD = new ReceiptsReportType('receiptsByCreditCard', "Receipts by Credit Card");
	
	static readonly VALUES: GandalfConstantList<ReceiptsReportType> = {
		label: 'Receipts report types',
		values: [ReceiptsReportType.RECEIPTS_BY_PAYER, ReceiptsReportType.RECEIPTS_BY_METHOD, ReceiptsReportType.RECEIPTS_BY_PAYMENT, ReceiptsReportType.RECEIPTS_BY_PROVIDER, ReceiptsReportType.RECEIPTS_BY_PATIENT, ReceiptsReportType.RECEIPTS_BY_CREDIT_CARD, ]
	};
}

/** see com.rev360.model.inventory.reconciliation.constant.reconciliationreportstatus.ReconciliationReportStatus */
/* istanbul ignore next */
export class ReconciliationReportStatus extends GandalfConstant<number> {
	static readonly REQUESTED = new ReconciliationReportStatus(0, "Requested");
	static readonly NEW = new ReconciliationReportStatus(1, "New");
	static readonly COUNTED = new ReconciliationReportStatus(2, "Counted");
	static readonly RECONCILED = new ReconciliationReportStatus(3, "Reconciled");
	static readonly CANCELED = new ReconciliationReportStatus(4, "Canceled");
	
	static readonly VALUES: GandalfConstantList<ReconciliationReportStatus> = {
		label: 'Reconciliation Report Status',
		values: [ReconciliationReportStatus.REQUESTED, ReconciliationReportStatus.NEW, ReconciliationReportStatus.COUNTED, ReconciliationReportStatus.RECONCILED, ReconciliationReportStatus.CANCELED, ]
	};
}

/** see com.rev360.model.schedule.constant.recurendtype.RecurEndType */
/* istanbul ignore next */
export class RecurEndType extends GandalfConstant<number> {
	static readonly NONE = new RecurEndType(0, "None");
	static readonly X_OCCURRENCES = new RecurEndType(1, "X Occurrences");
	static readonly DATE = new RecurEndType(2, "Date");
	
	static readonly VALUES: GandalfConstantList<RecurEndType> = {
		label: 'Recurrence End Type',
		values: [RecurEndType.NONE, RecurEndType.X_OCCURRENCES, RecurEndType.DATE, ]
	};
}

/** see com.rev360.model.schedule.constant.recurpatterntype.RecurPatternType */
/* istanbul ignore next */
export class RecurPatternType extends GandalfConstant<number> {
	static readonly DAILY = new RecurPatternType(1, "Daily");
	static readonly WEEKLY = new RecurPatternType(2, "Weekly");
	static readonly MONTHLY = new RecurPatternType(3, "Monthly");
	static readonly YEARLY = new RecurPatternType(4, "Yearly");
	
	static readonly VALUES: GandalfConstantList<RecurPatternType> = {
		label: 'Recurrence Pattern Type',
		values: [RecurPatternType.DAILY, RecurPatternType.WEEKLY, RecurPatternType.MONTHLY, RecurPatternType.YEARLY, ]
	};
}

/** see com.rev360.model.data.constant.referencedatadefaults.ReferenceDataDefaults */
/* istanbul ignore next */
export class ReferenceDataDefaults extends GandalfConstant<number> {
	static readonly ETHNICITY_DEFAULT_TYPE = new ReferenceDataDefaults(31, "Default Ethnicity");
	static readonly RACE_DEFAULT_TYPE = new ReferenceDataDefaults(39, "Default Race");
	static readonly LANGUAGE_DEFAULT_TYPE = new ReferenceDataDefaults(92, "Default Language");
	
	static readonly VALUES: GandalfConstantList<ReferenceDataDefaults> = {
		label: 'Reference Data Defaults',
		values: [ReferenceDataDefaults.ETHNICITY_DEFAULT_TYPE, ReferenceDataDefaults.RACE_DEFAULT_TYPE, ReferenceDataDefaults.LANGUAGE_DEFAULT_TYPE, ]
	};
}

/** see com.rev360.model.data.constant.referencedatamastercategory.ReferenceDataMasterCategory */
/* istanbul ignore next */
export class ReferenceDataMasterCategory extends GandalfConstant<number> {
	static readonly PERSON_PHONE_TYPE = new ReferenceDataMasterCategory(1, "Person phone types");
	static readonly PERSON_ADDR_TYPE = new ReferenceDataMasterCategory(2, "Person address types");
	static readonly PERSON_ADDR_STATE = new ReferenceDataMasterCategory(5, "Person address - states");
	static readonly PERSON_DEMO_ETHNICITY = new ReferenceDataMasterCategory(10, "Person demographics - ethnicity");
	static readonly PERSON_DEMO_RACE = new ReferenceDataMasterCategory(11, "Person demographics - race");
	static readonly PERSON_DEMO_CITIZENSHIP = new ReferenceDataMasterCategory(12, "Person demographics - citizenship");
	static readonly PERSON_DEMO_RELIGION = new ReferenceDataMasterCategory(13, "Person demographics - religion");
	static readonly PERSON_DEMO_MARITAL_STATUS = new ReferenceDataMasterCategory(14, "Person demographics - marital status");
	static readonly PERSON_DEMO_TITLE = new ReferenceDataMasterCategory(15, "Person demographics - title");
	static readonly PERSON_DEMO_LANGUAGE = new ReferenceDataMasterCategory(16, "Person demographics - language");
	static readonly PERSON_ALLERGIC_REACTION = new ReferenceDataMasterCategory(17, "Person allergic reactions");
	static readonly PERSON_DOMINANT_EYE = new ReferenceDataMasterCategory(18, "Person demographics - dominant eye");
	static readonly PERSON_DOMINANT_HAND = new ReferenceDataMasterCategory(19, "Person demographics - dominant hand");
	static readonly PERSON_DEMO_SEXUAL_ORIENTATION = new ReferenceDataMasterCategory(20, "Person demographics - sexual orientation");
	static readonly PERSON_DEMO_GENDER_IDENTITY = new ReferenceDataMasterCategory(21, "Person demographics - gender identity");
	static readonly PERSON_DEMO_PRONOUN = new ReferenceDataMasterCategory(22, "Person demographics - preferred pronoun");
	static readonly PERSON_DEMO_TRIBAL_AFFILIATION = new ReferenceDataMasterCategory(23, "Person demographics - tribal affiliation");
	static readonly PERSON_DEMO_ETHNICITY_EXTENDED = new ReferenceDataMasterCategory(30, "Person demographics - ethnicity - extended");
	static readonly PERSON_DEMO_RACE_EXTENDED = new ReferenceDataMasterCategory(40, "Person demographics - race - extended");
	static readonly PERSON_SDOH_FOOD_INSECURITY = new ReferenceDataMasterCategory(41, "Person social determinants of health - food insecurity");
	static readonly PERSON_SDOH_HOUSING_INSECURITY = new ReferenceDataMasterCategory(42, "Person social determinants of health - housing insecurity");
	static readonly PERSON_SDOH_TRANSPORT_INSECURITY = new ReferenceDataMasterCategory(43, "Person social determinants of health - transportation insecurity");
	static readonly PERSON_SDOH_FINANCIAL_INSECURITY = new ReferenceDataMasterCategory(44, "Person social determinants of health - financial insecurity");
	static readonly PERSON_SDOH_SOCIAL_CONNECTION = new ReferenceDataMasterCategory(45, "Person social determinants of health - social connection");
	static readonly PERSON_SDOH_STRESS = new ReferenceDataMasterCategory(46, "Person social determinants of health - stress");
	static readonly PERSON_SDOH_EDUCATION_LEVEL = new ReferenceDataMasterCategory(47, "Person social determinants of health - education level");
	static readonly PERSON_SDOH_MILITARY_STATUS = new ReferenceDataMasterCategory(48, "Person social determinants of health - military status");
	static readonly LOCATION_PHONE_TYPE = new ReferenceDataMasterCategory(100, "Location phone types");
	static readonly PATIENT_EMPLOYMENT_STATUS = new ReferenceDataMasterCategory(150, "Employment status");
	static readonly FAMILY_MEMBER_ROLE = new ReferenceDataMasterCategory(151, "Family member roles");
	static readonly PATIENT_CONTACT_ROLE = new ReferenceDataMasterCategory(152, "Contact roles");
	static readonly PATIENT_CATEGORIES = new ReferenceDataMasterCategory(153, "Patient categories");
	static readonly PATIENT_REFERRAL_SOURCES = new ReferenceDataMasterCategory(154, "Referral source");
	static readonly PATIENT_REFERRAL_PROGRAMS = new ReferenceDataMasterCategory(155, "Referral incentive program");
	static readonly PROVIDER_TYPE = new ReferenceDataMasterCategory(200, "Provider types");
	static readonly PROVIDER_ROLE = new ReferenceDataMasterCategory(202, "Provider roles");
	static readonly INSURANCE_PHONE_TYPE = new ReferenceDataMasterCategory(250, "Insurance carrier phone types");
	static readonly INSURANCE_PRIORITY = new ReferenceDataMasterCategory(251, "Insurance priorities");
	static readonly INSURANCE_TYPE = new ReferenceDataMasterCategory(252, "Insurance types");
	static readonly MED_DOSAGE_UNIT = new ReferenceDataMasterCategory(260, "Med Dosage Unit");
	static readonly MED_ROUTE = new ReferenceDataMasterCategory(261, "Med Route");
	static readonly MED_FREQUENCY = new ReferenceDataMasterCategory(262, "Med Frequency");
	static readonly MED_DISPENSE_UNIT = new ReferenceDataMasterCategory(263, "Med Dispense Unit");
	static readonly GENERAL_MEDS = new ReferenceDataMasterCategory(264, "General Medications");
	static readonly NO_IMMUNIZATION_REASON = new ReferenceDataMasterCategory(265, "No Immunization Reason");
	static readonly PRESCRIPTION_STOP_REASONS = new ReferenceDataMasterCategory(270, "Prescription stop reasons");
	static readonly BODY_LOCATION = new ReferenceDataMasterCategory(280, "Body locations");
	static readonly INSURANCE_CLASS = new ReferenceDataMasterCategory(300, "Insurance Classifications");
	static readonly ACCOUNTING_WRITEOFF_REASONS = new ReferenceDataMasterCategory(400, "Writeoff Reasons");
	static readonly ACCOUNTING_TRANSFER_REASONS = new ReferenceDataMasterCategory(401, "Transfer Reasons");
	static readonly ACCOUNTING_DISCOUNT_REASONS = new ReferenceDataMasterCategory(402, "Discount Reasons");
	static readonly ACCOUNTING_STATEMENT_DUE_DATE_REASONS = new ReferenceDataMasterCategory(403, "Statement Due Date Reasons");
	static readonly ACCOUNTING_STATEMENT_MESSAGE_REASONS = new ReferenceDataMasterCategory(404, "Statement Message Reasons");
	static readonly EYEGLASS_RX_USED_FOR_REASONS = new ReferenceDataMasterCategory(500, "Used For Reasons");
	static readonly EYEGLASS_RX_MATERIALS = new ReferenceDataMasterCategory(501, "Eyeglass Materials");
	static readonly EYEGLASS_RX_TINTS = new ReferenceDataMasterCategory(502, "Eyeglass Tints");
	static readonly EYEGLASS_RX_LENS_TYPES = new ReferenceDataMasterCategory(503, "Eyeglass Lens Types");
	static readonly CL_RX_ADD_DESIGNATIONS = new ReferenceDataMasterCategory(600, "Add Designations");
	static readonly CL_SYNERGEYES_DESIGN = new ReferenceDataMasterCategory(700, "SynergEyes Designs");
	static readonly CL_SYNERGEYES_SKIRT = new ReferenceDataMasterCategory(701, "SynergEyes Skirt Curve Radius");
	static readonly CL_SYNERGEYES_SEGMENTSIZE = new ReferenceDataMasterCategory(702, "SynergEyes Segment Sizes");
	static readonly CL_SYNERGEYES_ADDZONESIZE = new ReferenceDataMasterCategory(703, "SynergEyes Add Zone Sizes");
	static readonly CL_MATERIAL_SOFT = new ReferenceDataMasterCategory(800, "CL Material - Soft");
	static readonly CL_MATERIAL_RGP = new ReferenceDataMasterCategory(801, "CL Material - RGP");
	static readonly CL_MATERIAL_SYNERGEYES = new ReferenceDataMasterCategory(802, "CL Material - Synergeyes");
	static readonly CL_RGP_EDGE_LIFT = new ReferenceDataMasterCategory(900, "CL RGP - Edge Lift");
	static readonly CL_RGP_SPECIAL_CHARS = new ReferenceDataMasterCategory(901, "CL RGP - Special Characteristics");
	static readonly CL_RGP_PROFILE = new ReferenceDataMasterCategory(902, "CL RGP - Profile");
	static readonly CL_RGP_PERIPHERAL_EDGE = new ReferenceDataMasterCategory(903, "CL RGP - Peripheral Edge");
	static readonly CL_RGP_MIDPERIPHERAL_LIMBAL_CLEARANCE = new ReferenceDataMasterCategory(904, "CL RGP - Mid-Peripheral Limbal Clearance");
	static readonly CL_PACKAGING = new ReferenceDataMasterCategory(1000, "CL Packaging");
	static readonly CL_TRIAL_ORDER_INSTRUCTIONS = new ReferenceDataMasterCategory(1100, "CL Trial Order Instructions");
	static readonly LAB_ORDER_TEST_TYPE = new ReferenceDataMasterCategory(1200, "Lab/Imaging Order Test Types");
	static readonly LAB_ORDER_SPEC_SOURCE = new ReferenceDataMasterCategory(1201, "Lab/Imaging Order Specimen Source");
	static readonly LAB_ORDER_RESULT_UNIT = new ReferenceDataMasterCategory(1202, "Lab/Imaging Order Result Unit");
	static readonly FAVORITE_SERVICES = new ReferenceDataMasterCategory(1300, "Common Services");
	static readonly CLINICAL_QUALITY_MEASURES = new ReferenceDataMasterCategory(1400, "Clinical Quality Measures");
	static readonly RECONCILIATION_REASONS = new ReferenceDataMasterCategory(1600, "Reconciliation Reasons");
	static readonly QUANTITY_CHANGE_REASONS = new ReferenceDataMasterCategory(1601, "Quantity Adjustment Reasons");
	static readonly ORDER_REMAKE_REASONS = new ReferenceDataMasterCategory(1700, "Order Remake Reasons");
	static readonly ORDER_RETURN_REASONS = new ReferenceDataMasterCategory(1800, "Return Reasons");
	static readonly LENS_TREATMENT_SUB_CATEGORIES = new ReferenceDataMasterCategory(1900, "Lens treatment sub-category");
	static readonly ORDER_SOURCE = new ReferenceDataMasterCategory(3000, "Order Source");
	static readonly IMAGING_MODALITY_CLINICAL = new ReferenceDataMasterCategory(2200, "Imaging Modality: Clinical");
	static readonly IMAGING_MODALITY_CLERICAL = new ReferenceDataMasterCategory(2300, "Imaging Modality: Clerical");
	static readonly IMAGING_SUB_MODALITY_CLINICAL = new ReferenceDataMasterCategory(2400, "Imaging Submodality Clinical");
	static readonly IMAGING_LATERALITY = new ReferenceDataMasterCategory(2500, "Imaging Laterality");
	static readonly IMAGING_DEVICE_CLINICAL = new ReferenceDataMasterCategory(2600, "Imaging Device: Clinical");
	static readonly IMAGING_DEVICE_CLERICAL = new ReferenceDataMasterCategory(2700, "Imaging Device: Clerical");
	static readonly CL_ELECTRONIC_DELIVERY_METHODS = new ReferenceDataMasterCategory(2800, "CL Electronic Delivery Methods");
	static readonly PREDICTIVE_INTERVENTION_ATTRIBUTES = new ReferenceDataMasterCategory(2900, "Predictive Intervention Attributes");
	
	static readonly VALUES: GandalfConstantList<ReferenceDataMasterCategory> = {
		label: 'ReferenceDataMasterCategory',
		values: [ReferenceDataMasterCategory.PERSON_PHONE_TYPE, ReferenceDataMasterCategory.PERSON_ADDR_TYPE, ReferenceDataMasterCategory.PERSON_ADDR_STATE, ReferenceDataMasterCategory.PERSON_DEMO_ETHNICITY, ReferenceDataMasterCategory.PERSON_DEMO_RACE, ReferenceDataMasterCategory.PERSON_DEMO_CITIZENSHIP, ReferenceDataMasterCategory.PERSON_DEMO_RELIGION, ReferenceDataMasterCategory.PERSON_DEMO_MARITAL_STATUS, ReferenceDataMasterCategory.PERSON_DEMO_TITLE, ReferenceDataMasterCategory.PERSON_DEMO_LANGUAGE, ReferenceDataMasterCategory.PERSON_ALLERGIC_REACTION, ReferenceDataMasterCategory.PERSON_DOMINANT_EYE, ReferenceDataMasterCategory.PERSON_DOMINANT_HAND, ReferenceDataMasterCategory.PERSON_DEMO_SEXUAL_ORIENTATION, ReferenceDataMasterCategory.PERSON_DEMO_GENDER_IDENTITY, ReferenceDataMasterCategory.PERSON_DEMO_PRONOUN, ReferenceDataMasterCategory.PERSON_DEMO_TRIBAL_AFFILIATION, ReferenceDataMasterCategory.PERSON_DEMO_ETHNICITY_EXTENDED, ReferenceDataMasterCategory.PERSON_DEMO_RACE_EXTENDED, ReferenceDataMasterCategory.PERSON_SDOH_FOOD_INSECURITY, ReferenceDataMasterCategory.PERSON_SDOH_HOUSING_INSECURITY, ReferenceDataMasterCategory.PERSON_SDOH_TRANSPORT_INSECURITY, ReferenceDataMasterCategory.PERSON_SDOH_FINANCIAL_INSECURITY, ReferenceDataMasterCategory.PERSON_SDOH_SOCIAL_CONNECTION, ReferenceDataMasterCategory.PERSON_SDOH_STRESS, ReferenceDataMasterCategory.PERSON_SDOH_EDUCATION_LEVEL, ReferenceDataMasterCategory.PERSON_SDOH_MILITARY_STATUS, ReferenceDataMasterCategory.LOCATION_PHONE_TYPE, ReferenceDataMasterCategory.PATIENT_EMPLOYMENT_STATUS, ReferenceDataMasterCategory.FAMILY_MEMBER_ROLE, ReferenceDataMasterCategory.PATIENT_CONTACT_ROLE, ReferenceDataMasterCategory.PATIENT_CATEGORIES, ReferenceDataMasterCategory.PATIENT_REFERRAL_SOURCES, ReferenceDataMasterCategory.PATIENT_REFERRAL_PROGRAMS, ReferenceDataMasterCategory.PROVIDER_TYPE, ReferenceDataMasterCategory.PROVIDER_ROLE, ReferenceDataMasterCategory.INSURANCE_PHONE_TYPE, ReferenceDataMasterCategory.INSURANCE_PRIORITY, ReferenceDataMasterCategory.INSURANCE_TYPE, ReferenceDataMasterCategory.MED_DOSAGE_UNIT, ReferenceDataMasterCategory.MED_ROUTE, ReferenceDataMasterCategory.MED_FREQUENCY, ReferenceDataMasterCategory.MED_DISPENSE_UNIT, ReferenceDataMasterCategory.GENERAL_MEDS, ReferenceDataMasterCategory.NO_IMMUNIZATION_REASON, ReferenceDataMasterCategory.PRESCRIPTION_STOP_REASONS, ReferenceDataMasterCategory.BODY_LOCATION, ReferenceDataMasterCategory.INSURANCE_CLASS, ReferenceDataMasterCategory.ACCOUNTING_WRITEOFF_REASONS, ReferenceDataMasterCategory.ACCOUNTING_TRANSFER_REASONS, ReferenceDataMasterCategory.ACCOUNTING_DISCOUNT_REASONS, ReferenceDataMasterCategory.ACCOUNTING_STATEMENT_DUE_DATE_REASONS, ReferenceDataMasterCategory.ACCOUNTING_STATEMENT_MESSAGE_REASONS, ReferenceDataMasterCategory.EYEGLASS_RX_USED_FOR_REASONS, ReferenceDataMasterCategory.EYEGLASS_RX_MATERIALS, ReferenceDataMasterCategory.EYEGLASS_RX_TINTS, ReferenceDataMasterCategory.EYEGLASS_RX_LENS_TYPES, ReferenceDataMasterCategory.CL_RX_ADD_DESIGNATIONS, ReferenceDataMasterCategory.CL_SYNERGEYES_DESIGN, ReferenceDataMasterCategory.CL_SYNERGEYES_SKIRT, ReferenceDataMasterCategory.CL_SYNERGEYES_SEGMENTSIZE, ReferenceDataMasterCategory.CL_SYNERGEYES_ADDZONESIZE, ReferenceDataMasterCategory.CL_MATERIAL_SOFT, ReferenceDataMasterCategory.CL_MATERIAL_RGP, ReferenceDataMasterCategory.CL_MATERIAL_SYNERGEYES, ReferenceDataMasterCategory.CL_RGP_EDGE_LIFT, ReferenceDataMasterCategory.CL_RGP_SPECIAL_CHARS, ReferenceDataMasterCategory.CL_RGP_PROFILE, ReferenceDataMasterCategory.CL_RGP_PERIPHERAL_EDGE, ReferenceDataMasterCategory.CL_RGP_MIDPERIPHERAL_LIMBAL_CLEARANCE, ReferenceDataMasterCategory.CL_PACKAGING, ReferenceDataMasterCategory.CL_TRIAL_ORDER_INSTRUCTIONS, ReferenceDataMasterCategory.LAB_ORDER_TEST_TYPE, ReferenceDataMasterCategory.LAB_ORDER_SPEC_SOURCE, ReferenceDataMasterCategory.LAB_ORDER_RESULT_UNIT, ReferenceDataMasterCategory.FAVORITE_SERVICES, ReferenceDataMasterCategory.CLINICAL_QUALITY_MEASURES, ReferenceDataMasterCategory.RECONCILIATION_REASONS, ReferenceDataMasterCategory.QUANTITY_CHANGE_REASONS, ReferenceDataMasterCategory.ORDER_REMAKE_REASONS, ReferenceDataMasterCategory.ORDER_RETURN_REASONS, ReferenceDataMasterCategory.LENS_TREATMENT_SUB_CATEGORIES, ReferenceDataMasterCategory.ORDER_SOURCE, ReferenceDataMasterCategory.IMAGING_MODALITY_CLINICAL, ReferenceDataMasterCategory.IMAGING_MODALITY_CLERICAL, ReferenceDataMasterCategory.IMAGING_SUB_MODALITY_CLINICAL, ReferenceDataMasterCategory.IMAGING_LATERALITY, ReferenceDataMasterCategory.IMAGING_DEVICE_CLINICAL, ReferenceDataMasterCategory.IMAGING_DEVICE_CLERICAL, ReferenceDataMasterCategory.CL_ELECTRONIC_DELIVERY_METHODS, ReferenceDataMasterCategory.PREDICTIVE_INTERVENTION_ATTRIBUTES, ]
	};
}

/** see com.rev360.pms.service.common.constant.ReferenceDataMasterId */
/* istanbul ignore next */
export class ReferenceDataMasterId extends GandalfConstant<number> {
	static readonly MEDICATION_ROUTE_TOPICAL = new ReferenceDataMasterId(1720, "Topical");
	static readonly MEDICATION_ROUTE_ORALLY = new ReferenceDataMasterId(1721, "Orally");
	static readonly MEDICATION_ROUTE_INTRAVENOUS = new ReferenceDataMasterId(1722, "Intravenous");
	static readonly MEDICATION_ROUTE_INJECTION = new ReferenceDataMasterId(1723, "Injection");
	static readonly MEDICATION_ROUTE_INHALE = new ReferenceDataMasterId(1724, "Inhale");
	static readonly LENS_TREATMENTS_MATERIAL = new ReferenceDataMasterId(19010, "Lens Material");
	static readonly LENS_TREATMENTS_THICKNESS = new ReferenceDataMasterId(19030, "Lens Thickness");
	static readonly LENS_TREATMENTS_SPECIAL_OPTION = new ReferenceDataMasterId(19040, "Special Lens Option");
	static readonly LENS_TREATMENTS_MOUNTING_TYPE = new ReferenceDataMasterId(19050, "Mounting Type");
	static readonly LENS_TREATMENTS_EDGE_TREATMENT = new ReferenceDataMasterId(19060, "Edge Treatment");
	static readonly LENS_TREATMENTS_TINT_TYPE = new ReferenceDataMasterId(19070, "Tint Type");
	static readonly LENS_TREATMENTS_TINT_FACTOR = new ReferenceDataMasterId(19080, "Tint Factor");
	static readonly LENS_TREATMENTS_PHOTOCHROMIC = new ReferenceDataMasterId(19100, "Photochromic");
	static readonly LENS_TREATMENTS_POLARIZATION = new ReferenceDataMasterId(19110, "Polarization");
	static readonly LENS_TREATMENTS_AR_COATING = new ReferenceDataMasterId(19120, "AR Coating");
	static readonly LENS_TREATMENTS_SCRATCH_COATING = new ReferenceDataMasterId(19140, "Scratch Coating");
	static readonly LENS_TREATMENTS_UV_TREATMENT = new ReferenceDataMasterId(19150, "UV Treatment");
	static readonly LENS_TREATMENTS_MIRROR_COATING = new ReferenceDataMasterId(19160, "Mirror Coating");
	static readonly LENS_TREATMENTS_OTHER_COATING = new ReferenceDataMasterId(19170, "Other Coating");
	
	static readonly VALUES: GandalfConstantList<ReferenceDataMasterId> = {
		label: 'ReferenceDataMasterId',
		values: [ReferenceDataMasterId.MEDICATION_ROUTE_TOPICAL, ReferenceDataMasterId.MEDICATION_ROUTE_ORALLY, ReferenceDataMasterId.MEDICATION_ROUTE_INTRAVENOUS, ReferenceDataMasterId.MEDICATION_ROUTE_INJECTION, ReferenceDataMasterId.MEDICATION_ROUTE_INHALE, ReferenceDataMasterId.LENS_TREATMENTS_MATERIAL, ReferenceDataMasterId.LENS_TREATMENTS_THICKNESS, ReferenceDataMasterId.LENS_TREATMENTS_SPECIAL_OPTION, ReferenceDataMasterId.LENS_TREATMENTS_MOUNTING_TYPE, ReferenceDataMasterId.LENS_TREATMENTS_EDGE_TREATMENT, ReferenceDataMasterId.LENS_TREATMENTS_TINT_TYPE, ReferenceDataMasterId.LENS_TREATMENTS_TINT_FACTOR, ReferenceDataMasterId.LENS_TREATMENTS_PHOTOCHROMIC, ReferenceDataMasterId.LENS_TREATMENTS_POLARIZATION, ReferenceDataMasterId.LENS_TREATMENTS_AR_COATING, ReferenceDataMasterId.LENS_TREATMENTS_SCRATCH_COATING, ReferenceDataMasterId.LENS_TREATMENTS_UV_TREATMENT, ReferenceDataMasterId.LENS_TREATMENTS_MIRROR_COATING, ReferenceDataMasterId.LENS_TREATMENTS_OTHER_COATING, ]
	};
}

/** see com.rev360.model.patient.ongoingcare.RefractionTestMasterId */
/* istanbul ignore next */
export class RefractionTestMasterId extends GandalfConstant<number> {
	static readonly LENSOMETRY = new RefractionTestMasterId(162, "Lensometry");
	static readonly LENSOMETRY_WITH_PRISM = new RefractionTestMasterId(168, "Lensometry With Prism");
	static readonly AUTOREFRACTION = new RefractionTestMasterId(163, "Autorefraction");
	static readonly RETINOSCOPY = new RefractionTestMasterId(164, "Retinoscopy");
	static readonly CYCLOPLEGIC_RETINOSCOPY = new RefractionTestMasterId(172, "Cycloplegic Retinoscopy");
	static readonly TECHNICAL_REFRACTION = new RefractionTestMasterId(165, "Technical Refraction");
	static readonly REFRACTION_DISTANCE = new RefractionTestMasterId(166, "Refraction - Distance");
	static readonly REFRACTION_NEARPOINT = new RefractionTestMasterId(167, "Refraction - Nearpoint");
	static readonly CYCLOPLEGIC_REFRACTION = new RefractionTestMasterId(170, "Cycloplegic Refraction");
	static readonly CYCLOPLEGIC_AUTOREFRACTION = new RefractionTestMasterId(171, "Cycloplegic Autorefraction");
	static readonly FINAL_REFRACTION = new RefractionTestMasterId(175, "Final Refraction");
	static readonly FINAL_REFRACTION_WITH_PRISM = new RefractionTestMasterId(176, "Final Refraction With Prism");
	static readonly HISTORICAL_REFRACTION = new RefractionTestMasterId(178, "Historical Refraction");
	static readonly ISCRIPTION_REFRACTION = new RefractionTestMasterId(179, "iScription Refraction");
	static readonly RETINOSCOPY_WITH_VAS = new RefractionTestMasterId(161, "Retinoscopy With VAs");
	static readonly TRIAL_FRAME_REFRACTION = new RefractionTestMasterId(181, "Trial Frame Refraction");
	static readonly SCHOOL_OF_OPTOMETRY_MANIFEST_REFRACTION = new RefractionTestMasterId(9003, "School of Optometry Manifest Refraction");
	static readonly FINAL_REFRACTION_WITH_PRISM_METRIC = new RefractionTestMasterId(154, "Final Refraction With Prism - Metric");
	static readonly TECHNICAL_REFRACTION_METRIC = new RefractionTestMasterId(155, "Technical Refraction - Metric");
	static readonly RETINOSCOPY_WITH_VAS_METRIC = new RefractionTestMasterId(156, "Retinoscopy With VAs - Metric");
	static readonly REFRACTION_DISTANCE_METRIC = new RefractionTestMasterId(153, "Refraction - Distance - Metric");
	static readonly VR800 = new RefractionTestMasterId(150, "VR800");
	
	static readonly VALUES: GandalfConstantList<RefractionTestMasterId> = {
		label: 'RefractionTestMasterId',
		values: [RefractionTestMasterId.LENSOMETRY, RefractionTestMasterId.LENSOMETRY_WITH_PRISM, RefractionTestMasterId.AUTOREFRACTION, RefractionTestMasterId.RETINOSCOPY, RefractionTestMasterId.CYCLOPLEGIC_RETINOSCOPY, RefractionTestMasterId.TECHNICAL_REFRACTION, RefractionTestMasterId.REFRACTION_DISTANCE, RefractionTestMasterId.REFRACTION_NEARPOINT, RefractionTestMasterId.CYCLOPLEGIC_REFRACTION, RefractionTestMasterId.CYCLOPLEGIC_AUTOREFRACTION, RefractionTestMasterId.FINAL_REFRACTION, RefractionTestMasterId.FINAL_REFRACTION_WITH_PRISM, RefractionTestMasterId.HISTORICAL_REFRACTION, RefractionTestMasterId.ISCRIPTION_REFRACTION, RefractionTestMasterId.RETINOSCOPY_WITH_VAS, RefractionTestMasterId.TRIAL_FRAME_REFRACTION, RefractionTestMasterId.SCHOOL_OF_OPTOMETRY_MANIFEST_REFRACTION, RefractionTestMasterId.FINAL_REFRACTION_WITH_PRISM_METRIC, RefractionTestMasterId.TECHNICAL_REFRACTION_METRIC, RefractionTestMasterId.RETINOSCOPY_WITH_VAS_METRIC, RefractionTestMasterId.REFRACTION_DISTANCE_METRIC, RefractionTestMasterId.VR800, ]
	};
}

/** see com.rev360.model.accounting.constant.refundfrom.RefundFrom */
/* istanbul ignore next */
export class RefundFrom extends GandalfConstant<number> {
	static readonly CASH = new RefundFrom(1, "Cash");
	static readonly CHECK = new RefundFrom(2, "Check");
	static readonly CREDIT_CARD = new RefundFrom(3, "Credit Card");
	static readonly CARE_CREDIT = new RefundFrom(5, "Care Credit");
	static readonly OTHER = new RefundFrom(4, "Other");
	static readonly APPLE_PAY = new RefundFrom(8, "Apple Pay");
	static readonly GIFT_CERTIFICATE = new RefundFrom(9, "Gift Certificate");
	static readonly VENMO = new RefundFrom(10, "Venmo");
	static readonly SUNBIT = new RefundFrom(11, "Sunbit");
	static readonly ONLINE_PAYMENT = new RefundFrom(12, "Online Payment");
	static readonly COFI = new RefundFrom(13, "CoFi");
	static readonly CRYPTO_CURRENCY = new RefundFrom(14, "Crypto Currency");
	static readonly CASH_APP = new RefundFrom(15, "Cash App");
	
	static readonly VALUES: GandalfConstantList<RefundFrom> = {
		label: 'Refund From',
		values: [RefundFrom.CASH, RefundFrom.CHECK, RefundFrom.CREDIT_CARD, RefundFrom.CARE_CREDIT, RefundFrom.OTHER, RefundFrom.APPLE_PAY, RefundFrom.GIFT_CERTIFICATE, RefundFrom.VENMO, RefundFrom.SUNBIT, RefundFrom.ONLINE_PAYMENT, RefundFrom.COFI, RefundFrom.CRYPTO_CURRENCY, RefundFrom.CASH_APP, ]
	};
}

/** see com.rev360.model.accounting.constant.refundstatus.RefundStatus */
/* istanbul ignore next */
export class RefundStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new RefundStatus(1, "Applied");
	static readonly VOID = new RefundStatus(2, "Void");
	
	static readonly VALUES: GandalfConstantList<RefundStatus> = {
		label: 'Refund Status',
		values: [RefundStatus.ACTIVE, RefundStatus.VOID, ]
	};
}

/** see com.rev360.model.accounting.constant.refundtype.RefundType */
/* istanbul ignore next */
export class RefundType extends GandalfConstant<number> {
	static readonly PATIENT = new RefundType(1, "Patient");
	static readonly INSURANCE = new RefundType(2, "Insurance");
	static readonly ANONYMOUS = new RefundType(3, "Anonymous");
	
	static readonly VALUES: GandalfConstantList<RefundType> = {
		label: 'Refund Type',
		values: [RefundType.PATIENT, RefundType.INSURANCE, RefundType.ANONYMOUS, ]
	};
}

/** see com.rev360.pms.service.reporting.accounting.constants.refundsreporttype.RefundsReportType */
/* istanbul ignore next */
export class RefundsReportType extends GandalfConstant<string> {
	static readonly REFUNDS_BY_PAYER = new RefundsReportType('refundsByPayor', "Refunds by Payer");
	static readonly REFUNDS_BY_METHOD = new RefundsReportType('refundsByMethod', "Refunds by Method");
	static readonly REFUNDS_BY_PROVIDER = new RefundsReportType('refundsByProvider', "Refunds by Provider");
	
	static readonly VALUES: GandalfConstantList<RefundsReportType> = {
		label: 'Refunds Report Type',
		values: [RefundsReportType.REFUNDS_BY_PAYER, RefundsReportType.REFUNDS_BY_METHOD, RefundsReportType.REFUNDS_BY_PROVIDER, ]
	};
}

/** see com.rev360.model.patient.constant.registrationsource.RegistrationSource */
/* istanbul ignore next */
export class RegistrationSource extends GandalfConstant<number> {
	static readonly UNKNOWN = new RegistrationSource(0, "Unknown");
	static readonly EHR = new RegistrationSource(1, "EHR");
	static readonly PHR = new RegistrationSource(2, "PHR");
	
	static readonly VALUES: GandalfConstantList<RegistrationSource> = {
		label: 'Registration Source',
		values: [RegistrationSource.UNKNOWN, RegistrationSource.EHR, RegistrationSource.PHR, ]
	};
}

/** see com.rev360.model.category.constant.relatedentitytype.RelatedEntityType */
/* istanbul ignore next */
export class RelatedEntityType extends GandalfConstant<string> {
	static readonly INVOICE_ITEM = new RelatedEntityType('InvoiceItem', "Invoice Item");
	static readonly SERVICE = new RelatedEntityType('Service', "Service");
	
	static readonly VALUES: GandalfConstantList<RelatedEntityType> = {
		label: 'Related Entity Type',
		values: [RelatedEntityType.INVOICE_ITEM, RelatedEntityType.SERVICE, ]
	};
}

/** see com.rev360.model.practice.constant.remittanceadjustmentgroupcode.RemittanceAdjustmentGroupCode */
/* istanbul ignore next */
export class RemittanceAdjustmentGroupCode extends GandalfConstant<string> {
	static readonly CONTRACTUAL_OBLIGATIONS = new RemittanceAdjustmentGroupCode('CO', "CO - Contractual Obligations");
	static readonly OTHER_ADJUSTMENTS = new RemittanceAdjustmentGroupCode('OA', "OA - Other Adjustments");
	static readonly PAYER_INITIATED_REDUCTIONS = new RemittanceAdjustmentGroupCode('PI', "PI - Payer Initiated Reductions");
	static readonly PATIENT_RESPONSIBILITY = new RemittanceAdjustmentGroupCode('PR', "PR - Patient Responsibility");
	
	static readonly VALUES: GandalfConstantList<RemittanceAdjustmentGroupCode> = {
		label: 'Remittance Adjustment Group Code',
		values: [RemittanceAdjustmentGroupCode.CONTRACTUAL_OBLIGATIONS, RemittanceAdjustmentGroupCode.OTHER_ADJUSTMENTS, RemittanceAdjustmentGroupCode.PAYER_INITIATED_REDUCTIONS, RemittanceAdjustmentGroupCode.PATIENT_RESPONSIBILITY, ]
	};
}

/** see com.rev360.model.user.constant.resourcecategory.ResourceCategory */
/* istanbul ignore next */
export class ResourceCategory extends GandalfConstant<number> {
	static readonly PATIENT = new ResourceCategory(1, "Patient");
	static readonly SCHEDULE = new ResourceCategory(2, "Schedule");
	static readonly ACCOUNTING = new ResourceCategory(3, "Accounting");
	static readonly INVENTORY = new ResourceCategory(4, "Inventory");
	static readonly ORDERS = new ResourceCategory(5, "Orders");
	static readonly REPORTS = new ResourceCategory(6, "Reports");
	static readonly ADMIN = new ResourceCategory(7, "Admin");
	static readonly REVCONNECT = new ResourceCategory(8, "RevConnect");
	static readonly REVENGAGE = new ResourceCategory(9, "RevEngage");
	
	static readonly VALUES: GandalfConstantList<ResourceCategory> = {
		label: 'Resource Categories',
		values: [ResourceCategory.PATIENT, ResourceCategory.SCHEDULE, ResourceCategory.ACCOUNTING, ResourceCategory.INVENTORY, ResourceCategory.ORDERS, ResourceCategory.REPORTS, ResourceCategory.ADMIN, ResourceCategory.REVCONNECT, ResourceCategory.REVENGAGE, ]
	};
}

/** see com.rev360.model.practice.constant.revpayprocessortype.RevPayProcessorType */
/* istanbul ignore next */
export class RevPayProcessorType extends GandalfConstant<number> {
	static readonly NONE = new RevPayProcessorType(0, "None");
	static readonly GLOBAL = new RevPayProcessorType(1, "Global");
	static readonly ADYEN = new RevPayProcessorType(2, "Adyen (Practice Pay)");
	
	static readonly VALUES: GandalfConstantList<RevPayProcessorType> = {
		label: 'RevPay Processor Type',
		values: [RevPayProcessorType.NONE, RevPayProcessorType.GLOBAL, RevPayProcessorType.ADYEN, ]
	};
}

/** see com.rev360.model.history.constant.reviewhistorycategory.ReviewHistoryCategory */
/* istanbul ignore next */
export class ReviewHistoryCategory extends GandalfConstant<number> {
	static readonly ALLERGIES = new ReviewHistoryCategory(1, "Allergies");
	static readonly MEDICATIONS = new ReviewHistoryCategory(2, "Medications");
	static readonly DIAGNOSES = new ReviewHistoryCategory(3, "Diagnoses");
	
	static readonly VALUES: GandalfConstantList<ReviewHistoryCategory> = {
		label: 'Review History Category',
		values: [ReviewHistoryCategory.ALLERGIES, ReviewHistoryCategory.MEDICATIONS, ReviewHistoryCategory.DIAGNOSES, ]
	};
}

/** see com.rev360.model.history.constant.reviewhistorysubcategory.ReviewHistorySubCategory */
/* istanbul ignore next */
export class ReviewHistorySubCategory extends GandalfConstant<number> {
	static readonly NONE = new ReviewHistorySubCategory(0, "None");
	
	static readonly VALUES: GandalfConstantList<ReviewHistorySubCategory> = {
		label: 'Review History Subcategory',
		values: [ReviewHistorySubCategory.NONE, ]
	};
}

/** see com.rev360.model.bridge.constant.runtimeparameterdatakey.RuntimeParameterDataKey */
/* istanbul ignore next */
export class RuntimeParameterDataKey extends GandalfConstant<string> {
	static readonly FORUM_EXTENSION = new RuntimeParameterDataKey('HIT.Bridge.Extensions.ForumExtension', "HIT.Bridge.Extensions.ForumExtension");
	static readonly LOCAL_FILE_EXTENSION = new RuntimeParameterDataKey('HIT.Bridge.Extensions.LocalFileExtension', "HIT.Bridge.Extensions.LocalFileExtension");
	static readonly OPTOS_EXTENSION = new RuntimeParameterDataKey('HIT.Bridge.Extensions.OptosExtension', "HIT.Bridge.Extensions.OptosExtension");
	static readonly OPTOVUE_EXTENSION = new RuntimeParameterDataKey('HIT.Bridge.Extensions.OptovueExtension', "HIT.Bridge.Extensions.OptovueExtension");
	static readonly PARM1 = new RuntimeParameterDataKey('Parm1', "Parm1");
	static readonly PARM2 = new RuntimeParameterDataKey('Parm2', "Parm2");
	static readonly PARM3 = new RuntimeParameterDataKey('Parm3', "Parm3");
	
	static readonly VALUES: GandalfConstantList<RuntimeParameterDataKey> = {
		label: 'Runtime Parameter Data Key',
		values: [RuntimeParameterDataKey.FORUM_EXTENSION, RuntimeParameterDataKey.LOCAL_FILE_EXTENSION, RuntimeParameterDataKey.OPTOS_EXTENSION, RuntimeParameterDataKey.OPTOVUE_EXTENSION, RuntimeParameterDataKey.PARM1, RuntimeParameterDataKey.PARM2, RuntimeParameterDataKey.PARM3, ]
	};
}

/** see com.rev360.pms.api.controller.prescription.constants.RxDisplayStatusLegacy */
/* istanbul ignore next */
export class RxDisplayStatusLegacy extends GandalfConstant<number> {
	static readonly ACTIVE = new RxDisplayStatusLegacy(0, "Active");
	static readonly AUTHORIZED = new RxDisplayStatusLegacy(1, "Authorized");
	static readonly STOPPED = new RxDisplayStatusLegacy(2, "Stopped");
	static readonly EXPIRED = new RxDisplayStatusLegacy(3, "Expired");
	static readonly PENDING = new RxDisplayStatusLegacy(4, "Pending");
	static readonly TRIAL = new RxDisplayStatusLegacy(100, "CL Trial");
	
	static readonly VALUES: GandalfConstantList<RxDisplayStatusLegacy> = {
		label: 'Rx Display Status Legacy',
		values: [RxDisplayStatusLegacy.ACTIVE, RxDisplayStatusLegacy.AUTHORIZED, RxDisplayStatusLegacy.STOPPED, RxDisplayStatusLegacy.EXPIRED, RxDisplayStatusLegacy.PENDING, RxDisplayStatusLegacy.TRIAL, ]
	};
}

/** see com.rev360.model.accounting.constant.rxqualifier.RxQualifier */
/* istanbul ignore next */
export class RxQualifier extends GandalfConstant<string> {
	static readonly PRESCRIPTION_NUM = new RxQualifier('XZ', "Prescription #");
	static readonly PROVIDER_ASSIGNED_NUM = new RxQualifier('VY', "Provider Assigned #");
	
	static readonly VALUES: GandalfConstantList<RxQualifier> = {
		label: 'Rx Qualifiers',
		values: [RxQualifier.PRESCRIPTION_NUM, RxQualifier.PROVIDER_ASSIGNED_NUM, ]
	};
}

/** see com.rev360.model.ws.rxnt.constant.rxntcompanymaprefreshstatus.RxntCompanyMapRefreshStatus */
/* istanbul ignore next */
export class RxntCompanyMapRefreshStatus extends GandalfConstant<string> {
	static readonly SUCCESS = new RxntCompanyMapRefreshStatus('Success', "Success");
	static readonly ERROR = new RxntCompanyMapRefreshStatus('Error', "Error");
	
	static readonly VALUES: GandalfConstantList<RxntCompanyMapRefreshStatus> = {
		label: 'RxNT Company Map Refresh Status',
		values: [RxntCompanyMapRefreshStatus.SUCCESS, RxntCompanyMapRefreshStatus.ERROR, ]
	};
}

/** see com.rev360.pms.service.reporting.accounting.constants.salesreporttype.SalesReportType */
/* istanbul ignore next */
export class SalesReportType extends GandalfConstant<string> {
	static readonly ALL_SALES_BY_TYPE = new SalesReportType('allSalesByCategory', "All Sales by Type");
	static readonly ALL_SALES_BY_PROVIDER = new SalesReportType('allSalesByProvider', "All Sales by Provider");
	static readonly ALL_SALES_BY_EMPLOYEE = new SalesReportType('allSalesByEmployee', "All Sales by Employee");
	static readonly ALL_SALES_BY_PATIENT = new SalesReportType('allSalesByPatient', "All Sales by Patient");
	static readonly ALL_SALES_BY_PAYER = new SalesReportType('allSalesByPayor', "All Sales by Payer");
	static readonly ALL_SALES_BY_TAX = new SalesReportType('allSalesByTax', "All Sales by Tax");
	static readonly ALL_SALES_CHARGED_TAX = new SalesReportType('allSalesChargedTax', "All Sales Charged Tax");
	static readonly PRODUCTS_BY_CATEGORY = new SalesReportType('productsByCategory', "Products by Category");
	static readonly PRODUCTS_BY_PROVIDER = new SalesReportType('productsByProvider', "Products by Provider");
	static readonly SERVICES_BY_CATEGORY = new SalesReportType('servicesByCategory', "Services by Category");
	static readonly SERVICES_BY_PROVIDER = new SalesReportType('servicesByProvider', "Services by Provider");
	static readonly ADJUSTMENTS_BY_TYPE = new SalesReportType('adjustmentsByType', "Adjustments by Type");
	static readonly ADJUSTMENTS_BY_ITEM = new SalesReportType('adjustmentsByItem', "Adjustments by Item");
	
	static readonly VALUES: GandalfConstantList<SalesReportType> = {
		label: 'Sales Report Type',
		values: [SalesReportType.ALL_SALES_BY_TYPE, SalesReportType.ALL_SALES_BY_PROVIDER, SalesReportType.ALL_SALES_BY_EMPLOYEE, SalesReportType.ALL_SALES_BY_PATIENT, SalesReportType.ALL_SALES_BY_PAYER, SalesReportType.ALL_SALES_BY_TAX, SalesReportType.ALL_SALES_CHARGED_TAX, SalesReportType.PRODUCTS_BY_CATEGORY, SalesReportType.PRODUCTS_BY_PROVIDER, SalesReportType.SERVICES_BY_CATEGORY, SalesReportType.SERVICES_BY_PROVIDER, SalesReportType.ADJUSTMENTS_BY_TYPE, SalesReportType.ADJUSTMENTS_BY_ITEM, ]
	};
}

/** see com.rev360.model.vendor.constant.salesrepresentativestatus.SalesRepresentativeStatus */
/* istanbul ignore next */
export class SalesRepresentativeStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new SalesRepresentativeStatus(0, "Inactive");
	static readonly ACTIVE = new SalesRepresentativeStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<SalesRepresentativeStatus> = {
		label: 'Sales Representative Status',
		values: [SalesRepresentativeStatus.INACTIVE, SalesRepresentativeStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.common.constant.schedule.ScheduleIncrementPreferenceValues */
/* istanbul ignore next */
export class ScheduleIncrementPreferenceValues extends GandalfConstant<string> {
	static readonly FIVE_MINUTES = new ScheduleIncrementPreferenceValues('5', "5 minute increments");
	static readonly TEN_MINUTES = new ScheduleIncrementPreferenceValues('10', "10 minute increments");
	static readonly FIFTEEN_MINUTES = new ScheduleIncrementPreferenceValues('15', "15 minute increments");
	static readonly TWENTY_MINUTES = new ScheduleIncrementPreferenceValues('20', "20 minute increments");
	static readonly THIRTY_MINUTES = new ScheduleIncrementPreferenceValues('30', "30 minute increments");
	static readonly SIXTY_MINUTES = new ScheduleIncrementPreferenceValues('60', "60 minute increments");
	static readonly ONE_HUNDRED_TWENTY_MINUTES = new ScheduleIncrementPreferenceValues('120', "120 minute increments");
	
	static readonly VALUES: GandalfConstantList<ScheduleIncrementPreferenceValues> = {
		label: 'Schedule Increment Preference Values',
		values: [ScheduleIncrementPreferenceValues.FIVE_MINUTES, ScheduleIncrementPreferenceValues.TEN_MINUTES, ScheduleIncrementPreferenceValues.FIFTEEN_MINUTES, ScheduleIncrementPreferenceValues.TWENTY_MINUTES, ScheduleIncrementPreferenceValues.THIRTY_MINUTES, ScheduleIncrementPreferenceValues.SIXTY_MINUTES, ScheduleIncrementPreferenceValues.ONE_HUNDRED_TWENTY_MINUTES, ]
	};
}

/** see com.rev360.model.schedule.constant.scheduleitemfilterstatus.ScheduleItemFilterStatus */
/* istanbul ignore next */
export class ScheduleItemFilterStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new ScheduleItemFilterStatus(0, "Active");
	static readonly CANCELED = new ScheduleItemFilterStatus(1, "Office Canceled");
	static readonly RESCHEDULED = new ScheduleItemFilterStatus(2, "Rescheduled");
	static readonly COMPLETED = new ScheduleItemFilterStatus(3, "Completed");
	static readonly IN_PROGRESS = new ScheduleItemFilterStatus(4, "In-Progress");
	static readonly NO_SHOW = new ScheduleItemFilterStatus(5, "No Show");
	static readonly PATIENT_CANCELED = new ScheduleItemFilterStatus(6, "Patient Canceled");
	static readonly ALL_SLOTS = new ScheduleItemFilterStatus(100, "All Slots");
	static readonly AVAILABLE_SLOTS = new ScheduleItemFilterStatus(101, "Available Slots");
	static readonly UNAVAILABLE_SLOTS = new ScheduleItemFilterStatus(102, "Unavailable Slots");
	
	static readonly VALUES: GandalfConstantList<ScheduleItemFilterStatus> = {
		label: 'Schedule Item Filter Status',
		values: [ScheduleItemFilterStatus.ACTIVE, ScheduleItemFilterStatus.CANCELED, ScheduleItemFilterStatus.RESCHEDULED, ScheduleItemFilterStatus.COMPLETED, ScheduleItemFilterStatus.IN_PROGRESS, ScheduleItemFilterStatus.NO_SHOW, ScheduleItemFilterStatus.PATIENT_CANCELED, ScheduleItemFilterStatus.ALL_SLOTS, ScheduleItemFilterStatus.AVAILABLE_SLOTS, ScheduleItemFilterStatus.UNAVAILABLE_SLOTS, ]
	};
}

/** see com.rev360.model.schedule.constant.scheduleitemstatus.ScheduleItemStatus */
/* istanbul ignore next */
export class ScheduleItemStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new ScheduleItemStatus(0, "Active");
	static readonly CANCELED = new ScheduleItemStatus(1, "Canceled");
	static readonly RESCHEDULED = new ScheduleItemStatus(2, "Rescheduled");
	static readonly COMPLETED = new ScheduleItemStatus(3, "Completed");
	static readonly IN_PROGRESS = new ScheduleItemStatus(4, "In-Progress");
	static readonly NO_SHOW = new ScheduleItemStatus(5, "No Show");
	static readonly PATIENT_CANCELED = new ScheduleItemStatus(6, "Patient Canceled");
	
	static readonly VALUES: GandalfConstantList<ScheduleItemStatus> = {
		label: 'Schedule Item Status',
		values: [ScheduleItemStatus.ACTIVE, ScheduleItemStatus.CANCELED, ScheduleItemStatus.RESCHEDULED, ScheduleItemStatus.COMPLETED, ScheduleItemStatus.IN_PROGRESS, ScheduleItemStatus.NO_SHOW, ScheduleItemStatus.PATIENT_CANCELED, ]
	};
}

/** see com.rev360.model.schedule.constant.scheduleitemtype.ScheduleItemType */
/* istanbul ignore next */
export class ScheduleItemType extends GandalfConstant<number> {
	static readonly NONE = new ScheduleItemType(0, "");
	static readonly APPOINTMENT = new ScheduleItemType(1, "Appointment");
	static readonly BUSY = new ScheduleItemType(2, "Busy Time");
	static readonly MEETING = new ScheduleItemType(3, "Meeting");
	static readonly HOLIDAY = new ScheduleItemType(4, "Holiday");
	static readonly OFFICE_CLOSED = new ScheduleItemType(5, "Office Closed");
	static readonly PERSONAL_TIME = new ScheduleItemType(6, "Personal Time");
	static readonly VACATION = new ScheduleItemType(7, "Vacation");
	static readonly EMPLOYEE_HOURS = new ScheduleItemType(8, "Employee Hours");
	static readonly APPOINTMENT_SLOT = new ScheduleItemType(9, "Appointment Slot");
	static readonly LUNCH_HOURS = new ScheduleItemType(10, "Lunch Hours");
	
	static readonly VALUES: GandalfConstantList<ScheduleItemType> = {
		label: 'Schedule Item Type',
		values: [ScheduleItemType.NONE, ScheduleItemType.APPOINTMENT, ScheduleItemType.BUSY, ScheduleItemType.MEETING, ScheduleItemType.HOLIDAY, ScheduleItemType.OFFICE_CLOSED, ScheduleItemType.PERSONAL_TIME, ScheduleItemType.VACATION, ScheduleItemType.EMPLOYEE_HOURS, ScheduleItemType.APPOINTMENT_SLOT, ScheduleItemType.LUNCH_HOURS, ]
	};
}

/** see com.rev360.model.common.constant.schedule.ScheduleLayoutPreferenceValues */
/* istanbul ignore next */
export class ScheduleLayoutPreferenceValues extends GandalfConstant<string> {
	static readonly HORIZONTAL = new ScheduleLayoutPreferenceValues('horizontal', "Horizontal");
	static readonly VERTICAL = new ScheduleLayoutPreferenceValues('vertical', "Vertical");
	
	static readonly VALUES: GandalfConstantList<ScheduleLayoutPreferenceValues> = {
		label: 'Schedule Layout',
		values: [ScheduleLayoutPreferenceValues.HORIZONTAL, ScheduleLayoutPreferenceValues.VERTICAL, ]
	};
}

/** see com.rev360.model.common.constant.preferencename.SchedulePodDefaultTabPreferenceValues */
/* istanbul ignore next */
export class SchedulePodDefaultTabPreferenceValues extends GandalfConstant<string> {
	static readonly ALL = new SchedulePodDefaultTabPreferenceValues('all', "All");
	static readonly UPCOMING = new SchedulePodDefaultTabPreferenceValues('upcoming', "Upcoming");
	static readonly IN_PROGRESS = new SchedulePodDefaultTabPreferenceValues('inprogress', "In Progress");
	static readonly COMPLETED = new SchedulePodDefaultTabPreferenceValues('completed', "Completed");
	
	static readonly VALUES: GandalfConstantList<SchedulePodDefaultTabPreferenceValues> = {
		label: 'Schedule Pod Default Tab Preference Values',
		values: [SchedulePodDefaultTabPreferenceValues.ALL, SchedulePodDefaultTabPreferenceValues.UPCOMING, SchedulePodDefaultTabPreferenceValues.IN_PROGRESS, SchedulePodDefaultTabPreferenceValues.COMPLETED, ]
	};
}

/** see com.rev360.model.common.constant.schedule.ScheduleView */
/* istanbul ignore next */
export class ScheduleView extends GandalfConstant<string> {
	static readonly DAY = new ScheduleView('day', "Day");
	static readonly WEEK = new ScheduleView('week', "Week");
	static readonly WORK_WEEK = new ScheduleView('workWeek', "Work Week");
	
	static readonly VALUES: GandalfConstantList<ScheduleView> = {
		label: 'Schedule View',
		values: [ScheduleView.DAY, ScheduleView.WEEK, ScheduleView.WORK_WEEK, ]
	};
}

/** see com.rev360.model.utilities.constant.scheduledbatchjobstatus.ScheduledBatchJobStatus */
/* istanbul ignore next */
export class ScheduledBatchJobStatus extends GandalfConstant<number> {
	static readonly PENDING = new ScheduledBatchJobStatus(1, "Pending");
	static readonly PROCESSING = new ScheduledBatchJobStatus(2, "Processing");
	static readonly COMPLETE = new ScheduledBatchJobStatus(3, "Complete");
	static readonly ERROR = new ScheduledBatchJobStatus(4, "Error");
	static readonly CANCELED = new ScheduledBatchJobStatus(5, "Canceled");
	
	static readonly VALUES: GandalfConstantList<ScheduledBatchJobStatus> = {
		label: 'Scheduled Batch Job Status',
		values: [ScheduledBatchJobStatus.PENDING, ScheduledBatchJobStatus.PROCESSING, ScheduledBatchJobStatus.COMPLETE, ScheduledBatchJobStatus.ERROR, ScheduledBatchJobStatus.CANCELED, ]
	};
}

/** see com.rev360.model.patient.constant.schedulingpreferencesschedulerisk.SchedulingPreferencesScheduleRisk */
/* istanbul ignore next */
export class SchedulingPreferencesScheduleRisk extends GandalfConstant<number> {
	static readonly LOW = new SchedulingPreferencesScheduleRisk(1, "Low");
	static readonly MEDIUM = new SchedulingPreferencesScheduleRisk(2, "Medium");
	static readonly HIGH = new SchedulingPreferencesScheduleRisk(3, "High");
	
	static readonly VALUES: GandalfConstantList<SchedulingPreferencesScheduleRisk> = {
		label: 'Scheduling Preferences Schedule Risk',
		values: [SchedulingPreferencesScheduleRisk.LOW, SchedulingPreferencesScheduleRisk.MEDIUM, SchedulingPreferencesScheduleRisk.HIGH, ]
	};
}

/** see com.rev360.model.patient.constant.schedulingpreferencestimeofday.SchedulingPreferencesTimeOfDay */
/* istanbul ignore next */
export class SchedulingPreferencesTimeOfDay extends GandalfConstant<number> {
	static readonly NONE = new SchedulingPreferencesTimeOfDay(-1, "None");
	static readonly EARLY_MORNING = new SchedulingPreferencesTimeOfDay(0, "Early Morning (Before 9:00 AM)");
	static readonly LATE_MORNING = new SchedulingPreferencesTimeOfDay(1, "Late Morning (9:00 AM - 11:00 AM)");
	static readonly LUNCH = new SchedulingPreferencesTimeOfDay(2, "Lunch (11:00 AM - 1:00 PM)");
	static readonly AFTERNOON = new SchedulingPreferencesTimeOfDay(3, "Afternoon (1:00 PM - 4:00 PM)");
	static readonly EVENING = new SchedulingPreferencesTimeOfDay(4, "Evening (After 4:00 PM)");
	static readonly ANY = new SchedulingPreferencesTimeOfDay(5, "Anytime");
	
	static readonly VALUES: GandalfConstantList<SchedulingPreferencesTimeOfDay> = {
		label: 'Scheduling Preferences Time Of Day',
		values: [SchedulingPreferencesTimeOfDay.NONE, SchedulingPreferencesTimeOfDay.EARLY_MORNING, SchedulingPreferencesTimeOfDay.LATE_MORNING, SchedulingPreferencesTimeOfDay.LUNCH, SchedulingPreferencesTimeOfDay.AFTERNOON, SchedulingPreferencesTimeOfDay.EVENING, SchedulingPreferencesTimeOfDay.ANY, ]
	};
}

/** see com.rev360.model.email.constant.sendingsystem.SendingSystem */
/* istanbul ignore next */
export class SendingSystem extends GandalfConstant<number> {
	static readonly CONNECT_CAMPAIGNS = new SendingSystem(1, "Connect Campaigns");
	static readonly CONNECT = new SendingSystem(2, "Connect");
	
	static readonly VALUES: GandalfConstantList<SendingSystem> = {
		label: 'Sending System',
		values: [SendingSystem.CONNECT_CAMPAIGNS, SendingSystem.CONNECT, ]
	};
}

/** see com.rev360.model.practice.constant.servicelocationindicator.ServiceLocationIndicator */
/* istanbul ignore next */
export class ServiceLocationIndicator extends GandalfConstant<string> {
	static readonly HDS = new ServiceLocationIndicator('HDS', "Hospital Day Surgery");
	static readonly HED = new ServiceLocationIndicator('HED', "Hospital Emergency Department");
	static readonly HIP = new ServiceLocationIndicator('HIP', "Hospital In-Patient");
	static readonly HOP = new ServiceLocationIndicator('HOP', "Hospital Out-Patient");
	static readonly HRP = new ServiceLocationIndicator('HRP', "Hospital Referred Patient");
	static readonly IHF = new ServiceLocationIndicator('IHF', "Independent Health Facility");
	static readonly OFF = new ServiceLocationIndicator('OFF', "Office of community physician");
	static readonly OTN = new ServiceLocationIndicator('OTN', "Ontario Telemedicine Network");
	static readonly PDF = new ServiceLocationIndicator('PDF', "Private Diagnostic Facility");
	static readonly RTF = new ServiceLocationIndicator('RTF', "Rehabilitation Treatment Facility");
	
	static readonly VALUES: GandalfConstantList<ServiceLocationIndicator> = {
		label: 'Service Location Indicator',
		values: [ServiceLocationIndicator.HDS, ServiceLocationIndicator.HED, ServiceLocationIndicator.HIP, ServiceLocationIndicator.HOP, ServiceLocationIndicator.HRP, ServiceLocationIndicator.IHF, ServiceLocationIndicator.OFF, ServiceLocationIndicator.OTN, ServiceLocationIndicator.PDF, ServiceLocationIndicator.RTF, ]
	};
}

/** see com.rev360.model.inventory.service.constant.servicetype.ServiceType */
/* istanbul ignore next */
export class ServiceType extends GandalfConstant<number> {
	static readonly CPT = new ServiceType(1, "CPT");
	static readonly OTHER = new ServiceType(2, "Other");
	
	static readonly VALUES: GandalfConstantList<ServiceType> = {
		label: 'Service Type',
		values: [ServiceType.CPT, ServiceType.OTHER, ]
	};
}

/** see com.rev360.model.serviceuser.constant.serviceuserrolename.ServiceUserRoleName */
/* istanbul ignore next */
export class ServiceUserRoleName extends GandalfConstant<string> {
	static readonly CUSTOMER_CARE = new ServiceUserRoleName('customer_care', "customer_care");
	static readonly CUSTOMER_CARE_AFFILIATIONS = new ServiceUserRoleName('customer_care_affiliations', "customer_care_affiliations");
	static readonly CUSTOMER_CARE_DATA = new ServiceUserRoleName('customer_care_data', "customer_care_data");
	static readonly CUSTOMER_CARE_REGISTER_PRACTICE = new ServiceUserRoleName('customer_care_register_practice', "customer_care_register_practice");
	static readonly CUSTOMER_CARE_MOTD = new ServiceUserRoleName('customer_care_motd', "customer_care_motd");
	static readonly CUSTOMER_CARE_ADMIN = new ServiceUserRoleName('customer_care_admin', "customer_care_admin");
	static readonly CUSTOMER_CARE_SOLUTIONS = new ServiceUserRoleName('customer_care_solutions', "customer_care_solutions");
	static readonly CUSTOMER_CARE_CLEAR_TAB_MAPPINGS = new ServiceUserRoleName('customer_care_clear_tab_mappings', "customer_care_clear_tab_mappings");
	static readonly CUSTOMER_CARE_TEST_BUILDER = new ServiceUserRoleName('customer_care_test_builder', "customer_care_test_builder");
	static readonly CUSTOMER_CARE_GENERAL_AI_PROMPT = new ServiceUserRoleName('customer_care_general_ai_prompt', "customer_care_general_ai_prompt");
	static readonly REVBILLING = new ServiceUserRoleName('revbilling', "revbilling");
	static readonly REVBILLING_EDIT = new ServiceUserRoleName('revbilling_edit', "revbilling_edit");
	static readonly REVASSURE = new ServiceUserRoleName('revassure', "revassure");
	static readonly REVCYCLE = new ServiceUserRoleName('revcycle', "revcycle");
	static readonly REVCYCLE_ADMIN = new ServiceUserRoleName('revcycle_admin', "revcycle_admin");
	static readonly REVCYCLE_MANAGER = new ServiceUserRoleName('revcycle_manager', "revcycle_manager");
	static readonly REVCYCLE_BILLER = new ServiceUserRoleName('revcycle_biller', "revcycle_biller");
	static readonly REVASPIRE = new ServiceUserRoleName('revaspire', "revaspire");
	static readonly FEATURE_FLAG_VIEW = new ServiceUserRoleName('feature_flag_view', "feature_flag_view");
	static readonly FEATURE_FLAG_MANAGE = new ServiceUserRoleName('feature_flag_manage', "feature_flag_manage");
	
	static readonly VALUES: GandalfConstantList<ServiceUserRoleName> = {
		label: 'Service User Role Name',
		values: [ServiceUserRoleName.CUSTOMER_CARE, ServiceUserRoleName.CUSTOMER_CARE_AFFILIATIONS, ServiceUserRoleName.CUSTOMER_CARE_DATA, ServiceUserRoleName.CUSTOMER_CARE_REGISTER_PRACTICE, ServiceUserRoleName.CUSTOMER_CARE_MOTD, ServiceUserRoleName.CUSTOMER_CARE_ADMIN, ServiceUserRoleName.CUSTOMER_CARE_SOLUTIONS, ServiceUserRoleName.CUSTOMER_CARE_CLEAR_TAB_MAPPINGS, ServiceUserRoleName.CUSTOMER_CARE_TEST_BUILDER, ServiceUserRoleName.CUSTOMER_CARE_GENERAL_AI_PROMPT, ServiceUserRoleName.REVBILLING, ServiceUserRoleName.REVBILLING_EDIT, ServiceUserRoleName.REVASSURE, ServiceUserRoleName.REVCYCLE, ServiceUserRoleName.REVCYCLE_ADMIN, ServiceUserRoleName.REVCYCLE_MANAGER, ServiceUserRoleName.REVCYCLE_BILLER, ServiceUserRoleName.REVASPIRE, ServiceUserRoleName.FEATURE_FLAG_VIEW, ServiceUserRoleName.FEATURE_FLAG_MANAGE, ]
	};
}

/** see com.rev360.model.serviceuser.constant.serviceuserrolestatus.ServiceUserRoleStatus */
/* istanbul ignore next */
export class ServiceUserRoleStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new ServiceUserRoleStatus(0, "Inactive");
	static readonly ACTIVE = new ServiceUserRoleStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<ServiceUserRoleStatus> = {
		label: 'ServiceUser Role Status',
		values: [ServiceUserRoleStatus.INACTIVE, ServiceUserRoleStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.serviceuser.constant.serviceuserstatus.ServiceUserStatus */
/* istanbul ignore next */
export class ServiceUserStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new ServiceUserStatus(0, "Inactive");
	static readonly ACTIVE = new ServiceUserStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<ServiceUserStatus> = {
		label: 'ServiceUser Status',
		values: [ServiceUserStatus.INACTIVE, ServiceUserStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.data.constant.sexualorientation.SexualOrientation */
/* istanbul ignore next */
export class SexualOrientation extends GandalfConstant<number> {
	static readonly LESBIAN_GAY_HOMOSEXUAL = new SexualOrientation(20000, "Lesbian, gay or homosexual");
	static readonly STRAIGHT_OR_HETEROSEXUAL = new SexualOrientation(20001, "Straight or heterosexual");
	static readonly BISEXUAL = new SexualOrientation(20002, "Bisexual");
	static readonly SOMETHING_ELSE = new SexualOrientation(20003, "Something else, please describe");
	static readonly UNKNOWN = new SexualOrientation(20004, "Unknown");
	static readonly UNDISCLOSED = new SexualOrientation(20005, "Choose not to disclose");
	
	static readonly VALUES: GandalfConstantList<SexualOrientation> = {
		label: 'Sexual Orientation',
		values: [SexualOrientation.LESBIAN_GAY_HOMOSEXUAL, SexualOrientation.STRAIGHT_OR_HETEROSEXUAL, SexualOrientation.BISEXUAL, SexualOrientation.SOMETHING_ELSE, SexualOrientation.UNKNOWN, SexualOrientation.UNDISCLOSED, ]
	};
}

/** see com.rev360.pms.service.smartflow.constant.SmartflowMasterManufacturer */
/* istanbul ignore next */
export class SmartflowMasterManufacturer extends GandalfConstant<string> {
	static readonly TWELVE84 = new SmartflowMasterManufacturer('TWELVE84', "twelve84");
	
	static readonly VALUES: GandalfConstantList<SmartflowMasterManufacturer> = {
		label: 'Smartflow Master Manufacturer',
		values: [SmartflowMasterManufacturer.TWELVE84, ]
	};
}

/** see com.rev360.pms.service.smartflow.constant.SmartflowMasterSupplierType */
/* istanbul ignore next */
export class SmartflowMasterSupplierType extends GandalfConstant<string> {
	static readonly TWELVE84 = new SmartflowMasterSupplierType('TWELVE84', "twelve84");
	
	static readonly VALUES: GandalfConstantList<SmartflowMasterSupplierType> = {
		label: 'Smartflow Master Supplier Type',
		values: [SmartflowMasterSupplierType.TWELVE84, ]
	};
}

/** see com.rev360.model.smartflow.constant.smartflowproductpartnercategory.SmartflowProductPartnerCategory */
/* istanbul ignore next */
export class SmartflowProductPartnerCategory extends GandalfConstant<number> {
	static readonly CONTACT_LENS_DISTRIBUTOR = new SmartflowProductPartnerCategory(1, "Contact Lens Distributor");
	static readonly CONTACT_LENS_MANUFACTURER = new SmartflowProductPartnerCategory(2, "Contact Lens Manufacturer");
	static readonly FRAME_MANUFACTURER = new SmartflowProductPartnerCategory(3, "Frame Manufacturer");
	static readonly EYEGLASS_LENS_LAB = new SmartflowProductPartnerCategory(4, "Eyeglass Lens Lab");
	
	static readonly VALUES: GandalfConstantList<SmartflowProductPartnerCategory> = {
		label: 'Smartflow Product Partner Category',
		values: [SmartflowProductPartnerCategory.CONTACT_LENS_DISTRIBUTOR, SmartflowProductPartnerCategory.CONTACT_LENS_MANUFACTURER, SmartflowProductPartnerCategory.FRAME_MANUFACTURER, SmartflowProductPartnerCategory.EYEGLASS_LENS_LAB, ]
	};
}

/** see com.rev360.model.history.constant.smokingpreference.SmokingPreference */
/* istanbul ignore next */
export class SmokingPreference extends GandalfConstant<number> {
	static readonly NONE = new SmokingPreference(0, "No preference");
	static readonly CIGARETTE = new SmokingPreference(1, "Cigarettes");
	static readonly CIGAR = new SmokingPreference(2, "Cigars");
	static readonly PIPE = new SmokingPreference(3, "Pipes");
	static readonly OTHER = new SmokingPreference(4, "Other");
	static readonly SMOKELESS = new SmokingPreference(5, "Smokeless tobacco");
	
	static readonly VALUES: GandalfConstantList<SmokingPreference> = {
		label: 'Preference',
		values: [SmokingPreference.NONE, SmokingPreference.CIGARETTE, SmokingPreference.CIGAR, SmokingPreference.PIPE, SmokingPreference.OTHER, SmokingPreference.SMOKELESS, ]
	};
}

/** see com.rev360.model.history.constant.smokingstatus.SmokingStatus */
/* istanbul ignore next */
export class SmokingStatus extends GandalfConstant<number> {
	static readonly UNKNOWN_EVER = new SmokingStatus(0, "Unknown if ever smoked");
	static readonly UNKNOWN_CURRENT = new SmokingStatus(1, "Smoker, current status unknown");
	static readonly NEVER = new SmokingStatus(2, "Never smoker");
	static readonly FORMER = new SmokingStatus(3, "Former smoker");
	static readonly SOMEDAY = new SmokingStatus(4, "Current some day smoker");
	static readonly EVERYDAY = new SmokingStatus(5, "Current every day smoker");
	static readonly UNKNOWN = new SmokingStatus(6, "Unknown if ever smoked");
	static readonly HEAVY = new SmokingStatus(7, "Heavy tobacco smoker");
	static readonly LIGHT = new SmokingStatus(8, "Light tobacco smoker");
	
	static readonly VALUES: GandalfConstantList<SmokingStatus> = {
		label: 'Status',
		values: [SmokingStatus.UNKNOWN_EVER, SmokingStatus.UNKNOWN_CURRENT, SmokingStatus.NEVER, SmokingStatus.FORMER, SmokingStatus.SOMEDAY, SmokingStatus.EVERYDAY, SmokingStatus.UNKNOWN, SmokingStatus.HEAVY, SmokingStatus.LIGHT, ]
	};
}

/** see com.rev360.model.snomed.constant.SnomedFamilialRelationship */
/* istanbul ignore next */
export class SnomedFamilialRelationship extends GandalfConstant<string> {
	static readonly FATHER = new SnomedFamilialRelationship('66839005', "Father");
	static readonly MOTHER = new SnomedFamilialRelationship('72705000', "Mother");
	static readonly SON = new SnomedFamilialRelationship('65616008', "Son");
	static readonly DAUGHTER = new SnomedFamilialRelationship('66089001', "Daughter");
	static readonly BROTHER = new SnomedFamilialRelationship('70924004', "Brother");
	static readonly SISTER = new SnomedFamilialRelationship('27733009', "Sister");
	
	static readonly VALUES: GandalfConstantList<SnomedFamilialRelationship> = {
		label: 'Relationship',
		values: [SnomedFamilialRelationship.FATHER, SnomedFamilialRelationship.MOTHER, SnomedFamilialRelationship.SON, SnomedFamilialRelationship.DAUGHTER, SnomedFamilialRelationship.BROTHER, SnomedFamilialRelationship.SISTER, ]
	};
}

/** see com.rev360.model.snomed.constant.SnomedType */
/* istanbul ignore next */
export class SnomedType extends GandalfConstant<number> {
	static readonly GENERAL = new SnomedType(0, "General");
	static readonly PROCEDURE = new SnomedType(1, "Procedure");
	static readonly CLINICAL_FINDING = new SnomedType(2, "Clinical Finding");
	
	static readonly VALUES: GandalfConstantList<SnomedType> = {
		label: 'Type',
		values: [SnomedType.GENERAL, SnomedType.PROCEDURE, SnomedType.CLINICAL_FINDING, ]
	};
}

/** see com.rev360.jpa.repository.constant.sortorder.SortOrder */
/* istanbul ignore next */
export class SortOrder extends GandalfConstant<number> {
	static readonly ASCENDING = new SortOrder(1, "Ascending");
	static readonly DESCENDING = new SortOrder(2, "Descending");
	
	static readonly VALUES: GandalfConstantList<SortOrder> = {
		label: 'Sort Order',
		values: [SortOrder.ASCENDING, SortOrder.DESCENDING, ]
	};
}

/** see com.rev360.model.example.rpg.spell.constant.spellstatus.SpellStatus */
/* istanbul ignore next */
export class SpellStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new SpellStatus(0, "Inactive");
	static readonly ACTIVE = new SpellStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<SpellStatus> = {
		label: 'Status',
		values: [SpellStatus.INACTIVE, SpellStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.example.sprocket.constant.sprockettype.SprocketType */
/* istanbul ignore next */
export class SprocketType extends GandalfConstant<number> {
	static readonly A_TYPE = new SprocketType(0, "A-type");
	static readonly A_TYPE_HARDENED_TEETH = new SprocketType(1, "Hardened teeth A-type");
	static readonly B_TYPE_SINGLE_STRAND = new SprocketType(2, "Single-strand B-type");
	static readonly B_TYPE_DOUBLE_STRANDS = new SprocketType(3, "Double-strands B-type");
	static readonly KB_TYPE_SINGLE = new SprocketType(4, "Single KB-type");
	static readonly KB_TYPE_DOUBLE = new SprocketType(5, "Double KB-type");
	
	static readonly VALUES: GandalfConstantList<SprocketType> = {
		label: 'Sprocket Type',
		values: [SprocketType.A_TYPE, SprocketType.A_TYPE_HARDENED_TEETH, SprocketType.B_TYPE_SINGLE_STRAND, SprocketType.B_TYPE_DOUBLE_STRANDS, SprocketType.KB_TYPE_SINGLE, SprocketType.KB_TYPE_DOUBLE, ]
	};
}

/** see com.rev360.pms.api.controller.accounting.StatementFormat */
/* istanbul ignore next */
export class StatementFormat extends GandalfConstant<number> {
	static readonly PDF = new StatementFormat(1, "PDF");
	static readonly XML = new StatementFormat(2, "XML");
	
	static readonly VALUES: GandalfConstantList<StatementFormat> = {
		label: 'Statement Format',
		values: [StatementFormat.PDF, StatementFormat.XML, ]
	};
}

/** see com.rev360.model.practice.constant.stockexchange.StockExchange */
/* istanbul ignore next */
export class StockExchange extends GandalfConstant<number> {
	static readonly NASDAQ = new StockExchange(1, "NASDAQ");
	static readonly NYSE = new StockExchange(2, "NYSE");
	
	static readonly VALUES: GandalfConstantList<StockExchange> = {
		label: 'Stock Exchange',
		values: [StockExchange.NASDAQ, StockExchange.NYSE, ]
	};
}

/** see com.rev360.model.common.constant.systemconfiginstallmode.SystemConfigInstallMode */
/* istanbul ignore next */
export class SystemConfigInstallMode extends GandalfConstant<string> {
	static readonly STANDARD = new SystemConfigInstallMode('Standard', "Standard");
	static readonly CANADA = new SystemConfigInstallMode('Canada', "Canada");
	
	static readonly VALUES: GandalfConstantList<SystemConfigInstallMode> = {
		label: 'SystemConfigInstallMode',
		values: [SystemConfigInstallMode.STANDARD, SystemConfigInstallMode.CANADA, ]
	};
}

/** see com.rev360.model.person.constant.taskpriority.TaskPriority */
/* istanbul ignore next */
export class TaskPriority extends GandalfConstant<number> {
	static readonly HIGH = new TaskPriority(0, "High");
	static readonly NORMAL = new TaskPriority(1, "Normal");
	static readonly LOW = new TaskPriority(2, "Low");
	
	static readonly VALUES: GandalfConstantList<TaskPriority> = {
		label: 'Task Priority',
		values: [TaskPriority.HIGH, TaskPriority.NORMAL, TaskPriority.LOW, ]
	};
}

/** see com.rev360.model.person.constant.taskstatus.TaskStatus */
/* istanbul ignore next */
export class TaskStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new TaskStatus(1, "Active");
	static readonly COMPLETED = new TaskStatus(2, "Completed");
	static readonly CANCELED = new TaskStatus(3, "Canceled");
	static readonly UNASSIGNED = new TaskStatus(4, "Unassigned");
	
	static readonly VALUES: GandalfConstantList<TaskStatus> = {
		label: 'Task Status',
		values: [TaskStatus.ACTIVE, TaskStatus.COMPLETED, TaskStatus.CANCELED, TaskStatus.UNASSIGNED, ]
	};
}

/** see com.rev360.model.document.constant.templatecategory.TemplateCategory */
/* istanbul ignore next */
export class TemplateCategory extends GandalfConstant<number> {
	static readonly PATIENT = new TemplateCategory(1, "Patient");
	static readonly ENCOUNTER = new TemplateCategory(2, "Encounter");
	static readonly CONNECT = new TemplateCategory(3, "Connect");
	
	static readonly VALUES: GandalfConstantList<TemplateCategory> = {
		label: 'Template Category',
		values: [TemplateCategory.PATIENT, TemplateCategory.ENCOUNTER, TemplateCategory.CONNECT, ]
	};
}

/** see com.rev360.model.document.constant.templateformat.TemplateFormat */
/* istanbul ignore next */
export class TemplateFormat extends GandalfConstant<number> {
	static readonly FLEX = new TemplateFormat(0, "FLEX");
	static readonly HTML = new TemplateFormat(1, "HTML");
	
	static readonly VALUES: GandalfConstantList<TemplateFormat> = {
		label: 'Template Format',
		values: [TemplateFormat.FLEX, TemplateFormat.HTML, ]
	};
}

/** see com.rev360.model.document.constant.templatemeasurementunit.TemplateMeasurementUnit */
/* istanbul ignore next */
export class TemplateMarginUnit extends GandalfConstant<number> {
	static readonly NONE = new TemplateMarginUnit(0, "None");
	static readonly PIXEL = new TemplateMarginUnit(1, "px");
	static readonly INCH = new TemplateMarginUnit(2, "in");
	static readonly CENTIMETER = new TemplateMarginUnit(3, "cm");
	
	static readonly VALUES: GandalfConstantList<TemplateMarginUnit> = {
		label: 'Template Margin Unit',
		values: [TemplateMarginUnit.NONE, TemplateMarginUnit.PIXEL, TemplateMarginUnit.INCH, TemplateMarginUnit.CENTIMETER, ]
	};
}

/** see com.rev360.model.document.constant.templatepagesize.TemplatePageSize */
/* istanbul ignore next */
export class TemplatePageSize extends GandalfConstant<number> {
	static readonly UNKNOWN = new TemplatePageSize(0, "0");
	static readonly A4 = new TemplatePageSize(1, "A4");
	static readonly LETTER = new TemplatePageSize(2, "Letter");
	
	static readonly VALUES: GandalfConstantList<TemplatePageSize> = {
		label: 'TemplatePageSize',
		values: [TemplatePageSize.UNKNOWN, TemplatePageSize.A4, TemplatePageSize.LETTER, ]
	};
}

/** see com.rev360.model.encounter.constant.templatestatus.TemplateStatus */
/* istanbul ignore next */
export class TemplateStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new TemplateStatus(1, "Active");
	static readonly INACTIVE = new TemplateStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<TemplateStatus> = {
		label: 'Template Status',
		values: [TemplateStatus.ACTIVE, TemplateStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.history.constant.tocreceivedstatus.TocReceivedStatus */
/* istanbul ignore next */
export class TocReceivedStatus extends GandalfConstant<number> {
	static readonly RECEIVED = new TocReceivedStatus(1, "Received and Incorporated");
	static readonly REQUESTED_NOT_RECEIVED = new TocReceivedStatus(2, "Requested, but Unavailable");
	
	static readonly VALUES: GandalfConstantList<TocReceivedStatus> = {
		label: 'Transition of Care Received Status',
		values: [TocReceivedStatus.RECEIVED, TocReceivedStatus.REQUESTED_NOT_RECEIVED, ]
	};
}

/** see com.rev360.model.bridge.constant.tokenstatus.TokenStatus */
/* istanbul ignore next */
export class TokenStatus extends GandalfConstant<number> {
	static readonly CREATED = new TokenStatus(5, "Created");
	static readonly IN_PROGRESS = new TokenStatus(6, "In-Progress");
	static readonly SUCCESS = new TokenStatus(7, "Success");
	static readonly EXCEPTION = new TokenStatus(8, "Exception");
	
	static readonly VALUES: GandalfConstantList<TokenStatus> = {
		label: 'Token Status',
		values: [TokenStatus.CREATED, TokenStatus.IN_PROGRESS, TokenStatus.SUCCESS, TokenStatus.EXCEPTION, ]
	};
}

/** see com.rev360.model.bridge.constant.tokentaskstatus.TokenTaskStatus */
/* istanbul ignore next */
export class TokenTaskStatus extends GandalfConstant<number> {
	static readonly CREATED = new TokenTaskStatus(1, "Created");
	static readonly IN_PROGRESS = new TokenTaskStatus(2, "In-Progress");
	static readonly SUCCESS = new TokenTaskStatus(3, "Success");
	static readonly EXCEPTION = new TokenTaskStatus(4, "Exception");
	
	static readonly VALUES: GandalfConstantList<TokenTaskStatus> = {
		label: 'Token Task Status',
		values: [TokenTaskStatus.CREATED, TokenTaskStatus.IN_PROGRESS, TokenTaskStatus.SUCCESS, TokenTaskStatus.EXCEPTION, ]
	};
}

/** see com.rev360.pms.api.controller.accounting.TransferType */
/* istanbul ignore next */
export class TransferType extends GandalfConstant<number> {
	static readonly TRANSFER = new TransferType(1, "Transfer");
	static readonly WRITEOFF = new TransferType(2, "Write-off");
	
	static readonly VALUES: GandalfConstantList<TransferType> = {
		label: 'Transfer Type',
		values: [TransferType.TRANSFER, TransferType.WRITEOFF, ]
	};
}

/** see com.rev360.model.query.constant.triggeroutcomestatus.TriggerOutcomeStatus */
/* istanbul ignore next */
export class TriggerOutcomeStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new TriggerOutcomeStatus(1, "Active");
	static readonly INACTIVE = new TriggerOutcomeStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<TriggerOutcomeStatus> = {
		label: 'Trigger Outcome Status',
		values: [TriggerOutcomeStatus.ACTIVE, TriggerOutcomeStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.query.constant.triggeroutcometype.TriggerOutcomeType */
/* istanbul ignore next */
export class TriggerOutcomeType extends GandalfConstant<number> {
	static readonly ALERT = new TriggerOutcomeType(1, "Alert");
	static readonly CARE_PLAN_ITEM = new TriggerOutcomeType(2, "Care Plan Item");
	static readonly CARE_PLAN_TEMPLATE = new TriggerOutcomeType(3, "Care Plan Template");
	
	static readonly VALUES: GandalfConstantList<TriggerOutcomeType> = {
		label: 'Trigger Outcome Type',
		values: [TriggerOutcomeType.ALERT, TriggerOutcomeType.CARE_PLAN_ITEM, TriggerOutcomeType.CARE_PLAN_TEMPLATE, ]
	};
}

/** see com.rev360.model.workflow.constant.triggerrulefieldvaluecompareoperator.TriggerRuleFieldValueCompareOperator */
/* istanbul ignore next */
export class TriggerRuleFieldValueCompareOperator extends GandalfConstant<number> {
	static readonly EQUAL = new TriggerRuleFieldValueCompareOperator(1, "Equal");
	static readonly NOT_EQUAL = new TriggerRuleFieldValueCompareOperator(2, "Not Equal");
	static readonly LESS_THAN = new TriggerRuleFieldValueCompareOperator(3, "Less Than");
	static readonly LESS_THAN_OR_EQUAL = new TriggerRuleFieldValueCompareOperator(4, "Less Than or Equal");
	static readonly GREATER_THAN = new TriggerRuleFieldValueCompareOperator(5, "Greater Than");
	static readonly GREATER_THAN_OR_EQUAL = new TriggerRuleFieldValueCompareOperator(6, "Greater Than or Equal");
	
	static readonly VALUES: GandalfConstantList<TriggerRuleFieldValueCompareOperator> = {
		label: 'Trigger Rule Field Value Compare Operator',
		values: [TriggerRuleFieldValueCompareOperator.EQUAL, TriggerRuleFieldValueCompareOperator.NOT_EQUAL, TriggerRuleFieldValueCompareOperator.LESS_THAN, TriggerRuleFieldValueCompareOperator.LESS_THAN_OR_EQUAL, TriggerRuleFieldValueCompareOperator.GREATER_THAN, TriggerRuleFieldValueCompareOperator.GREATER_THAN_OR_EQUAL, ]
	};
}

/** see com.rev360.pms.service.encounter.constant.TriggerRuleType */
/* istanbul ignore next */
export class TriggerRuleType extends GandalfConstant<number> {
	static readonly ANY = new TriggerRuleType(0, "Any field");
	static readonly ALL = new TriggerRuleType(1, "All fields");
	static readonly ALL_SELECTED = new TriggerRuleType(2, "All selected fields");
	static readonly ANY_SELECTED = new TriggerRuleType(3, "Any selected fields");
	
	static readonly VALUES: GandalfConstantList<TriggerRuleType> = {
		label: 'Trigger Rule Type',
		values: [TriggerRuleType.ANY, TriggerRuleType.ALL, TriggerRuleType.ALL_SELECTED, TriggerRuleType.ANY_SELECTED, ]
	};
}

/** see com.rev360.model.smartflow.constant.Twelve84SmartflowCode */
/* istanbul ignore next */
export class Twelve84SmartflowCode extends GandalfConstant<string> {
	static readonly PACKAGE_DISCOVER = new Twelve84SmartflowCode('DISCOVER', "Discover");
	static readonly LENS_DISCOVER_SINGLE_VISION = new Twelve84SmartflowCode('TW84NSV', "Single Vision");
	static readonly LENS_DISCOVER_PROGRESSIVE = new Twelve84SmartflowCode('TW84NPAL', "Progressive");
	static readonly LENS_DISCOVER_FLAT_TOP_28 = new Twelve84SmartflowCode('TW84DFTBF', "Flat Top 28");
	static readonly PACKAGE_INSPIRE = new Twelve84SmartflowCode('INSPIRE', "Inspire");
	static readonly LENS_INSPIRE_SINGLE_VISION = new Twelve84SmartflowCode('TW84ESV', "Single Vision");
	static readonly LENS_INSPIRE_PROGRESSIVE = new Twelve84SmartflowCode('TW84EPAL', "Progressive");
	static readonly MATERIAL_CR_39 = new Twelve84SmartflowCode('TW84MATCR39', "CR-39");
	static readonly MATERIAL_POLYCARBONATE = new Twelve84SmartflowCode('TW84MATPOLY', "Polycarbonate");
	static readonly MATERIAL_TRIVEX = new Twelve84SmartflowCode('TW84MATTRIVEX', "Trivex");
	static readonly MATERIAL_160_HI_INDEX = new Twelve84SmartflowCode('TW84MAT160', "1.60 Hi-Index");
	static readonly MATERIAL_167_HI_INDEX = new Twelve84SmartflowCode('TW84MAT167', "1.67 Hi-Index");
	static readonly PHOTO_POLAR_CLEAR = new Twelve84SmartflowCode('CLEAR', "Clear");
	static readonly PHOTO_POLAR_PHOTOCHROMIC_BROWN = new Twelve84SmartflowCode('TW84PHBRN', "Photochromic - Brown");
	static readonly PHOTO_POLAR_PHOTOCHROMIC_GREY = new Twelve84SmartflowCode('TW84PHGRY', "Photochromic - Grey");
	static readonly PHOTO_POLAR_POLARIZED_BROWN = new Twelve84SmartflowCode('TW84POLBRN', "Polarized - Brown");
	static readonly PHOTO_POLAR_POLARIZED_GREY = new Twelve84SmartflowCode('TW84POLGRY', "Polarized - Grey");
	static readonly COATING_STANDARD = new Twelve84SmartflowCode('TW84ARSTD', "Standard");
	static readonly COATING_TOP_LEVEL = new Twelve84SmartflowCode('TW84ARTL', "Top Level");
	static readonly COATING_TOP_LEVEL_WITH_BLUE_LIGHT = new Twelve84SmartflowCode('TW84ARTLBLP', "Top Level with Blue Light Protection");
	
	static readonly VALUES: GandalfConstantList<Twelve84SmartflowCode> = {
		label: 'twelve84 Smartflow Code',
		values: [Twelve84SmartflowCode.PACKAGE_DISCOVER, Twelve84SmartflowCode.LENS_DISCOVER_SINGLE_VISION, Twelve84SmartflowCode.LENS_DISCOVER_PROGRESSIVE, Twelve84SmartflowCode.LENS_DISCOVER_FLAT_TOP_28, Twelve84SmartflowCode.PACKAGE_INSPIRE, Twelve84SmartflowCode.LENS_INSPIRE_SINGLE_VISION, Twelve84SmartflowCode.LENS_INSPIRE_PROGRESSIVE, Twelve84SmartflowCode.MATERIAL_CR_39, Twelve84SmartflowCode.MATERIAL_POLYCARBONATE, Twelve84SmartflowCode.MATERIAL_TRIVEX, Twelve84SmartflowCode.MATERIAL_160_HI_INDEX, Twelve84SmartflowCode.MATERIAL_167_HI_INDEX, Twelve84SmartflowCode.PHOTO_POLAR_CLEAR, Twelve84SmartflowCode.PHOTO_POLAR_PHOTOCHROMIC_BROWN, Twelve84SmartflowCode.PHOTO_POLAR_PHOTOCHROMIC_GREY, Twelve84SmartflowCode.PHOTO_POLAR_POLARIZED_BROWN, Twelve84SmartflowCode.PHOTO_POLAR_POLARIZED_GREY, Twelve84SmartflowCode.COATING_STANDARD, Twelve84SmartflowCode.COATING_TOP_LEVEL, Twelve84SmartflowCode.COATING_TOP_LEVEL_WITH_BLUE_LIGHT, ]
	};
}

/** see com.rev360.model.twelve84.constant.twelve84kitstatus.Twelve84KitStatus */
/* istanbul ignore next */
export class TwelveEightyFourKitStatus extends GandalfConstant<number> {
	static readonly ORDERED = new TwelveEightyFourKitStatus(10, "Ordered");
	static readonly RECEIVED = new TwelveEightyFourKitStatus(20, "Received");
	static readonly RETURNED = new TwelveEightyFourKitStatus(30, "Returned");
	
	static readonly VALUES: GandalfConstantList<TwelveEightyFourKitStatus> = {
		label: 'Twelve84 Kit Status',
		values: [TwelveEightyFourKitStatus.ORDERED, TwelveEightyFourKitStatus.RECEIVED, TwelveEightyFourKitStatus.RETURNED, ]
	};
}

/** see com.rev360.model.twelve84.constant.twelve84subscriptionstatus.Twelve84SubscriptionStatus */
/* istanbul ignore next */
export class TwelveEightyFourSubscriptionStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new TwelveEightyFourSubscriptionStatus(0, "Inactive");
	static readonly ACTIVE = new TwelveEightyFourSubscriptionStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<TwelveEightyFourSubscriptionStatus> = {
		label: 'Twelve84 Subscription Status',
		values: [TwelveEightyFourSubscriptionStatus.INACTIVE, TwelveEightyFourSubscriptionStatus.ACTIVE, ]
	};
}

/** see com.rev360.pms.service.schedule.constant.ChangeMode */
/* istanbul ignore next */
export class UpdateMode extends GandalfConstant<number> {
	static readonly ITEM_ONLY = new UpdateMode(0, "Item Only");
	static readonly ITEM_AND_FUTURE_RECUR = new UpdateMode(1, "Item and Future Recurrences");
	static readonly FUTURE_RECUR = new UpdateMode(2, "Future Recurrences");
	static readonly ALL = new UpdateMode(3, "All");
	
	static readonly VALUES: GandalfConstantList<UpdateMode> = {
		label: 'Update Mode',
		values: [UpdateMode.ITEM_ONLY, UpdateMode.ITEM_AND_FUTURE_RECUR, UpdateMode.FUTURE_RECUR, UpdateMode.ALL, ]
	};
}

/** see com.rev360.model.user.constant.usersessionlogaction.UserSessionLogAction */
/* istanbul ignore next */
export class UserSessionLogAction extends GandalfConstant<string> {
	static readonly VIEW = new UserSessionLogAction('View', "View");
	static readonly CREATE = new UserSessionLogAction('Create', "Create");
	static readonly UPDATE = new UserSessionLogAction('Update', "Update");
	static readonly DELETE = new UserSessionLogAction('Delete', "Delete");
	static readonly ACTIVATE = new UserSessionLogAction('Activate', "Activate");
	static readonly DEACTIVATE = new UserSessionLogAction('Deactivate', "Deactivate");
	static readonly SIGN = new UserSessionLogAction('Sign', "Sign");
	static readonly UNSIGN = new UserSessionLogAction('Unsign', "Unsign");
	static readonly START = new UserSessionLogAction('Start', "Start");
	static readonly CONFIRM = new UserSessionLogAction('Confirm', "Confirm");
	static readonly CANCEL = new UserSessionLogAction('Cancel', "Cancel");
	static readonly STOP = new UserSessionLogAction('Stop', "Stop");
	static readonly AUTHORIZE = new UserSessionLogAction('Authorize', "Authorize");
	static readonly REFILL = new UserSessionLogAction('Refill', "Refill");
	static readonly REVIEW = new UserSessionLogAction('Review', "Review");
	static readonly RESOLVE = new UserSessionLogAction('Resolve', "Resolve");
	static readonly DECEASE = new UserSessionLogAction('Decease', "Decease");
	static readonly RESCHEDULE = new UserSessionLogAction('Reschedule', "Reschedule");
	static readonly VIEW_SSN = new UserSessionLogAction('View SSN', "View SSN");
	static readonly PRINT = new UserSessionLogAction('Print', "Print");
	static readonly DOWNLOAD = new UserSessionLogAction('Download', "Download");
	static readonly TRANSMIT = new UserSessionLogAction('Transmit', "Transmit");
	static readonly MOVE = new UserSessionLogAction('Move', "Move");
	static readonly CONVERT = new UserSessionLogAction('Convert', "Convert");
	static readonly QUERY = new UserSessionLogAction('Query', "Query");
	static readonly SUBSCRIBE = new UserSessionLogAction('Subscribe', "Subscribe");
	static readonly UNSUBSCRIBE = new UserSessionLogAction('Unsubscribe', "Unsubscribe");
	static readonly COPY = new UserSessionLogAction('Copy', "Copy");
	static readonly CLEAR = new UserSessionLogAction('Clear', "Clear");
	static readonly EXPORT = new UserSessionLogAction('Export', "Export");
	
	static readonly VALUES: GandalfConstantList<UserSessionLogAction> = {
		label: 'User Session Log Action',
		values: [UserSessionLogAction.VIEW, UserSessionLogAction.CREATE, UserSessionLogAction.UPDATE, UserSessionLogAction.DELETE, UserSessionLogAction.ACTIVATE, UserSessionLogAction.DEACTIVATE, UserSessionLogAction.SIGN, UserSessionLogAction.UNSIGN, UserSessionLogAction.START, UserSessionLogAction.CONFIRM, UserSessionLogAction.CANCEL, UserSessionLogAction.STOP, UserSessionLogAction.AUTHORIZE, UserSessionLogAction.REFILL, UserSessionLogAction.REVIEW, UserSessionLogAction.RESOLVE, UserSessionLogAction.DECEASE, UserSessionLogAction.RESCHEDULE, UserSessionLogAction.VIEW_SSN, UserSessionLogAction.PRINT, UserSessionLogAction.DOWNLOAD, UserSessionLogAction.TRANSMIT, UserSessionLogAction.MOVE, UserSessionLogAction.CONVERT, UserSessionLogAction.QUERY, UserSessionLogAction.SUBSCRIBE, UserSessionLogAction.UNSUBSCRIBE, UserSessionLogAction.COPY, UserSessionLogAction.CLEAR, UserSessionLogAction.EXPORT, ]
	};
}

/** see com.rev360.model.user.constant.usersessionlogentitytype.UserSessionLogEntityType */
/* istanbul ignore next */
export class UserSessionLogEntityType extends GandalfConstant<number> {
	static readonly PATIENT = new UserSessionLogEntityType(1, "Demographics");
	static readonly CONTACT = new UserSessionLogEntityType(2, "Contact");
	static readonly FAMILY_MEMBER = new UserSessionLogEntityType(3, "Family Member");
	static readonly RECALL = new UserSessionLogEntityType(4, "Recall");
	static readonly ENCOUNTER = new UserSessionLogEntityType(5, "Encounter");
	static readonly TEST = new UserSessionLogEntityType(6, "Test");
	static readonly APPOINTMENT = new UserSessionLogEntityType(7, "Appointment");
	static readonly MEDICATION_PRESCRIPTION = new UserSessionLogEntityType(8, "Medication Rx");
	static readonly EYEGLASS_PRESCRIPTION = new UserSessionLogEntityType(9, "Eyeglass Rx");
	static readonly CONTACT_LENS_PRESCRIPTION = new UserSessionLogEntityType(10, "Contact Lens Rx");
	static readonly DRUG_ALLERGY = new UserSessionLogEntityType(11, "Drug Allergy");
	static readonly OTHER_ALLERGY = new UserSessionLogEntityType(12, "Other Allergy");
	static readonly DIAGNOSIS = new UserSessionLogEntityType(13, "Diagnosis");
	static readonly FAMILY_ACCOUNT = new UserSessionLogEntityType(14, "Family Account");
	static readonly TRIGGER_OUTCOME = new UserSessionLogEntityType(15, "Trigger Outcome");
	static readonly CLINICAL_DECISION_SUPPORT_OUTCOME = new UserSessionLogEntityType(16, "Clinical Decision Support Outcome");
	static readonly PATIENT_EDUCATION_OUTCOME = new UserSessionLogEntityType(17, "Patient Education");
	static readonly PATIENT_HISTORY = new UserSessionLogEntityType(18, "History");
	static readonly AMENDMENT = new UserSessionLogEntityType(19, "Amendment");
	static readonly ORDER = new UserSessionLogEntityType(20, "Order");
	static readonly INTERVIEW = new UserSessionLogEntityType(21, "Interview");
	static readonly INVOICE = new UserSessionLogEntityType(22, "Invoice");
	static readonly INSURANCE_CLAIM = new UserSessionLogEntityType(23, "Claim");
	static readonly PATIENT_PHR_RECORD = new UserSessionLogEntityType(24, "Patient PHR Record");
	static readonly CLINICAL_DECISION_SUPPORT_TRIGGER = new UserSessionLogEntityType(25, "Clinical Decision Support Trigger");
	static readonly PATIENT_FILE = new UserSessionLogEntityType(26, "Docs/Images");
	static readonly LAB_ORDER = new UserSessionLogEntityType(27, "Lab Order");
	static readonly USER = new UserSessionLogEntityType(28, "User");
	static readonly PATIENT_THIRD_PARTY_API = new UserSessionLogEntityType(29, "Patient Third-party API");
	static readonly CAMPAIGN_MESSAGE = new UserSessionLogEntityType(30, "Campaign Message");
	static readonly PULL_FORWARD_EXAM_DATA = new UserSessionLogEntityType(31, "Pull Forward Exam Data");
	static readonly CLEAR_EXAM_DATA = new UserSessionLogEntityType(32, "Clear Exam Data");
	static readonly TIMER = new UserSessionLogEntityType(33, "Timer");
	static readonly RAPID_REVIEW = new UserSessionLogEntityType(34, "Rapid Review");
	
	static readonly VALUES: GandalfConstantList<UserSessionLogEntityType> = {
		label: 'User Session Log Entity Type',
		values: [UserSessionLogEntityType.PATIENT, UserSessionLogEntityType.CONTACT, UserSessionLogEntityType.FAMILY_MEMBER, UserSessionLogEntityType.RECALL, UserSessionLogEntityType.ENCOUNTER, UserSessionLogEntityType.TEST, UserSessionLogEntityType.APPOINTMENT, UserSessionLogEntityType.MEDICATION_PRESCRIPTION, UserSessionLogEntityType.EYEGLASS_PRESCRIPTION, UserSessionLogEntityType.CONTACT_LENS_PRESCRIPTION, UserSessionLogEntityType.DRUG_ALLERGY, UserSessionLogEntityType.OTHER_ALLERGY, UserSessionLogEntityType.DIAGNOSIS, UserSessionLogEntityType.FAMILY_ACCOUNT, UserSessionLogEntityType.TRIGGER_OUTCOME, UserSessionLogEntityType.CLINICAL_DECISION_SUPPORT_OUTCOME, UserSessionLogEntityType.PATIENT_EDUCATION_OUTCOME, UserSessionLogEntityType.PATIENT_HISTORY, UserSessionLogEntityType.AMENDMENT, UserSessionLogEntityType.ORDER, UserSessionLogEntityType.INTERVIEW, UserSessionLogEntityType.INVOICE, UserSessionLogEntityType.INSURANCE_CLAIM, UserSessionLogEntityType.PATIENT_PHR_RECORD, UserSessionLogEntityType.CLINICAL_DECISION_SUPPORT_TRIGGER, UserSessionLogEntityType.PATIENT_FILE, UserSessionLogEntityType.LAB_ORDER, UserSessionLogEntityType.USER, UserSessionLogEntityType.PATIENT_THIRD_PARTY_API, UserSessionLogEntityType.CAMPAIGN_MESSAGE, UserSessionLogEntityType.PULL_FORWARD_EXAM_DATA, UserSessionLogEntityType.CLEAR_EXAM_DATA, UserSessionLogEntityType.TIMER, UserSessionLogEntityType.RAPID_REVIEW, ]
	};
}

/** see com.rev360.model.user.constant.usersessionshareddatatype.UserSessionSharedDataType */
/* istanbul ignore next */
export class UserSessionSharedDataType extends GandalfConstant<number> {
	static readonly LEGACY = new UserSessionSharedDataType(1, "Legacy UserSession/SessionData");
	static readonly OAUTH2_SSO = new UserSessionSharedDataType(2, "OAuth2/OIDC SSO");
	static readonly SPRING_SESSION = new UserSessionSharedDataType(3, "Spring Session");
	
	static readonly VALUES: GandalfConstantList<UserSessionSharedDataType> = {
		label: 'User Session Shared Data Type',
		values: [UserSessionSharedDataType.LEGACY, UserSessionSharedDataType.OAUTH2_SSO, UserSessionSharedDataType.SPRING_SESSION, ]
	};
}

/** see com.rev360.model.user.constant.usersystem.UserSystem */
/* istanbul ignore next */
export class UserSystem extends GandalfConstant<number> {
	static readonly UNKNOWN = new UserSystem(0, "Unknown");
	static readonly PMS = new UserSystem(1, "PMS");
	static readonly PHR = new UserSystem(2, "PHR");
	static readonly CUSTOMER_CARE = new UserSystem(3, "Customer Care");
	static readonly MYREV = new UserSystem(4, "MyRev");
	static readonly REVCYCLE_DEPRECATED = new UserSystem(5, "RevCycle (Deprecated)");
	static readonly REVASSURE_DEPRECATED = new UserSystem(6, "RevAssure (Deprecated)");
	static readonly PARTNER_DEPRECATED = new UserSystem(7, "Partner (Deprecated)");
	static readonly CONVERSION = new UserSystem(8, "Conversion");
	static readonly INTEGRATIONS = new UserSystem(9, "Integrations");
	static readonly SERVER_UTILITIES = new UserSystem(10, "Server Utilities");
	static readonly PATIENT_COMMS_LANDING = new UserSystem(11, "Patient Communications Landing");
	static readonly EPAY = new UserSystem(12, "ePay");
	static readonly DATA_EXPORT = new UserSystem(13, "Data Export");
	
	static readonly VALUES: GandalfConstantList<UserSystem> = {
		label: 'User System',
		values: [UserSystem.UNKNOWN, UserSystem.PMS, UserSystem.PHR, UserSystem.CUSTOMER_CARE, UserSystem.MYREV, UserSystem.REVCYCLE_DEPRECATED, UserSystem.REVASSURE_DEPRECATED, UserSystem.PARTNER_DEPRECATED, UserSystem.CONVERSION, UserSystem.INTEGRATIONS, UserSystem.SERVER_UTILITIES, UserSystem.PATIENT_COMMS_LANDING, UserSystem.EPAY, UserSystem.DATA_EXPORT, ]
	};
}

/** see com.rev360.model.user.constant.usertype.UserType */
/* istanbul ignore next */
export class UserType extends GandalfConstant<number> {
	static readonly UNKNOWN = new UserType(0, "Unknown");
	static readonly EMPLOYEE = new UserType(1, "Employee");
	static readonly PATIENT = new UserType(2, "Patient");
	static readonly SERVICE_USER = new UserType(3, "Service User");
	static readonly DATA_LOADER = new UserType(4, "Data Loader");
	static readonly WEB_SERVICE = new UserType(5, "Web Service");
	static readonly SERVER_UTILITY = new UserType(6, "Server Utility");
	static readonly PAYER_PERSON = new UserType(7, "Payer Person");
	static readonly APPLICATION_SERVICE_USER = new UserType(8, "Application Service User");
	
	static readonly VALUES: GandalfConstantList<UserType> = {
		label: 'User Type',
		values: [UserType.UNKNOWN, UserType.EMPLOYEE, UserType.PATIENT, UserType.SERVICE_USER, UserType.DATA_LOADER, UserType.WEB_SERVICE, UserType.SERVER_UTILITY, UserType.PAYER_PERSON, UserType.APPLICATION_SERVICE_USER, ]
	};
}

/** see com.rev360.model.immunization.constant.vaccinationstatus.VaccinationStatus */
/* istanbul ignore next */
export class VaccinationStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new VaccinationStatus(1, "Active");
	static readonly INACTIVE = new VaccinationStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<VaccinationStatus> = {
		label: 'Vaccination Status',
		values: [VaccinationStatus.ACTIVE, VaccinationStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.immunization.constant.vaccinemanufacturerstatus.VaccineManufacturerStatus */
/* istanbul ignore next */
export class VaccineManufacturerStatus extends GandalfConstant<string> {
	static readonly ACTIVE = new VaccineManufacturerStatus('Active', "Active");
	static readonly INACTIVE = new VaccineManufacturerStatus('Inactive', "Inactive");
	
	static readonly VALUES: GandalfConstantList<VaccineManufacturerStatus> = {
		label: 'Vaccine Manufacturer Status',
		values: [VaccineManufacturerStatus.ACTIVE, VaccineManufacturerStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.vendor.constant.vendorordersubmissionmechanism.VendorOrderSubmissionMechanism */
/* istanbul ignore next */
export class VendorOrderSubmissionMechanism extends GandalfConstant<number> {
	static readonly NO_MECHANISM = new VendorOrderSubmissionMechanism(0, "None");
	static readonly ELECTRONIC = new VendorOrderSubmissionMechanism(1, "Electronic");
	static readonly FAX = new VendorOrderSubmissionMechanism(2, "Fax");
	static readonly MAIL = new VendorOrderSubmissionMechanism(3, "Mail");
	static readonly PRINT = new VendorOrderSubmissionMechanism(4, "Print");
	
	static readonly VALUES: GandalfConstantList<VendorOrderSubmissionMechanism> = {
		label: 'Vendor Order Submission Mechanism',
		values: [VendorOrderSubmissionMechanism.NO_MECHANISM, VendorOrderSubmissionMechanism.ELECTRONIC, VendorOrderSubmissionMechanism.FAX, VendorOrderSubmissionMechanism.MAIL, VendorOrderSubmissionMechanism.PRINT, ]
	};
}

/** see com.rev360.model.vendor.constant.vendortype.VendorType */
/* istanbul ignore next */
export class VendorType extends GandalfConstant<number> {
	static readonly LAB = new VendorType(1, "Lab");
	static readonly CONTACT_LENS_SUPPLIER = new VendorType(4, "Contact Lens Supplier");
	static readonly COLLECTIONS_AGENCY = new VendorType(5, "Collections Agency");
	static readonly FRAME_SUPPLIER = new VendorType(6, "Frame Supplier");
	static readonly ALTERNATE_SERVICE_LOCATION = new VendorType(7, "Alternate Service Location");
	static readonly ORDER_LAB = new VendorType(8, "Order Lab");
	static readonly VSP_LAB = new VendorType(9, "VSP Lab");
	
	static readonly VALUES: GandalfConstantList<VendorType> = {
		label: 'Vendor Type',
		values: [VendorType.LAB, VendorType.CONTACT_LENS_SUPPLIER, VendorType.COLLECTIONS_AGENCY, VendorType.FRAME_SUPPLIER, VendorType.ALTERNATE_SERVICE_LOCATION, VendorType.ORDER_LAB, VendorType.VSP_LAB, ]
	};
}

/** see com.rev360.model.common.constant.verification.VerificationStatus */
/* istanbul ignore next */
export class VerificationStatus extends GandalfConstant<number> {
	static readonly NOT_VERIFIED = new VerificationStatus(1, "Not Verified");
	static readonly VERIFIED_VALID = new VerificationStatus(2, "Valid");
	static readonly VERIFIED_INVALID = new VerificationStatus(3, "Invalid");
	
	static readonly VALUES: GandalfConstantList<VerificationStatus> = {
		label: 'Verification Status',
		values: [VerificationStatus.NOT_VERIFIED, VerificationStatus.VERIFIED_VALID, VerificationStatus.VERIFIED_INVALID, ]
	};
}

/** see com.rev360.model.prescription.constant.verticalprismorientation.VerticalPrismOrientation */
/* istanbul ignore next */
export class VerticalPrismOrientation extends GandalfConstant<string> {
	static readonly BASE_UP = new VerticalPrismOrientation('BU', "BU");
	static readonly BASE_DOWN = new VerticalPrismOrientation('BD', "BD");
	static readonly SLAB_OFF = new VerticalPrismOrientation('Slab Off', "Slab Off");
	static readonly BLANK = new VerticalPrismOrientation(' ', "");
	static readonly NONE = new VerticalPrismOrientation('', "");
	
	static readonly VALUES: GandalfConstantList<VerticalPrismOrientation> = {
		label: 'Vertical Prism Orientation',
		values: [VerticalPrismOrientation.BASE_UP, VerticalPrismOrientation.BASE_DOWN, VerticalPrismOrientation.SLAB_OFF, VerticalPrismOrientation.BLANK, VerticalPrismOrientation.NONE, ]
	};
}

/** see com.rev360.pms.service.order.VisionwebProcessorAttribute */
/* istanbul ignore next */
export class VisionwebProcessorAttribute extends GandalfConstant<string> {
	static readonly USERNAME = new VisionwebProcessorAttribute('Login name', "Login name");
	static readonly PASSWORD = new VisionwebProcessorAttribute('Password', "Password");
	
	static readonly VALUES: GandalfConstantList<VisionwebProcessorAttribute> = {
		label: 'VisionWeb',
		values: [VisionwebProcessorAttribute.USERNAME, VisionwebProcessorAttribute.PASSWORD, ]
	};
}

/** see com.rev360.model.ws.visionweb.constant.VisionwebTransactionStatus */
/* istanbul ignore next */
export class VisionwebTransactionStatus extends GandalfConstant<string> {
	static readonly PASS = new VisionwebTransactionStatus('PASS', "Success");
	static readonly FAIL = new VisionwebTransactionStatus('FAIL', "Failure");
	static readonly ERROR = new VisionwebTransactionStatus('ERROR', "Error");
	
	static readonly VALUES: GandalfConstantList<VisionwebTransactionStatus> = {
		label: 'Visionweb Transaction Status',
		values: [VisionwebTransactionStatus.PASS, VisionwebTransactionStatus.FAIL, VisionwebTransactionStatus.ERROR, ]
	};
}

/** see com.rev360.model.schedule.constant.waitlistpriority.WaitListPriority */
/* istanbul ignore next */
export class WaitListPriority extends GandalfConstant<number> {
	static readonly NORMAL = new WaitListPriority(0, "Normal");
	static readonly HIGH = new WaitListPriority(1, "High");
	
	static readonly VALUES: GandalfConstantList<WaitListPriority> = {
		label: 'Wait List Priority',
		values: [WaitListPriority.NORMAL, WaitListPriority.HIGH, ]
	};
}

/** see com.rev360.model.schedule.constant.waitliststatus.WaitListStatus */
/* istanbul ignore next */
export class WaitListStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new WaitListStatus(0, "Active");
	static readonly INACTIVE = new WaitListStatus(1, "Inactive");
	
	static readonly VALUES: GandalfConstantList<WaitListStatus> = {
		label: 'Wait List Status',
		values: [WaitListStatus.ACTIVE, WaitListStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.warehouse.constant.warehousepracticestatus.WarehousePracticeStatus */
/* istanbul ignore next */
export class WarehousePracticeStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new WarehousePracticeStatus(1, "Active");
	static readonly INACTIVE = new WarehousePracticeStatus(2, "Inactive");
	
	static readonly VALUES: GandalfConstantList<WarehousePracticeStatus> = {
		label: 'Warehouse Practice Status',
		values: [WarehousePracticeStatus.ACTIVE, WarehousePracticeStatus.INACTIVE, ]
	};
}

/** see com.rev360.model.warehouse.constant.warehouserunstatus.WarehouseRunStatus */
/* istanbul ignore next */
export class WarehouseRunStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new WarehouseRunStatus(1, "Active");
	static readonly FINISHED = new WarehouseRunStatus(2, "Finished");
	static readonly DELETED = new WarehouseRunStatus(3, "Deleted");
	
	static readonly VALUES: GandalfConstantList<WarehouseRunStatus> = {
		label: 'Warehouse run status ',
		values: [WarehouseRunStatus.ACTIVE, WarehouseRunStatus.FINISHED, WarehouseRunStatus.DELETED, ]
	};
}

/** see com.rev360.model.warehouse.constant.warehousetablename.WarehouseTableName */
/* istanbul ignore next */
export class WarehouseTableName extends GandalfConstant<string> {
	static readonly POSTING = new WarehouseTableName('WAREHOUSE_LEDGER_POSTING', "Posting");
	static readonly REFUND = new WarehouseTableName('WAREHOUSE_LEDGER_REFUND', "Refund");
	static readonly PAYMENT = new WarehouseTableName('WAREHOUSE_LEDGER_PAYMENT', "Payment");
	static readonly SALE = new WarehouseTableName('WAREHOUSE_LEDGER_SALE', "Sale");
	static readonly SALE_ADJUST = new WarehouseTableName('WAREHOUSE_LEDGER_SALE_ADJUST', "Sale Adjust");
	
	static readonly VALUES: GandalfConstantList<WarehouseTableName> = {
		label: 'Warehouse Table Name',
		values: [WarehouseTableName.POSTING, WarehouseTableName.REFUND, WarehouseTableName.PAYMENT, WarehouseTableName.SALE, WarehouseTableName.SALE_ADJUST, ]
	};
}

/** see com.rev360.model.ws.common.constant.WebServiceUserPartnerKey */
/* istanbul ignore next */
export class WebServiceUserPartnerKey extends GandalfConstant<string> {
	static readonly DOCTIBLE = new WebServiceUserPartnerKey('DOCTIBLE', "Doctible");
	static readonly THE_EDGE = new WebServiceUserPartnerKey('EDGE', "EDGEPro");
	static readonly EPPOINTMENTS = new WebServiceUserPartnerKey('EPPOINTMENTS', "Eppointments");
	static readonly GLIMPSE = new WebServiceUserPartnerKey('GLIMPSE', "ABB Analyze/Glimpse");
	static readonly PRACTICE_JET = new WebServiceUserPartnerKey('PRACTICEJET', "PracticeJet");
	static readonly TAB = new WebServiceUserPartnerKey('TAB', "TAB");
	static readonly AFFINITY_ANALYTICS = new WebServiceUserPartnerKey('AFFINITY-ANALYTICS', "AffinityAnalytics");
	static readonly INTAKE_Q = new WebServiceUserPartnerKey('INTAKEQ', "IntakeQ");
	static readonly PAPER_WISE = new WebServiceUserPartnerKey('PAPERWISE', "PaperWise");
	static readonly KNO2 = new WebServiceUserPartnerKey('KNO2', "Kno2");
	static readonly PRACTICE_PAL = new WebServiceUserPartnerKey('PRACTICEPAL', "PracticePal");
	static readonly AUTO_REMIND = new WebServiceUserPartnerKey('AUTOREMIND', "AutoRemind");
	static readonly REVINTAKE = new WebServiceUserPartnerKey('REVINTAKE', "RevIntake");
	static readonly REV_CYCLE = new WebServiceUserPartnerKey('REVCYCLE', "RevCycle Partners");
	static readonly EYECARE_PRO = new WebServiceUserPartnerKey('EYECARE-PRO', "EyeCare Pro");
	static readonly FOUR_PATIENT_CARE = new WebServiceUserPartnerKey('4PC', "4PatientCare");
	static readonly DEMAND_FORCE = new WebServiceUserPartnerKey('DF', "Demand Force");
	static readonly EYE_CARE_PRIME = new WebServiceUserPartnerKey('PRIME', "EyeCare Prime");
	static readonly EYE_CONX = new WebServiceUserPartnerKey('EYECONX', "EyeConx");
	static readonly SOLUTION_REACH = new WebServiceUserPartnerKey('SR', "SolutionReach");
	static readonly WEAVE = new WebServiceUserPartnerKey('WEAVE', "Weave");
	static readonly PURPLE_GO = new WebServiceUserPartnerKey('PURPLEGO', "Purple Go");
	static readonly EYE_APPOINT = new WebServiceUserPartnerKey('EYEAPPOINT', "EyeAppoint");
	static readonly MARCO = new WebServiceUserPartnerKey('MARCO', "Marco");
	static readonly REV_INTEGRATOR = new WebServiceUserPartnerKey('REV-INTEGRATOR', "RevEHR Integrator");
	static readonly REV_INTEGRATOR_FOR_IMAGING = new WebServiceUserPartnerKey('REV-INTEGRATOR-FOR-IMAGING', "RevEHR Integrator for Imaging");
	static readonly OPTIKAM = new WebServiceUserPartnerKey('OPTIKAM', "Optikam");
	static readonly REV_TEST_APP = new WebServiceUserPartnerKey('REV360_TEST', "RevEHR Test App");
	static readonly ARRELLIO = new WebServiceUserPartnerKey('ARRELLIO', "Arrellio");
	static readonly CLX = new WebServiceUserPartnerKey('CLX', "CLX");
	static readonly MARLO = new WebServiceUserPartnerKey('MARLO', "Marlo");
	static readonly REV_ENGAGE = new WebServiceUserPartnerKey('REVENGAGE', "RevEngage");
	
	static readonly VALUES: GandalfConstantList<WebServiceUserPartnerKey> = {
		label: 'WebServiceUser Partner Key',
		values: [WebServiceUserPartnerKey.DOCTIBLE, WebServiceUserPartnerKey.THE_EDGE, WebServiceUserPartnerKey.EPPOINTMENTS, WebServiceUserPartnerKey.GLIMPSE, WebServiceUserPartnerKey.PRACTICE_JET, WebServiceUserPartnerKey.TAB, WebServiceUserPartnerKey.AFFINITY_ANALYTICS, WebServiceUserPartnerKey.INTAKE_Q, WebServiceUserPartnerKey.PAPER_WISE, WebServiceUserPartnerKey.KNO2, WebServiceUserPartnerKey.PRACTICE_PAL, WebServiceUserPartnerKey.AUTO_REMIND, WebServiceUserPartnerKey.REVINTAKE, WebServiceUserPartnerKey.REV_CYCLE, WebServiceUserPartnerKey.EYECARE_PRO, WebServiceUserPartnerKey.FOUR_PATIENT_CARE, WebServiceUserPartnerKey.DEMAND_FORCE, WebServiceUserPartnerKey.EYE_CARE_PRIME, WebServiceUserPartnerKey.EYE_CONX, WebServiceUserPartnerKey.SOLUTION_REACH, WebServiceUserPartnerKey.WEAVE, WebServiceUserPartnerKey.PURPLE_GO, WebServiceUserPartnerKey.EYE_APPOINT, WebServiceUserPartnerKey.MARCO, WebServiceUserPartnerKey.REV_INTEGRATOR, WebServiceUserPartnerKey.REV_INTEGRATOR_FOR_IMAGING, WebServiceUserPartnerKey.OPTIKAM, WebServiceUserPartnerKey.REV_TEST_APP, WebServiceUserPartnerKey.ARRELLIO, WebServiceUserPartnerKey.CLX, WebServiceUserPartnerKey.MARLO, WebServiceUserPartnerKey.REV_ENGAGE, ]
	};
}

/** see com.rev360.model.ws.common.constant.webserviceuserservicetype.WebServiceUserServiceType */
/* istanbul ignore next */
export class WebServiceUserServiceType extends GandalfConstant<string> {
	static readonly FOUR_PATIENT_CARE = new WebServiceUserServiceType('4PC', "4PatientCare");
	static readonly DEVICE = new WebServiceUserServiceType('DEVICE', "Device");
	static readonly TAB = new WebServiceUserServiceType('EPP', "TAB");
	static readonly EPPOINTMENTS = new WebServiceUserServiceType('EPPOINTMENTS', "eppointments");
	static readonly PARTNER = new WebServiceUserServiceType('PARTNER', "Partner");
	static readonly MU2015 = new WebServiceUserServiceType('MU2015', "MU2015");
	
	static readonly VALUES: GandalfConstantList<WebServiceUserServiceType> = {
		label: 'Web Service User Service Type',
		values: [WebServiceUserServiceType.FOUR_PATIENT_CARE, WebServiceUserServiceType.DEVICE, WebServiceUserServiceType.TAB, WebServiceUserServiceType.EPPOINTMENTS, WebServiceUserServiceType.PARTNER, WebServiceUserServiceType.MU2015, ]
	};
}

/** see com.rev360.model.schedule.constant.weekselect.WeekSelect */
/* istanbul ignore next */
export class WeekSelect extends GandalfConstant<number> {
	static readonly FIRST = new WeekSelect(1, "first");
	static readonly SECOND = new WeekSelect(2, "second");
	static readonly THIRD = new WeekSelect(3, "third");
	static readonly FOURTH = new WeekSelect(4, "fourth");
	static readonly LAST = new WeekSelect(5, "last");
	
	static readonly VALUES: GandalfConstantList<WeekSelect> = {
		label: 'Week Select',
		values: [WeekSelect.FIRST, WeekSelect.SECOND, WeekSelect.THIRD, WeekSelect.FOURTH, WeekSelect.LAST, ]
	};
}

/** see com.rev360.model.example.widget.constant.powersource.PowerSource */
/* istanbul ignore next */
export class WidgetPowerSource extends GandalfConstant<string> {
	static readonly NUCLEAR = new WidgetPowerSource('N', "Nuclear Powered");
	static readonly HAND_CRANKED = new WidgetPowerSource('H', "Hand Cranked");
	
	static readonly VALUES: GandalfConstantList<WidgetPowerSource> = {
		label: 'Widget Power Source',
		values: [WidgetPowerSource.NUCLEAR, WidgetPowerSource.HAND_CRANKED, ]
	};
}

/** see com.rev360.model.example.widget.constant.widgetstatus.WidgetStatus */
/* istanbul ignore next */
export class WidgetStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new WidgetStatus(0, "Inactive");
	static readonly ACTIVE = new WidgetStatus(1, "Active");
	static readonly DELETED = new WidgetStatus(2, "Deleted");
	
	static readonly VALUES: GandalfConstantList<WidgetStatus> = {
		label: 'Widget Status',
		values: [WidgetStatus.INACTIVE, WidgetStatus.ACTIVE, WidgetStatus.DELETED, ]
	};
}

/** see com.rev360.model.common.constant.workflowscreenclassname.WorkflowScreenClassName */
/* istanbul ignore next */
export class WorkflowScreenClassName extends GandalfConstant<string> {
	static readonly ALLERGIES = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryAllergies', "Allergies");
	static readonly ASSESSMENT_COMMENTS = new WorkflowScreenClassName('com.hit.view.encounter.assessment.AssessmentComments', "Assessment Comments");
	static readonly ASSESSMENT = new WorkflowScreenClassName('com.hit.view.encounter.assessment.Assessment', "Assessment");
	static readonly CHECKIN_DEMOGRAPHICS = new WorkflowScreenClassName('com.hit.view.encounter.checkin.CheckinDemographics', "Checkin Demographics");
	static readonly CHECKIN_INSURANCE = new WorkflowScreenClassName('com.hit.view.encounter.checkin.CheckinInsurance', "Check-In Insurance");
	static readonly CHECKOUT = new WorkflowScreenClassName('com.hit.view.encounter.checkout.Checkout', "Check-Out");
	static readonly CHECKOUT_BILLING = new WorkflowScreenClassName('com.hit.view.encounter.checkout.CheckoutBilling', "Check-Out Billing");
	static readonly CHECKOUT_TASKS = new WorkflowScreenClassName('com.hit.view.encounter.checkout.CheckoutTasks', "Check-Out Tasks");
	static readonly CODING = new WorkflowScreenClassName('com.hit.view.encounter.coding.Coding', "Coding");
	static readonly CONSENTS = new WorkflowScreenClassName('com.hit.view.encounter.checkin.CheckinConsentForms', "Consents");
	static readonly CONTACT_LENS_TRIALS = new WorkflowScreenClassName('com.hit.view.encounter.contactlens.CLRxReview', "Contact Lens Trials");
	static readonly FAMILY_MEDICAL_HX = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryFamilyHealthMedical', "Family Medical Hx");
	static readonly FAMILY_OCULAR_HX = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryFamilyHealthOcular', "Family Ocular Hx");
	static readonly HISTORY_CL = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryCL', "CL History");
	static readonly HISTORY_MEDS = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryMeds', "Medications");
	static readonly HISTORY_ORIENTATION_MOOD = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryOrientationMood', "Orientation/Mood");
	static readonly HISTORY_PFSH = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryPFSH', "PFSH");
	static readonly HISTORY_PRESENT_ILLNESS = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryHPI', "HPI");
	static readonly HISTORY_RC = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryRC', "Related Conditions");
	static readonly HISTORY_RFV = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryRFV', "RFV");
	static readonly HISTORY_ROS = new WorkflowScreenClassName('com.hit.view.encounter.history.HistoryROS', "ROS");
	static readonly HISTORY_SURGERY = new WorkflowScreenClassName('com.hit.view.encounter.history.HistorySurgeries', "Surgeries");
	static readonly OPTICAL_EYEGLASS_REVIEW = new WorkflowScreenClassName('com.hit.view.encounter.optical.OpticalRxReview', "Optical Eyeglass Review");
	static readonly ORDERS_MEDICAL = new WorkflowScreenClassName('com.hit.view.encounter.laborder.LabOrder', "Orders Medical");
	static readonly MDM = new WorkflowScreenClassName('com.hit.view.encounter.assessment.Mdm', "MDM");
	static readonly CLINICAL_DECISION_SUPPORT = new WorkflowScreenClassName('com.hit.view.encounter.assessment.Triggers', "Clinical Decision Support");
	static readonly PATIENT_EDUCATION = new WorkflowScreenClassName('com.hit.view.encounter.assessment.PatientEducation', "Patient Education");
	static readonly PLAN = new WorkflowScreenClassName('com.hit.view.encounter.assessment.Plan', "Plan");
	
	static readonly VALUES: GandalfConstantList<WorkflowScreenClassName> = {
		label: 'WorkflowScreenClassNameLabel',
		values: [WorkflowScreenClassName.ALLERGIES, WorkflowScreenClassName.ASSESSMENT_COMMENTS, WorkflowScreenClassName.ASSESSMENT, WorkflowScreenClassName.CHECKIN_DEMOGRAPHICS, WorkflowScreenClassName.CHECKIN_INSURANCE, WorkflowScreenClassName.CHECKOUT, WorkflowScreenClassName.CHECKOUT_BILLING, WorkflowScreenClassName.CHECKOUT_TASKS, WorkflowScreenClassName.CODING, WorkflowScreenClassName.CONSENTS, WorkflowScreenClassName.CONTACT_LENS_TRIALS, WorkflowScreenClassName.FAMILY_MEDICAL_HX, WorkflowScreenClassName.FAMILY_OCULAR_HX, WorkflowScreenClassName.HISTORY_CL, WorkflowScreenClassName.HISTORY_MEDS, WorkflowScreenClassName.HISTORY_ORIENTATION_MOOD, WorkflowScreenClassName.HISTORY_PFSH, WorkflowScreenClassName.HISTORY_PRESENT_ILLNESS, WorkflowScreenClassName.HISTORY_RC, WorkflowScreenClassName.HISTORY_RFV, WorkflowScreenClassName.HISTORY_ROS, WorkflowScreenClassName.HISTORY_SURGERY, WorkflowScreenClassName.OPTICAL_EYEGLASS_REVIEW, WorkflowScreenClassName.ORDERS_MEDICAL, WorkflowScreenClassName.MDM, WorkflowScreenClassName.CLINICAL_DECISION_SUPPORT, WorkflowScreenClassName.PATIENT_EDUCATION, WorkflowScreenClassName.PLAN, ]
	};
}

/** see com.rev360.model.workflow.constant.workflowscreenstatus.WorkflowScreenStatus */
/* istanbul ignore next */
export class WorkflowScreenStatus extends GandalfConstant<number> {
	static readonly INACTIVE = new WorkflowScreenStatus(0, "Inactive");
	static readonly ACTIVE = new WorkflowScreenStatus(1, "Active");
	
	static readonly VALUES: GandalfConstantList<WorkflowScreenStatus> = {
		label: 'Workflow Screen Status',
		values: [WorkflowScreenStatus.INACTIVE, WorkflowScreenStatus.ACTIVE, ]
	};
}

/** see com.rev360.model.workflow.constant.workflowscreentemplatelayout.WorkflowScreenTemplateLayout */
/* istanbul ignore next */
export class WorkflowScreenTemplateLayout extends GandalfConstant<number> {
	static readonly DEFAULT = new WorkflowScreenTemplateLayout(0, "Default");
	
	static readonly VALUES: GandalfConstantList<WorkflowScreenTemplateLayout> = {
		label: 'Workflow Screen Template Layout',
		values: [WorkflowScreenTemplateLayout.DEFAULT, ]
	};
}

/** see com.rev360.model.workflow.constant.workflowstepstatus.WorkflowStepStatus */
/* istanbul ignore next */
export class WorkflowStepStatus extends GandalfConstant<number> {
	static readonly PENDING = new WorkflowStepStatus(0, "Pending");
	static readonly IN_PROGRESS = new WorkflowStepStatus(1, "In-Progress");
	static readonly COMPLETED = new WorkflowStepStatus(2, "Completed");
	
	static readonly VALUES: GandalfConstantList<WorkflowStepStatus> = {
		label: 'Workflow Step Status',
		values: [WorkflowStepStatus.PENDING, WorkflowStepStatus.IN_PROGRESS, WorkflowStepStatus.COMPLETED, ]
	};
}

/** see com.rev360.model.workflow.constant.workflowsteptemplatetype.WorkflowStepTemplateType */
/* istanbul ignore next */
export class WorkflowStepTemplateType extends GandalfConstant<number> {
	static readonly NOT_SPECIFIED = new WorkflowStepTemplateType(0, "Not specified");
	static readonly CHECKIN = new WorkflowStepTemplateType(1, "Check-in");
	static readonly HISTORY = new WorkflowStepTemplateType(2, "History");
	static readonly EXAM = new WorkflowStepTemplateType(3, "Exam");
	static readonly ASSESSMENT = new WorkflowStepTemplateType(4, "Assessment");
	static readonly CODING = new WorkflowStepTemplateType(5, "Coding");
	static readonly OPTICAL = new WorkflowStepTemplateType(6, "Optical");
	static readonly CONTACT_LENS = new WorkflowStepTemplateType(7, "Contact Lens");
	static readonly CHECKOUT = new WorkflowStepTemplateType(8, "Check-out");
	
	static readonly VALUES: GandalfConstantList<WorkflowStepTemplateType> = {
		label: 'Workflow Step Template Type',
		values: [WorkflowStepTemplateType.NOT_SPECIFIED, WorkflowStepTemplateType.CHECKIN, WorkflowStepTemplateType.HISTORY, WorkflowStepTemplateType.EXAM, WorkflowStepTemplateType.ASSESSMENT, WorkflowStepTemplateType.CODING, WorkflowStepTemplateType.OPTICAL, WorkflowStepTemplateType.CONTACT_LENS, WorkflowStepTemplateType.CHECKOUT, ]
	};
}

/** see com.rev360.pms.service.workflow.WorkflowTestHpiWizardMasterId */
/* istanbul ignore next */
export class WorkflowTestHpiWizardMasterId extends GandalfConstant<number> {
	static readonly GENERIC = new WorkflowTestHpiWizardMasterId(3000, "Generic");
	static readonly CATARACT = new WorkflowTestHpiWizardMasterId(3001, "Cataract");
	static readonly AGE_RELATED_MACULAR_DEGENERATION = new WorkflowTestHpiWizardMasterId(3002, "Age-related Macular Degeneration");
	static readonly GLAUCOMA = new WorkflowTestHpiWizardMasterId(3003, "Glaucoma");
	static readonly DIABETES = new WorkflowTestHpiWizardMasterId(3004, "Diabetes");
	static readonly DIABETIC_RETINOPATHY = new WorkflowTestHpiWizardMasterId(3005, "Diabetic Retinopathy");
	static readonly DRY_EYE = new WorkflowTestHpiWizardMasterId(3006, "Dry Eye");
	static readonly EYE_INFECTION_INFLAMMATION_ALLERGY = new WorkflowTestHpiWizardMasterId(3007, "Eye infection, inflammation, or allergy");
	static readonly FLOATERS_FLASHES = new WorkflowTestHpiWizardMasterId(3008, "Floaters and/or flashes of light");
	static readonly IRITIS_UVEITIS = new WorkflowTestHpiWizardMasterId(3009, "Iritis or Uveitis");
	static readonly RETINA_DEFECTS_DEGENERATIONS = new WorkflowTestHpiWizardMasterId(3010, "Retina defects or degenerations");
	static readonly REDNESS = new WorkflowTestHpiWizardMasterId(3011, "Redness");
	static readonly BURNING = new WorkflowTestHpiWizardMasterId(3012, "Burning");
	static readonly ITCHING = new WorkflowTestHpiWizardMasterId(3013, "Itching");
	static readonly TEARING = new WorkflowTestHpiWizardMasterId(3014, "Tearing");
	static readonly DISCHARGE = new WorkflowTestHpiWizardMasterId(3015, "Discharge");
	static readonly BLURRED_VISION = new WorkflowTestHpiWizardMasterId(3016, "Blurred vision");
	static readonly EYESTRAIN = new WorkflowTestHpiWizardMasterId(3017, "Eyestrain");
	static readonly EYE_PAIN = new WorkflowTestHpiWizardMasterId(3018, "Eye pain");
	static readonly SEVERE_SENSITIVITY_LIGHTS = new WorkflowTestHpiWizardMasterId(3019, "Severe sensitivity to lights");
	static readonly HEADACHE = new WorkflowTestHpiWizardMasterId(3020, "Headache");
	static readonly POOR_NIGHT_VISION = new WorkflowTestHpiWizardMasterId(3021, "Poor night vision");
	static readonly BOTHERSOME_NIGHT_GLARE = new WorkflowTestHpiWizardMasterId(3022, "Bothersome night glare");
	static readonly DOUBLE_VISION = new WorkflowTestHpiWizardMasterId(3023, "Double vision");
	static readonly TOTAL_LOSS_VISION = new WorkflowTestHpiWizardMasterId(3024, "Total loss of vision");
	
	static readonly VALUES: GandalfConstantList<WorkflowTestHpiWizardMasterId> = {
		label: 'WorkflowTestHpiWizardMasterId',
		values: [WorkflowTestHpiWizardMasterId.GENERIC, WorkflowTestHpiWizardMasterId.CATARACT, WorkflowTestHpiWizardMasterId.AGE_RELATED_MACULAR_DEGENERATION, WorkflowTestHpiWizardMasterId.GLAUCOMA, WorkflowTestHpiWizardMasterId.DIABETES, WorkflowTestHpiWizardMasterId.DIABETIC_RETINOPATHY, WorkflowTestHpiWizardMasterId.DRY_EYE, WorkflowTestHpiWizardMasterId.EYE_INFECTION_INFLAMMATION_ALLERGY, WorkflowTestHpiWizardMasterId.FLOATERS_FLASHES, WorkflowTestHpiWizardMasterId.IRITIS_UVEITIS, WorkflowTestHpiWizardMasterId.RETINA_DEFECTS_DEGENERATIONS, WorkflowTestHpiWizardMasterId.REDNESS, WorkflowTestHpiWizardMasterId.BURNING, WorkflowTestHpiWizardMasterId.ITCHING, WorkflowTestHpiWizardMasterId.TEARING, WorkflowTestHpiWizardMasterId.DISCHARGE, WorkflowTestHpiWizardMasterId.BLURRED_VISION, WorkflowTestHpiWizardMasterId.EYESTRAIN, WorkflowTestHpiWizardMasterId.EYE_PAIN, WorkflowTestHpiWizardMasterId.SEVERE_SENSITIVITY_LIGHTS, WorkflowTestHpiWizardMasterId.HEADACHE, WorkflowTestHpiWizardMasterId.POOR_NIGHT_VISION, WorkflowTestHpiWizardMasterId.BOTHERSOME_NIGHT_GLARE, WorkflowTestHpiWizardMasterId.DOUBLE_VISION, WorkflowTestHpiWizardMasterId.TOTAL_LOSS_VISION, ]
	};
}

/** see com.rev360.core.service.workflow.WorkflowTestTemplateMasterId */
/* istanbul ignore next */
export class WorkflowTestTemplateMasterId extends GandalfConstant<number> {
	static readonly AIDED_VISUAL_ACUITY = new WorkflowTestTemplateMasterId(2, "AIDED_VISUAL_ACUITY");
	static readonly DIOPSYS_VEP = new WorkflowTestTemplateMasterId(3, "DIOPSYS_VEP");
	static readonly GLARE_TESTING_VISUAL_ACUITY = new WorkflowTestTemplateMasterId(4, "GLARE_TESTING_VISUAL_ACUITY");
	static readonly UNCORRECTED_VISUAL_ACUITY = new WorkflowTestTemplateMasterId(5, "UNCORRECTED_VISUAL_ACUITY");
	static readonly VA_UNTESTABLE = new WorkflowTestTemplateMasterId(6, "VA_UNTESTABLE");
	static readonly SPECIAL_VA_TESTING = new WorkflowTestTemplateMasterId(7, "SPECIAL_VA_TESTING");
	static readonly INFANTSEE_VA_TESTING = new WorkflowTestTemplateMasterId(8, "INFANTSEE_VA_TESTING");
	static readonly POTENTIAL_ACUITY_METER = new WorkflowTestTemplateMasterId(9, "POTENTIAL_ACUITY_METER");
	static readonly RED_DESATURATION = new WorkflowTestTemplateMasterId(11, "RED_DESATURATION");
	static readonly PINHOLE_VISUAL_ACUITY = new WorkflowTestTemplateMasterId(12, "PINHOLE_VISUAL_ACUITY");
	static readonly BRIGHTNESS_VISUAL_ACUITY = new WorkflowTestTemplateMasterId(13, "BRIGHTNESS_VISUAL_ACUITY");
	static readonly UNCORRECTED_VISUAL_ACUITY_METRIC = new WorkflowTestTemplateMasterId(14, "UNCORRECTED_VISUAL_ACUITY_METRIC");
	static readonly AIDED_VISUAL_ACUITY_METRIC = new WorkflowTestTemplateMasterId(15, "AIDED_VISUAL_ACUITY_METRIC");
	static readonly PHOTO_STRESS = new WorkflowTestTemplateMasterId(16, "PHOTO_STRESS");
	static readonly PHOTO_STRESS_MONOCULAR = new WorkflowTestTemplateMasterId(17, "PHOTO_STRESS_MONOCULAR");
	static readonly PUPILS = new WorkflowTestTemplateMasterId(30, "PUPILS");
	static readonly PUPILS_PDS = new WorkflowTestTemplateMasterId(33, "PUPILS_PDS");
	static readonly PUPILS_PERRL = new WorkflowTestTemplateMasterId(35, "PUPILS_PERRL");
	static readonly VR800 = new WorkflowTestTemplateMasterId(150, "VR800");
	static readonly REFRACTION_DISTANCE_METRIC = new WorkflowTestTemplateMasterId(153, "REFRACTION_DISTANCE_METRIC");
	static readonly FINAL_REFRACTION_WITH_PRISM_METRIC = new WorkflowTestTemplateMasterId(154, "FINAL_REFRACTION_WITH_PRISM_METRIC");
	static readonly TECHNICAL_REFRACTION_METRIC = new WorkflowTestTemplateMasterId(155, "TECHNICAL_REFRACTION_METRIC");
	static readonly RETINOSCOPY_WITH_VAS_METRIC = new WorkflowTestTemplateMasterId(156, "RETINOSCOPY_WITH_VAS_METRIC");
	static readonly ACCOMMODATIVE_LAG = new WorkflowTestTemplateMasterId(157, "ACCOMMODATIVE_LAG");
	static readonly WAVEFRONT_OPTIMIZED_AR = new WorkflowTestTemplateMasterId(158, "WAVEFRONT_OPTIMIZED_AR");
	static readonly NIGHT_TIME_REFRACTIVE_DATA = new WorkflowTestTemplateMasterId(159, "NIGHT_TIME_REFRACTIVE_DATA");
	static readonly KERATOMETRY = new WorkflowTestTemplateMasterId(160, "KERATOMETRY");
	static readonly RETINOSCOPY_WITH_VAS = new WorkflowTestTemplateMasterId(161, "RETINOSCOPY_WITH_VAS");
	static readonly LENSOMETRY = new WorkflowTestTemplateMasterId(162, "LENSOMETRY");
	static readonly LENSOMETRY_WITH_PRISM = new WorkflowTestTemplateMasterId(168, "LENSOMETRY_WITH_PRISM");
	static readonly AUTOREFRACTION = new WorkflowTestTemplateMasterId(163, "AUTOREFRACTION");
	static readonly RETINOSCOPY = new WorkflowTestTemplateMasterId(164, "RETINOSCOPY");
	static readonly TECHNICAL_REFRACTION = new WorkflowTestTemplateMasterId(165, "TECHNICAL_REFRACTION");
	static readonly REFRACTION_DISTANCE = new WorkflowTestTemplateMasterId(166, "REFRACTION_DISTANCE");
	static readonly REFRACTION_NEARPOINT = new WorkflowTestTemplateMasterId(167, "REFRACTION_NEARPOINT");
	static readonly CONTACT_LENS_OVER_REFRACTION = new WorkflowTestTemplateMasterId(169, "CONTACT_LENS_OVER_REFRACTION");
	static readonly CYCLOPLEGIC_REFRACTION = new WorkflowTestTemplateMasterId(170, "CYCLOPLEGIC_REFRACTION");
	static readonly FINAL_REFRACTION = new WorkflowTestTemplateMasterId(175, "FINAL_REFRACTION");
	static readonly FINAL_REFRACTION_WITH_PRISM = new WorkflowTestTemplateMasterId(176, "FINAL_REFRACTION_WITH_PRISM");
	static readonly CORNEAL_TYPOGRAPHY = new WorkflowTestTemplateMasterId(177, "CORNEAL_TYPOGRAPHY");
	static readonly HISTORICAL_RX = new WorkflowTestTemplateMasterId(178, "HISTORICAL_RX");
	static readonly CYCLOPLEGIC_AUTOREFRACTION = new WorkflowTestTemplateMasterId(171, "CYCLOPLEGIC_AUTOREFRACTION");
	static readonly CYCLOPLEGIC_RETINOSCOPY = new WorkflowTestTemplateMasterId(172, "CYCLOPLEGIC_RETINOSCOPY");
	static readonly OPD = new WorkflowTestTemplateMasterId(173, "OPD");
	static readonly BRUCKNER = new WorkflowTestTemplateMasterId(174, "BRUCKNER");
	static readonly ISCRIPTION = new WorkflowTestTemplateMasterId(179, "ISCRIPTION");
	static readonly TRIAL_FRAME_REFRACTION = new WorkflowTestTemplateMasterId(181, "TRIAL_FRAME_REFRACTION");
	static readonly DPAS_USED = new WorkflowTestTemplateMasterId(230, "DPAS_USED");
	static readonly GOLDMANN_APPLANATION_TONOMETRY = new WorkflowTestTemplateMasterId(240, "GOLDMANN_APPLANATION_TONOMETRY");
	static readonly PASCAL_TONOMETRY = new WorkflowTestTemplateMasterId(241, "PASCAL_TONOMETRY");
	static readonly TONOPEN_TONOMETRY = new WorkflowTestTemplateMasterId(242, "TONOPEN_TONOMETRY");
	static readonly NON_CONTACT_TONOMETRY = new WorkflowTestTemplateMasterId(243, "NON_CONTACT_TONOMETRY");
	static readonly DUAL_NON_CONTACT_TONOMETRY = new WorkflowTestTemplateMasterId(244, "DUAL_NON_CONTACT_TONOMETRY");
	static readonly SERIAL_TONOMETRY = new WorkflowTestTemplateMasterId(245, "SERIAL_TONOMETRY");
	static readonly AT_555_TONOMETRY = new WorkflowTestTemplateMasterId(246, "AT_555_TONOMETRY");
	static readonly PT_100_TONOMETRY = new WorkflowTestTemplateMasterId(247, "PT_100_TONOMETRY");
	static readonly TONOMETRY_7_CR = new WorkflowTestTemplateMasterId(248, "TONOMETRY_7_CR");
	static readonly TONOMETRY_7 = new WorkflowTestTemplateMasterId(249, "TONOMETRY_7");
	static readonly ULTRASONIC_PACHYMETRY = new WorkflowTestTemplateMasterId(250, "ULTRASONIC_PACHYMETRY");
	static readonly OPTICAL_PACHYMETRY = new WorkflowTestTemplateMasterId(251, "OPTICAL_PACHYMETRY");
	static readonly OCULAR_RESPONSE_ANALYZER = new WorkflowTestTemplateMasterId(252, "OCULAR_RESPONSE_ANALYZER");
	static readonly PNEUMO_TONOMETRY = new WorkflowTestTemplateMasterId(256, "PNEUMO_TONOMETRY");
	static readonly ICARE_TONOMETRY = new WorkflowTestTemplateMasterId(257, "ICARE_TONOMETRY");
	static readonly IOP_UNTESTABLE = new WorkflowTestTemplateMasterId(255, "IOP_UNTESTABLE");
	static readonly TACTILE_TONOMETRY = new WorkflowTestTemplateMasterId(258, "TACTILE_TONOMETRY");
	static readonly OPTIC_NERVE = new WorkflowTestTemplateMasterId(295, "OPTIC_NERVE");
	static readonly VITAL_SIGNS_ENGLISH = new WorkflowTestTemplateMasterId(402, "VITAL_SIGNS_ENGLISH");
	static readonly VITAL_SIGNS_METRIC = new WorkflowTestTemplateMasterId(403, "VITAL_SIGNS_METRIC");
	static readonly VITAL_SIGNS_STATIC = new WorkflowTestTemplateMasterId(405, "VITAL_SIGNS_STATIC");
	static readonly CONTACT_LENS_EVALUATION = new WorkflowTestTemplateMasterId(500, "CONTACT_LENS_EVALUATION");
	static readonly HEMOGLOBIN_A1C = new WorkflowTestTemplateMasterId(1008, "HEMOGLOBIN_A1C");
	static readonly INTERVENTIONS = new WorkflowTestTemplateMasterId(1009, "INTERVENTIONS");
	static readonly THOROUGH_DOCUMENTATION = new WorkflowTestTemplateMasterId(1003, "THOROUGH_DOCUMENTATION");
	static readonly DEVICE_MEASUREMENT_PUPILS_PDS = new WorkflowTestTemplateMasterId(5001, "DEVICE_MEASUREMENT_PUPILS_PDS");
	static readonly DEVICE_MEASUREMENT_LENS_MEASUREMENT = new WorkflowTestTemplateMasterId(5002, "DEVICE_MEASUREMENT_LENS_MEASUREMENT");
	static readonly DEVICE_MEASUREMENT_DEMOGRAPHICS = new WorkflowTestTemplateMasterId(5005, "DEVICE_MEASUREMENT_DEMOGRAPHICS");
	
	static readonly VALUES: GandalfConstantList<WorkflowTestTemplateMasterId> = {
		label: 'WorkflowTestTemplateMasterId',
		values: [WorkflowTestTemplateMasterId.AIDED_VISUAL_ACUITY, WorkflowTestTemplateMasterId.DIOPSYS_VEP, WorkflowTestTemplateMasterId.GLARE_TESTING_VISUAL_ACUITY, WorkflowTestTemplateMasterId.UNCORRECTED_VISUAL_ACUITY, WorkflowTestTemplateMasterId.VA_UNTESTABLE, WorkflowTestTemplateMasterId.SPECIAL_VA_TESTING, WorkflowTestTemplateMasterId.INFANTSEE_VA_TESTING, WorkflowTestTemplateMasterId.POTENTIAL_ACUITY_METER, WorkflowTestTemplateMasterId.RED_DESATURATION, WorkflowTestTemplateMasterId.PINHOLE_VISUAL_ACUITY, WorkflowTestTemplateMasterId.BRIGHTNESS_VISUAL_ACUITY, WorkflowTestTemplateMasterId.UNCORRECTED_VISUAL_ACUITY_METRIC, WorkflowTestTemplateMasterId.AIDED_VISUAL_ACUITY_METRIC, WorkflowTestTemplateMasterId.PHOTO_STRESS, WorkflowTestTemplateMasterId.PHOTO_STRESS_MONOCULAR, WorkflowTestTemplateMasterId.PUPILS, WorkflowTestTemplateMasterId.PUPILS_PDS, WorkflowTestTemplateMasterId.PUPILS_PERRL, WorkflowTestTemplateMasterId.VR800, WorkflowTestTemplateMasterId.REFRACTION_DISTANCE_METRIC, WorkflowTestTemplateMasterId.FINAL_REFRACTION_WITH_PRISM_METRIC, WorkflowTestTemplateMasterId.TECHNICAL_REFRACTION_METRIC, WorkflowTestTemplateMasterId.RETINOSCOPY_WITH_VAS_METRIC, WorkflowTestTemplateMasterId.ACCOMMODATIVE_LAG, WorkflowTestTemplateMasterId.WAVEFRONT_OPTIMIZED_AR, WorkflowTestTemplateMasterId.NIGHT_TIME_REFRACTIVE_DATA, WorkflowTestTemplateMasterId.KERATOMETRY, WorkflowTestTemplateMasterId.RETINOSCOPY_WITH_VAS, WorkflowTestTemplateMasterId.LENSOMETRY, WorkflowTestTemplateMasterId.LENSOMETRY_WITH_PRISM, WorkflowTestTemplateMasterId.AUTOREFRACTION, WorkflowTestTemplateMasterId.RETINOSCOPY, WorkflowTestTemplateMasterId.TECHNICAL_REFRACTION, WorkflowTestTemplateMasterId.REFRACTION_DISTANCE, WorkflowTestTemplateMasterId.REFRACTION_NEARPOINT, WorkflowTestTemplateMasterId.CONTACT_LENS_OVER_REFRACTION, WorkflowTestTemplateMasterId.CYCLOPLEGIC_REFRACTION, WorkflowTestTemplateMasterId.FINAL_REFRACTION, WorkflowTestTemplateMasterId.FINAL_REFRACTION_WITH_PRISM, WorkflowTestTemplateMasterId.CORNEAL_TYPOGRAPHY, WorkflowTestTemplateMasterId.HISTORICAL_RX, WorkflowTestTemplateMasterId.CYCLOPLEGIC_AUTOREFRACTION, WorkflowTestTemplateMasterId.CYCLOPLEGIC_RETINOSCOPY, WorkflowTestTemplateMasterId.OPD, WorkflowTestTemplateMasterId.BRUCKNER, WorkflowTestTemplateMasterId.ISCRIPTION, WorkflowTestTemplateMasterId.TRIAL_FRAME_REFRACTION, WorkflowTestTemplateMasterId.DPAS_USED, WorkflowTestTemplateMasterId.GOLDMANN_APPLANATION_TONOMETRY, WorkflowTestTemplateMasterId.PASCAL_TONOMETRY, WorkflowTestTemplateMasterId.TONOPEN_TONOMETRY, WorkflowTestTemplateMasterId.NON_CONTACT_TONOMETRY, WorkflowTestTemplateMasterId.DUAL_NON_CONTACT_TONOMETRY, WorkflowTestTemplateMasterId.SERIAL_TONOMETRY, WorkflowTestTemplateMasterId.AT_555_TONOMETRY, WorkflowTestTemplateMasterId.PT_100_TONOMETRY, WorkflowTestTemplateMasterId.TONOMETRY_7_CR, WorkflowTestTemplateMasterId.TONOMETRY_7, WorkflowTestTemplateMasterId.ULTRASONIC_PACHYMETRY, WorkflowTestTemplateMasterId.OPTICAL_PACHYMETRY, WorkflowTestTemplateMasterId.OCULAR_RESPONSE_ANALYZER, WorkflowTestTemplateMasterId.PNEUMO_TONOMETRY, WorkflowTestTemplateMasterId.ICARE_TONOMETRY, WorkflowTestTemplateMasterId.IOP_UNTESTABLE, WorkflowTestTemplateMasterId.TACTILE_TONOMETRY, WorkflowTestTemplateMasterId.OPTIC_NERVE, WorkflowTestTemplateMasterId.VITAL_SIGNS_ENGLISH, WorkflowTestTemplateMasterId.VITAL_SIGNS_METRIC, WorkflowTestTemplateMasterId.VITAL_SIGNS_STATIC, WorkflowTestTemplateMasterId.CONTACT_LENS_EVALUATION, WorkflowTestTemplateMasterId.HEMOGLOBIN_A1C, WorkflowTestTemplateMasterId.INTERVENTIONS, WorkflowTestTemplateMasterId.THOROUGH_DOCUMENTATION, WorkflowTestTemplateMasterId.DEVICE_MEASUREMENT_PUPILS_PDS, WorkflowTestTemplateMasterId.DEVICE_MEASUREMENT_LENS_MEASUREMENT, WorkflowTestTemplateMasterId.DEVICE_MEASUREMENT_DEMOGRAPHICS, ]
	};
}

/** see com.rev360.model.workflow.constant.workflowtriggerscreentemplatestatus.WorkflowTriggerScreenTemplateStatus */
/* istanbul ignore next */
export class WorkflowTriggerScreenTemplateStatus extends GandalfConstant<number> {
	static readonly ACTIVE = new WorkflowTriggerScreenTemplateStatus(1, "Active");
	static readonly INACTIVE = new WorkflowTriggerScreenTemplateStatus(2, "Inactive");
	static readonly PROCESSED = new WorkflowTriggerScreenTemplateStatus(3, "Processed");
	
	static readonly VALUES: GandalfConstantList<WorkflowTriggerScreenTemplateStatus> = {
		label: 'Workflow Trigger Screen Template Status',
		values: [WorkflowTriggerScreenTemplateStatus.ACTIVE, WorkflowTriggerScreenTemplateStatus.INACTIVE, WorkflowTriggerScreenTemplateStatus.PROCESSED, ]
	};
}

/** see com.rev360.model.schedule.constant.yearlypatterntype.YearlyPatternType */
/* istanbul ignore next */
export class YearlyPatternType extends GandalfConstant<number> {
	static readonly EVERY_X_MONTH_ON_DAY_Y = new YearlyPatternType(1, "Every X Month on Day Y");
	static readonly EVERY_X_DAY_OF_MONTH = new YearlyPatternType(2, "Every X Day of Month");
	
	static readonly VALUES: GandalfConstantList<YearlyPatternType> = {
		label: 'Yearly Pattern Type',
		values: [YearlyPatternType.EVERY_X_MONTH_ON_DAY_Y, YearlyPatternType.EVERY_X_DAY_OF_MONTH, ]
	};
}


